/* tslint:disable */
/* eslint-disable */
/**
 * Pecosta Search API
 * TBD
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptNewPriceRequest
 */
export interface AcceptNewPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AcceptNewPriceRequest
     */
    'cartItemId': number;
    /**
     * 
     * @type {number}
     * @memberof AcceptNewPriceRequest
     */
    'newPriceVariantId': number;
}
/**
 * 
 * @export
 * @interface AcceptOrderRequest
 */
export interface AcceptOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptOrderRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface AddManualSupplierRequest
 */
export interface AddManualSupplierRequest {
    /**
     * 
     * @type {number}
     * @memberof AddManualSupplierRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AddManualSupplierRequest
     */
    'catalogCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddManualSupplierRequest
     */
    'catalogName': string;
    /**
     * 
     * @type {number}
     * @memberof AddManualSupplierRequest
     */
    'priceWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof AddManualSupplierRequest
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddManualSupplierRequest
     */
    'validTo': string;
    /**
     * 
     * @type {number}
     * @memberof AddManualSupplierRequest
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof AddManualSupplierRequest
     */
    'multiply': boolean;
}
/**
 * 
 * @export
 * @interface AddressDTO
 */
export interface AddressDTO {
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDTO
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface AdminWorkflowDetailDTO
 */
export interface AdminWorkflowDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowDetailDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowDetailDTO
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowDetailDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminWorkflowDetailDTO
     */
    'fallback': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowDetailDTO
     */
    'startNodeId'?: string;
    /**
     * 
     * @type {Array<AdminWorkflowNodeDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'nodes': Array<AdminWorkflowNodeDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowEdgeDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'edges': Array<AdminWorkflowEdgeDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowPortalRefDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'defaultForPortals': Array<AdminWorkflowPortalRefDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowOrganizationRefDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'organizationOverrides': Array<AdminWorkflowOrganizationRefDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowStatusCountDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'statusCounts': Array<AdminWorkflowStatusCountDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowNodeCountDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'activeByNode': Array<AdminWorkflowNodeCountDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowRoleDTO>}
     * @memberof AdminWorkflowDetailDTO
     */
    'roles': Array<AdminWorkflowRoleDTO>;
}
/**
 * 
 * @export
 * @interface AdminWorkflowEdgeDTO
 */
export interface AdminWorkflowEdgeDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'kind': AdminWorkflowEdgeDTOKindEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'actionId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminWorkflowEdgeDTO
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowEdgeDTO
     */
    'businessState'?: string;
}

export const AdminWorkflowEdgeDTOKindEnum = {
    Flow: 'FLOW',
    UserAction: 'USER_ACTION',
    Condition: 'CONDITION',
    Default: 'DEFAULT'
} as const;

export type AdminWorkflowEdgeDTOKindEnum = typeof AdminWorkflowEdgeDTOKindEnum[keyof typeof AdminWorkflowEdgeDTOKindEnum];

/**
 * 
 * @export
 * @interface AdminWorkflowGatewayConditionDTO
 */
export interface AdminWorkflowGatewayConditionDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowGatewayConditionDTO
     */
    'expression': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowGatewayConditionDTO
     */
    'targetNode': string;
}
/**
 * 
 * @export
 * @interface AdminWorkflowListItemDTO
 */
export interface AdminWorkflowListItemDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowListItemDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowListItemDTO
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowListItemDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowListItemDTO
     */
    'nodeCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowListItemDTO
     */
    'userTaskCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminWorkflowListItemDTO
     */
    'fallback': boolean;
    /**
     * 
     * @type {Array<AdminWorkflowPortalRefDTO>}
     * @memberof AdminWorkflowListItemDTO
     */
    'defaultForPortals': Array<AdminWorkflowPortalRefDTO>;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowListItemDTO
     */
    'organizationOverrideCount': number;
    /**
     * 
     * @type {Array<AdminWorkflowStatusCountDTO>}
     * @memberof AdminWorkflowListItemDTO
     */
    'statusCounts': Array<AdminWorkflowStatusCountDTO>;
}
/**
 * 
 * @export
 * @interface AdminWorkflowNodeCountDTO
 */
export interface AdminWorkflowNodeCountDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeCountDTO
     */
    'nodeId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowNodeCountDTO
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminWorkflowNodeDTO
 */
export interface AdminWorkflowNodeDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'type': AdminWorkflowNodeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'actionBean'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'assigneeExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'businessState'?: string;
    /**
     * 
     * @type {Array<AdminWorkflowUserActionDTO>}
     * @memberof AdminWorkflowNodeDTO
     */
    'actions': Array<AdminWorkflowUserActionDTO>;
    /**
     * 
     * @type {Array<AdminWorkflowGatewayConditionDTO>}
     * @memberof AdminWorkflowNodeDTO
     */
    'conditions': Array<AdminWorkflowGatewayConditionDTO>;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowNodeDTO
     */
    'defaultTarget'?: string;
}

export const AdminWorkflowNodeDTOTypeEnum = {
    Start: 'START',
    End: 'END',
    ServiceTask: 'SERVICE_TASK',
    UserTask: 'USER_TASK',
    ExclusiveGateway: 'EXCLUSIVE_GATEWAY',
    ParallelFork: 'PARALLEL_FORK',
    ParallelJoin: 'PARALLEL_JOIN'
} as const;

export type AdminWorkflowNodeDTOTypeEnum = typeof AdminWorkflowNodeDTOTypeEnum[keyof typeof AdminWorkflowNodeDTOTypeEnum];

/**
 * 
 * @export
 * @interface AdminWorkflowOrganizationRefDTO
 */
export interface AdminWorkflowOrganizationRefDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowOrganizationRefDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowOrganizationRefDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowOrganizationRefDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowOrganizationRefDTO
     */
    'portalName': string;
}
/**
 * 
 * @export
 * @interface AdminWorkflowPortalRefDTO
 */
export interface AdminWorkflowPortalRefDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowPortalRefDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowPortalRefDTO
     */
    'portalName': string;
}
/**
 * 
 * @export
 * @interface AdminWorkflowRoleDTO
 */
export interface AdminWorkflowRoleDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowRoleDTO
     */
    'roleName': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminWorkflowRoleDTO
     */
    'exists': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminWorkflowRoleDTO
     */
    'scopes': Array<AdminWorkflowRoleDTOScopesEnum>;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowRoleDTO
     */
    'directUserCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowRoleDTO
     */
    'securityGroupUserCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowRoleDTO
     */
    'securityGroupCount': number;
    /**
     * 
     * @type {Array<AdminWorkflowSecurityGroupRefDTO>}
     * @memberof AdminWorkflowRoleDTO
     */
    'securityGroups': Array<AdminWorkflowSecurityGroupRefDTO>;
}

export const AdminWorkflowRoleDTOScopesEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminWorkflowRoleDTOScopesEnum = typeof AdminWorkflowRoleDTOScopesEnum[keyof typeof AdminWorkflowRoleDTOScopesEnum];

/**
 * 
 * @export
 * @interface AdminWorkflowSecurityGroupRefDTO
 */
export interface AdminWorkflowSecurityGroupRefDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowSecurityGroupRefDTO
     */
    'securityGroupId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowSecurityGroupRefDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowSecurityGroupRefDTO
     */
    'scope': AdminWorkflowSecurityGroupRefDTOScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowSecurityGroupRefDTO
     */
    'organizationName'?: string;
}

export const AdminWorkflowSecurityGroupRefDTOScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminWorkflowSecurityGroupRefDTOScopeEnum = typeof AdminWorkflowSecurityGroupRefDTOScopeEnum[keyof typeof AdminWorkflowSecurityGroupRefDTOScopeEnum];

/**
 * 
 * @export
 * @interface AdminWorkflowStatusCountDTO
 */
export interface AdminWorkflowStatusCountDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowStatusCountDTO
     */
    'status': AdminWorkflowStatusCountDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkflowStatusCountDTO
     */
    'count': number;
}

export const AdminWorkflowStatusCountDTOStatusEnum = {
    Running: 'RUNNING',
    WaitingUser: 'WAITING_USER',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Error: 'ERROR'
} as const;

export type AdminWorkflowStatusCountDTOStatusEnum = typeof AdminWorkflowStatusCountDTOStatusEnum[keyof typeof AdminWorkflowStatusCountDTOStatusEnum];

/**
 * 
 * @export
 * @interface AdminWorkflowUserActionDTO
 */
export interface AdminWorkflowUserActionDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowUserActionDTO
     */
    'actionId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowUserActionDTO
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowUserActionDTO
     */
    'targetNode': string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowUserActionDTO
     */
    'actionBean'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminWorkflowUserActionDTO
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowUserActionDTO
     */
    'businessState'?: string;
}
/**
 * 
 * @export
 * @interface ApprovalMessage
 */
export interface ApprovalMessage {
    /**
     * 
     * @type {string}
     * @memberof ApprovalMessage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalMessage
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApprovalStatus = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


/**
 * 
 * @export
 * @interface AssistantChatMessage
 */
export interface AssistantChatMessage {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatMessage
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatMessage
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface AssistantMessageRequest
 */
export interface AssistantMessageRequest {
    /**
     * 
     * @type {Array<AssistantChatMessage>}
     * @memberof AssistantMessageRequest
     */
    'messages': Array<AssistantChatMessage>;
}
/**
 * 
 * @export
 * @interface AssistantMessageResponse
 */
export interface AssistantMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof AssistantMessageResponse
     */
    'reply': string;
    /**
     * 
     * @type {Array<AssistantProposedItem>}
     * @memberof AssistantMessageResponse
     */
    'proposedItems': Array<AssistantProposedItem>;
    /**
     * 
     * @type {number}
     * @memberof AssistantMessageResponse
     */
    'toolIterations': number;
}
/**
 * 
 * @export
 * @interface AssistantProposedItem
 */
export interface AssistantProposedItem {
    /**
     * 
     * @type {number}
     * @memberof AssistantProposedItem
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AssistantProposedItem
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AssistantProposedItem
     */
    'ecid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantProposedItem
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof AssistantProposedItem
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AssistantProposedItem
     */
    'supplierName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantProposedItem
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof AssistantProposedItem
     */
    'unit'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantProposedItem
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssistantProposedItem
     */
    'searchQuery': string;
}
/**
 * Response po nahrání přílohy
 * @export
 * @interface AttachmentResponseDTO
 */
export interface AttachmentResponseDTO {
    /**
     * UUID přílohy
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    'uuid': string;
    /**
     * Název souboru
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    'fileName': string;
    /**
     * Velikost souboru v bytech
     * @type {number}
     * @memberof AttachmentResponseDTO
     */
    'fileSize': number;
    /**
     * MIME typ souboru
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    'mimeType': string;
    /**
     * URL souboru na S3
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    'url': string;
    /**
     * SHA256 hash souboru
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    'sha256Hash': string;
}
/**
 * Request s dataURL a původním názvem souboru
 * @export
 * @interface AttachmentUploadRequestDTO
 */
export interface AttachmentUploadRequestDTO {
    /**
     * DataURL souboru (data:*_/_*;base64,...)
     * @type {string}
     * @memberof AttachmentUploadRequestDTO
     */
    'dataUrl': string;
    /**
     * Původní název souboru
     * @type {string}
     * @memberof AttachmentUploadRequestDTO
     */
    'originalFileName': string;
}
/**
 * 
 * @export
 * @interface AutocompleteResponse
 */
export interface AutocompleteResponse {
    /**
     * 
     * @type {number}
     * @memberof AutocompleteResponse
     */
    'totalProducts': number;
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof AutocompleteResponse
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {Array<IndexedCategoryDTO>}
     * @memberof AutocompleteResponse
     */
    'categories': Array<IndexedCategoryDTO>;
    /**
     * 
     * @type {Array<IndexedSupplierESDTO>}
     * @memberof AutocompleteResponse
     */
    'suppliers': Array<IndexedSupplierESDTO>;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof AutocompleteResponse
     */
    'supplierDelivery'?: Array<SupplierDeliveryWindow>;
}
/**
 * 
 * @export
 * @interface BreadcrumbInfo
 */
export interface BreadcrumbInfo {
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof BreadcrumbInfo
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface CatalogDataResponse
 */
export interface CatalogDataResponse {
    /**
     * 
     * @type {number}
     * @memberof CatalogDataResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CatalogDataResponse
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogDataResponse
     */
    'multiply': boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogDataResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDataResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDataResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDataResponse
     */
    'supplierNote'?: string;
}
/**
 * 
 * @export
 * @interface CategoryControllerResponse
 */
export interface CategoryControllerResponse {
    /**
     * 
     * @type {Array<CategoryControllerResponseDTO>}
     * @memberof CategoryControllerResponse
     */
    'allCategories': Array<CategoryControllerResponseDTO>;
}
/**
 * 
 * @export
 * @interface CategoryControllerResponseDTO
 */
export interface CategoryControllerResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof CategoryControllerResponseDTO
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof CategoryControllerResponseDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryControllerResponseDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryControllerResponseDTO
     */
    'categoryImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryControllerResponseDTO
     */
    'auctionAmount'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof CategoryControllerResponseDTO
     */
    'auctionUnit'?: UnitType;
    /**
     * 
     * @type {Array<CategoryControllerResponseDTO>}
     * @memberof CategoryControllerResponseDTO
     */
    'children': Array<CategoryControllerResponseDTO>;
}


/**
 * 
 * @export
 * @interface CategoryInfo
 */
export interface CategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof CategoryInfo
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryImageUrl'?: string;
    /**
     * 
     * @type {Array<SubcategoryInfo>}
     * @memberof CategoryInfo
     */
    'subcategories': Array<SubcategoryInfo>;
    /**
     * 
     * @type {Array<BreadcrumbInfo>}
     * @memberof CategoryInfo
     */
    'breadcrumb': Array<BreadcrumbInfo>;
}
/**
 * 
 * @export
 * @interface CheckReport
 */
export interface CheckReport {
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'service': string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'status': CheckReportStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'checkedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReport
     */
    'cached': boolean;
    /**
     * 
     * @type {Array<CheckResult>}
     * @memberof CheckReport
     */
    'checks': Array<CheckResult>;
}

export const CheckReportStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckReportStatusEnum = typeof CheckReportStatusEnum[keyof typeof CheckReportStatusEnum];

/**
 * 
 * @export
 * @interface CheckResult
 */
export interface CheckResult {
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'status': CheckResultStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CheckResult
     */
    'latencyMs': number;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'detail'?: string;
}

export const CheckResultStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckResultStatusEnum = typeof CheckResultStatusEnum[keyof typeof CheckResultStatusEnum];

/**
 * 
 * @export
 * @interface ClientAddressDTO
 */
export interface ClientAddressDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAddressDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientAddressDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'name2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'zipcode': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAddressDTO
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface ClientArticleDetailResponse
 */
export interface ClientArticleDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientArticleDetailResponse
     */
    'articleId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'body': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientArticleDetailResponse
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientArticleDetailResponse
     */
    'isRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'validTo': string;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleDetailResponse
     */
    'created': string;
}
/**
 * 
 * @export
 * @interface ClientArticleListResponse
 */
export interface ClientArticleListResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientArticleListResponse
     */
    'articleId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleListResponse
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientArticleListResponse
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientArticleListResponse
     */
    'isRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleListResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientArticleListResponse
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface ClientAuctionAttachmentDTO
 */
export interface ClientAuctionAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionAttachmentDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionAttachmentDTO
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionAttachmentDTO
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionAttachmentDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface ClientAuctionDetailDTO
 */
export interface ClientAuctionDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionDetailDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'validTo': string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionDetailDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'portalShortcut': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionDetailDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {Array<ClientAuctionAttachmentDTO>}
     * @memberof ClientAuctionDetailDTO
     */
    'attachments': Array<ClientAuctionAttachmentDTO>;
}
/**
 * 
 * @export
 * @interface ClientAuctionLimitDTO
 */
export interface ClientAuctionLimitDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitDTO
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionLimitDTO
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionLimitDTO
     */
    'auctionCode': string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitDTO
     */
    'maxAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitDTO
     */
    'usedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitDTO
     */
    'cartAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitDTO
     */
    'remainingAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientAuctionLimitDTO
     */
    'cartExceedsLimit': boolean;
}
/**
 * 
 * @export
 * @interface ClientAuctionLimitsResponse
 */
export interface ClientAuctionLimitsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ClientAuctionLimitsResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<ClientAuctionLimitDTO>}
     * @memberof ClientAuctionLimitsResponse
     */
    'limits': Array<ClientAuctionLimitDTO>;
}
/**
 * 
 * @export
 * @interface ClientAuctionListResponseDTO
 */
export interface ClientAuctionListResponseDTO {
    /**
     * 
     * @type {Array<ClientAuctionResponseDTO>}
     * @memberof ClientAuctionListResponseDTO
     */
    'auctions': Array<ClientAuctionResponseDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionListResponseDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionListResponseDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionListResponseDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionListResponseDTO
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface ClientAuctionPriceDTO
 */
export interface ClientAuctionPriceDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceDTO
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientAuctionPriceDTO
     */
    'priceUnit'?: UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientAuctionPriceDTO
     */
    'packageItemUnit'?: UnitType;
    /**
     * 
     * @type {PriceType}
     * @memberof ClientAuctionPriceDTO
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof ClientAuctionPriceDTO
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionPriceDTO
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface ClientAuctionPriceListDTO
 */
export interface ClientAuctionPriceListDTO {
    /**
     * 
     * @type {Array<ClientAuctionPriceDTO>}
     * @memberof ClientAuctionPriceListDTO
     */
    'prices': Array<ClientAuctionPriceDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceListDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceListDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceListDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionPriceListDTO
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface ClientAuctionProductDTO
 */
export interface ClientAuctionProductDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionProductDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionProductDTO
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionProductDTO
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionProductDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {ClientAuctionProductImageDTO}
     * @memberof ClientAuctionProductDTO
     */
    'image'?: ClientAuctionProductImageDTO;
}
/**
 * 
 * @export
 * @interface ClientAuctionProductImageDTO
 */
export interface ClientAuctionProductImageDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductImageDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionProductImageDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface ClientAuctionProductListDTO
 */
export interface ClientAuctionProductListDTO {
    /**
     * 
     * @type {Array<ClientAuctionProductDTO>}
     * @memberof ClientAuctionProductListDTO
     */
    'products': Array<ClientAuctionProductDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductListDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductListDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductListDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionProductListDTO
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface ClientAuctionResponseDTO
 */
export interface ClientAuctionResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionResponseDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'validTo': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'portalShortcut': string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionResponseDTO
     */
    'productCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionResponseDTO
     */
    'supplierCount': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionResponseDTO
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface ClientAuctionSupplierDTO
 */
export interface ClientAuctionSupplierDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionSupplierDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionSupplierDTO
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAuctionSupplierDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierDTO
     */
    'productCount': number;
}
/**
 * 
 * @export
 * @interface ClientAuctionSupplierListDTO
 */
export interface ClientAuctionSupplierListDTO {
    /**
     * 
     * @type {Array<ClientAuctionSupplierDTO>}
     * @memberof ClientAuctionSupplierListDTO
     */
    'suppliers': Array<ClientAuctionSupplierDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierListDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierListDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierListDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionSupplierListDTO
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface ClientBasketItemDTO
 */
export interface ClientBasketItemDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientBasketItemDTO
     */
    'sellUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketItemDTO
     */
    'multiply': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketItemDTO
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {GarancyResponse}
     * @memberof ClientBasketItemDTO
     */
    'garancy'?: GarancyResponse;
    /**
     * 
     * @type {GarancyResponse}
     * @memberof ClientBasketItemDTO
     */
    'newGarancy'?: GarancyResponse;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketItemDTO
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketItemDTO
     */
    'isManualSupplier': boolean;
}


/**
 * 
 * @export
 * @interface ClientBasketResponse
 */
export interface ClientBasketResponse {
    /**
     * 
     * @type {Array<ClientBasketSupplierDTO>}
     * @memberof ClientBasketResponse
     */
    'supplierItems': Array<ClientBasketSupplierDTO>;
    /**
     * 
     * @type {Array<ClientAddressDTO>}
     * @memberof ClientBasketResponse
     */
    'deliveryAddresses': Array<ClientAddressDTO>;
}
/**
 * 
 * @export
 * @interface ClientBasketSavingsAlternativeDTO
 */
export interface ClientBasketSavingsAlternativeDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'unitPriceNet': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'sellUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'vatPercentage': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'priceValidTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {PriceType}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {DeliveryCalendarDay}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'firstDeliveryDate'?: DeliveryCalendarDay;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'isSameProduct': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'isSameSupplier': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'savableNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'savingPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'suggestedQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'multiplyOnly': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'newLineNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsAlternativeDTO
     */
    'lineNetDelta': number;
}


/**
 * 
 * @export
 * @interface ClientBasketSavingsItemDTO
 */
export interface ClientBasketSavingsItemDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'cartItemId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientBasketSavingsItemDTO
     */
    'sellUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'unitPriceNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'lineNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'vatPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'auctionAmount': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientBasketSavingsItemDTO
     */
    'auctionUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSavingsItemDTO
     */
    'priceValidTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsItemDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {PriceType}
     * @memberof ClientBasketSavingsItemDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {DeliveryCalendarDay}
     * @memberof ClientBasketSavingsItemDTO
     */
    'firstDeliveryDate'?: DeliveryCalendarDay;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'savableNet': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientBasketSavingsItemDTO
     */
    'hasBenchmark': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsItemDTO
     */
    'cheaperOptionCount': number;
    /**
     * 
     * @type {ClientBasketSavingsAlternativeDTO}
     * @memberof ClientBasketSavingsItemDTO
     */
    'bestAlternative'?: ClientBasketSavingsAlternativeDTO;
}


/**
 * 
 * @export
 * @interface ClientBasketSavingsResponse
 */
export interface ClientBasketSavingsResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'itemCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'totalNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'bestNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'savableNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'noBenchmarkNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'itemsWithoutBenchmark': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSavingsResponse
     */
    'itemsWithSavings': number;
    /**
     * 
     * @type {Array<ClientBasketSavingsItemDTO>}
     * @memberof ClientBasketSavingsResponse
     */
    'items': Array<ClientBasketSavingsItemDTO>;
}
/**
 * 
 * @export
 * @interface ClientBasketSummaryResponse
 */
export interface ClientBasketSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'itemCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'totalNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'bestNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'savableNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'noBenchmarkNet': number;
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSummaryResponse
     */
    'itemsWithoutBenchmark': number;
}
/**
 * 
 * @export
 * @interface ClientBasketSupplierDTO
 */
export interface ClientBasketSupplierDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketSupplierDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSupplierDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientBasketSupplierDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientBasketSupplierDTO
     */
    'notificationEmails': Array<string>;
    /**
     * 
     * @type {Array<ClientBasketItemDTO>}
     * @memberof ClientBasketSupplierDTO
     */
    'items': Array<ClientBasketItemDTO>;
    /**
     * 
     * @type {SupplierAddressDTO}
     * @memberof ClientBasketSupplierDTO
     */
    'supplierAddress'?: SupplierAddressDTO;
    /**
     * 
     * @type {DeliveryCalendarDay}
     * @memberof ClientBasketSupplierDTO
     */
    'firstDeliveryDate'?: DeliveryCalendarDay;
}
/**
 * 
 * @export
 * @interface ClientCreateScheduledOrderFromOrderRequest
 */
export interface ClientCreateScheduledOrderFromOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'deliveryAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {ClientScheduledOrderRecurrenceRequest}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'recurrence': ClientScheduledOrderRecurrenceRequest;
    /**
     * 
     * @type {boolean}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'requiresApproval': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientCreateScheduledOrderFromOrderRequest
     */
    'notifyBeforeHours': number;
}
/**
 * 
 * @export
 * @interface ClientFavoritesListResponse
 */
export interface ClientFavoritesListResponse {
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof ClientFavoritesListResponse
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof ClientFavoritesListResponse
     */
    'supplierDelivery': Array<SupplierDeliveryWindow>;
}
/**
 * 
 * @export
 * @interface ClientLoVSupplier
 */
export interface ClientLoVSupplier {
    /**
     * 
     * @type {number}
     * @memberof ClientLoVSupplier
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientLoVSupplier
     */
    'supplierName': string;
}
/**
 * 
 * @export
 * @interface ClientManualSupplierListResponse
 */
export interface ClientManualSupplierListResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierListResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientManualSupplierListResponse
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierListResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientManualSupplierListResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientManualSupplierListResponse
     */
    'catalogCode': string;
    /**
     * 
     * @type {string}
     * @memberof ClientManualSupplierListResponse
     */
    'catalogName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierListResponse
     */
    'priceWithoutVat': number;
    /**
     * 
     * @type {string}
     * @memberof ClientManualSupplierListResponse
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface ClientMessageThreadItemResponse
 */
export interface ClientMessageThreadItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientMessageThreadItemResponse
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientMessageThreadItemResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientMessageThreadItemResponse
     */
    'unreadMessagesCount': number;
}
/**
 * 
 * @export
 * @interface ClientMessageThreadListResponse
 */
export interface ClientMessageThreadListResponse {
    /**
     * 
     * @type {Array<ClientMessageThreadItemResponse>}
     * @memberof ClientMessageThreadListResponse
     */
    'threads': Array<ClientMessageThreadItemResponse>;
}
/**
 * 
 * @export
 * @interface ClientNotificationPreferenceRequest
 */
export interface ClientNotificationPreferenceRequest {
    /**
     * 
     * @type {NotificationType}
     * @memberof ClientNotificationPreferenceRequest
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {boolean}
     * @memberof ClientNotificationPreferenceRequest
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface ClientNotificationPreferenceResponse
 */
export interface ClientNotificationPreferenceResponse {
    /**
     * 
     * @type {NotificationType}
     * @memberof ClientNotificationPreferenceResponse
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof ClientNotificationPreferenceResponse
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientNotificationPreferenceResponse
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface ClientOrderDTO
 */
export interface ClientOrderDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientOrderDTO
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {OrderType}
     * @memberof ClientOrderDTO
     */
    'orderType': OrderType;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'readByUserName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'workflowInstanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'workflowDefinitionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDTO
     */
    'scheduledOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDTO
     */
    'scheduledOrderName'?: string;
}


/**
 * 
 * @export
 * @interface ClientOrderDetailDTO
 */
export interface ClientOrderDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDetailDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientOrderDetailDTO
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {OrderType}
     * @memberof ClientOrderDetailDTO
     */
    'orderType': OrderType;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'readByUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {ClientOrderSupplierInfoDTO}
     * @memberof ClientOrderDetailDTO
     */
    'supplier': ClientOrderSupplierInfoDTO;
    /**
     * 
     * @type {OrganizationInfoDTO}
     * @memberof ClientOrderDetailDTO
     */
    'organization': OrganizationInfoDTO;
    /**
     * 
     * @type {Array<OrderItemDTO>}
     * @memberof ClientOrderDetailDTO
     */
    'items': Array<OrderItemDTO>;
    /**
     * 
     * @type {Array<OrderContactDTO>}
     * @memberof ClientOrderDetailDTO
     */
    'contacts': Array<OrderContactDTO>;
    /**
     * 
     * @type {Array<OrderAttachmentDTO>}
     * @memberof ClientOrderDetailDTO
     */
    'attachments': Array<OrderAttachmentDTO>;
    /**
     * 
     * @type {Array<OrderHistoryDTO>}
     * @memberof ClientOrderDetailDTO
     */
    'history': Array<OrderHistoryDTO>;
    /**
     * 
     * @type {OrderTotalsDTO}
     * @memberof ClientOrderDetailDTO
     */
    'totals': OrderTotalsDTO;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDetailDTO
     */
    'workflowInstanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderDetailDTO
     */
    'scheduledOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderDetailDTO
     */
    'scheduledOrderName'?: string;
}


/**
 * 
 * @export
 * @interface ClientOrderListResponseDTO
 */
export interface ClientOrderListResponseDTO {
    /**
     * 
     * @type {Array<ClientOrderDTO>}
     * @memberof ClientOrderListResponseDTO
     */
    'orders': Array<ClientOrderDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderListResponseDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderListResponseDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderListResponseDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientOrderListResponseDTO
     */
    'pageSize': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientOrderListResponseDTO
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientOrderListResponseDTO
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @interface ClientOrderNumberAvailableResponse
 */
export interface ClientOrderNumberAvailableResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ClientOrderNumberAvailableResponse
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface ClientOrderSupplierInfoDTO
 */
export interface ClientOrderSupplierInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'vatPayer'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {AddressDTO}
     * @memberof ClientOrderSupplierInfoDTO
     */
    'marketAddress'?: AddressDTO;
}
/**
 * 
 * @export
 * @interface ClientPriceEvidenceAvailablePriceResponse
 */
export interface ClientPriceEvidenceAvailablePriceResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'productName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'price': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'auctionPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'isMinVd': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePriceResponse
     */
    'validTo': string;
}


/**
 * 
 * @export
 * @interface ClientPriceEvidenceAvailablePricesResponse
 */
export interface ClientPriceEvidenceAvailablePricesResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePricesResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceAvailablePricesResponse
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePricesResponse
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceAvailablePricesResponse
     */
    'date': string;
    /**
     * 
     * @type {Array<ClientPriceEvidenceAvailablePriceResponse>}
     * @memberof ClientPriceEvidenceAvailablePricesResponse
     */
    'prices': Array<ClientPriceEvidenceAvailablePriceResponse>;
}
/**
 * 
 * @export
 * @interface ClientProductAlternativeResponse
 */
export interface ClientProductAlternativeResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientProductAlternativeResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientProductAlternativeResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientProductAlternativeResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientProductAlternativeResponse
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ClientProductAlternativeResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientProductAlternativeResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientProductAlternativeResponse
     */
    'vatPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientProductAlternativeResponse
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ClientProductAlternativeResponse
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientProductAlternativeResponse
     */
    'isCheaperAlternative': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientProductAlternativeResponse
     */
    'isCheapestAlternative': boolean;
}
/**
 * 
 * @export
 * @interface ClientProductDetailResponse
 */
export interface ClientProductDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientProductDetailResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientProductDetailResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientProductDetailResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientProductDetailResponse
     */
    'imagesUrls': Array<string>;
    /**
     * 
     * @type {Array<ClientProductSuppliersResponse>}
     * @memberof ClientProductDetailResponse
     */
    'productSuppliers': Array<ClientProductSuppliersResponse>;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientProductDetailResponse
     */
    'auctionUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientProductDetailResponse
     */
    'auctionAmount': number;
    /**
     * 
     * @type {string}
     * @memberof ClientProductDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientProductDetailResponse
     */
    'isCheaperAlternative': boolean;
    /**
     * 
     * @type {Array<BreadcrumbInfo>}
     * @memberof ClientProductDetailResponse
     */
    'categoryBreadcrumbInfo': Array<BreadcrumbInfo>;
    /**
     * 
     * @type {Array<ClientProductAlternativeResponse>}
     * @memberof ClientProductDetailResponse
     */
    'alternateProducts': Array<ClientProductAlternativeResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ClientProductDetailResponse
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientProductDetailResponse
     */
    'hasSupplierPreference': boolean;
}


/**
 * 
 * @export
 * @interface ClientProductSuppliersResponse
 */
export interface ClientProductSuppliersResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientProductSuppliersResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientProductSuppliersResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientProductSuppliersResponse
     */
    'imagesUrls': Array<string>;
    /**
     * 
     * @type {Array<PriceVariantDTO>}
     * @memberof ClientProductSuppliersResponse
     */
    'priceVariants': Array<PriceVariantDTO>;
    /**
     * 
     * @type {CatalogDataResponse}
     * @memberof ClientProductSuppliersResponse
     */
    'catalogData'?: CatalogDataResponse;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ClientProductSuppliersResponse
     */
    'deliveryDays': Array<DayOfWeek>;
    /**
     * 
     * @type {string}
     * @memberof ClientProductSuppliersResponse
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {SupplierPreference}
     * @memberof ClientProductSuppliersResponse
     */
    'supplierPreference'?: SupplierPreference;
}


/**
 * 
 * @export
 * @interface ClientProductTilesResponse
 */
export interface ClientProductTilesResponse {
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof ClientProductTilesResponse
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof ClientProductTilesResponse
     */
    'supplierDelivery': Array<SupplierDeliveryWindow>;
}
/**
 * 
 * @export
 * @interface ClientRejectScheduledOrderRunRequest
 */
export interface ClientRejectScheduledOrderRunRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientRejectScheduledOrderRunRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface ClientScheduledOrderApproverDTO
 */
export interface ClientScheduledOrderApproverDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderApproverDTO
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderApproverDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderApproverDTO
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ClientScheduledOrderDTO
 */
export interface ClientScheduledOrderDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {ScheduledOrderStatus}
     * @memberof ClientScheduledOrderDTO
     */
    'status': ScheduledOrderStatus;
    /**
     * 
     * @type {ClientScheduledOrderRecurrenceDTO}
     * @memberof ClientScheduledOrderDTO
     */
    'recurrence': ClientScheduledOrderRecurrenceDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClientScheduledOrderDTO
     */
    'requiresApproval': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDTO
     */
    'notifyBeforeHours': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDTO
     */
    'itemsCount': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDTO
     */
    'nextRunAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDTO
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface ClientScheduledOrderDetailDTO
 */
export interface ClientScheduledOrderDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'deliveryAddressId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'createdByUserId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'createdByUserName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'sourceOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'sourceOrderNumber'?: string;
    /**
     * 
     * @type {ScheduledOrderStatus}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'status': ScheduledOrderStatus;
    /**
     * 
     * @type {ClientScheduledOrderRecurrenceDTO}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'recurrence': ClientScheduledOrderRecurrenceDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'requiresApproval': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'notifyBeforeHours': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'nextRunAt'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'upcomingRuns': Array<string>;
    /**
     * 
     * @type {Array<ClientScheduledOrderItemDTO>}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'items': Array<ClientScheduledOrderItemDTO>;
    /**
     * 
     * @type {Array<ClientScheduledOrderRunDTO>}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'recentRuns': Array<ClientScheduledOrderRunDTO>;
    /**
     * 
     * @type {Array<ClientScheduledOrderApproverDTO>}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'approvers': Array<ClientScheduledOrderApproverDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderDetailDTO
     */
    'updated'?: string;
}


/**
 * 
 * @export
 * @interface ClientScheduledOrderItemDTO
 */
export interface ClientScheduledOrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderItemDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderItemDTO
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ClientScheduledOrderListResponseDTO
 */
export interface ClientScheduledOrderListResponseDTO {
    /**
     * 
     * @type {Array<ClientScheduledOrderDTO>}
     * @memberof ClientScheduledOrderListResponseDTO
     */
    'scheduledOrders': Array<ClientScheduledOrderDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderListResponseDTO
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderListResponseDTO
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderListResponseDTO
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface ClientScheduledOrderRecurrenceDTO
 */
export interface ClientScheduledOrderRecurrenceDTO {
    /**
     * 
     * @type {RecurrenceType}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'recurrenceType': RecurrenceType;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'recurrenceInterval': number;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'daysOfWeek': Array<DayOfWeek>;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceDTO
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface ClientScheduledOrderRecurrenceRequest
 */
export interface ClientScheduledOrderRecurrenceRequest {
    /**
     * 
     * @type {RecurrenceType}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'recurrenceType': RecurrenceType;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'recurrenceInterval': number;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'daysOfWeek': Array<DayOfWeek>;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRecurrenceRequest
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface ClientScheduledOrderRunDTO
 */
export interface ClientScheduledOrderRunDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'scheduledOrderId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'scheduledOrderName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientScheduledOrderRunDTO
     */
    'requiresApproval': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'plannedAt': string;
    /**
     * 
     * @type {ScheduledOrderRunStatus}
     * @memberof ClientScheduledOrderRunDTO
     */
    'status': ScheduledOrderRunStatus;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'notifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'decidedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'rejectReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'createdOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'createdOrderNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'previousOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'previousOrderNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'totalWithVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'previousTotalWithVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'priceDifference'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunDTO
     */
    'priceDifferencePercent'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrderRunDTO
     */
    'errorMessage'?: string;
}


/**
 * 
 * @export
 * @interface ClientScheduledOrderRunListResponseDTO
 */
export interface ClientScheduledOrderRunListResponseDTO {
    /**
     * 
     * @type {Array<ClientScheduledOrderRunDTO>}
     * @memberof ClientScheduledOrderRunListResponseDTO
     */
    'runs': Array<ClientScheduledOrderRunDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrderRunListResponseDTO
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface ClientShoppingListAddProductRequest
 */
export interface ClientShoppingListAddProductRequest {
    /**
     * ID produktu
     * @type {number}
     * @memberof ClientShoppingListAddProductRequest
     */
    'productId': number;
}
/**
 * 
 * @export
 * @interface ClientShoppingListDTO
 */
export interface ClientShoppingListDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientShoppingListDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListDTO
     */
    'name': string;
    /**
     * 
     * @type {Array<ClientShoppingListItemResponse>}
     * @memberof ClientShoppingListDTO
     */
    'products': Array<ClientShoppingListItemResponse>;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof ClientShoppingListDTO
     */
    'supplierDelivery': Array<SupplierDeliveryWindow>;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListDTO
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListDTO
     */
    'updatedBy'?: string;
}
/**
 * 
 * @export
 * @interface ClientShoppingListItemResponse
 */
export interface ClientShoppingListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientShoppingListItemResponse
     */
    'shoppingListItemId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListItemResponse
     */
    'shoppingListName': string;
    /**
     * 
     * @type {ProductTileResponse}
     * @memberof ClientShoppingListItemResponse
     */
    'product': ProductTileResponse;
}
/**
 * 
 * @export
 * @interface ClientShoppingListSummaryDTO
 */
export interface ClientShoppingListSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientShoppingListSummaryDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListSummaryDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ClientShoppingListSummaryDTO
     */
    'productCount': number;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListSummaryDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListSummaryDTO
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListSummaryDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientShoppingListSummaryDTO
     */
    'updatedBy'?: string;
}
/**
 * 
 * @export
 * @interface ClientShoppingListSummaryListDTO
 */
export interface ClientShoppingListSummaryListDTO {
    /**
     * 
     * @type {Array<ClientShoppingListSummaryDTO>}
     * @memberof ClientShoppingListSummaryListDTO
     */
    'shoppingLists': Array<ClientShoppingListSummaryDTO>;
}
/**
 * Příjemka jedné provozovny
 * @export
 * @interface ClientStockReceiptItemRequest
 */
export interface ClientStockReceiptItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptItemRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptItemRequest
     */
    'amount': number;
}
/**
 * Příjemky za jeden měsíc
 * @export
 * @interface ClientStockReceiptMonthResponse
 */
export interface ClientStockReceiptMonthResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptMonthResponse
     */
    'period': string;
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptMonthResponse
     */
    'contractGroupName'?: string;
    /**
     * 
     * @type {Array<ClientStockReceiptRowResponse>}
     * @memberof ClientStockReceiptMonthResponse
     */
    'rows': Array<ClientStockReceiptRowResponse>;
}
/**
 * Příjemka jedné provozovny
 * @export
 * @interface ClientStockReceiptRowResponse
 */
export interface ClientStockReceiptRowResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptRowResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptRowResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptRowResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptRowResponse
     */
    'enteredBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptRowResponse
     */
    'enteredAt'?: string;
}
/**
 * Uložení příjemek za měsíc
 * @export
 * @interface ClientStockReceiptSaveRequest
 */
export interface ClientStockReceiptSaveRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptSaveRequest
     */
    'period': string;
    /**
     * 
     * @type {Array<ClientStockReceiptItemRequest>}
     * @memberof ClientStockReceiptSaveRequest
     */
    'items': Array<ClientStockReceiptItemRequest>;
}
/**
 * 
 * @export
 * @interface ClientUnreadArticleResponse
 */
export interface ClientUnreadArticleResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientUnreadArticleResponse
     */
    'articleId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUnreadArticleResponse
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientUnreadArticleResponse
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientUnreadArticleResponse
     */
    'validFrom': string;
}
/**
 * 
 * @export
 * @interface ClientUpcomingDeliveriesResponseDTO
 */
export interface ClientUpcomingDeliveriesResponseDTO {
    /**
     * 
     * @type {Array<ClientUpcomingDeliveryDayDTO>}
     * @memberof ClientUpcomingDeliveriesResponseDTO
     */
    'days': Array<ClientUpcomingDeliveryDayDTO>;
}
/**
 * 
 * @export
 * @interface ClientUpcomingDeliveryDayDTO
 */
export interface ClientUpcomingDeliveryDayDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'deliveryDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'today': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'ordersCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'productCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {Array<ClientUpcomingOrderDTO>}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'orders': Array<ClientUpcomingOrderDTO>;
    /**
     * 
     * @type {Array<ClientUpcomingItemDTO>}
     * @memberof ClientUpcomingDeliveryDayDTO
     */
    'items': Array<ClientUpcomingItemDTO>;
}
/**
 * 
 * @export
 * @interface ClientUpcomingItemDTO
 */
export interface ClientUpcomingItemDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ClientUpcomingItemDTO
     */
    'unit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingItemDTO
     */
    'ordersCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingItemDTO
     */
    'totalWithoutVat': number;
}


/**
 * 
 * @export
 * @interface ClientUpcomingOrderDTO
 */
export interface ClientUpcomingOrderDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingOrderDTO
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientUpcomingOrderDTO
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingOrderDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingOrderDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'itemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUpcomingOrderDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUpcomingOrderDTO
     */
    'readAt'?: string;
}


/**
 * 
 * @export
 * @interface ClientUpdateScheduledOrderRequest
 */
export interface ClientUpdateScheduledOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'deliveryAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {ClientScheduledOrderRecurrenceRequest}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'recurrence': ClientScheduledOrderRecurrenceRequest;
    /**
     * 
     * @type {boolean}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'requiresApproval': boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientUpdateScheduledOrderRequest
     */
    'notifyBeforeHours': number;
}
/**
 * 
 * @export
 * @interface ClientUserDTO
 */
export interface ClientUserDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientUserDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientUserDTO
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'login'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientUserDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUserDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUserDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientUserDTO
     */
    'organizationUserId'?: number;
    /**
     * 
     * @type {Array<ClientUserRoleDTO>}
     * @memberof ClientUserDTO
     */
    'roles': Array<ClientUserRoleDTO>;
    /**
     * 
     * @type {Array<ClientUserSecurityGroupDTO>}
     * @memberof ClientUserDTO
     */
    'securityGroups': Array<ClientUserSecurityGroupDTO>;
}
/**
 * 
 * @export
 * @interface ClientUserListDTO
 */
export interface ClientUserListDTO {
    /**
     * 
     * @type {Array<ClientUserDTO>}
     * @memberof ClientUserListDTO
     */
    'users': Array<ClientUserDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClientUserListDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUserListDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUserListDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ClientUserListDTO
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface ClientUserRoleDTO
 */
export interface ClientUserRoleDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientUserRoleDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUserRoleDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ClientUserSecurityGroupDTO
 */
export interface ClientUserSecurityGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientUserSecurityGroupDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientUserSecurityGroupDTO
     */
    'name': string;
}
/**
 * Typ adresy (např. INVOICE_ADDRESS, DELIVERY_ADDRESS)
 * @export
 * @interface CreateAddressRequestDTO
 */
export interface CreateAddressRequestDTO {
    /**
     * Název adresy
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'name': string;
    /**
     * Název adresy 2
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'name2': string;
    /**
     * Ulice a číslo
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'street': string;
    /**
     * Město
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'city': string;
    /**
     * PSČ
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'zipcode': string;
    /**
     * Země
     * @type {string}
     * @memberof CreateAddressRequestDTO
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface CreateClientAddressRequestDTO
 */
export interface CreateClientAddressRequestDTO {
    /**
     * 
     * @type {CreateAddressRequestDTO}
     * @memberof CreateClientAddressRequestDTO
     */
    'address': CreateAddressRequestDTO;
}
/**
 * 
 * @export
 * @interface CreateClientShoppingListRequestDTO
 */
export interface CreateClientShoppingListRequestDTO {
    /**
     * Název nákupního seznamu
     * @type {string}
     * @memberof CreateClientShoppingListRequestDTO
     */
    'name': string;
    /**
     * Produkty v seznamu
     * @type {Array<CreateShoppingListProductRequestDTO>}
     * @memberof CreateClientShoppingListRequestDTO
     */
    'products': Array<CreateShoppingListProductRequestDTO>;
}
/**
 * 
 * @export
 * @interface CreateClientUserRequestDTO
 */
export interface CreateClientUserRequestDTO {
    /**
     * Email uživatele
     * @type {string}
     * @memberof CreateClientUserRequestDTO
     */
    'email': string;
    /**
     * Jméno uživatele
     * @type {string}
     * @memberof CreateClientUserRequestDTO
     */
    'firstName': string;
    /**
     * Příjmení uživatele
     * @type {string}
     * @memberof CreateClientUserRequestDTO
     */
    'familyName': string;
    /**
     * Login uživatele
     * @type {string}
     * @memberof CreateClientUserRequestDTO
     */
    'login': string;
    /**
     * Telefon uživatele
     * @type {string}
     * @memberof CreateClientUserRequestDTO
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface CreateCustomProductRequest
 */
export interface CreateCustomProductRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomProductRequest
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'categoryId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'vat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof CreateCustomProductRequest
     */
    'unit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomProductRequest
     */
    'multiply': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomProductRequest
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomProductRequest
     */
    'supplierProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomProductRequest
     */
    'supplierProductCode'?: string;
}


/**
 * 
 * @export
 * @interface CreateDeliveryContactRequestDTO
 */
export interface CreateDeliveryContactRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryContactRequestDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryContactRequestDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryContactRequestDTO
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface CreateDeliveryDayRequestDTO
 */
export interface CreateDeliveryDayRequestDTO {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CreateDeliveryDayRequestDTO
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryDayRequestDTO
     */
    'orderLimit': number;
}


/**
 * 
 * @export
 * @interface CreateDeliveryWindowRequestDTO
 */
export interface CreateDeliveryWindowRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<CreateDeliveryDayRequestDTO>}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'deliveryDays': Array<CreateDeliveryDayRequestDTO>;
    /**
     * 
     * @type {Array<CreateDeliveryContactRequestDTO>}
     * @memberof CreateDeliveryWindowRequestDTO
     */
    'contacts': Array<CreateDeliveryContactRequestDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CreateOrderOrderStatus = {
    Sent: 'SENT',
    SentForApproval: 'SENT_FOR_APPROVAL',
    Error: 'ERROR'
} as const;

export type CreateOrderOrderStatus = typeof CreateOrderOrderStatus[keyof typeof CreateOrderOrderStatus];


/**
 * 
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * 
     * @type {Array<CreateOrderSupplierOrderRequest>}
     * @memberof CreateOrderRequest
     */
    'supplierOrders': Array<CreateOrderSupplierOrderRequest>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'submissionId'?: string;
}
/**
 * 
 * @export
 * @interface CreateOrderResponse
 */
export interface CreateOrderResponse {
    /**
     * 
     * @type {Array<SupplierOrderResult>}
     * @memberof CreateOrderResponse
     */
    'orders': Array<SupplierOrderResult>;
}
/**
 * 
 * @export
 * @interface CreateOrderSupplierOrderItem
 */
export interface CreateOrderSupplierOrderItem {
    /**
     * 
     * @type {number}
     * @memberof CreateOrderSupplierOrderItem
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderSupplierOrderItem
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderSupplierOrderItem
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface CreateOrderSupplierOrderRequest
 */
export interface CreateOrderSupplierOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {Array<CreateOrderSupplierOrderItem>}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'items': Array<CreateOrderSupplierOrderItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'attachmentUuids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'selectedDeliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'internalNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'deliveryAddressId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'skipCartRemoval': boolean;
    /**
     * 
     * @type {OrderType}
     * @memberof CreateOrderSupplierOrderRequest
     */
    'orderType': OrderType;
}


/**
 * Produkty v seznamu
 * @export
 * @interface CreateShoppingListProductRequestDTO
 */
export interface CreateShoppingListProductRequestDTO {
    /**
     * ID produktu
     * @type {number}
     * @memberof CreateShoppingListProductRequestDTO
     */
    'productId': number;
    /**
     * Množství
     * @type {number}
     * @memberof CreateShoppingListProductRequestDTO
     */
    'quantity': number;
    /**
     * Poznámky k produktu
     * @type {string}
     * @memberof CreateShoppingListProductRequestDTO
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface CustomProductDetailResponse
 */
export interface CustomProductDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'productCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'supplierProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'supplierProductCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'vat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof CustomProductDetailResponse
     */
    'unit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomProductDetailResponse
     */
    'multiply': boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductDetailResponse
     */
    'auctionPrice': number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomProductDetailResponse
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductDetailResponse
     */
    'updated'?: string;
}


/**
 * 
 * @export
 * @interface CustomProductImageUploadRequest
 */
export interface CustomProductImageUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomProductImageUploadRequest
     */
    'base64Data': string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImageUploadRequest
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomProductImageUploadRequest
     */
    'isPrimary': boolean;
}
/**
 * 
 * @export
 * @interface CustomProductImageUploadResponse
 */
export interface CustomProductImageUploadResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductImageUploadResponse
     */
    'physicalImageId': number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImageUploadResponse
     */
    's3Key': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CustomProductImportDuplicateMode = {
    Skip: 'SKIP',
    Update: 'UPDATE',
    CreateNew: 'CREATE_NEW'
} as const;

export type CustomProductImportDuplicateMode = typeof CustomProductImportDuplicateMode[keyof typeof CustomProductImportDuplicateMode];


/**
 * 
 * @export
 * @interface CustomProductImportPreviewResponse
 */
export interface CustomProductImportPreviewResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportPreviewResponse
     */
    'totalRows': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportPreviewResponse
     */
    'newCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportPreviewResponse
     */
    'updateCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportPreviewResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportPreviewResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<CustomProductImportRowPreview>}
     * @memberof CustomProductImportPreviewResponse
     */
    'rows': Array<CustomProductImportRowPreview>;
}
/**
 * 
 * @export
 * @interface CustomProductImportResultResponse
 */
export interface CustomProductImportResultResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportResultResponse
     */
    'createdCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportResultResponse
     */
    'updatedCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportResultResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportResultResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<CustomProductImportRowPreview>}
     * @memberof CustomProductImportResultResponse
     */
    'errors': Array<CustomProductImportRowPreview>;
    /**
     * 
     * @type {Array<CustomProductImportRowPreview>}
     * @memberof CustomProductImportResultResponse
     */
    'warnings': Array<CustomProductImportRowPreview>;
}
/**
 * 
 * @export
 * @interface CustomProductImportRowPreview
 */
export interface CustomProductImportRowPreview {
    /**
     * 
     * @type {number}
     * @memberof CustomProductImportRowPreview
     */
    'rowNumber': number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImportRowPreview
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImportRowPreview
     */
    'name'?: string;
    /**
     * 
     * @type {CustomProductImportRowStatus}
     * @memberof CustomProductImportRowPreview
     */
    'status': CustomProductImportRowStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomProductImportRowPreview
     */
    'messages': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImportRowPreview
     */
    'resolvedCategoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductImportRowPreview
     */
    'resolvedSupplierName'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomProductImportRowStatus = {
    New: 'NEW',
    Update: 'UPDATE',
    Skipped: 'SKIPPED',
    Error: 'ERROR'
} as const;

export type CustomProductImportRowStatus = typeof CustomProductImportRowStatus[keyof typeof CustomProductImportRowStatus];


/**
 * 
 * @export
 * @interface CustomProductListResponse
 */
export interface CustomProductListResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'supplierProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'supplierProductCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomProductListResponse
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {UnitType}
     * @memberof CustomProductListResponse
     */
    'unit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof CustomProductListResponse
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomProductListResponse
     */
    'multiply': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomProductListResponse
     */
    'created': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


/**
 * 
 * @export
 * @interface DeliveryCalendarDay
 */
export interface DeliveryCalendarDay {
    /**
     * 
     * @type {string}
     * @memberof DeliveryCalendarDay
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryCalendarDay
     */
    'limit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryCalendarDay
     */
    'blocked': boolean;
}
/**
 * 
 * @export
 * @interface DeliveryCalendarResponse
 */
export interface DeliveryCalendarResponse {
    /**
     * 
     * @type {Array<DeliveryCalendarDay>}
     * @memberof DeliveryCalendarResponse
     */
    'dates': Array<DeliveryCalendarDay>;
}
/**
 * 
 * @export
 * @interface DeliveryContactDTO
 */
export interface DeliveryContactDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryContactDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryContactDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryContactDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryContactDTO
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface DeliveryDayDTO
 */
export interface DeliveryDayDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryDayDTO
     */
    'id'?: number;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof DeliveryDayDTO
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof DeliveryDayDTO
     */
    'orderLimit': number;
}


/**
 * 
 * @export
 * @interface DeliveryExportRequestDTO
 */
export interface DeliveryExportRequestDTO {
    /**
     * ID organizace (zákazníka)
     * @type {number}
     * @memberof DeliveryExportRequestDTO
     */
    'organizationId': number;
    /**
     * ID portálu
     * @type {number}
     * @memberof DeliveryExportRequestDTO
     */
    'portalId': number;
}
/**
 * 
 * @export
 * @interface DeliveryExportResponseDTO
 */
export interface DeliveryExportResponseDTO {
    /**
     * Název vygenerovaného souboru
     * @type {string}
     * @memberof DeliveryExportResponseDTO
     */
    'fileName': string;
    /**
     * Počet exportovaných záznamů
     * @type {number}
     * @memberof DeliveryExportResponseDTO
     */
    'recordCount': number;
    /**
     * Čas exportu
     * @type {string}
     * @memberof DeliveryExportResponseDTO
     */
    'exportedAt': string;
    /**
     * Velikost souboru v bytech
     * @type {number}
     * @memberof DeliveryExportResponseDTO
     */
    'fileSizeBytes': number;
}
/**
 * 
 * @export
 * @interface DeliveryImportResponseDTO
 */
export interface DeliveryImportResponseDTO {
    /**
     * UUID úkolu pro sledování progress
     * @type {string}
     * @memberof DeliveryImportResponseDTO
     */
    'taskId': string;
    /**
     * Počet úspěšně importovaných záznamů
     * @type {number}
     * @memberof DeliveryImportResponseDTO
     */
    'importedCount': number;
    /**
     * Počet chybných záznamů
     * @type {number}
     * @memberof DeliveryImportResponseDTO
     */
    'errorCount': number;
    /**
     * Seznam chyb při importu
     * @type {Array<ImportErrorDTO>}
     * @memberof DeliveryImportResponseDTO
     */
    'errors': Array<ImportErrorDTO>;
    /**
     * Čas spuštění importu
     * @type {string}
     * @memberof DeliveryImportResponseDTO
     */
    'startedAt': string;
    /**
     * Stav importu
     * @type {string}
     * @memberof DeliveryImportResponseDTO
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface DeliveryWindowDTO
 */
export interface DeliveryWindowDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDTO
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {Array<DeliveryDayDTO>}
     * @memberof DeliveryWindowDTO
     */
    'deliveryDays': Array<DeliveryDayDTO>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDTO
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowDTO
     */
    'contactCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryWindowDTO
     */
    'hasContacts': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryWindowDTO
     */
    'isConfigured': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDTO
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryWindowDetailDTO
 */
export interface DeliveryWindowDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowDetailDTO
     */
    'id'?: number;
    /**
     * 
     * @type {SupplierInfoDTO}
     * @memberof DeliveryWindowDetailDTO
     */
    'supplier': SupplierInfoDTO;
    /**
     * 
     * @type {Array<DeliveryDayDTO>}
     * @memberof DeliveryWindowDetailDTO
     */
    'deliveryDays': Array<DeliveryDayDTO>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDetailDTO
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<DeliveryContactDTO>}
     * @memberof DeliveryWindowDetailDTO
     */
    'contacts': Array<DeliveryContactDTO>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDetailDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDetailDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindowDetailDTO
     */
    'customerNumber'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryWindowPageDTO
 */
export interface DeliveryWindowPageDTO {
    /**
     * 
     * @type {Array<DeliveryWindowDTO>}
     * @memberof DeliveryWindowPageDTO
     */
    'deliveryWindows': Array<DeliveryWindowDTO>;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowPageDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowPageDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowPageDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryWindowPageDTO
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryWindowPageDTO
     */
    'hasPrevious': boolean;
}
/**
 * 
 * @export
 * @interface DeliveryWindowStatisticsDTO
 */
export interface DeliveryWindowStatisticsDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowStatisticsDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowStatisticsDTO
     */
    'portalId': number;
    /**
     * 
     * @type {StatisticsDTO}
     * @memberof DeliveryWindowStatisticsDTO
     */
    'statistics': StatisticsDTO;
    /**
     * 
     * @type {Array<SupplierWithoutDeliveryDTO>}
     * @memberof DeliveryWindowStatisticsDTO
     */
    'suppliersWithoutDeliveryWindows': Array<SupplierWithoutDeliveryDTO>;
}
/**
 * 
 * @export
 * @interface DirectEmailSendRequest
 */
export interface DirectEmailSendRequest {
    /**
     * 
     * @type {string}
     * @memberof DirectEmailSendRequest
     */
    'recipientEmail': string;
    /**
     * 
     * @type {string}
     * @memberof DirectEmailSendRequest
     */
    'recipientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectEmailSendRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof DirectEmailSendRequest
     */
    'bodyHtml': string;
    /**
     * 
     * @type {number}
     * @memberof DirectEmailSendRequest
     */
    'organizationId'?: number;
}
/**
 * 
 * @export
 * @interface DirectEmailSendResponse
 */
export interface DirectEmailSendResponse {
    /**
     * 
     * @type {string}
     * @memberof DirectEmailSendResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface GarancyResponse
 */
export interface GarancyResponse {
    /**
     * 
     * @type {string}
     * @memberof GarancyResponse
     */
    'garancyFrom': string;
    /**
     * 
     * @type {string}
     * @memberof GarancyResponse
     */
    'garancyTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof GarancyResponse
     */
    'isValid': boolean;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'price'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof GarancyResponse
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {PriceType}
     * @memberof GarancyResponse
     */
    'priceType': PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof GarancyResponse
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'auctionAmount': number;
    /**
     * 
     * @type {UnitType}
     * @memberof GarancyResponse
     */
    'auctionUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof GarancyResponse
     */
    'packageItemUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof GarancyResponse
     */
    'auctionId'?: number;
}


/**
 * Seznam chyb při importu
 * @export
 * @interface ImportErrorDTO
 */
export interface ImportErrorDTO {
    /**
     * Řádek s chybou
     * @type {number}
     * @memberof ImportErrorDTO
     */
    'row': number;
    /**
     * Popis chyby
     * @type {string}
     * @memberof ImportErrorDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface IndexedCategoryDTO
 */
export interface IndexedCategoryDTO {
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'buyerId': number;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'parentEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'auctionAmount'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof IndexedCategoryDTO
     */
    'auctionUnit'?: UnitType;
}


/**
 * 
 * @export
 * @interface IndexedSupplierESDTO
 */
export interface IndexedSupplierESDTO {
    /**
     * 
     * @type {string}
     * @memberof IndexedSupplierESDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'buyerId': number;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'portalId': number;
}
/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'nano'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationType = {
    OrderCreatedSupplier: 'ORDER_CREATED_SUPPLIER',
    OrderCreatedClient: 'ORDER_CREATED_CLIENT',
    OrderStatusChangeSupplier: 'ORDER_STATUS_CHANGE_SUPPLIER',
    OrderStatusChangeClient: 'ORDER_STATUS_CHANGE_CLIENT',
    OrderPendingApproval: 'ORDER_PENDING_APPROVAL',
    OrderApproved: 'ORDER_APPROVED',
    OrderRejectedByApprover: 'ORDER_REJECTED_BY_APPROVER',
    OrderNewMessage: 'ORDER_NEW_MESSAGE',
    ScheduledOrderPending: 'SCHEDULED_ORDER_PENDING',
    PasswordReset: 'PASSWORD_RESET',
    DirectEmail: 'DIRECT_EMAIL'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * 
 * @export
 * @interface OrderActionResponse
 */
export interface OrderActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OrderActionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderActionResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof OrderActionResponse
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderActionResponse
     */
    'newStatus'?: OrderStatus;
}


/**
 * 
 * @export
 * @interface OrderAttachmentDTO
 */
export interface OrderAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentDTO
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAttachmentDTO
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentDTO
     */
    'mimeType': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentDTO
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface OrderContactDTO
 */
export interface OrderContactDTO {
    /**
     * 
     * @type {number}
     * @memberof OrderContactDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OrderContactDTO
     */
    'type': OrderContactDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderContactDTO
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderContactDTO
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderContactDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrderContactDTO
     */
    'phone'?: string;
}

export const OrderContactDTOTypeEnum = {
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type OrderContactDTOTypeEnum = typeof OrderContactDTOTypeEnum[keyof typeof OrderContactDTOTypeEnum];

/**
 * 
 * @export
 * @interface OrderError
 */
export interface OrderError {
    /**
     * 
     * @type {string}
     * @memberof OrderError
     */
    'type': OrderErrorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderError
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderError
     */
    'auctionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderError
     */
    'maxAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderError
     */
    'remainingAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderError
     */
    'requestedAmount'?: number;
}

export const OrderErrorTypeEnum = {
    DeadlineExceeded: 'DEADLINE_EXCEEDED',
    ProductNotAvailable: 'PRODUCT_NOT_AVAILABLE',
    PriceChanged: 'PRICE_CHANGED',
    DuplicateOrderNumber: 'DUPLICATE_ORDER_NUMBER',
    AuctionLimitExceeded: 'AUCTION_LIMIT_EXCEEDED'
} as const;

export type OrderErrorTypeEnum = typeof OrderErrorTypeEnum[keyof typeof OrderErrorTypeEnum];

/**
 * 
 * @export
 * @interface OrderExportResponse
 */
export interface OrderExportResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderExportResponse
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof OrderExportResponse
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof OrderExportResponse
     */
    'data': string;
    /**
     * 
     * @type {number}
     * @memberof OrderExportResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface OrderHistoryDTO
 */
export interface OrderHistoryDTO {
    /**
     * 
     * @type {number}
     * @memberof OrderHistoryDTO
     */
    'id': number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderHistoryDTO
     */
    'status': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryDTO
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryDTO
     */
    'changedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryDTO
     */
    'actorLabel'?: string;
}


/**
 * 
 * @export
 * @interface OrderItemDTO
 */
export interface OrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof OrderItemDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof OrderItemDTO
     */
    'productAuctionUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'catalogName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDTO
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemDTO
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof OrderItemDTO
     */
    'priceTypeCode': PriceTypeCode;
}


/**
 * 
 * @export
 * @interface OrderMessageResponse
 */
export interface OrderMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderMessageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OrderMessageResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof OrderMessageResponse
     */
    'authorName': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderMessageResponse
     */
    'mySide': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderMessageResponse
     */
    'timestamp': string;
}
/**
 * 
 * @export
 * @interface OrderMessagesResponse
 */
export interface OrderMessagesResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderMessagesResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {Array<OrderMessageResponse>}
     * @memberof OrderMessagesResponse
     */
    'messages': Array<OrderMessageResponse>;
}
/**
 * 
 * @export
 * @interface OrderPdfResponse
 */
export interface OrderPdfResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderPdfResponse
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPdfResponse
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPdfResponse
     */
    'data': string;
    /**
     * 
     * @type {number}
     * @memberof OrderPdfResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    New: 'NEW',
    WaitingForApproval1: 'WAITING_FOR_APPROVAL1',
    WaitingForApproval2: 'WAITING_FOR_APPROVAL2',
    RejectedByApprover1: 'REJECTED_BY_APPROVER1',
    RejectedByApprover2: 'REJECTED_BY_APPROVER2',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    AcceptedBySupplier: 'ACCEPTED_BY_SUPPLIER',
    Storno: 'STORNO',
    Completed: 'COMPLETED'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * 
 * @export
 * @interface OrderTotalsDTO
 */
export interface OrderTotalsDTO {
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDTO
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDTO
     */
    'totalVat': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrderType = {
    RegularOrder: 'REGULAR_ORDER',
    BlindOrder: 'BLIND_ORDER',
    Requisition: 'REQUISITION'
} as const;

export type OrderType = typeof OrderType[keyof typeof OrderType];


/**
 * 
 * @export
 * @interface OrganizationInfoDTO
 */
export interface OrganizationInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof OrganizationInfoDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationInfoDTO
     */
    'vatPayer'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInfoDTO
     */
    'contractGroupName'?: string;
    /**
     * 
     * @type {AddressDTO}
     * @memberof OrganizationInfoDTO
     */
    'deliveryAddress': AddressDTO;
}
/**
 * 
 * @export
 * @interface PageResultClientArticleListResponse
 */
export interface PageResultClientArticleListResponse {
    /**
     * 
     * @type {Array<ClientArticleListResponse>}
     * @memberof PageResultClientArticleListResponse
     */
    'items': Array<ClientArticleListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultClientArticleListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultClientArticleListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultClientArticleListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultClientArticleListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultClientArticleListResponse
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultClientArticleListResponse
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @interface PageResultSupplierOrderListResponse
 */
export interface PageResultSupplierOrderListResponse {
    /**
     * 
     * @type {Array<SupplierOrderListResponse>}
     * @memberof PageResultSupplierOrderListResponse
     */
    'items': Array<SupplierOrderListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierOrderListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierOrderListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierOrderListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierOrderListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierOrderListResponse
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierOrderListResponse
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @interface PageResultSupplierPriceListResponse
 */
export interface PageResultSupplierPriceListResponse {
    /**
     * 
     * @type {Array<SupplierPriceListResponse>}
     * @memberof PageResultSupplierPriceListResponse
     */
    'items': Array<SupplierPriceListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierPriceListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierPriceListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierPriceListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierPriceListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierPriceListResponse
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierPriceListResponse
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @interface PageResultSupplierProductPriceResponse
 */
export interface PageResultSupplierProductPriceResponse {
    /**
     * 
     * @type {Array<SupplierProductPriceResponse>}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'items': Array<SupplierProductPriceResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierProductPriceResponse
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @interface PageResultSupplierProductResponse
 */
export interface PageResultSupplierProductResponse {
    /**
     * 
     * @type {Array<SupplierProductResponse>}
     * @memberof PageResultSupplierProductResponse
     */
    'items': Array<SupplierProductResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultSupplierProductResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierProductResponse
     */
    'hasNext': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultSupplierProductResponse
     */
    'hasPrev': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PreferredDeliveryMode = {
    NoEarlierThan: 'NO_EARLIER_THAN',
    NoLaterThan: 'NO_LATER_THAN'
} as const;

export type PreferredDeliveryMode = typeof PreferredDeliveryMode[keyof typeof PreferredDeliveryMode];


/**
 * 
 * @export
 * @interface PreferredDeliveryResponse
 */
export interface PreferredDeliveryResponse {
    /**
     * 
     * @type {string}
     * @memberof PreferredDeliveryResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {PreferredDeliveryMode}
     * @memberof PreferredDeliveryResponse
     */
    'mode': PreferredDeliveryMode;
}


/**
 * 
 * @export
 * @interface PriceAuctionDTO
 */
export interface PriceAuctionDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceAuctionDTO
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof PriceAuctionDTO
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof PriceAuctionDTO
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof PriceAuctionDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PriceAuctionDTO
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface PriceCustomerDTO
 */
export interface PriceCustomerDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceCustomerDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof PriceCustomerDTO
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PriceType = {
    Standard: 'STANDARD',
    ActionPrice: 'ACTION_PRICE',
    SubstitutePrice: 'SUBSTITUTE_PRICE',
    FromDlPrice: 'FROM_DL_PRICE'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceTypeCode = {
    Gc: 'GC',
    Nc: 'NC',
    Ac: 'AC',
    Np: 'NP',
    Vp: 'VP',
    Dl: 'DL'
} as const;

export type PriceTypeCode = typeof PriceTypeCode[keyof typeof PriceTypeCode];


/**
 * 
 * @export
 * @interface PriceVariantDTO
 */
export interface PriceVariantDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {PriceType}
     * @memberof PriceVariantDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof PriceVariantDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof PriceVariantDTO
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof PriceVariantDTO
     */
    'basicUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof PriceVariantDTO
     */
    'packageItemUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'currentPrice': number;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'validTo': string;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'vatPercentage': number;
    /**
     * 
     * @type {boolean}
     * @memberof PriceVariantDTO
     */
    'isManual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceVariantDTO
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {number}
     * @memberof PriceVariantDTO
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PriceVariantDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof PriceVariantDTO
     */
    'priceTypeCode': PriceTypeCode;
}


/**
 * 
 * @export
 * @interface ProductTileResponse
 */
export interface ProductTileResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productCategory': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'categoryId': number;
    /**
     * 
     * @type {Array<BreadcrumbInfo>}
     * @memberof ProductTileResponse
     */
    'categoryBreadcrumbInfo': Array<BreadcrumbInfo>;
    /**
     * 
     * @type {Array<ProductTileResponseSupplier>}
     * @memberof ProductTileResponse
     */
    'suppliers': Array<ProductTileResponseSupplier>;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'buyerId': number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'portalId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTileResponse
     */
    'images': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'alternativesCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasCheapestVariant': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasValidPrice': boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof ProductTileResponse
     */
    'sortValues'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'customProductCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasSupplierPreference': boolean;
}
/**
 * 
 * @export
 * @interface ProductTileResponseSupplier
 */
export interface ProductTileResponseSupplier {
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'onlyMultiply': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'priceVariantId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'basicPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'basicUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'auctionPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'auctionUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'auctionAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'packageItemUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'price': number;
    /**
     * 
     * @type {PriceType}
     * @memberof ProductTileResponseSupplier
     */
    'priceType': PriceType;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'validPriceFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'validPriceTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'isManual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {SupplierPreference}
     * @memberof ProductTileResponseSupplier
     */
    'supplierPreference'?: SupplierPreference;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof ProductTileResponseSupplier
     */
    'priceTypeCode': PriceTypeCode;
}


/**
 * 
 * @export
 * @interface QuickActionAddressInfo
 */
export interface QuickActionAddressInfo {
    /**
     * 
     * @type {string}
     * @memberof QuickActionAddressInfo
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionAddressInfo
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionAddressInfo
     */
    'zip': string;
}
/**
 * 
 * @export
 * @interface QuickActionAttachment
 */
export interface QuickActionAttachment {
    /**
     * 
     * @type {number}
     * @memberof QuickActionAttachment
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionAttachment
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof QuickActionAttachment
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionAttachment
     */
    'fileType': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionAttachment
     */
    'downloadUrl': string;
}
/**
 * 
 * @export
 * @interface QuickActionCustomerInfo
 */
export interface QuickActionCustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionCustomerInfo
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface QuickActionOrderItem
 */
export interface QuickActionOrderItem {
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderItem
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderItem
     */
    'productCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderItem
     */
    'unit': string;
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderItem
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderItem
     */
    'totalPrice': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderItem
     */
    'imageUrl'?: string;
}
/**
 * 
 * @export
 * @interface QuickActionOrderPdfResponse
 */
export interface QuickActionOrderPdfResponse {
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderPdfResponse
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderPdfResponse
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderPdfResponse
     */
    'data': string;
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderPdfResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface QuickActionOrderResponse
 */
export interface QuickActionOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof QuickActionOrderResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof QuickActionOrderResponse
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'note'?: string;
    /**
     * 
     * @type {QuickActionCustomerInfo}
     * @memberof QuickActionOrderResponse
     */
    'customer': QuickActionCustomerInfo;
    /**
     * 
     * @type {QuickActionAddressInfo}
     * @memberof QuickActionOrderResponse
     */
    'deliveryAddress'?: QuickActionAddressInfo;
    /**
     * 
     * @type {Array<QuickActionOrderItem>}
     * @memberof QuickActionOrderResponse
     */
    'items': Array<QuickActionOrderItem>;
    /**
     * 
     * @type {Array<QuickActionAttachment>}
     * @memberof QuickActionOrderResponse
     */
    'attachments': Array<QuickActionAttachment>;
    /**
     * 
     * @type {QuickActionTotals}
     * @memberof QuickActionOrderResponse
     */
    'totals': QuickActionTotals;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof QuickActionOrderResponse
     */
    'portalName': string;
}


/**
 * 
 * @export
 * @interface QuickActionRejectRequest
 */
export interface QuickActionRejectRequest {
    /**
     * 
     * @type {string}
     * @memberof QuickActionRejectRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface QuickActionResultResponse
 */
export interface QuickActionResultResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuickActionResultResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuickActionResultResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface QuickActionTotals
 */
export interface QuickActionTotals {
    /**
     * 
     * @type {number}
     * @memberof QuickActionTotals
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuickActionTotals
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof QuickActionTotals
     */
    'totalVat': number;
    /**
     * 
     * @type {number}
     * @memberof QuickActionTotals
     */
    'totalWithVat': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecurrenceType = {
    Once: 'ONCE',
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;

export type RecurrenceType = typeof RecurrenceType[keyof typeof RecurrenceType];


/**
 * 
 * @export
 * @interface RejectOrderRequest
 */
export interface RejectOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectOrderRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface RemainingCartItems
 */
export interface RemainingCartItems {
    /**
     * 
     * @type {number}
     * @memberof RemainingCartItems
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof RemainingCartItems
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RepeatOrderRequest
 */
export interface RepeatOrderRequest {
    /**
     * 
     * @type {boolean}
     * @memberof RepeatOrderRequest
     */
    'clearSupplierCart'?: boolean;
}
/**
 * 
 * @export
 * @interface RepeatOrderResponse
 */
export interface RepeatOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RepeatOrderResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof RepeatOrderResponse
     */
    'addedItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof RepeatOrderResponse
     */
    'skippedItemsCount': number;
    /**
     * 
     * @type {Array<SkippedItemDTO>}
     * @memberof RepeatOrderResponse
     */
    'skippedItems': Array<SkippedItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof RepeatOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof RepeatOrderResponse
     */
    'requiresDecision': boolean;
}
/**
 * 
 * @export
 * @interface ReplaceBasketItemRequest
 */
export interface ReplaceBasketItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ReplaceBasketItemRequest
     */
    'cartItemId': number;
    /**
     * 
     * @type {number}
     * @memberof ReplaceBasketItemRequest
     */
    'newProductId': number;
    /**
     * 
     * @type {number}
     * @memberof ReplaceBasketItemRequest
     */
    'newPriceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof ReplaceBasketItemRequest
     */
    'newSupplierId': number;
    /**
     * 
     * @type {number}
     * @memberof ReplaceBasketItemRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface ScheduledOrderActionDetailResponse
 */
export interface ScheduledOrderActionDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'runId': number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'scheduledOrderId': number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'scheduledOrderName': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'plannedAt': string;
    /**
     * 
     * @type {ScheduledOrderRunStatus}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'status': ScheduledOrderRunStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'decidable': boolean;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'totalWithVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'previousTotalWithVat'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'previousOrderNumber'?: string;
    /**
     * 
     * @type {Array<ScheduledOrderActionItemResponse>}
     * @memberof ScheduledOrderActionDetailResponse
     */
    'items': Array<ScheduledOrderActionItemResponse>;
}


/**
 * 
 * @export
 * @interface ScheduledOrderActionItemResponse
 */
export interface ScheduledOrderActionItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionItemResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionItemResponse
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionItemResponse
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionItemResponse
     */
    'unitPriceWithVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledOrderActionItemResponse
     */
    'previousUnitPriceWithVat'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledOrderActionItemResponse
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface ScheduledOrderActionResultResponse
 */
export interface ScheduledOrderActionResultResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledOrderActionResultResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionResultResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ScheduledOrderRunStatus = {
    Planned: 'PLANNED',
    AwaitingApproval: 'AWAITING_APPROVAL',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    OrderCreated: 'ORDER_CREATED',
    Failed: 'FAILED',
    Skipped: 'SKIPPED'
} as const;

export type ScheduledOrderRunStatus = typeof ScheduledOrderRunStatus[keyof typeof ScheduledOrderRunStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ScheduledOrderStatus = {
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Finished: 'FINISHED'
} as const;

export type ScheduledOrderStatus = typeof ScheduledOrderStatus[keyof typeof ScheduledOrderStatus];


/**
 * 
 * @export
 * @interface SendMessageRequest
 */
export interface SendMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendMessageRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SetPreferredDeliveryRequest
 */
export interface SetPreferredDeliveryRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPreferredDeliveryRequest
     */
    'preferredDate': string;
    /**
     * 
     * @type {PreferredDeliveryMode}
     * @memberof SetPreferredDeliveryRequest
     */
    'mode': PreferredDeliveryMode;
}


/**
 * 
 * @export
 * @interface SetQuantityRequest
 */
export interface SetQuantityRequest {
    /**
     * 
     * @type {number}
     * @memberof SetQuantityRequest
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof SetQuantityRequest
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof SetQuantityRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof SetQuantityRequest
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof SetQuantityRequest
     */
    'deliveryDate'?: string;
}
/**
 * 
 * @export
 * @interface SetSupplierPreferenceRequest
 */
export interface SetSupplierPreferenceRequest {
    /**
     * 
     * @type {SupplierPreference}
     * @memberof SetSupplierPreferenceRequest
     */
    'preference'?: SupplierPreference;
}


/**
 * 
 * @export
 * @interface SkippedItemDTO
 */
export interface SkippedItemDTO {
    /**
     * 
     * @type {number}
     * @memberof SkippedItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof SkippedItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof SkippedItemDTO
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface StatisticsDTO
 */
export interface StatisticsDTO {
    /**
     * 
     * @type {number}
     * @memberof StatisticsDTO
     */
    'totalSuppliersWithProducts': number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsDTO
     */
    'suppliersWithDeliveryWindows': number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsDTO
     */
    'suppliersWithoutDeliveryWindows': number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsDTO
     */
    'totalDeliveryWindows': number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsDTO
     */
    'coveragePercentage': number;
}
/**
 * 
 * @export
 * @interface SubcategoryInfo
 */
export interface SubcategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof SubcategoryInfo
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubcategoryInfo
     */
    'productCount': number;
}
/**
 * 
 * @export
 * @interface SupplierAddressDTO
 */
export interface SupplierAddressDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierAddressDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddressDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddressDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddressDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddressDTO
     */
    'zipcode': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddressDTO
     */
    'countryCode': string;
}
/**
 * 
 * @export
 * @interface SupplierAggregation
 */
export interface SupplierAggregation {
    /**
     * 
     * @type {number}
     * @memberof SupplierAggregation
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierAggregation
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierAggregation
     */
    'productCount': number;
}
/**
 * 
 * @export
 * @interface SupplierContact
 */
export interface SupplierContact {
    /**
     * 
     * @type {string}
     * @memberof SupplierContact
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierContact
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierContact
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryContact
 */
export interface SupplierDeliveryContact {
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryContact
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryContact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryContact
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryDayLimit
 */
export interface SupplierDeliveryDayLimit {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof SupplierDeliveryDayLimit
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryDayLimit
     */
    'limit'?: number;
}


/**
 * 
 * @export
 * @interface SupplierDeliveryDayLimitUpdate
 */
export interface SupplierDeliveryDayLimitUpdate {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof SupplierDeliveryDayLimitUpdate
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryDayLimitUpdate
     */
    'limit'?: number;
}


/**
 * 
 * @export
 * @interface SupplierDeliveryWindow
 */
export interface SupplierDeliveryWindow {
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindow
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindow
     */
    'deliveryWindow'?: string;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryWindowCustomer
 */
export interface SupplierDeliveryWindowCustomer {
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {Array<SupplierDeliveryDayLimit>}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'dayLimits': Array<SupplierDeliveryDayLimit>;
    /**
     * 
     * @type {Array<SupplierDeliveryContact>}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'contacts': Array<SupplierDeliveryContact>;
    /**
     * 
     * @type {LocalTime}
     * @memberof SupplierDeliveryWindowCustomer
     */
    'deliveryTime'?: LocalTime;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryWindowListResponse
 */
export interface SupplierDeliveryWindowListResponse {
    /**
     * 
     * @type {Array<SupplierDeliveryWindowCustomer>}
     * @memberof SupplierDeliveryWindowListResponse
     */
    'customers': Array<SupplierDeliveryWindowCustomer>;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryWindowUpdateRequest
 */
export interface SupplierDeliveryWindowUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindowUpdateRequest
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {LocalTime}
     * @memberof SupplierDeliveryWindowUpdateRequest
     */
    'deliveryTime'?: LocalTime;
    /**
     * 
     * @type {Array<SupplierDeliveryDayLimitUpdate>}
     * @memberof SupplierDeliveryWindowUpdateRequest
     */
    'dayLimits': Array<SupplierDeliveryDayLimitUpdate>;
}
/**
 * 
 * @export
 * @interface SupplierInfoDTO
 */
export interface SupplierInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierInfoDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierInfoDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierInfoDTO
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface SupplierLovCustomer
 */
export interface SupplierLovCustomer {
    /**
     * 
     * @type {number}
     * @memberof SupplierLovCustomer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierLovCustomer
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SupplierMessageThreadItemResponse
 */
export interface SupplierMessageThreadItemResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessageThreadItemResponse
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierMessageThreadItemResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierMessageThreadItemResponse
     */
    'customerName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierMessageThreadItemResponse
     */
    'unreadMessagesCount': number;
}
/**
 * 
 * @export
 * @interface SupplierMessageThreadListResponse
 */
export interface SupplierMessageThreadListResponse {
    /**
     * 
     * @type {Array<SupplierMessageThreadItemResponse>}
     * @memberof SupplierMessageThreadListResponse
     */
    'threads': Array<SupplierMessageThreadItemResponse>;
}
/**
 * 
 * @export
 * @interface SupplierOrderAddressDTO
 */
export interface SupplierOrderAddressDTO {
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAddressDTO
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface SupplierOrderAttachmentDTO
 */
export interface SupplierOrderAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAttachmentDTO
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderAttachmentDTO
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAttachmentDTO
     */
    'mimeType': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderAttachmentDTO
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface SupplierOrderContactDTO
 */
export interface SupplierOrderContactDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderContactDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderContactDTO
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderContactDTO
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderContactDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderContactDTO
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface SupplierOrderCustomerInfoDTO
 */
export interface SupplierOrderCustomerInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'vatPayer'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'contractGroupName'?: string;
    /**
     * 
     * @type {SupplierOrderAddressDTO}
     * @memberof SupplierOrderCustomerInfoDTO
     */
    'deliveryAddress': SupplierOrderAddressDTO;
}
/**
 * 
 * @export
 * @interface SupplierOrderDetailResponse
 */
export interface SupplierOrderDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof SupplierOrderDetailResponse
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {SupplierOrderCustomerInfoDTO}
     * @memberof SupplierOrderDetailResponse
     */
    'customer': SupplierOrderCustomerInfoDTO;
    /**
     * 
     * @type {Array<SupplierOrderItemDTO>}
     * @memberof SupplierOrderDetailResponse
     */
    'items': Array<SupplierOrderItemDTO>;
    /**
     * 
     * @type {Array<SupplierOrderContactDTO>}
     * @memberof SupplierOrderDetailResponse
     */
    'contacts': Array<SupplierOrderContactDTO>;
    /**
     * 
     * @type {Array<SupplierOrderAttachmentDTO>}
     * @memberof SupplierOrderDetailResponse
     */
    'attachments': Array<SupplierOrderAttachmentDTO>;
    /**
     * 
     * @type {Array<SupplierOrderHistoryDTO>}
     * @memberof SupplierOrderDetailResponse
     */
    'history': Array<SupplierOrderHistoryDTO>;
    /**
     * 
     * @type {SupplierOrderTotalsDTO}
     * @memberof SupplierOrderDetailResponse
     */
    'totals': SupplierOrderTotalsDTO;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderDetailResponse
     */
    'workflowInstanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderDetailResponse
     */
    'workflowDefinitionName'?: string;
}


/**
 * 
 * @export
 * @interface SupplierOrderHistoryDTO
 */
export interface SupplierOrderHistoryDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderHistoryDTO
     */
    'id': number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof SupplierOrderHistoryDTO
     */
    'status': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderHistoryDTO
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderHistoryDTO
     */
    'changedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderHistoryDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderHistoryDTO
     */
    'actorLabel'?: string;
}


/**
 * 
 * @export
 * @interface SupplierOrderItemDTO
 */
export interface SupplierOrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof SupplierOrderItemDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderItemDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof SupplierOrderItemDTO
     */
    'productAuctionUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'catalogName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderItemDTO
     */
    'productImageUrl'?: string;
}


/**
 * 
 * @export
 * @interface SupplierOrderListResponse
 */
export interface SupplierOrderListResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof SupplierOrderListResponse
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'customerId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'totalWithVat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderListResponse
     */
    'workflowInstanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderListResponse
     */
    'workflowDefinitionName'?: string;
}


/**
 * 
 * @export
 * @interface SupplierOrderMessageResponse
 */
export interface SupplierOrderMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderMessageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderMessageResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderMessageResponse
     */
    'authorName': string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierOrderMessageResponse
     */
    'mySide': boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderMessageResponse
     */
    'timestamp': string;
}
/**
 * 
 * @export
 * @interface SupplierOrderMessagesResponse
 */
export interface SupplierOrderMessagesResponse {
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderMessagesResponse
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderMessagesResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {Array<SupplierOrderMessageResponse>}
     * @memberof SupplierOrderMessagesResponse
     */
    'messages': Array<SupplierOrderMessageResponse>;
}
/**
 * 
 * @export
 * @interface SupplierOrderPdfResponse
 */
export interface SupplierOrderPdfResponse {
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderPdfResponse
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderPdfResponse
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderPdfResponse
     */
    'data': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderPdfResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface SupplierOrderResult
 */
export interface SupplierOrderResult {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderResult
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderResult
     */
    'supplierName': string;
    /**
     * 
     * @type {CreateOrderOrderStatus}
     * @memberof SupplierOrderResult
     */
    'status'?: CreateOrderOrderStatus;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderResult
     */
    'orderId'?: number;
    /**
     * 
     * @type {OrderType}
     * @memberof SupplierOrderResult
     */
    'orderType': OrderType;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderResult
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierOrderResult
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {Array<SupplierContact>}
     * @memberof SupplierOrderResult
     */
    'supplierContacts': Array<SupplierContact>;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderResult
     */
    'totalWithoutVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderResult
     */
    'totalWithVat'?: number;
    /**
     * 
     * @type {ApprovalMessage}
     * @memberof SupplierOrderResult
     */
    'approvalMessage'?: ApprovalMessage;
    /**
     * 
     * @type {Array<OrderError>}
     * @memberof SupplierOrderResult
     */
    'errors': Array<OrderError>;
    /**
     * 
     * @type {RemainingCartItems}
     * @memberof SupplierOrderResult
     */
    'remainingItemsInCart'?: RemainingCartItems;
}


/**
 * 
 * @export
 * @interface SupplierOrderTotalsDTO
 */
export interface SupplierOrderTotalsDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderTotalsDTO
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderTotalsDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderTotalsDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderTotalsDTO
     */
    'totalVat': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SupplierPreference = {
    Preferred: 'PREFERRED',
    NonPreferred: 'NON_PREFERRED'
} as const;

export type SupplierPreference = typeof SupplierPreference[keyof typeof SupplierPreference];


/**
 * 
 * @export
 * @interface SupplierPriceListResponse
 */
export interface SupplierPriceListResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierPriceListResponse
     */
    'currentPrice'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof SupplierPriceListResponse
     */
    'priceUnit'?: UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof SupplierPriceListResponse
     */
    'packageItemUnit'?: UnitType;
    /**
     * 
     * @type {PriceType}
     * @memberof SupplierPriceListResponse
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierPriceListResponse
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierPriceListResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierPriceListResponse
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof SupplierPriceListResponse
     */
    'priceTypeCode'?: PriceTypeCode;
}


/**
 * 
 * @export
 * @interface SupplierProductAuctionResponse
 */
export interface SupplierProductAuctionResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductAuctionResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductAuctionResponse
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductAuctionResponse
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductAuctionResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductAuctionResponse
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface SupplierProductCustomerResponse
 */
export interface SupplierProductCustomerResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductCustomerResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductCustomerResponse
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @interface SupplierProductDetailResponse
 */
export interface SupplierProductDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailResponse
     */
    'minimumQty'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductDetailResponse
     */
    'multiply'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {UnitType}
     * @memberof SupplierProductDetailResponse
     */
    'auctionUnit'?: UnitType;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailResponse
     */
    'auctionAmount'?: number;
}


/**
 * 
 * @export
 * @interface SupplierProductImageResponse
 */
export interface SupplierProductImageResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductImageResponse
     */
    'physicalImageId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductImageResponse
     */
    's3Key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductImageResponse
     */
    'isPrimary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductImageResponse
     */
    'isSupplierImage': boolean;
    /**
     * 
     * @type {ApprovalStatus}
     * @memberof SupplierProductImageResponse
     */
    'approvalStatus': ApprovalStatus;
}


/**
 * 
 * @export
 * @interface SupplierProductImageUploadRequest
 */
export interface SupplierProductImageUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof SupplierProductImageUploadRequest
     */
    'base64Data': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductImageUploadRequest
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductImageUploadRequest
     */
    'isPrimary': boolean;
}
/**
 * 
 * @export
 * @interface SupplierProductImageUploadResponse
 */
export interface SupplierProductImageUploadResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductImageUploadResponse
     */
    'physicalImageId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductImageUploadResponse
     */
    's3Key': string;
}
/**
 * 
 * @export
 * @interface SupplierProductPortalResponse
 */
export interface SupplierProductPortalResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPortalResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPortalResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPortalResponse
     */
    'portalShortcut': string;
}
/**
 * 
 * @export
 * @interface SupplierProductPriceResponse
 */
export interface SupplierProductPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPriceResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPriceResponse
     */
    'auctionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductPriceResponse
     */
    'currentPrice'?: number;
    /**
     * 
     * @type {PriceType}
     * @memberof SupplierProductPriceResponse
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductPriceResponse
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPriceResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductPriceResponse
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface SupplierProductResponse
 */
export interface SupplierProductResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    'catalogName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductResponse
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierProductResponse
     */
    'multiply': boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    'catalogCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierProductResponse
     */
    'imageUrls': Array<string>;
}
/**
 * 
 * @export
 * @interface SupplierSendMessageRequest
 */
export interface SupplierSendMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SupplierSendMessageRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SupplierWithoutDeliveryDTO
 */
export interface SupplierWithoutDeliveryDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierWithoutDeliveryDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierWithoutDeliveryDTO
     */
    'supplierName': string;
}
/**
 * 
 * @export
 * @interface TaskDTO
 */
export interface TaskDTO {
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof TaskDTO
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'taskName': string;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskDTO
     */
    'taskType': TaskType;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskDTO
     */
    'status': TaskStatus;
    /**
     * 
     * @type {number}
     * @memberof TaskDTO
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskDTO
     */
    'durationMs'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskDTO
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskDTO
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface TaskDetailResponse
 */
export interface TaskDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskDetailResponse
     */
    'instanceId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'taskName': string;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'taskRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'entityType': string;
    /**
     * 
     * @type {number}
     * @memberof TaskDetailResponse
     */
    'entityId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'definitionName': string;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'currentNode': string;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TaskDetailResponse
     */
    'created': string;
}
/**
 * 
 * @export
 * @interface TaskResponse
 */
export interface TaskResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskResponse
     */
    'instanceId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    'taskName': string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    'taskRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    'entityType': string;
    /**
     * 
     * @type {number}
     * @memberof TaskResponse
     */
    'entityId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    'definitionName': string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    'created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaskStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    PartialFailed: 'PARTIAL_FAILED'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaskType = {
    ReindexAll: 'REINDEX_ALL',
    ReindexCompany: 'REINDEX_COMPANY',
    ReindexProduct: 'REINDEX_PRODUCT'
} as const;

export type TaskType = typeof TaskType[keyof typeof TaskType];


/**
 * 
 * @export
 * @enum {string}
 */

export const UnitType = {
    Kilogram: 'KILOGRAM',
    Kus: 'KUS',
    Baleni: 'BALENI',
    Litr: 'LITR',
    Kbelik: 'KBELIK',
    Role: 'ROLE',
    Krabice: 'KRABICE',
    Jednotka: 'JEDNOTKA',
    Hodina: 'HODINA',
    MetrCtverecni: 'METR_CTVERECNI',
    Sada: 'SADA',
    Svazek: 'SVAZEK',
    Par: 'PAR',
    Souprava: 'SOUPRAVA',
    Gram: 'GRAM',
    Mililitr: 'MILILITR',
    Tableta: 'TABLETA',
    Pytel: 'PYTEL',
    Doza: 'DOZA',
    Kilometr: 'KILOMETR',
    List: 'LIST',
    Metr: 'METR',
    Kanystr: 'KANYSTR',
    Vana: 'VANA',
    KorunaCeska: 'KORUNA_CESKA',
    Davka: 'DAVKA',
    Blok: 'BLOK',
    Karton: 'KARTON',
    Piece: 'PIECE',
    Kr: 'KR',
    Lt: 'LT',
    Pk: 'PK',
    Ct: 'CT',
    St: 'ST'
} as const;

export type UnitType = typeof UnitType[keyof typeof UnitType];


/**
 * Typ adresy (např. INVOICE_ADDRESS, DELIVERY_ADDRESS)
 * @export
 * @interface UpdateAddressRequestDTO
 */
export interface UpdateAddressRequestDTO {
    /**
     * Název adresy
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'name': string;
    /**
     * Název adresy 2
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'name2': string;
    /**
     * Ulice a číslo
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'street': string;
    /**
     * Město
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'city': string;
    /**
     * PSČ
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'zipcode': string;
    /**
     * Země
     * @type {string}
     * @memberof UpdateAddressRequestDTO
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface UpdateClientAddressRequestDTO
 */
export interface UpdateClientAddressRequestDTO {
    /**
     * 
     * @type {UpdateAddressRequestDTO}
     * @memberof UpdateClientAddressRequestDTO
     */
    'address': UpdateAddressRequestDTO;
}
/**
 * 
 * @export
 * @interface UpdateClientShoppingListRequestDTO
 */
export interface UpdateClientShoppingListRequestDTO {
    /**
     * Název nákupního seznamu
     * @type {string}
     * @memberof UpdateClientShoppingListRequestDTO
     */
    'name'?: string;
    /**
     * Popis nákupního seznamu
     * @type {string}
     * @memberof UpdateClientShoppingListRequestDTO
     */
    'description'?: string;
    /**
     * Produkty v seznamu
     * @type {Array<CreateShoppingListProductRequestDTO>}
     * @memberof UpdateClientShoppingListRequestDTO
     */
    'products'?: Array<CreateShoppingListProductRequestDTO>;
}
/**
 * 
 * @export
 * @interface UpdateClientUserRequestDTO
 */
export interface UpdateClientUserRequestDTO {
    /**
     * Email uživatele
     * @type {string}
     * @memberof UpdateClientUserRequestDTO
     */
    'email'?: string;
    /**
     * Jméno uživatele
     * @type {string}
     * @memberof UpdateClientUserRequestDTO
     */
    'firstName'?: string;
    /**
     * Příjmení uživatele
     * @type {string}
     * @memberof UpdateClientUserRequestDTO
     */
    'familyName'?: string;
    /**
     * Login uživatele
     * @type {string}
     * @memberof UpdateClientUserRequestDTO
     */
    'login'?: string;
    /**
     * Telefon uživatele
     * @type {string}
     * @memberof UpdateClientUserRequestDTO
     */
    'phone'?: string;
    /**
     * Zda je email ověřen
     * @type {boolean}
     * @memberof UpdateClientUserRequestDTO
     */
    'emailVerified'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCustomProductRequest
 */
export interface UpdateCustomProductRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomProductRequest
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'categoryId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'vat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof UpdateCustomProductRequest
     */
    'unit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomProductRequest
     */
    'multiply': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomProductRequest
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomProductRequest
     */
    'supplierProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomProductRequest
     */
    'supplierProductCode'?: string;
}


/**
 * 
 * @export
 * @interface UpdateDeliveryContactRequestDTO
 */
export interface UpdateDeliveryContactRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryContactRequestDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryContactRequestDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryContactRequestDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryContactRequestDTO
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface UpdateDeliveryDayRequestDTO
 */
export interface UpdateDeliveryDayRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryDayRequestDTO
     */
    'id'?: number;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof UpdateDeliveryDayRequestDTO
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryDayRequestDTO
     */
    'orderLimit': number;
}


/**
 * 
 * @export
 * @interface UpdateDeliveryWindowRequestDTO
 */
export interface UpdateDeliveryWindowRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryWindowRequestDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryWindowRequestDTO
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<UpdateDeliveryDayRequestDTO>}
     * @memberof UpdateDeliveryWindowRequestDTO
     */
    'deliveryDays': Array<UpdateDeliveryDayRequestDTO>;
    /**
     * 
     * @type {Array<UpdateDeliveryContactRequestDTO>}
     * @memberof UpdateDeliveryWindowRequestDTO
     */
    'contacts': Array<UpdateDeliveryContactRequestDTO>;
}
/**
 * 
 * @export
 * @interface VirtualScrollResponseDTO
 */
export interface VirtualScrollResponseDTO {
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof VirtualScrollResponseDTO
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'startIndex': number;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'endIndex': number;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualScrollResponseDTO
     */
    'hasMore': boolean;
    /**
     * 
     * @type {CategoryInfo}
     * @memberof VirtualScrollResponseDTO
     */
    'categoryInfo'?: CategoryInfo;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof VirtualScrollResponseDTO
     */
    'supplierDelivery'?: Array<SupplierDeliveryWindow>;
    /**
     * 
     * @type {Array<SupplierAggregation>}
     * @memberof VirtualScrollResponseDTO
     */
    'supplierAggregations'?: Array<SupplierAggregation>;
}
/**
 * 
 * @export
 * @interface WorkflowActionResponse
 */
export interface WorkflowActionResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkflowActionResponse
     */
    'actionId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowActionResponse
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface WorkflowCompleteRequest
 */
export interface WorkflowCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkflowCompleteRequest
     */
    'actionId'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof WorkflowCompleteRequest
     */
    'variables': { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof WorkflowCompleteRequest
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface WorkflowStartRequest
 */
export interface WorkflowStartRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStartRequest
     */
    'definitionName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStartRequest
     */
    'entityType': string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartRequest
     */
    'entityId': number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStartRequest
     */
    'userType': WorkflowStartRequestUserTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartRequest
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartRequest
     */
    'initiatorUserId'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof WorkflowStartRequest
     */
    'variables': { [key: string]: object; };
}

export const WorkflowStartRequestUserTypeEnum = {
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type WorkflowStartRequestUserTypeEnum = typeof WorkflowStartRequestUserTypeEnum[keyof typeof WorkflowStartRequestUserTypeEnum];

/**
 * 
 * @export
 * @interface WorkflowStartResponse
 */
export interface WorkflowStartResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartResponse
     */
    'instanceId': number;
}

/**
 * AdminWorkflowsApi - axios parameter creator
 * @export
 */
export const AdminWorkflowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail workflow vcetne grafu a pouziti
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminWorkflowDetail: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getAdminWorkflowDetail', 'name', name)
            const localVarPath = `/api/admin/workflows/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam registrovanych workflow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminWorkflowList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/workflows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminWorkflowsApi - functional programming interface
 * @export
 */
export const AdminWorkflowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminWorkflowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail workflow vcetne grafu a pouziti
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminWorkflowDetail(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminWorkflowDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminWorkflowDetail(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWorkflowsApi.getAdminWorkflowDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam registrovanych workflow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminWorkflowList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminWorkflowListItemDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminWorkflowList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWorkflowsApi.getAdminWorkflowList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminWorkflowsApi - factory interface
 * @export
 */
export const AdminWorkflowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminWorkflowsApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail workflow vcetne grafu a pouziti
         * @param {AdminWorkflowsApiGetAdminWorkflowDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminWorkflowDetail(requestParameters: AdminWorkflowsApiGetAdminWorkflowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminWorkflowDetailDTO> {
            return localVarFp.getAdminWorkflowDetail(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam registrovanych workflow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminWorkflowList(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminWorkflowListItemDTO>> {
            return localVarFp.getAdminWorkflowList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminWorkflowsApi - interface
 * @export
 * @interface AdminWorkflowsApi
 */
export interface AdminWorkflowsApiInterface {
    /**
     * 
     * @summary Detail workflow vcetne grafu a pouziti
     * @param {AdminWorkflowsApiGetAdminWorkflowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWorkflowsApiInterface
     */
    getAdminWorkflowDetail(requestParameters: AdminWorkflowsApiGetAdminWorkflowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminWorkflowDetailDTO>;

    /**
     * 
     * @summary Seznam registrovanych workflow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWorkflowsApiInterface
     */
    getAdminWorkflowList(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminWorkflowListItemDTO>>;

}

/**
 * Request parameters for getAdminWorkflowDetail operation in AdminWorkflowsApi.
 * @export
 * @interface AdminWorkflowsApiGetAdminWorkflowDetailRequest
 */
export interface AdminWorkflowsApiGetAdminWorkflowDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkflowsApiGetAdminWorkflowDetail
     */
    readonly name: string
}

/**
 * AdminWorkflowsApi - object-oriented interface
 * @export
 * @class AdminWorkflowsApi
 * @extends {BaseAPI}
 */
export class AdminWorkflowsApi extends BaseAPI implements AdminWorkflowsApiInterface {
    /**
     * 
     * @summary Detail workflow vcetne grafu a pouziti
     * @param {AdminWorkflowsApiGetAdminWorkflowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWorkflowsApi
     */
    public getAdminWorkflowDetail(requestParameters: AdminWorkflowsApiGetAdminWorkflowDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminWorkflowsApiFp(this.configuration).getAdminWorkflowDetail(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam registrovanych workflow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWorkflowsApi
     */
    public getAdminWorkflowList(options?: RawAxiosRequestConfig) {
        return AdminWorkflowsApiFp(this.configuration).getAdminWorkflowList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
export const AttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Smaže přílohu z S3 úložiště podle URL
         * @summary Smaže přílohu
         * @param {string} url URL přílohy na S3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('deleteAttachment', 'url', url)
            const localVarPath = `/api/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nahraje přílohu jako dataURL (base64) na S3 úložiště. Podporuje dokumenty, obrázky a archivy. Max velikost: 50MB.
         * @summary Nahraje novou přílohu
         * @param {AttachmentUploadRequestDTO} attachmentUploadRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (attachmentUploadRequestDTO: AttachmentUploadRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentUploadRequestDTO' is not null or undefined
            assertParamExists('uploadAttachment', 'attachmentUploadRequestDTO', attachmentUploadRequestDTO)
            const localVarPath = `/api/attachments/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentUploadRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Smaže přílohu z S3 úložiště podle URL
         * @summary Smaže přílohu
         * @param {string} url URL přílohy na S3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.deleteAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nahraje přílohu jako dataURL (base64) na S3 úložiště. Podporuje dokumenty, obrázky a archivy. Max velikost: 50MB.
         * @summary Nahraje novou přílohu
         * @param {AttachmentUploadRequestDTO} attachmentUploadRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(attachmentUploadRequestDTO: AttachmentUploadRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(attachmentUploadRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.uploadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentsApiFp(configuration)
    return {
        /**
         * Smaže přílohu z S3 úložiště podle URL
         * @summary Smaže přílohu
         * @param {AttachmentsApiDeleteAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(requestParameters: AttachmentsApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAttachment(requestParameters.url, options).then((request) => request(axios, basePath));
        },
        /**
         * Nahraje přílohu jako dataURL (base64) na S3 úložiště. Podporuje dokumenty, obrázky a archivy. Max velikost: 50MB.
         * @summary Nahraje novou přílohu
         * @param {AttachmentsApiUploadAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(requestParameters: AttachmentsApiUploadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentResponseDTO> {
            return localVarFp.uploadAttachment(requestParameters.attachmentUploadRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentsApi - interface
 * @export
 * @interface AttachmentsApi
 */
export interface AttachmentsApiInterface {
    /**
     * Smaže přílohu z S3 úložiště podle URL
     * @summary Smaže přílohu
     * @param {AttachmentsApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApiInterface
     */
    deleteAttachment(requestParameters: AttachmentsApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Nahraje přílohu jako dataURL (base64) na S3 úložiště. Podporuje dokumenty, obrázky a archivy. Max velikost: 50MB.
     * @summary Nahraje novou přílohu
     * @param {AttachmentsApiUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApiInterface
     */
    uploadAttachment(requestParameters: AttachmentsApiUploadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentResponseDTO>;

}

/**
 * Request parameters for deleteAttachment operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiDeleteAttachmentRequest
 */
export interface AttachmentsApiDeleteAttachmentRequest {
    /**
     * URL přílohy na S3
     * @type {string}
     * @memberof AttachmentsApiDeleteAttachment
     */
    readonly url: string
}

/**
 * Request parameters for uploadAttachment operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiUploadAttachmentRequest
 */
export interface AttachmentsApiUploadAttachmentRequest {
    /**
     * 
     * @type {AttachmentUploadRequestDTO}
     * @memberof AttachmentsApiUploadAttachment
     */
    readonly attachmentUploadRequestDTO: AttachmentUploadRequestDTO
}

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI implements AttachmentsApiInterface {
    /**
     * Smaže přílohu z S3 úložiště podle URL
     * @summary Smaže přílohu
     * @param {AttachmentsApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public deleteAttachment(requestParameters: AttachmentsApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).deleteAttachment(requestParameters.url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nahraje přílohu jako dataURL (base64) na S3 úložiště. Podporuje dokumenty, obrázky a archivy. Max velikost: 50MB.
     * @summary Nahraje novou přílohu
     * @param {AttachmentsApiUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public uploadAttachment(requestParameters: AttachmentsApiUploadAttachmentRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).uploadAttachment(requestParameters.attachmentUploadRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AutocompleteControllerApi - axios parameter creator
 * @export
 */
export const AutocompleteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} query 
         * @param {string} [categoryEcid] 
         * @param {Array<number>} [supplierIds] 
         * @param {number} [startIndex] 
         * @param {number} [endIndex] 
         * @param {SearchSortByEnum} [sortBy] 
         * @param {boolean} [filterGarantedPrice] 
         * @param {PriceType} [filterPriceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (organizationId: number, portalId: number, query: string, categoryEcid?: string, supplierIds?: Array<number>, startIndex?: number, endIndex?: number, sortBy?: SearchSortByEnum, filterGarantedPrice?: boolean, filterPriceType?: PriceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('search', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('search', 'portalId', portalId)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('search', 'query', query)
            const localVarPath = `/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }

            if (startIndex !== undefined) {
                localVarQueryParameter['startIndex'] = startIndex;
            }

            if (endIndex !== undefined) {
                localVarQueryParameter['endIndex'] = endIndex;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterGarantedPrice !== undefined) {
                localVarQueryParameter['filterGarantedPrice'] = filterGarantedPrice;
            }

            if (filterPriceType !== undefined) {
                localVarQueryParameter['filterPriceType'] = filterPriceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutocompleteControllerApi - functional programming interface
 * @export
 */
export const AutocompleteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutocompleteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} query 
         * @param {string} [categoryEcid] 
         * @param {Array<number>} [supplierIds] 
         * @param {number} [startIndex] 
         * @param {number} [endIndex] 
         * @param {SearchSortByEnum} [sortBy] 
         * @param {boolean} [filterGarantedPrice] 
         * @param {PriceType} [filterPriceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(organizationId: number, portalId: number, query: string, categoryEcid?: string, supplierIds?: Array<number>, startIndex?: number, endIndex?: number, sortBy?: SearchSortByEnum, filterGarantedPrice?: boolean, filterPriceType?: PriceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualScrollResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(organizationId, portalId, query, categoryEcid, supplierIds, startIndex, endIndex, sortBy, filterGarantedPrice, filterPriceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutocompleteControllerApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutocompleteControllerApi - factory interface
 * @export
 */
export const AutocompleteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutocompleteControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AutocompleteControllerApiSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(requestParameters: AutocompleteControllerApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<VirtualScrollResponseDTO> {
            return localVarFp.search(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.categoryEcid, requestParameters.supplierIds, requestParameters.startIndex, requestParameters.endIndex, requestParameters.sortBy, requestParameters.filterGarantedPrice, requestParameters.filterPriceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutocompleteControllerApi - interface
 * @export
 * @interface AutocompleteControllerApi
 */
export interface AutocompleteControllerApiInterface {
    /**
     * 
     * @param {AutocompleteControllerApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteControllerApiInterface
     */
    search(requestParameters: AutocompleteControllerApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<VirtualScrollResponseDTO>;

}

/**
 * Request parameters for search operation in AutocompleteControllerApi.
 * @export
 * @interface AutocompleteControllerApiSearchRequest
 */
export interface AutocompleteControllerApiSearchRequest {
    /**
     * 
     * @type {number}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly query: string

    /**
     * 
     * @type {string}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly categoryEcid?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly supplierIds?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly startIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly endIndex?: number

    /**
     * 
     * @type {'RELEVANCE' | 'SORT_AZ' | 'SORT_ZA' | 'SORT_PRICE_ASC' | 'SORT_PRICE_DESC'}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly sortBy?: SearchSortByEnum

    /**
     * 
     * @type {boolean}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly filterGarantedPrice?: boolean

    /**
     * 
     * @type {PriceType}
     * @memberof AutocompleteControllerApiSearch
     */
    readonly filterPriceType?: PriceType
}

/**
 * AutocompleteControllerApi - object-oriented interface
 * @export
 * @class AutocompleteControllerApi
 * @extends {BaseAPI}
 */
export class AutocompleteControllerApi extends BaseAPI implements AutocompleteControllerApiInterface {
    /**
     * 
     * @param {AutocompleteControllerApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteControllerApi
     */
    public search(requestParameters: AutocompleteControllerApiSearchRequest, options?: RawAxiosRequestConfig) {
        return AutocompleteControllerApiFp(this.configuration).search(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.categoryEcid, requestParameters.supplierIds, requestParameters.startIndex, requestParameters.endIndex, requestParameters.sortBy, requestParameters.filterGarantedPrice, requestParameters.filterPriceType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SearchSortByEnum = {
    Relevance: 'RELEVANCE',
    SortAz: 'SORT_AZ',
    SortZa: 'SORT_ZA',
    SortPriceAsc: 'SORT_PRICE_ASC',
    SortPriceDesc: 'SORT_PRICE_DESC'
} as const;
export type SearchSortByEnum = typeof SearchSortByEnum[keyof typeof SearchSortByEnum];


/**
 * CategoryControllerApi - axios parameter creator
 * @export
 */
export const CategoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Načte strom kategorií pro daného kupujícího
         * @param {number} portalId 
         * @param {number} buyerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCategoryTree: async (portalId: number, buyerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('loadCategoryTree', 'portalId', portalId)
            // verify required parameter 'buyerId' is not null or undefined
            assertParamExists('loadCategoryTree', 'buyerId', buyerId)
            const localVarPath = `/categories/{portalId}/{buyerId}`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"buyerId"}}`, encodeURIComponent(String(buyerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Načte kompletní strom kategorií bez omezení na viditelnost pro kupujícího
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadFullCategoryTree: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryControllerApi - functional programming interface
 * @export
 */
export const CategoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Načte strom kategorií pro daného kupujícího
         * @param {number} portalId 
         * @param {number} buyerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadCategoryTree(portalId: number, buyerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryControllerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadCategoryTree(portalId, buyerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.loadCategoryTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Načte kompletní strom kategorií bez omezení na viditelnost pro kupujícího
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadFullCategoryTree(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryControllerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadFullCategoryTree(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.loadFullCategoryTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryControllerApi - factory interface
 * @export
 */
export const CategoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Načte strom kategorií pro daného kupujícího
         * @param {CategoryControllerApiLoadCategoryTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCategoryTree(requestParameters: CategoryControllerApiLoadCategoryTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryControllerResponse> {
            return localVarFp.loadCategoryTree(requestParameters.portalId, requestParameters.buyerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Načte kompletní strom kategorií bez omezení na viditelnost pro kupujícího
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadFullCategoryTree(options?: RawAxiosRequestConfig): AxiosPromise<CategoryControllerResponse> {
            return localVarFp.loadFullCategoryTree(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoryControllerApi - interface
 * @export
 * @interface CategoryControllerApi
 */
export interface CategoryControllerApiInterface {
    /**
     * 
     * @summary Načte strom kategorií pro daného kupujícího
     * @param {CategoryControllerApiLoadCategoryTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    loadCategoryTree(requestParameters: CategoryControllerApiLoadCategoryTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryControllerResponse>;

    /**
     * 
     * @summary Načte kompletní strom kategorií bez omezení na viditelnost pro kupujícího
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    loadFullCategoryTree(options?: RawAxiosRequestConfig): AxiosPromise<CategoryControllerResponse>;

}

/**
 * Request parameters for loadCategoryTree operation in CategoryControllerApi.
 * @export
 * @interface CategoryControllerApiLoadCategoryTreeRequest
 */
export interface CategoryControllerApiLoadCategoryTreeRequest {
    /**
     * 
     * @type {number}
     * @memberof CategoryControllerApiLoadCategoryTree
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CategoryControllerApiLoadCategoryTree
     */
    readonly buyerId: number
}

/**
 * CategoryControllerApi - object-oriented interface
 * @export
 * @class CategoryControllerApi
 * @extends {BaseAPI}
 */
export class CategoryControllerApi extends BaseAPI implements CategoryControllerApiInterface {
    /**
     * 
     * @summary Načte strom kategorií pro daného kupujícího
     * @param {CategoryControllerApiLoadCategoryTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public loadCategoryTree(requestParameters: CategoryControllerApiLoadCategoryTreeRequest, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).loadCategoryTree(requestParameters.portalId, requestParameters.buyerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Načte kompletní strom kategorií bez omezení na viditelnost pro kupujícího
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public loadFullCategoryTree(options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).loadFullCategoryTree(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CheckControllerApi - axios parameter creator
 * @export
 */
export const CheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check: async (only?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (only !== undefined) {
                localVarQueryParameter['only'] = only;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckControllerApi - functional programming interface
 * @export
 */
export const CheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async check(only?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.check(only, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckControllerApi.check']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckControllerApi - factory interface
 * @export
 */
export const CheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(requestParameters: CheckControllerApiCheckRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport> {
            return localVarFp.check(requestParameters.only, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckControllerApi - interface
 * @export
 * @interface CheckControllerApi
 */
export interface CheckControllerApiInterface {
    /**
     * 
     * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckControllerApiInterface
     */
    check(requestParameters?: CheckControllerApiCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport>;

}

/**
 * Request parameters for check operation in CheckControllerApi.
 * @export
 * @interface CheckControllerApiCheckRequest
 */
export interface CheckControllerApiCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckControllerApiCheck
     */
    readonly only?: string
}

/**
 * CheckControllerApi - object-oriented interface
 * @export
 * @class CheckControllerApi
 * @extends {BaseAPI}
 */
export class CheckControllerApi extends BaseAPI implements CheckControllerApiInterface {
    /**
     * 
     * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckControllerApi
     */
    public check(requestParameters: CheckControllerApiCheckRequest = {}, options?: RawAxiosRequestConfig) {
        return CheckControllerApiFp(this.configuration).check(requestParameters.only, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAddressManagementApi - axios parameter creator
 * @export
 */
export const ClientAddressManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří novou adresu pro organizaci
         * @summary Vytvoří novou adresu
         * @param {number} organizationId ID organizace
         * @param {CreateClientAddressRequestDTO} createClientAddressRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: async (organizationId: number, createClientAddressRequestDTO: CreateClientAddressRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAddress', 'organizationId', organizationId)
            // verify required parameter 'createClientAddressRequestDTO' is not null or undefined
            assertParamExists('createAddress', 'createClientAddressRequestDTO', createClientAddressRequestDTO)
            const localVarPath = `/client/addresses/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientAddressRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže existující adresu
         * @summary Smaže adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (organizationId: number, addressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAddress', 'organizationId', organizationId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('deleteAddress', 'addressId', addressId)
            const localVarPath = `/client/addresses/organization/{organizationId}/address/{addressId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail konkrétní adresy
         * @summary Získá konkrétní adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressById: async (organizationId: number, addressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAddressById', 'organizationId', organizationId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getAddressById', 'addressId', addressId)
            const localVarPath = `/client/addresses/organization/{organizationId}/address/{addressId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam všech adres pro danou organizaci
         * @summary Získá všechny adresy organizace
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByOrganization: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAddressesByOrganization', 'organizationId', organizationId)
            const localVarPath = `/client/addresses/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam adres podle zadaného typu
         * @summary Získá adresy podle typu
         * @param {number} organizationId ID organizace
         * @param {string} addressType Typ adresy (např. INVOICE_ADDRESS, DELIVERY_ADDRESS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByType: async (organizationId: number, addressType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAddressesByType', 'organizationId', organizationId)
            // verify required parameter 'addressType' is not null or undefined
            assertParamExists('getAddressesByType', 'addressType', addressType)
            const localVarPath = `/client/addresses/organization/{organizationId}/type/{addressType}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"addressType"}}`, encodeURIComponent(String(addressType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující adresu
         * @summary Aktualizuje adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {UpdateClientAddressRequestDTO} updateClientAddressRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: async (organizationId: number, addressId: number, updateClientAddressRequestDTO: UpdateClientAddressRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAddress', 'organizationId', organizationId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('updateAddress', 'addressId', addressId)
            // verify required parameter 'updateClientAddressRequestDTO' is not null or undefined
            assertParamExists('updateAddress', 'updateClientAddressRequestDTO', updateClientAddressRequestDTO)
            const localVarPath = `/client/addresses/organization/{organizationId}/address/{addressId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientAddressRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAddressManagementApi - functional programming interface
 * @export
 */
export const ClientAddressManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAddressManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří novou adresu pro organizaci
         * @summary Vytvoří novou adresu
         * @param {number} organizationId ID organizace
         * @param {CreateClientAddressRequestDTO} createClientAddressRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddress(organizationId: number, createClientAddressRequestDTO: CreateClientAddressRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddress(organizationId, createClientAddressRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.createAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže existující adresu
         * @summary Smaže adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(organizationId: number, addressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(organizationId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.deleteAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail konkrétní adresy
         * @summary Získá konkrétní adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressById(organizationId: number, addressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressById(organizationId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.getAddressById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam všech adres pro danou organizaci
         * @summary Získá všechny adresy organizace
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressesByOrganization(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAddressDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressesByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.getAddressesByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam adres podle zadaného typu
         * @summary Získá adresy podle typu
         * @param {number} organizationId ID organizace
         * @param {string} addressType Typ adresy (např. INVOICE_ADDRESS, DELIVERY_ADDRESS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressesByType(organizationId: number, addressType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAddressDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressesByType(organizationId, addressType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.getAddressesByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující adresu
         * @summary Aktualizuje adresu
         * @param {number} organizationId ID organizace
         * @param {number} addressId ID adresy
         * @param {UpdateClientAddressRequestDTO} updateClientAddressRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddress(organizationId: number, addressId: number, updateClientAddressRequestDTO: UpdateClientAddressRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddress(organizationId, addressId, updateClientAddressRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressManagementApi.updateAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAddressManagementApi - factory interface
 * @export
 */
export const ClientAddressManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAddressManagementApiFp(configuration)
    return {
        /**
         * Vytvoří novou adresu pro organizaci
         * @summary Vytvoří novou adresu
         * @param {ClientAddressManagementApiCreateAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(requestParameters: ClientAddressManagementApiCreateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO> {
            return localVarFp.createAddress(requestParameters.organizationId, requestParameters.createClientAddressRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže existující adresu
         * @summary Smaže adresu
         * @param {ClientAddressManagementApiDeleteAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(requestParameters: ClientAddressManagementApiDeleteAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAddress(requestParameters.organizationId, requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail konkrétní adresy
         * @summary Získá konkrétní adresu
         * @param {ClientAddressManagementApiGetAddressByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressById(requestParameters: ClientAddressManagementApiGetAddressByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO> {
            return localVarFp.getAddressById(requestParameters.organizationId, requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam všech adres pro danou organizaci
         * @summary Získá všechny adresy organizace
         * @param {ClientAddressManagementApiGetAddressesByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByOrganization(requestParameters: ClientAddressManagementApiGetAddressesByOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientAddressDTO>> {
            return localVarFp.getAddressesByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam adres podle zadaného typu
         * @summary Získá adresy podle typu
         * @param {ClientAddressManagementApiGetAddressesByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByType(requestParameters: ClientAddressManagementApiGetAddressesByTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientAddressDTO>> {
            return localVarFp.getAddressesByType(requestParameters.organizationId, requestParameters.addressType, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující adresu
         * @summary Aktualizuje adresu
         * @param {ClientAddressManagementApiUpdateAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(requestParameters: ClientAddressManagementApiUpdateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO> {
            return localVarFp.updateAddress(requestParameters.organizationId, requestParameters.addressId, requestParameters.updateClientAddressRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAddressManagementApi - interface
 * @export
 * @interface ClientAddressManagementApi
 */
export interface ClientAddressManagementApiInterface {
    /**
     * Vytvoří novou adresu pro organizaci
     * @summary Vytvoří novou adresu
     * @param {ClientAddressManagementApiCreateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    createAddress(requestParameters: ClientAddressManagementApiCreateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO>;

    /**
     * Smaže existující adresu
     * @summary Smaže adresu
     * @param {ClientAddressManagementApiDeleteAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    deleteAddress(requestParameters: ClientAddressManagementApiDeleteAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí detail konkrétní adresy
     * @summary Získá konkrétní adresu
     * @param {ClientAddressManagementApiGetAddressByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    getAddressById(requestParameters: ClientAddressManagementApiGetAddressByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO>;

    /**
     * Vrátí seznam všech adres pro danou organizaci
     * @summary Získá všechny adresy organizace
     * @param {ClientAddressManagementApiGetAddressesByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    getAddressesByOrganization(requestParameters: ClientAddressManagementApiGetAddressesByOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientAddressDTO>>;

    /**
     * Vrátí seznam adres podle zadaného typu
     * @summary Získá adresy podle typu
     * @param {ClientAddressManagementApiGetAddressesByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    getAddressesByType(requestParameters: ClientAddressManagementApiGetAddressesByTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientAddressDTO>>;

    /**
     * Aktualizuje existující adresu
     * @summary Aktualizuje adresu
     * @param {ClientAddressManagementApiUpdateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApiInterface
     */
    updateAddress(requestParameters: ClientAddressManagementApiUpdateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressDTO>;

}

/**
 * Request parameters for createAddress operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiCreateAddressRequest
 */
export interface ClientAddressManagementApiCreateAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiCreateAddress
     */
    readonly organizationId: number

    /**
     * 
     * @type {CreateClientAddressRequestDTO}
     * @memberof ClientAddressManagementApiCreateAddress
     */
    readonly createClientAddressRequestDTO: CreateClientAddressRequestDTO
}

/**
 * Request parameters for deleteAddress operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiDeleteAddressRequest
 */
export interface ClientAddressManagementApiDeleteAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiDeleteAddress
     */
    readonly organizationId: number

    /**
     * ID adresy
     * @type {number}
     * @memberof ClientAddressManagementApiDeleteAddress
     */
    readonly addressId: number
}

/**
 * Request parameters for getAddressById operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiGetAddressByIdRequest
 */
export interface ClientAddressManagementApiGetAddressByIdRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiGetAddressById
     */
    readonly organizationId: number

    /**
     * ID adresy
     * @type {number}
     * @memberof ClientAddressManagementApiGetAddressById
     */
    readonly addressId: number
}

/**
 * Request parameters for getAddressesByOrganization operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiGetAddressesByOrganizationRequest
 */
export interface ClientAddressManagementApiGetAddressesByOrganizationRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiGetAddressesByOrganization
     */
    readonly organizationId: number
}

/**
 * Request parameters for getAddressesByType operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiGetAddressesByTypeRequest
 */
export interface ClientAddressManagementApiGetAddressesByTypeRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiGetAddressesByType
     */
    readonly organizationId: number

    /**
     * Typ adresy (např. INVOICE_ADDRESS, DELIVERY_ADDRESS)
     * @type {string}
     * @memberof ClientAddressManagementApiGetAddressesByType
     */
    readonly addressType: string
}

/**
 * Request parameters for updateAddress operation in ClientAddressManagementApi.
 * @export
 * @interface ClientAddressManagementApiUpdateAddressRequest
 */
export interface ClientAddressManagementApiUpdateAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientAddressManagementApiUpdateAddress
     */
    readonly organizationId: number

    /**
     * ID adresy
     * @type {number}
     * @memberof ClientAddressManagementApiUpdateAddress
     */
    readonly addressId: number

    /**
     * 
     * @type {UpdateClientAddressRequestDTO}
     * @memberof ClientAddressManagementApiUpdateAddress
     */
    readonly updateClientAddressRequestDTO: UpdateClientAddressRequestDTO
}

/**
 * ClientAddressManagementApi - object-oriented interface
 * @export
 * @class ClientAddressManagementApi
 * @extends {BaseAPI}
 */
export class ClientAddressManagementApi extends BaseAPI implements ClientAddressManagementApiInterface {
    /**
     * Vytvoří novou adresu pro organizaci
     * @summary Vytvoří novou adresu
     * @param {ClientAddressManagementApiCreateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public createAddress(requestParameters: ClientAddressManagementApiCreateAddressRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).createAddress(requestParameters.organizationId, requestParameters.createClientAddressRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže existující adresu
     * @summary Smaže adresu
     * @param {ClientAddressManagementApiDeleteAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public deleteAddress(requestParameters: ClientAddressManagementApiDeleteAddressRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).deleteAddress(requestParameters.organizationId, requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail konkrétní adresy
     * @summary Získá konkrétní adresu
     * @param {ClientAddressManagementApiGetAddressByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public getAddressById(requestParameters: ClientAddressManagementApiGetAddressByIdRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).getAddressById(requestParameters.organizationId, requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam všech adres pro danou organizaci
     * @summary Získá všechny adresy organizace
     * @param {ClientAddressManagementApiGetAddressesByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public getAddressesByOrganization(requestParameters: ClientAddressManagementApiGetAddressesByOrganizationRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).getAddressesByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam adres podle zadaného typu
     * @summary Získá adresy podle typu
     * @param {ClientAddressManagementApiGetAddressesByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public getAddressesByType(requestParameters: ClientAddressManagementApiGetAddressesByTypeRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).getAddressesByType(requestParameters.organizationId, requestParameters.addressType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující adresu
     * @summary Aktualizuje adresu
     * @param {ClientAddressManagementApiUpdateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressManagementApi
     */
    public updateAddress(requestParameters: ClientAddressManagementApiUpdateAddressRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressManagementApiFp(this.configuration).updateAddress(requestParameters.organizationId, requestParameters.addressId, requestParameters.updateClientAddressRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientArticlesApi - axios parameter creator
 * @export
 */
export const ClientArticlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí detail článku a označí ho jako přečtený.
         * @summary Získá detail článku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientArticleDetail: async (organizationId: number, portalId: number, articleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientArticleDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientArticleDetail', 'portalId', portalId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getClientArticleDetail', 'articleId', articleId)
            const localVarPath = `/api/client/{organizationId}/portal/{portalId}/articles/{articleId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam všech článků (přečtených i nepřečtených) pro uživatele.
         * @summary Získá seznam článků
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientArticles: async (organizationId: number, portalId: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientArticles', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientArticles', 'portalId', portalId)
            const localVarPath = `/api/client/{organizationId}/portal/{portalId}/articles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam nepřečtených článků pro uživatele. Pokud nejsou žádné, vrátí prázdný seznam.
         * @summary Získá nepřečtené články
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUnreadArticles: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUnreadArticles', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUnreadArticles', 'portalId', portalId)
            const localVarPath = `/api/client/{organizationId}/portal/{portalId}/articles/unread`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientArticlesApi - functional programming interface
 * @export
 */
export const ClientArticlesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientArticlesApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí detail článku a označí ho jako přečtený.
         * @summary Získá detail článku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientArticleDetail(organizationId: number, portalId: number, articleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientArticleDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientArticleDetail(organizationId, portalId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientArticlesApi.getClientArticleDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam všech článků (přečtených i nepřečtených) pro uživatele.
         * @summary Získá seznam článků
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientArticles(organizationId: number, portalId: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultClientArticleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientArticles(organizationId, portalId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientArticlesApi.getClientArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam nepřečtených článků pro uživatele. Pokud nejsou žádné, vrátí prázdný seznam.
         * @summary Získá nepřečtené články
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUnreadArticles(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientUnreadArticleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUnreadArticles(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientArticlesApi.getClientUnreadArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientArticlesApi - factory interface
 * @export
 */
export const ClientArticlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientArticlesApiFp(configuration)
    return {
        /**
         * Vrátí detail článku a označí ho jako přečtený.
         * @summary Získá detail článku
         * @param {ClientArticlesApiGetClientArticleDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientArticleDetail(requestParameters: ClientArticlesApiGetClientArticleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientArticleDetailResponse> {
            return localVarFp.getClientArticleDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam všech článků (přečtených i nepřečtených) pro uživatele.
         * @summary Získá seznam článků
         * @param {ClientArticlesApiGetClientArticlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientArticles(requestParameters: ClientArticlesApiGetClientArticlesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultClientArticleListResponse> {
            return localVarFp.getClientArticles(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam nepřečtených článků pro uživatele. Pokud nejsou žádné, vrátí prázdný seznam.
         * @summary Získá nepřečtené články
         * @param {ClientArticlesApiGetClientUnreadArticlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUnreadArticles(requestParameters: ClientArticlesApiGetClientUnreadArticlesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUnreadArticleResponse>> {
            return localVarFp.getClientUnreadArticles(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientArticlesApi - interface
 * @export
 * @interface ClientArticlesApi
 */
export interface ClientArticlesApiInterface {
    /**
     * Vrátí detail článku a označí ho jako přečtený.
     * @summary Získá detail článku
     * @param {ClientArticlesApiGetClientArticleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApiInterface
     */
    getClientArticleDetail(requestParameters: ClientArticlesApiGetClientArticleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientArticleDetailResponse>;

    /**
     * Vrátí stránkovaný seznam všech článků (přečtených i nepřečtených) pro uživatele.
     * @summary Získá seznam článků
     * @param {ClientArticlesApiGetClientArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApiInterface
     */
    getClientArticles(requestParameters: ClientArticlesApiGetClientArticlesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultClientArticleListResponse>;

    /**
     * Vrátí seznam nepřečtených článků pro uživatele. Pokud nejsou žádné, vrátí prázdný seznam.
     * @summary Získá nepřečtené články
     * @param {ClientArticlesApiGetClientUnreadArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApiInterface
     */
    getClientUnreadArticles(requestParameters: ClientArticlesApiGetClientUnreadArticlesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUnreadArticleResponse>>;

}

/**
 * Request parameters for getClientArticleDetail operation in ClientArticlesApi.
 * @export
 * @interface ClientArticlesApiGetClientArticleDetailRequest
 */
export interface ClientArticlesApiGetClientArticleDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticleDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticleDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticleDetail
     */
    readonly articleId: number
}

/**
 * Request parameters for getClientArticles operation in ClientArticlesApi.
 * @export
 * @interface ClientArticlesApiGetClientArticlesRequest
 */
export interface ClientArticlesApiGetClientArticlesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticles
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticles
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticles
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientArticles
     */
    readonly size?: number
}

/**
 * Request parameters for getClientUnreadArticles operation in ClientArticlesApi.
 * @export
 * @interface ClientArticlesApiGetClientUnreadArticlesRequest
 */
export interface ClientArticlesApiGetClientUnreadArticlesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientUnreadArticles
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientArticlesApiGetClientUnreadArticles
     */
    readonly portalId: number
}

/**
 * ClientArticlesApi - object-oriented interface
 * @export
 * @class ClientArticlesApi
 * @extends {BaseAPI}
 */
export class ClientArticlesApi extends BaseAPI implements ClientArticlesApiInterface {
    /**
     * Vrátí detail článku a označí ho jako přečtený.
     * @summary Získá detail článku
     * @param {ClientArticlesApiGetClientArticleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApi
     */
    public getClientArticleDetail(requestParameters: ClientArticlesApiGetClientArticleDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientArticlesApiFp(this.configuration).getClientArticleDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam všech článků (přečtených i nepřečtených) pro uživatele.
     * @summary Získá seznam článků
     * @param {ClientArticlesApiGetClientArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApi
     */
    public getClientArticles(requestParameters: ClientArticlesApiGetClientArticlesRequest, options?: RawAxiosRequestConfig) {
        return ClientArticlesApiFp(this.configuration).getClientArticles(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam nepřečtených článků pro uživatele. Pokud nejsou žádné, vrátí prázdný seznam.
     * @summary Získá nepřečtené články
     * @param {ClientArticlesApiGetClientUnreadArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientArticlesApi
     */
    public getClientUnreadArticles(requestParameters: ClientArticlesApiGetClientUnreadArticlesRequest, options?: RawAxiosRequestConfig) {
        return ClientArticlesApiFp(this.configuration).getClientUnreadArticles(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAssistantApi - axios parameter creator
 * @export
 */
export const ClientAssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Pošle zprávu asistentovi a vrátí odpověď s návrhem nákupního seznamu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {AssistantMessageRequest} assistantMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage: async (organizationId: number, portalId: number, assistantMessageRequest: AssistantMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postMessage', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('postMessage', 'portalId', portalId)
            // verify required parameter 'assistantMessageRequest' is not null or undefined
            assertParamExists('postMessage', 'assistantMessageRequest', assistantMessageRequest)
            const localVarPath = `/api/client/assistant/message/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assistantMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAssistantApi - functional programming interface
 * @export
 */
export const ClientAssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Pošle zprávu asistentovi a vrátí odpověď s návrhem nákupního seznamu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {AssistantMessageRequest} assistantMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessage(organizationId: number, portalId: number, assistantMessageRequest: AssistantMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessage(organizationId, portalId, assistantMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAssistantApi.postMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAssistantApi - factory interface
 * @export
 */
export const ClientAssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAssistantApiFp(configuration)
    return {
        /**
         * 
         * @summary Pošle zprávu asistentovi a vrátí odpověď s návrhem nákupního seznamu
         * @param {ClientAssistantApiPostMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage(requestParameters: ClientAssistantApiPostMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantMessageResponse> {
            return localVarFp.postMessage(requestParameters.organizationId, requestParameters.portalId, requestParameters.assistantMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAssistantApi - interface
 * @export
 * @interface ClientAssistantApi
 */
export interface ClientAssistantApiInterface {
    /**
     * 
     * @summary Pošle zprávu asistentovi a vrátí odpověď s návrhem nákupního seznamu
     * @param {ClientAssistantApiPostMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAssistantApiInterface
     */
    postMessage(requestParameters: ClientAssistantApiPostMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantMessageResponse>;

}

/**
 * Request parameters for postMessage operation in ClientAssistantApi.
 * @export
 * @interface ClientAssistantApiPostMessageRequest
 */
export interface ClientAssistantApiPostMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAssistantApiPostMessage
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAssistantApiPostMessage
     */
    readonly portalId: number

    /**
     * 
     * @type {AssistantMessageRequest}
     * @memberof ClientAssistantApiPostMessage
     */
    readonly assistantMessageRequest: AssistantMessageRequest
}

/**
 * ClientAssistantApi - object-oriented interface
 * @export
 * @class ClientAssistantApi
 * @extends {BaseAPI}
 */
export class ClientAssistantApi extends BaseAPI implements ClientAssistantApiInterface {
    /**
     * 
     * @summary Pošle zprávu asistentovi a vrátí odpověď s návrhem nákupního seznamu
     * @param {ClientAssistantApiPostMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAssistantApi
     */
    public postMessage(requestParameters: ClientAssistantApiPostMessageRequest, options?: RawAxiosRequestConfig) {
        return ClientAssistantApiFp(this.configuration).postMessage(requestParameters.organizationId, requestParameters.portalId, requestParameters.assistantMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAuctionControllerApi - axios parameter creator
 * @export
 */
export const ClientAuctionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionBasicDetail: async (auctionId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionBasicDetail', 'auctionId', auctionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionBasicDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionBasicDetail', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/{auctionId}/basic`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionDetail: async (auctionId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionDetail', 'auctionId', auctionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionDetail', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/{auctionId}`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionPrices: async (auctionId: number, organizationId: number, portalId: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionPrices', 'auctionId', auctionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionPrices', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionPrices', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/{auctionId}/prices`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (productQuery !== undefined) {
                localVarQueryParameter['productQuery'] = productQuery;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (isGuaranteed !== undefined) {
                localVarQueryParameter['isGuaranteed'] = isGuaranteed;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionProducts: async (auctionId: number, organizationId: number, portalId: number, q?: string, supplierId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionProducts', 'auctionId', auctionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionProducts', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionProducts', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/{auctionId}/products`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [q] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSuppliers: async (auctionId: number, organizationId: number, portalId: number, q?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionSuppliers', 'auctionId', auctionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionSuppliers', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionSuppliers', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/{auctionId}/suppliers`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {string} [validFrom] 
         * @param {string} [validTo] 
         * @param {number} [supplierId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: async (organizationId: number, portalId: number, query?: string, validFrom?: string, validTo?: string, supplierId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctions', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctions', 'portalId', portalId)
            const localVarPath = `/api/client/auctions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (validFrom !== undefined) {
                localVarQueryParameter['validFrom'] = (validFrom as any instanceof Date) ?
                    (validFrom as any).toISOString().substring(0,10) :
                    validFrom;
            }

            if (validTo !== undefined) {
                localVarQueryParameter['validTo'] = (validTo as any instanceof Date) ?
                    (validTo as any).toISOString().substring(0,10) :
                    validTo;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionsByOrganization: async (organizationId: number, portalId: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAuctionsByOrganization', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAuctionsByOrganization', 'portalId', portalId)
            const localVarPath = `/api/client/auctions/organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAuctionControllerApi - functional programming interface
 * @export
 */
export const ClientAuctionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAuctionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionBasicDetail(auctionId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionBasicDetail(auctionId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionBasicDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionDetail(auctionId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionDetail(auctionId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionPrices(auctionId: number, organizationId: number, portalId: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionPriceListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionPrices(auctionId, organizationId, portalId, supplierId, productQuery, priceType, isGuaranteed, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionProducts(auctionId: number, organizationId: number, portalId: number, q?: string, supplierId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionProductListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionProducts(auctionId, organizationId, portalId, q, supplierId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [q] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionSuppliers(auctionId: number, organizationId: number, portalId: number, q?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionSupplierListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionSuppliers(auctionId, organizationId, portalId, q, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {string} [validFrom] 
         * @param {string} [validTo] 
         * @param {number} [supplierId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctions(organizationId: number, portalId: number, query?: string, validFrom?: string, validTo?: string, supplierId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctions(organizationId, portalId, query, validFrom, validTo, supplierId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionsByOrganization(organizationId: number, portalId: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionsByOrganization(organizationId, portalId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionControllerApi.getAuctionsByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAuctionControllerApi - factory interface
 * @export
 */
export const ClientAuctionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAuctionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionBasicDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionBasicDetail(requestParameters: ClientAuctionControllerApiGetAuctionBasicDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionResponseDTO> {
            return localVarFp.getAuctionBasicDetail(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionDetail(requestParameters: ClientAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionDetailDTO> {
            return localVarFp.getAuctionDetail(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionPrices(requestParameters: ClientAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionPriceListDTO> {
            return localVarFp.getAuctionPrices(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionProducts(requestParameters: ClientAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionProductListDTO> {
            return localVarFp.getAuctionProducts(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.q, requestParameters.supplierId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSuppliers(requestParameters: ClientAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionSupplierListDTO> {
            return localVarFp.getAuctionSuppliers(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.q, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions(requestParameters: ClientAuctionControllerApiGetAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionListResponseDTO> {
            return localVarFp.getAuctions(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.validFrom, requestParameters.validTo, requestParameters.supplierId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAuctionControllerApiGetAuctionsByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionsByOrganization(requestParameters: ClientAuctionControllerApiGetAuctionsByOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionListResponseDTO> {
            return localVarFp.getAuctionsByOrganization(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAuctionControllerApi - interface
 * @export
 * @interface ClientAuctionControllerApi
 */
export interface ClientAuctionControllerApiInterface {
    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionBasicDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionBasicDetail(requestParameters: ClientAuctionControllerApiGetAuctionBasicDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionResponseDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionDetail(requestParameters: ClientAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionDetailDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionPrices(requestParameters: ClientAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionPriceListDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionProducts(requestParameters: ClientAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionProductListDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionSuppliers(requestParameters: ClientAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionSupplierListDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctions(requestParameters: ClientAuctionControllerApiGetAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionListResponseDTO>;

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApiInterface
     */
    getAuctionsByOrganization(requestParameters: ClientAuctionControllerApiGetAuctionsByOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionListResponseDTO>;

}

/**
 * Request parameters for getAuctionBasicDetail operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionBasicDetailRequest
 */
export interface ClientAuctionControllerApiGetAuctionBasicDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionBasicDetail
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionBasicDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionBasicDetail
     */
    readonly portalId: number
}

/**
 * Request parameters for getAuctionDetail operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionDetailRequest
 */
export interface ClientAuctionControllerApiGetAuctionDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionDetail
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionDetail
     */
    readonly portalId: number
}

/**
 * Request parameters for getAuctionPrices operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionPricesRequest
 */
export interface ClientAuctionControllerApiGetAuctionPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly supplierId?: number

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly productQuery?: string

    /**
     * 
     * @type {PriceType}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly priceType?: PriceType

    /**
     * 
     * @type {boolean}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly isGuaranteed?: boolean

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionPrices
     */
    readonly size?: number
}

/**
 * Request parameters for getAuctionProducts operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionProductsRequest
 */
export interface ClientAuctionControllerApiGetAuctionProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionProducts
     */
    readonly size?: number
}

/**
 * Request parameters for getAuctionSuppliers operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionSuppliersRequest
 */
export interface ClientAuctionControllerApiGetAuctionSuppliersRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionSuppliers
     */
    readonly size?: number
}

/**
 * Request parameters for getAuctions operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionsRequest
 */
export interface ClientAuctionControllerApiGetAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly query?: string

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly validFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly validTo?: string

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctions
     */
    readonly size?: number
}

/**
 * Request parameters for getAuctionsByOrganization operation in ClientAuctionControllerApi.
 * @export
 * @interface ClientAuctionControllerApiGetAuctionsByOrganizationRequest
 */
export interface ClientAuctionControllerApiGetAuctionsByOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionsByOrganization
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionsByOrganization
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionsByOrganization
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionControllerApiGetAuctionsByOrganization
     */
    readonly size?: number
}

/**
 * ClientAuctionControllerApi - object-oriented interface
 * @export
 * @class ClientAuctionControllerApi
 * @extends {BaseAPI}
 */
export class ClientAuctionControllerApi extends BaseAPI implements ClientAuctionControllerApiInterface {
    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionBasicDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionBasicDetail(requestParameters: ClientAuctionControllerApiGetAuctionBasicDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionBasicDetail(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionDetail(requestParameters: ClientAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionDetail(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionPrices(requestParameters: ClientAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionPrices(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionProducts(requestParameters: ClientAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionProducts(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.q, requestParameters.supplierId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionSuppliers(requestParameters: ClientAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionSuppliers(requestParameters.auctionId, requestParameters.organizationId, requestParameters.portalId, requestParameters.q, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctions(requestParameters: ClientAuctionControllerApiGetAuctionsRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctions(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.validFrom, requestParameters.validTo, requestParameters.supplierId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAuctionControllerApiGetAuctionsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionControllerApi
     */
    public getAuctionsByOrganization(requestParameters: ClientAuctionControllerApiGetAuctionsByOrganizationRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionControllerApiFp(this.configuration).getAuctionsByOrganization(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAuctionLimitsApi - axios parameter creator
 * @export
 */
export const ClientAuctionLimitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Stav limitů nákupu z aukcí (bez DPH) včetně hodnoty košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAuctionLimits: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientAuctionLimits', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientAuctionLimits', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/auction-limits`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAuctionLimitsApi - functional programming interface
 * @export
 */
export const ClientAuctionLimitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAuctionLimitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Stav limitů nákupu z aukcí (bez DPH) včetně hodnoty košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientAuctionLimits(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuctionLimitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientAuctionLimits(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuctionLimitsApi.getClientAuctionLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAuctionLimitsApi - factory interface
 * @export
 */
export const ClientAuctionLimitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAuctionLimitsApiFp(configuration)
    return {
        /**
         * 
         * @summary Stav limitů nákupu z aukcí (bez DPH) včetně hodnoty košíku
         * @param {ClientAuctionLimitsApiGetClientAuctionLimitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAuctionLimits(requestParameters: ClientAuctionLimitsApiGetClientAuctionLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionLimitsResponse> {
            return localVarFp.getClientAuctionLimits(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAuctionLimitsApi - interface
 * @export
 * @interface ClientAuctionLimitsApi
 */
export interface ClientAuctionLimitsApiInterface {
    /**
     * 
     * @summary Stav limitů nákupu z aukcí (bez DPH) včetně hodnoty košíku
     * @param {ClientAuctionLimitsApiGetClientAuctionLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionLimitsApiInterface
     */
    getClientAuctionLimits(requestParameters: ClientAuctionLimitsApiGetClientAuctionLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuctionLimitsResponse>;

}

/**
 * Request parameters for getClientAuctionLimits operation in ClientAuctionLimitsApi.
 * @export
 * @interface ClientAuctionLimitsApiGetClientAuctionLimitsRequest
 */
export interface ClientAuctionLimitsApiGetClientAuctionLimitsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitsApiGetClientAuctionLimits
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientAuctionLimitsApiGetClientAuctionLimits
     */
    readonly portalId: number
}

/**
 * ClientAuctionLimitsApi - object-oriented interface
 * @export
 * @class ClientAuctionLimitsApi
 * @extends {BaseAPI}
 */
export class ClientAuctionLimitsApi extends BaseAPI implements ClientAuctionLimitsApiInterface {
    /**
     * 
     * @summary Stav limitů nákupu z aukcí (bez DPH) včetně hodnoty košíku
     * @param {ClientAuctionLimitsApiGetClientAuctionLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuctionLimitsApi
     */
    public getClientAuctionLimits(requestParameters: ClientAuctionLimitsApiGetClientAuctionLimitsRequest, options?: RawAxiosRequestConfig) {
        return ClientAuctionLimitsApiFp(this.configuration).getClientAuctionLimits(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientBasketManagementApi - axios parameter creator
 * @export
 */
export const ClientBasketManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Akceptuje novou cenu pro položku v košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {AcceptNewPriceRequest} acceptNewPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptNewPrice: async (organizationId: number, portalId: number, acceptNewPriceRequest: AcceptNewPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('acceptNewPrice', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('acceptNewPrice', 'portalId', portalId)
            // verify required parameter 'acceptNewPriceRequest' is not null or undefined
            assertParamExists('acceptNewPrice', 'acceptNewPriceRequest', acceptNewPriceRequest)
            const localVarPath = `/api/client/basket/accept-price/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptNewPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vymaže celý košík
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBasket: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clearBasket', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('clearBasket', 'portalId', portalId)
            const localVarPath = `/api/client/basket/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odstraní všechny položky od dodavatele z košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSupplierBasket: async (organizationId: number, portalId: number, supplierId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clearSupplierBasket', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('clearSupplierBasket', 'portalId', portalId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('clearSupplierBasket', 'supplierId', supplierId)
            const localVarPath = `/api/client/basket/{organizationId}/{portalId}/supplier/{supplierId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá detail košíku klienta
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketDetail: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBasketDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getBasketDetail', 'portalId', portalId)
            const localVarPath = `/api/client/basket/detail/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rozpad košíku po položkách včetně levnější náhrady
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketSavings: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBasketSavings', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getBasketSavings', 'portalId', portalId)
            const localVarPath = `/api/client/basket/savings/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Souhrn košíku pro dashboard – kolik jde ještě ušetřit
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketSummary: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBasketSummary', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getBasketSummary', 'portalId', portalId)
            const localVarPath = `/api/client/basket/summary/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přepočítá košík dle preferovaných dnů doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeBasket: async (organizationId: number, portalId: number, requestBody: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('recomputeBasket', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('recomputeBasket', 'portalId', portalId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('recomputeBasket', 'requestBody', requestBody)
            const localVarPath = `/api/client/basket/recompute-basket/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odstraní produkt z košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductFromBasket: async (organizationId: number, portalId: number, cartItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeProductFromBasket', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('removeProductFromBasket', 'portalId', portalId)
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('removeProductFromBasket', 'cartItemId', cartItemId)
            const localVarPath = `/api/client/basket/{organizationId}/{portalId}/{cartItemId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"cartItemId"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nahradí položku košíku levnější variantou z téže matky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {ReplaceBasketItemRequest} replaceBasketItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceBasketItem: async (organizationId: number, portalId: number, replaceBasketItemRequest: ReplaceBasketItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('replaceBasketItem', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('replaceBasketItem', 'portalId', portalId)
            // verify required parameter 'replaceBasketItemRequest' is not null or undefined
            assertParamExists('replaceBasketItem', 'replaceBasketItemRequest', replaceBasketItemRequest)
            const localVarPath = `/api/client/basket/replace-item/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceBasketItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nastaví množství produktu v košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {SetQuantityRequest} setQuantityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setQuantityForProduct: async (organizationId: number, portalId: number, setQuantityRequest: SetQuantityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setQuantityForProduct', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('setQuantityForProduct', 'portalId', portalId)
            // verify required parameter 'setQuantityRequest' is not null or undefined
            assertParamExists('setQuantityForProduct', 'setQuantityRequest', setQuantityRequest)
            const localVarPath = `/api/client/basket/set-quantity/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientBasketManagementApi - functional programming interface
 * @export
 */
export const ClientBasketManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientBasketManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Akceptuje novou cenu pro položku v košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {AcceptNewPriceRequest} acceptNewPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptNewPrice(organizationId: number, portalId: number, acceptNewPriceRequest: AcceptNewPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptNewPrice(organizationId, portalId, acceptNewPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.acceptNewPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vymaže celý košík
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearBasket(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearBasket(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.clearBasket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odstraní všechny položky od dodavatele z košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearSupplierBasket(organizationId: number, portalId: number, supplierId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearSupplierBasket(organizationId, portalId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.clearSupplierBasket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá detail košíku klienta
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasketDetail(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBasketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasketDetail(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.getBasketDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rozpad košíku po položkách včetně levnější náhrady
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasketSavings(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBasketSavingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasketSavings(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.getBasketSavings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Souhrn košíku pro dashboard – kolik jde ještě ušetřit
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasketSummary(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBasketSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasketSummary(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.getBasketSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přepočítá košík dle preferovaných dnů doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recomputeBasket(organizationId: number, portalId: number, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBasketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recomputeBasket(organizationId, portalId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.recomputeBasket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odstraní produkt z košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProductFromBasket(organizationId: number, portalId: number, cartItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProductFromBasket(organizationId, portalId, cartItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.removeProductFromBasket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nahradí položku košíku levnější variantou z téže matky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {ReplaceBasketItemRequest} replaceBasketItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceBasketItem(organizationId: number, portalId: number, replaceBasketItemRequest: ReplaceBasketItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceBasketItem(organizationId, portalId, replaceBasketItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.replaceBasketItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nastaví množství produktu v košíku
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {SetQuantityRequest} setQuantityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setQuantityForProduct(organizationId: number, portalId: number, setQuantityRequest: SetQuantityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setQuantityForProduct(organizationId, portalId, setQuantityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientBasketManagementApi.setQuantityForProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientBasketManagementApi - factory interface
 * @export
 */
export const ClientBasketManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientBasketManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Akceptuje novou cenu pro položku v košíku
         * @param {ClientBasketManagementApiAcceptNewPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptNewPrice(requestParameters: ClientBasketManagementApiAcceptNewPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptNewPrice(requestParameters.organizationId, requestParameters.portalId, requestParameters.acceptNewPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vymaže celý košík
         * @param {ClientBasketManagementApiClearBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBasket(requestParameters: ClientBasketManagementApiClearBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearBasket(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odstraní všechny položky od dodavatele z košíku
         * @param {ClientBasketManagementApiClearSupplierBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSupplierBasket(requestParameters: ClientBasketManagementApiClearSupplierBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearSupplierBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá detail košíku klienta
         * @param {ClientBasketManagementApiGetBasketDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketDetail(requestParameters: ClientBasketManagementApiGetBasketDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketResponse> {
            return localVarFp.getBasketDetail(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rozpad košíku po položkách včetně levnější náhrady
         * @param {ClientBasketManagementApiGetBasketSavingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketSavings(requestParameters: ClientBasketManagementApiGetBasketSavingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketSavingsResponse> {
            return localVarFp.getBasketSavings(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Souhrn košíku pro dashboard – kolik jde ještě ušetřit
         * @param {ClientBasketManagementApiGetBasketSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketSummary(requestParameters: ClientBasketManagementApiGetBasketSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketSummaryResponse> {
            return localVarFp.getBasketSummary(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přepočítá košík dle preferovaných dnů doručení
         * @param {ClientBasketManagementApiRecomputeBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeBasket(requestParameters: ClientBasketManagementApiRecomputeBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketResponse> {
            return localVarFp.recomputeBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odstraní produkt z košíku
         * @param {ClientBasketManagementApiRemoveProductFromBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductFromBasket(requestParameters: ClientBasketManagementApiRemoveProductFromBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeProductFromBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.cartItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nahradí položku košíku levnější variantou z téže matky
         * @param {ClientBasketManagementApiReplaceBasketItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceBasketItem(requestParameters: ClientBasketManagementApiReplaceBasketItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.replaceBasketItem(requestParameters.organizationId, requestParameters.portalId, requestParameters.replaceBasketItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nastaví množství produktu v košíku
         * @param {ClientBasketManagementApiSetQuantityForProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setQuantityForProduct(requestParameters: ClientBasketManagementApiSetQuantityForProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setQuantityForProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.setQuantityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientBasketManagementApi - interface
 * @export
 * @interface ClientBasketManagementApi
 */
export interface ClientBasketManagementApiInterface {
    /**
     * 
     * @summary Akceptuje novou cenu pro položku v košíku
     * @param {ClientBasketManagementApiAcceptNewPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    acceptNewPrice(requestParameters: ClientBasketManagementApiAcceptNewPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Vymaže celý košík
     * @param {ClientBasketManagementApiClearBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    clearBasket(requestParameters: ClientBasketManagementApiClearBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Odstraní všechny položky od dodavatele z košíku
     * @param {ClientBasketManagementApiClearSupplierBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    clearSupplierBasket(requestParameters: ClientBasketManagementApiClearSupplierBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Získá detail košíku klienta
     * @param {ClientBasketManagementApiGetBasketDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    getBasketDetail(requestParameters: ClientBasketManagementApiGetBasketDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketResponse>;

    /**
     * 
     * @summary Rozpad košíku po položkách včetně levnější náhrady
     * @param {ClientBasketManagementApiGetBasketSavingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    getBasketSavings(requestParameters: ClientBasketManagementApiGetBasketSavingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketSavingsResponse>;

    /**
     * 
     * @summary Souhrn košíku pro dashboard – kolik jde ještě ušetřit
     * @param {ClientBasketManagementApiGetBasketSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    getBasketSummary(requestParameters: ClientBasketManagementApiGetBasketSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketSummaryResponse>;

    /**
     * 
     * @summary Přepočítá košík dle preferovaných dnů doručení
     * @param {ClientBasketManagementApiRecomputeBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    recomputeBasket(requestParameters: ClientBasketManagementApiRecomputeBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBasketResponse>;

    /**
     * 
     * @summary Odstraní produkt z košíku
     * @param {ClientBasketManagementApiRemoveProductFromBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    removeProductFromBasket(requestParameters: ClientBasketManagementApiRemoveProductFromBasketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Nahradí položku košíku levnější variantou z téže matky
     * @param {ClientBasketManagementApiReplaceBasketItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    replaceBasketItem(requestParameters: ClientBasketManagementApiReplaceBasketItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Nastaví množství produktu v košíku
     * @param {ClientBasketManagementApiSetQuantityForProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApiInterface
     */
    setQuantityForProduct(requestParameters: ClientBasketManagementApiSetQuantityForProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for acceptNewPrice operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiAcceptNewPriceRequest
 */
export interface ClientBasketManagementApiAcceptNewPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiAcceptNewPrice
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiAcceptNewPrice
     */
    readonly portalId: number

    /**
     * 
     * @type {AcceptNewPriceRequest}
     * @memberof ClientBasketManagementApiAcceptNewPrice
     */
    readonly acceptNewPriceRequest: AcceptNewPriceRequest
}

/**
 * Request parameters for clearBasket operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiClearBasketRequest
 */
export interface ClientBasketManagementApiClearBasketRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiClearBasket
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiClearBasket
     */
    readonly portalId: number
}

/**
 * Request parameters for clearSupplierBasket operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiClearSupplierBasketRequest
 */
export interface ClientBasketManagementApiClearSupplierBasketRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiClearSupplierBasket
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiClearSupplierBasket
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiClearSupplierBasket
     */
    readonly supplierId: number
}

/**
 * Request parameters for getBasketDetail operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiGetBasketDetailRequest
 */
export interface ClientBasketManagementApiGetBasketDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketDetail
     */
    readonly portalId: number
}

/**
 * Request parameters for getBasketSavings operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiGetBasketSavingsRequest
 */
export interface ClientBasketManagementApiGetBasketSavingsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketSavings
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketSavings
     */
    readonly portalId: number
}

/**
 * Request parameters for getBasketSummary operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiGetBasketSummaryRequest
 */
export interface ClientBasketManagementApiGetBasketSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketSummary
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiGetBasketSummary
     */
    readonly portalId: number
}

/**
 * Request parameters for recomputeBasket operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiRecomputeBasketRequest
 */
export interface ClientBasketManagementApiRecomputeBasketRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiRecomputeBasket
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiRecomputeBasket
     */
    readonly portalId: number

    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ClientBasketManagementApiRecomputeBasket
     */
    readonly requestBody: { [key: string]: string; }
}

/**
 * Request parameters for removeProductFromBasket operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiRemoveProductFromBasketRequest
 */
export interface ClientBasketManagementApiRemoveProductFromBasketRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiRemoveProductFromBasket
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiRemoveProductFromBasket
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiRemoveProductFromBasket
     */
    readonly cartItemId: number
}

/**
 * Request parameters for replaceBasketItem operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiReplaceBasketItemRequest
 */
export interface ClientBasketManagementApiReplaceBasketItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiReplaceBasketItem
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiReplaceBasketItem
     */
    readonly portalId: number

    /**
     * 
     * @type {ReplaceBasketItemRequest}
     * @memberof ClientBasketManagementApiReplaceBasketItem
     */
    readonly replaceBasketItemRequest: ReplaceBasketItemRequest
}

/**
 * Request parameters for setQuantityForProduct operation in ClientBasketManagementApi.
 * @export
 * @interface ClientBasketManagementApiSetQuantityForProductRequest
 */
export interface ClientBasketManagementApiSetQuantityForProductRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiSetQuantityForProduct
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientBasketManagementApiSetQuantityForProduct
     */
    readonly portalId: number

    /**
     * 
     * @type {SetQuantityRequest}
     * @memberof ClientBasketManagementApiSetQuantityForProduct
     */
    readonly setQuantityRequest: SetQuantityRequest
}

/**
 * ClientBasketManagementApi - object-oriented interface
 * @export
 * @class ClientBasketManagementApi
 * @extends {BaseAPI}
 */
export class ClientBasketManagementApi extends BaseAPI implements ClientBasketManagementApiInterface {
    /**
     * 
     * @summary Akceptuje novou cenu pro položku v košíku
     * @param {ClientBasketManagementApiAcceptNewPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public acceptNewPrice(requestParameters: ClientBasketManagementApiAcceptNewPriceRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).acceptNewPrice(requestParameters.organizationId, requestParameters.portalId, requestParameters.acceptNewPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vymaže celý košík
     * @param {ClientBasketManagementApiClearBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public clearBasket(requestParameters: ClientBasketManagementApiClearBasketRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).clearBasket(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odstraní všechny položky od dodavatele z košíku
     * @param {ClientBasketManagementApiClearSupplierBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public clearSupplierBasket(requestParameters: ClientBasketManagementApiClearSupplierBasketRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).clearSupplierBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá detail košíku klienta
     * @param {ClientBasketManagementApiGetBasketDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public getBasketDetail(requestParameters: ClientBasketManagementApiGetBasketDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).getBasketDetail(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rozpad košíku po položkách včetně levnější náhrady
     * @param {ClientBasketManagementApiGetBasketSavingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public getBasketSavings(requestParameters: ClientBasketManagementApiGetBasketSavingsRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).getBasketSavings(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Souhrn košíku pro dashboard – kolik jde ještě ušetřit
     * @param {ClientBasketManagementApiGetBasketSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public getBasketSummary(requestParameters: ClientBasketManagementApiGetBasketSummaryRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).getBasketSummary(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přepočítá košík dle preferovaných dnů doručení
     * @param {ClientBasketManagementApiRecomputeBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public recomputeBasket(requestParameters: ClientBasketManagementApiRecomputeBasketRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).recomputeBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odstraní produkt z košíku
     * @param {ClientBasketManagementApiRemoveProductFromBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public removeProductFromBasket(requestParameters: ClientBasketManagementApiRemoveProductFromBasketRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).removeProductFromBasket(requestParameters.organizationId, requestParameters.portalId, requestParameters.cartItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nahradí položku košíku levnější variantou z téže matky
     * @param {ClientBasketManagementApiReplaceBasketItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public replaceBasketItem(requestParameters: ClientBasketManagementApiReplaceBasketItemRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).replaceBasketItem(requestParameters.organizationId, requestParameters.portalId, requestParameters.replaceBasketItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nastaví množství produktu v košíku
     * @param {ClientBasketManagementApiSetQuantityForProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientBasketManagementApi
     */
    public setQuantityForProduct(requestParameters: ClientBasketManagementApiSetQuantityForProductRequest, options?: RawAxiosRequestConfig) {
        return ClientBasketManagementApiFp(this.configuration).setQuantityForProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.setQuantityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientDashboardApi - axios parameter creator
 * @export
 */
export const ClientDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrati nejblizsi dny s objednavkou (dnesek vcetne) - objednavky dne i zbozi secteny pres cely den. Dny bez objednavky se preskakuji.
         * @summary Nejblizsi zavozove dny
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [days] Kolik nejblizsich zavozovych dnu vratit (1-7)
         * @param {number} [itemsPerDay] Maximalni pocet polozek zbozi na den (1-50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUpcomingDeliveries: async (organizationId: number, portalId: number, days?: number, itemsPerDay?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUpcomingDeliveries', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUpcomingDeliveries', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/dashboard/upcoming-deliveries`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (itemsPerDay !== undefined) {
                localVarQueryParameter['itemsPerDay'] = itemsPerDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientDashboardApi - functional programming interface
 * @export
 */
export const ClientDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrati nejblizsi dny s objednavkou (dnesek vcetne) - objednavky dne i zbozi secteny pres cely den. Dny bez objednavky se preskakuji.
         * @summary Nejblizsi zavozove dny
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [days] Kolik nejblizsich zavozovych dnu vratit (1-7)
         * @param {number} [itemsPerDay] Maximalni pocet polozek zbozi na den (1-50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUpcomingDeliveries(organizationId: number, portalId: number, days?: number, itemsPerDay?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUpcomingDeliveriesResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUpcomingDeliveries(organizationId, portalId, days, itemsPerDay, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientDashboardApi.getClientUpcomingDeliveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientDashboardApi - factory interface
 * @export
 */
export const ClientDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientDashboardApiFp(configuration)
    return {
        /**
         * Vrati nejblizsi dny s objednavkou (dnesek vcetne) - objednavky dne i zbozi secteny pres cely den. Dny bez objednavky se preskakuji.
         * @summary Nejblizsi zavozove dny
         * @param {ClientDashboardApiGetClientUpcomingDeliveriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUpcomingDeliveries(requestParameters: ClientDashboardApiGetClientUpcomingDeliveriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUpcomingDeliveriesResponseDTO> {
            return localVarFp.getClientUpcomingDeliveries(requestParameters.organizationId, requestParameters.portalId, requestParameters.days, requestParameters.itemsPerDay, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientDashboardApi - interface
 * @export
 * @interface ClientDashboardApi
 */
export interface ClientDashboardApiInterface {
    /**
     * Vrati nejblizsi dny s objednavkou (dnesek vcetne) - objednavky dne i zbozi secteny pres cely den. Dny bez objednavky se preskakuji.
     * @summary Nejblizsi zavozove dny
     * @param {ClientDashboardApiGetClientUpcomingDeliveriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDashboardApiInterface
     */
    getClientUpcomingDeliveries(requestParameters: ClientDashboardApiGetClientUpcomingDeliveriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUpcomingDeliveriesResponseDTO>;

}

/**
 * Request parameters for getClientUpcomingDeliveries operation in ClientDashboardApi.
 * @export
 * @interface ClientDashboardApiGetClientUpcomingDeliveriesRequest
 */
export interface ClientDashboardApiGetClientUpcomingDeliveriesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardApiGetClientUpcomingDeliveries
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientDashboardApiGetClientUpcomingDeliveries
     */
    readonly portalId: number

    /**
     * Kolik nejblizsich zavozovych dnu vratit (1-7)
     * @type {number}
     * @memberof ClientDashboardApiGetClientUpcomingDeliveries
     */
    readonly days?: number

    /**
     * Maximalni pocet polozek zbozi na den (1-50)
     * @type {number}
     * @memberof ClientDashboardApiGetClientUpcomingDeliveries
     */
    readonly itemsPerDay?: number
}

/**
 * ClientDashboardApi - object-oriented interface
 * @export
 * @class ClientDashboardApi
 * @extends {BaseAPI}
 */
export class ClientDashboardApi extends BaseAPI implements ClientDashboardApiInterface {
    /**
     * Vrati nejblizsi dny s objednavkou (dnesek vcetne) - objednavky dne i zbozi secteny pres cely den. Dny bez objednavky se preskakuji.
     * @summary Nejblizsi zavozove dny
     * @param {ClientDashboardApiGetClientUpcomingDeliveriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDashboardApi
     */
    public getClientUpcomingDeliveries(requestParameters: ClientDashboardApiGetClientUpcomingDeliveriesRequest, options?: RawAxiosRequestConfig) {
        return ClientDashboardApiFp(this.configuration).getClientUpcomingDeliveries(requestParameters.organizationId, requestParameters.portalId, requestParameters.days, requestParameters.itemsPerDay, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientFavoritesControllerApi - axios parameter creator
 * @export
 */
export const ClientFavoritesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Přidá produkt do oblíbených
         * @summary Přidá produkt do oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToFavorites: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addProductToFavorites', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('addProductToFavorites', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addProductToFavorites', 'productId', productId)
            const localVarPath = `/client/favorites/organization/{organizationId}/portal/{portalId}/product/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrati seznam Id oblibenych
         * @summary Vrati seznam Id oblibenych
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteIds: async (portalId: number, organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getFavoriteIds', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFavoriteIds', 'organizationId', organizationId)
            const localVarPath = `/client/favorites/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Načte seznam oblíbených
         * @summary Načte seznam oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesList: async (organizationId: number, portalId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFavoritesList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getFavoritesList', 'portalId', portalId)
            const localVarPath = `/client/favorites/list/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Odebere produkt z oblíbených
         * @summary Odebere produkt z oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromFavorites: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeFromFavorites', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('removeFromFavorites', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('removeFromFavorites', 'productId', productId)
            const localVarPath = `/client/favorites/organization/{organizationId}/portal/{portalId}/product/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientFavoritesControllerApi - functional programming interface
 * @export
 */
export const ClientFavoritesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientFavoritesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Přidá produkt do oblíbených
         * @summary Přidá produkt do oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductToFavorites(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductToFavorites(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientFavoritesControllerApi.addProductToFavorites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrati seznam Id oblibenych
         * @summary Vrati seznam Id oblibenych
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteIds(portalId: number, organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoriteIds(portalId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientFavoritesControllerApi.getFavoriteIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Načte seznam oblíbených
         * @summary Načte seznam oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritesList(organizationId: number, portalId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientFavoritesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoritesList(organizationId, portalId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientFavoritesControllerApi.getFavoritesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Odebere produkt z oblíbených
         * @summary Odebere produkt z oblíbených
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromFavorites(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromFavorites(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientFavoritesControllerApi.removeFromFavorites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientFavoritesControllerApi - factory interface
 * @export
 */
export const ClientFavoritesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientFavoritesControllerApiFp(configuration)
    return {
        /**
         * Přidá produkt do oblíbených
         * @summary Přidá produkt do oblíbených
         * @param {ClientFavoritesControllerApiAddProductToFavoritesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToFavorites(requestParameters: ClientFavoritesControllerApiAddProductToFavoritesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.addProductToFavorites(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrati seznam Id oblibenych
         * @summary Vrati seznam Id oblibenych
         * @param {ClientFavoritesControllerApiGetFavoriteIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteIds(requestParameters: ClientFavoritesControllerApiGetFavoriteIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getFavoriteIds(requestParameters.portalId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Načte seznam oblíbených
         * @summary Načte seznam oblíbených
         * @param {ClientFavoritesControllerApiGetFavoritesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesList(requestParameters: ClientFavoritesControllerApiGetFavoritesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientFavoritesListResponse> {
            return localVarFp.getFavoritesList(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Odebere produkt z oblíbených
         * @summary Odebere produkt z oblíbených
         * @param {ClientFavoritesControllerApiRemoveFromFavoritesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromFavorites(requestParameters: ClientFavoritesControllerApiRemoveFromFavoritesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.removeFromFavorites(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientFavoritesControllerApi - interface
 * @export
 * @interface ClientFavoritesControllerApi
 */
export interface ClientFavoritesControllerApiInterface {
    /**
     * Přidá produkt do oblíbených
     * @summary Přidá produkt do oblíbených
     * @param {ClientFavoritesControllerApiAddProductToFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApiInterface
     */
    addProductToFavorites(requestParameters: ClientFavoritesControllerApiAddProductToFavoritesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>>;

    /**
     * Vrati seznam Id oblibenych
     * @summary Vrati seznam Id oblibenych
     * @param {ClientFavoritesControllerApiGetFavoriteIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApiInterface
     */
    getFavoriteIds(requestParameters: ClientFavoritesControllerApiGetFavoriteIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>>;

    /**
     * Načte seznam oblíbených
     * @summary Načte seznam oblíbených
     * @param {ClientFavoritesControllerApiGetFavoritesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApiInterface
     */
    getFavoritesList(requestParameters: ClientFavoritesControllerApiGetFavoritesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientFavoritesListResponse>;

    /**
     * Odebere produkt z oblíbených
     * @summary Odebere produkt z oblíbených
     * @param {ClientFavoritesControllerApiRemoveFromFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApiInterface
     */
    removeFromFavorites(requestParameters: ClientFavoritesControllerApiRemoveFromFavoritesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>>;

}

/**
 * Request parameters for addProductToFavorites operation in ClientFavoritesControllerApi.
 * @export
 * @interface ClientFavoritesControllerApiAddProductToFavoritesRequest
 */
export interface ClientFavoritesControllerApiAddProductToFavoritesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiAddProductToFavorites
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiAddProductToFavorites
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiAddProductToFavorites
     */
    readonly productId: number
}

/**
 * Request parameters for getFavoriteIds operation in ClientFavoritesControllerApi.
 * @export
 * @interface ClientFavoritesControllerApiGetFavoriteIdsRequest
 */
export interface ClientFavoritesControllerApiGetFavoriteIdsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiGetFavoriteIds
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiGetFavoriteIds
     */
    readonly organizationId: number
}

/**
 * Request parameters for getFavoritesList operation in ClientFavoritesControllerApi.
 * @export
 * @interface ClientFavoritesControllerApiGetFavoritesListRequest
 */
export interface ClientFavoritesControllerApiGetFavoritesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiGetFavoritesList
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiGetFavoritesList
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientFavoritesControllerApiGetFavoritesList
     */
    readonly query?: string
}

/**
 * Request parameters for removeFromFavorites operation in ClientFavoritesControllerApi.
 * @export
 * @interface ClientFavoritesControllerApiRemoveFromFavoritesRequest
 */
export interface ClientFavoritesControllerApiRemoveFromFavoritesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiRemoveFromFavorites
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiRemoveFromFavorites
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientFavoritesControllerApiRemoveFromFavorites
     */
    readonly productId: number
}

/**
 * ClientFavoritesControllerApi - object-oriented interface
 * @export
 * @class ClientFavoritesControllerApi
 * @extends {BaseAPI}
 */
export class ClientFavoritesControllerApi extends BaseAPI implements ClientFavoritesControllerApiInterface {
    /**
     * Přidá produkt do oblíbených
     * @summary Přidá produkt do oblíbených
     * @param {ClientFavoritesControllerApiAddProductToFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApi
     */
    public addProductToFavorites(requestParameters: ClientFavoritesControllerApiAddProductToFavoritesRequest, options?: RawAxiosRequestConfig) {
        return ClientFavoritesControllerApiFp(this.configuration).addProductToFavorites(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrati seznam Id oblibenych
     * @summary Vrati seznam Id oblibenych
     * @param {ClientFavoritesControllerApiGetFavoriteIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApi
     */
    public getFavoriteIds(requestParameters: ClientFavoritesControllerApiGetFavoriteIdsRequest, options?: RawAxiosRequestConfig) {
        return ClientFavoritesControllerApiFp(this.configuration).getFavoriteIds(requestParameters.portalId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Načte seznam oblíbených
     * @summary Načte seznam oblíbených
     * @param {ClientFavoritesControllerApiGetFavoritesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApi
     */
    public getFavoritesList(requestParameters: ClientFavoritesControllerApiGetFavoritesListRequest, options?: RawAxiosRequestConfig) {
        return ClientFavoritesControllerApiFp(this.configuration).getFavoritesList(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Odebere produkt z oblíbených
     * @summary Odebere produkt z oblíbených
     * @param {ClientFavoritesControllerApiRemoveFromFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientFavoritesControllerApi
     */
    public removeFromFavorites(requestParameters: ClientFavoritesControllerApiRemoveFromFavoritesRequest, options?: RawAxiosRequestConfig) {
        return ClientFavoritesControllerApiFp(this.configuration).removeFromFavorites(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientLoVControllerApi - axios parameter creator
 * @export
 */
export const ClientLoVControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSuppliers: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientSuppliers', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientSuppliers', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/lov/suppliers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientLoVControllerApi - functional programming interface
 * @export
 */
export const ClientLoVControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientLoVControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientSuppliers(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientLoVSupplier>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientSuppliers(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientLoVControllerApi.getClientSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientLoVControllerApi - factory interface
 * @export
 */
export const ClientLoVControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientLoVControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientLoVControllerApiGetClientSuppliersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSuppliers(requestParameters: ClientLoVControllerApiGetClientSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientLoVSupplier>> {
            return localVarFp.getClientSuppliers(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientLoVControllerApi - interface
 * @export
 * @interface ClientLoVControllerApi
 */
export interface ClientLoVControllerApiInterface {
    /**
     * 
     * @param {ClientLoVControllerApiGetClientSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientLoVControllerApiInterface
     */
    getClientSuppliers(requestParameters: ClientLoVControllerApiGetClientSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientLoVSupplier>>;

}

/**
 * Request parameters for getClientSuppliers operation in ClientLoVControllerApi.
 * @export
 * @interface ClientLoVControllerApiGetClientSuppliersRequest
 */
export interface ClientLoVControllerApiGetClientSuppliersRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientLoVControllerApiGetClientSuppliers
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientLoVControllerApiGetClientSuppliers
     */
    readonly portalId: number
}

/**
 * ClientLoVControllerApi - object-oriented interface
 * @export
 * @class ClientLoVControllerApi
 * @extends {BaseAPI}
 */
export class ClientLoVControllerApi extends BaseAPI implements ClientLoVControllerApiInterface {
    /**
     * 
     * @param {ClientLoVControllerApiGetClientSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientLoVControllerApi
     */
    public getClientSuppliers(requestParameters: ClientLoVControllerApiGetClientSuppliersRequest, options?: RawAxiosRequestConfig) {
        return ClientLoVControllerApiFp(this.configuration).getClientSuppliers(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientManualSupplierControllerApi - axios parameter creator
 * @export
 */
export const ClientManualSupplierControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Smazání vlastního dodavatele u produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientManualSupplier: async (organizationId: number, portalId: number, productId: number, supplierId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClientManualSupplier', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteClientManualSupplier', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteClientManualSupplier', 'productId', productId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('deleteClientManualSupplier', 'supplierId', supplierId)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/product/{productId}/manual-supplier/{supplierId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam vlastních dodavatelů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientManualSuppliers: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientManualSuppliers', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientManualSuppliers', 'portalId', portalId)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/manual-suppliers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientManualSupplierControllerApi - functional programming interface
 * @export
 */
export const ClientManualSupplierControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientManualSupplierControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Smazání vlastního dodavatele u produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClientManualSupplier(organizationId: number, portalId: number, productId: number, supplierId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClientManualSupplier(organizationId, portalId, productId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManualSupplierControllerApi.deleteClientManualSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam vlastních dodavatelů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientManualSuppliers(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientManualSupplierListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientManualSuppliers(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManualSupplierControllerApi.getClientManualSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientManualSupplierControllerApi - factory interface
 * @export
 */
export const ClientManualSupplierControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientManualSupplierControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Smazání vlastního dodavatele u produktu
         * @param {ClientManualSupplierControllerApiDeleteClientManualSupplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientManualSupplier(requestParameters: ClientManualSupplierControllerApiDeleteClientManualSupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClientManualSupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam vlastních dodavatelů
         * @param {ClientManualSupplierControllerApiGetClientManualSuppliersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientManualSuppliers(requestParameters: ClientManualSupplierControllerApiGetClientManualSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientManualSupplierListResponse>> {
            return localVarFp.getClientManualSuppliers(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientManualSupplierControllerApi - interface
 * @export
 * @interface ClientManualSupplierControllerApi
 */
export interface ClientManualSupplierControllerApiInterface {
    /**
     * 
     * @summary Smazání vlastního dodavatele u produktu
     * @param {ClientManualSupplierControllerApiDeleteClientManualSupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManualSupplierControllerApiInterface
     */
    deleteClientManualSupplier(requestParameters: ClientManualSupplierControllerApiDeleteClientManualSupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Seznam vlastních dodavatelů
     * @param {ClientManualSupplierControllerApiGetClientManualSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManualSupplierControllerApiInterface
     */
    getClientManualSuppliers(requestParameters: ClientManualSupplierControllerApiGetClientManualSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientManualSupplierListResponse>>;

}

/**
 * Request parameters for deleteClientManualSupplier operation in ClientManualSupplierControllerApi.
 * @export
 * @interface ClientManualSupplierControllerApiDeleteClientManualSupplierRequest
 */
export interface ClientManualSupplierControllerApiDeleteClientManualSupplierRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiDeleteClientManualSupplier
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiDeleteClientManualSupplier
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiDeleteClientManualSupplier
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiDeleteClientManualSupplier
     */
    readonly supplierId: number
}

/**
 * Request parameters for getClientManualSuppliers operation in ClientManualSupplierControllerApi.
 * @export
 * @interface ClientManualSupplierControllerApiGetClientManualSuppliersRequest
 */
export interface ClientManualSupplierControllerApiGetClientManualSuppliersRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiGetClientManualSuppliers
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientManualSupplierControllerApiGetClientManualSuppliers
     */
    readonly portalId: number
}

/**
 * ClientManualSupplierControllerApi - object-oriented interface
 * @export
 * @class ClientManualSupplierControllerApi
 * @extends {BaseAPI}
 */
export class ClientManualSupplierControllerApi extends BaseAPI implements ClientManualSupplierControllerApiInterface {
    /**
     * 
     * @summary Smazání vlastního dodavatele u produktu
     * @param {ClientManualSupplierControllerApiDeleteClientManualSupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManualSupplierControllerApi
     */
    public deleteClientManualSupplier(requestParameters: ClientManualSupplierControllerApiDeleteClientManualSupplierRequest, options?: RawAxiosRequestConfig) {
        return ClientManualSupplierControllerApiFp(this.configuration).deleteClientManualSupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam vlastních dodavatelů
     * @param {ClientManualSupplierControllerApiGetClientManualSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManualSupplierControllerApi
     */
    public getClientManualSuppliers(requestParameters: ClientManualSupplierControllerApiGetClientManualSuppliersRequest, options?: RawAxiosRequestConfig) {
        return ClientManualSupplierControllerApiFp(this.configuration).getClientManualSuppliers(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientMessagesApi - axios parameter creator
 * @export
 */
export const ClientMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageThreads: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMessageThreads', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getMessageThreads', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/messages/threads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {number} orderId ID objednávky
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderMessageThread: async (orderId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderMessageThread', 'orderId', orderId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrderMessageThread', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrderMessageThread', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/order/{orderId}/messages`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessagesCount: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUnreadMessagesCount', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getUnreadMessagesCount', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/messages/unread-count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markClientMessagesAsRead: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('markClientMessagesAsRead', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('markClientMessagesAsRead', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('markClientMessagesAsRead', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/order/{orderId}/mark-read`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {number} orderId ID objednávky
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {SendMessageRequest} sendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: async (orderId: number, organizationId: number, portalId: number, sendMessageRequest: SendMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('sendMessage', 'orderId', orderId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendMessage', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('sendMessage', 'portalId', portalId)
            // verify required parameter 'sendMessageRequest' is not null or undefined
            assertParamExists('sendMessage', 'sendMessageRequest', sendMessageRequest)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientMessagesApi - functional programming interface
 * @export
 */
export const ClientMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageThreads(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientMessageThreadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageThreads(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientMessagesApi.getMessageThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {number} orderId ID objednávky
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderMessageThread(orderId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderMessageThread(orderId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientMessagesApi.getOrderMessageThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadMessagesCount(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadMessagesCount(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientMessagesApi.getUnreadMessagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markClientMessagesAsRead(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markClientMessagesAsRead(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientMessagesApi.markClientMessagesAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {number} orderId ID objednávky
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {SendMessageRequest} sendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessage(orderId: number, organizationId: number, portalId: number, sendMessageRequest: SendMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessage(orderId, organizationId, portalId, sendMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientMessagesApi.sendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientMessagesApi - factory interface
 * @export
 */
export const ClientMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientMessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro uživatele
         * @param {ClientMessagesApiGetMessageThreadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageThreads(requestParameters: ClientMessagesApiGetMessageThreadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientMessageThreadListResponse> {
            return localVarFp.getMessageThreads(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {ClientMessagesApiGetOrderMessageThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderMessageThread(requestParameters: ClientMessagesApiGetOrderMessageThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderMessagesResponse> {
            return localVarFp.getOrderMessageThread(requestParameters.orderId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro uživatele
         * @param {ClientMessagesApiGetUnreadMessagesCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessagesCount(requestParameters: ClientMessagesApiGetUnreadMessagesCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getUnreadMessagesCount(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {ClientMessagesApiMarkClientMessagesAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markClientMessagesAsRead(requestParameters: ClientMessagesApiMarkClientMessagesAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markClientMessagesAsRead(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {ClientMessagesApiSendMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(requestParameters: ClientMessagesApiSendMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendMessage(requestParameters.orderId, requestParameters.organizationId, requestParameters.portalId, requestParameters.sendMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientMessagesApi - interface
 * @export
 * @interface ClientMessagesApi
 */
export interface ClientMessagesApiInterface {
    /**
     * 
     * @summary Získá seznam vláken zpráv pro uživatele
     * @param {ClientMessagesApiGetMessageThreadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApiInterface
     */
    getMessageThreads(requestParameters: ClientMessagesApiGetMessageThreadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientMessageThreadListResponse>;

    /**
     * 
     * @summary Získá vlákno zpráv k objednávce
     * @param {ClientMessagesApiGetOrderMessageThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApiInterface
     */
    getOrderMessageThread(requestParameters: ClientMessagesApiGetOrderMessageThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderMessagesResponse>;

    /**
     * 
     * @summary Získá počet nepřečtených zpráv pro uživatele
     * @param {ClientMessagesApiGetUnreadMessagesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApiInterface
     */
    getUnreadMessagesCount(requestParameters: ClientMessagesApiGetUnreadMessagesCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Označí zprávy k objednávce jako přečtené
     * @param {ClientMessagesApiMarkClientMessagesAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApiInterface
     */
    markClientMessagesAsRead(requestParameters: ClientMessagesApiMarkClientMessagesAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Odešle zprávu k objednávce
     * @param {ClientMessagesApiSendMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApiInterface
     */
    sendMessage(requestParameters: ClientMessagesApiSendMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getMessageThreads operation in ClientMessagesApi.
 * @export
 * @interface ClientMessagesApiGetMessageThreadsRequest
 */
export interface ClientMessagesApiGetMessageThreadsRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientMessagesApiGetMessageThreads
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientMessagesApiGetMessageThreads
     */
    readonly portalId: number
}

/**
 * Request parameters for getOrderMessageThread operation in ClientMessagesApi.
 * @export
 * @interface ClientMessagesApiGetOrderMessageThreadRequest
 */
export interface ClientMessagesApiGetOrderMessageThreadRequest {
    /**
     * ID objednávky
     * @type {number}
     * @memberof ClientMessagesApiGetOrderMessageThread
     */
    readonly orderId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientMessagesApiGetOrderMessageThread
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientMessagesApiGetOrderMessageThread
     */
    readonly portalId: number
}

/**
 * Request parameters for getUnreadMessagesCount operation in ClientMessagesApi.
 * @export
 * @interface ClientMessagesApiGetUnreadMessagesCountRequest
 */
export interface ClientMessagesApiGetUnreadMessagesCountRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientMessagesApiGetUnreadMessagesCount
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientMessagesApiGetUnreadMessagesCount
     */
    readonly portalId: number
}

/**
 * Request parameters for markClientMessagesAsRead operation in ClientMessagesApi.
 * @export
 * @interface ClientMessagesApiMarkClientMessagesAsReadRequest
 */
export interface ClientMessagesApiMarkClientMessagesAsReadRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientMessagesApiMarkClientMessagesAsRead
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientMessagesApiMarkClientMessagesAsRead
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientMessagesApiMarkClientMessagesAsRead
     */
    readonly orderId: number
}

/**
 * Request parameters for sendMessage operation in ClientMessagesApi.
 * @export
 * @interface ClientMessagesApiSendMessageRequest
 */
export interface ClientMessagesApiSendMessageRequest {
    /**
     * ID objednávky
     * @type {number}
     * @memberof ClientMessagesApiSendMessage
     */
    readonly orderId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientMessagesApiSendMessage
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientMessagesApiSendMessage
     */
    readonly portalId: number

    /**
     * 
     * @type {SendMessageRequest}
     * @memberof ClientMessagesApiSendMessage
     */
    readonly sendMessageRequest: SendMessageRequest
}

/**
 * ClientMessagesApi - object-oriented interface
 * @export
 * @class ClientMessagesApi
 * @extends {BaseAPI}
 */
export class ClientMessagesApi extends BaseAPI implements ClientMessagesApiInterface {
    /**
     * 
     * @summary Získá seznam vláken zpráv pro uživatele
     * @param {ClientMessagesApiGetMessageThreadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApi
     */
    public getMessageThreads(requestParameters: ClientMessagesApiGetMessageThreadsRequest, options?: RawAxiosRequestConfig) {
        return ClientMessagesApiFp(this.configuration).getMessageThreads(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá vlákno zpráv k objednávce
     * @param {ClientMessagesApiGetOrderMessageThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApi
     */
    public getOrderMessageThread(requestParameters: ClientMessagesApiGetOrderMessageThreadRequest, options?: RawAxiosRequestConfig) {
        return ClientMessagesApiFp(this.configuration).getOrderMessageThread(requestParameters.orderId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá počet nepřečtených zpráv pro uživatele
     * @param {ClientMessagesApiGetUnreadMessagesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApi
     */
    public getUnreadMessagesCount(requestParameters: ClientMessagesApiGetUnreadMessagesCountRequest, options?: RawAxiosRequestConfig) {
        return ClientMessagesApiFp(this.configuration).getUnreadMessagesCount(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Označí zprávy k objednávce jako přečtené
     * @param {ClientMessagesApiMarkClientMessagesAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApi
     */
    public markClientMessagesAsRead(requestParameters: ClientMessagesApiMarkClientMessagesAsReadRequest, options?: RawAxiosRequestConfig) {
        return ClientMessagesApiFp(this.configuration).markClientMessagesAsRead(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odešle zprávu k objednávce
     * @param {ClientMessagesApiSendMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientMessagesApi
     */
    public sendMessage(requestParameters: ClientMessagesApiSendMessageRequest, options?: RawAxiosRequestConfig) {
        return ClientMessagesApiFp(this.configuration).sendMessage(requestParameters.orderId, requestParameters.organizationId, requestParameters.portalId, requestParameters.sendMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientNotificationPreferencesApi - axios parameter creator
 * @export
 */
export const ClientNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Seznam notifikačních preferencí uživatele
         * @param {number} portalId ID portálu
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNotificationPreferences: async (portalId: number, organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientNotificationPreferences', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientNotificationPreferences', 'organizationId', organizationId)
            const localVarPath = `/api/client/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uložení notifikační preference
         * @param {number} portalId ID portálu
         * @param {number} organizationId ID organizace
         * @param {ClientNotificationPreferenceRequest} clientNotificationPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientNotificationPreference: async (portalId: number, organizationId: number, clientNotificationPreferenceRequest: ClientNotificationPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('setClientNotificationPreference', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setClientNotificationPreference', 'organizationId', organizationId)
            // verify required parameter 'clientNotificationPreferenceRequest' is not null or undefined
            assertParamExists('setClientNotificationPreference', 'clientNotificationPreferenceRequest', clientNotificationPreferenceRequest)
            const localVarPath = `/api/client/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientNotificationPreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientNotificationPreferencesApi - functional programming interface
 * @export
 */
export const ClientNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Seznam notifikačních preferencí uživatele
         * @param {number} portalId ID portálu
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientNotificationPreferences(portalId: number, organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientNotificationPreferenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientNotificationPreferences(portalId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.getClientNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uložení notifikační preference
         * @param {number} portalId ID portálu
         * @param {number} organizationId ID organizace
         * @param {ClientNotificationPreferenceRequest} clientNotificationPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setClientNotificationPreference(portalId: number, organizationId: number, clientNotificationPreferenceRequest: ClientNotificationPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setClientNotificationPreference(portalId, organizationId, clientNotificationPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.setClientNotificationPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientNotificationPreferencesApi - factory interface
 * @export
 */
export const ClientNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Seznam notifikačních preferencí uživatele
         * @param {ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNotificationPreferences(requestParameters: ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientNotificationPreferenceResponse>> {
            return localVarFp.getClientNotificationPreferences(requestParameters.portalId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uložení notifikační preference
         * @param {ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientNotificationPreference(requestParameters: ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setClientNotificationPreference(requestParameters.portalId, requestParameters.organizationId, requestParameters.clientNotificationPreferenceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientNotificationPreferencesApi - interface
 * @export
 * @interface ClientNotificationPreferencesApi
 */
export interface ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Seznam notifikačních preferencí uživatele
     * @param {ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNotificationPreferencesApiInterface
     */
    getClientNotificationPreferences(requestParameters: ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientNotificationPreferenceResponse>>;

    /**
     * 
     * @summary Uložení notifikační preference
     * @param {ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNotificationPreferencesApiInterface
     */
    setClientNotificationPreference(requestParameters: ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getClientNotificationPreferences operation in ClientNotificationPreferencesApi.
 * @export
 * @interface ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest
 */
export interface ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest {
    /**
     * ID portálu
     * @type {number}
     * @memberof ClientNotificationPreferencesApiGetClientNotificationPreferences
     */
    readonly portalId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientNotificationPreferencesApiGetClientNotificationPreferences
     */
    readonly organizationId: number
}

/**
 * Request parameters for setClientNotificationPreference operation in ClientNotificationPreferencesApi.
 * @export
 * @interface ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest
 */
export interface ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest {
    /**
     * ID portálu
     * @type {number}
     * @memberof ClientNotificationPreferencesApiSetClientNotificationPreference
     */
    readonly portalId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientNotificationPreferencesApiSetClientNotificationPreference
     */
    readonly organizationId: number

    /**
     * 
     * @type {ClientNotificationPreferenceRequest}
     * @memberof ClientNotificationPreferencesApiSetClientNotificationPreference
     */
    readonly clientNotificationPreferenceRequest: ClientNotificationPreferenceRequest
}

/**
 * ClientNotificationPreferencesApi - object-oriented interface
 * @export
 * @class ClientNotificationPreferencesApi
 * @extends {BaseAPI}
 */
export class ClientNotificationPreferencesApi extends BaseAPI implements ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Seznam notifikačních preferencí uživatele
     * @param {ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNotificationPreferencesApi
     */
    public getClientNotificationPreferences(requestParameters: ClientNotificationPreferencesApiGetClientNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).getClientNotificationPreferences(requestParameters.portalId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uložení notifikační preference
     * @param {ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNotificationPreferencesApi
     */
    public setClientNotificationPreference(requestParameters: ClientNotificationPreferencesApiSetClientNotificationPreferenceRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).setClientNotificationPreference(requestParameters.portalId, requestParameters.organizationId, requestParameters.clientNotificationPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientOrderControllerApi - axios parameter creator
 * @export
 */
export const ClientOrderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('cancelOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrder', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} orderNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrderNumberAvailable: async (organizationId: number, portalId: number, orderNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('checkOrderNumberAvailable', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('checkOrderNumberAvailable', 'portalId', portalId)
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('checkOrderNumberAvailable', 'orderNumber', orderNumber)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/check-order-number`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderNumber !== undefined) {
                localVarQueryParameter['orderNumber'] = orderNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (organizationId: number, portalId: number, createOrderRequest: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('createOrder', 'portalId', portalId)
            // verify required parameter 'createOrderRequest' is not null or undefined
            assertParamExists('createOrder', 'createOrderRequest', createOrderRequest)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderCsv: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadOrderCsv', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('downloadOrderCsv', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('downloadOrderCsv', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderPdf: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadOrderPdf', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('downloadOrderPdf', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('downloadOrderPdf', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/pdf`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClientOrderItemsCsv: async (organizationId: number, portalId: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportClientOrderItemsCsv', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('exportClientOrderItemsCsv', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/items/export`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClientOrdersCsv: async (organizationId: number, portalId: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportClientOrdersCsv', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('exportClientOrdersCsv', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/export`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishOrder: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('finishOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('finishOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('finishOrder', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/finish`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCsvBase64: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrderCsvBase64', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrderCsvBase64', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderCsvBase64', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/csv-base64`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrderDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrderDetail', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderDetail', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPdfBase64: async (organizationId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrderPdfBase64', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrderPdfBase64', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderPdfBase64', 'orderId', orderId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/pdf-base64`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (organizationId: number, portalId: number, page?: number, size?: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrders', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrders', 'portalId', portalId)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {RepeatOrderRequest} repeatOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatOrder: async (organizationId: number, portalId: number, orderId: number, repeatOrderRequest: RepeatOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('repeatOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('repeatOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('repeatOrder', 'orderId', orderId)
            // verify required parameter 'repeatOrderRequest' is not null or undefined
            assertParamExists('repeatOrder', 'repeatOrderRequest', repeatOrderRequest)
            const localVarPath = `/api/client/organizations/{organizationId}/portals/{portalId}/orders/{orderId}/repeat`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repeatOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientOrderControllerApi - functional programming interface
 * @export
 */
export const ClientOrderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientOrderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} orderNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkOrderNumberAvailable(organizationId: number, portalId: number, orderNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientOrderNumberAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkOrderNumberAvailable(organizationId, portalId, orderNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.checkOrderNumberAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(organizationId: number, portalId: number, createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(organizationId, portalId, createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.createOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrderCsv(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrderCsv(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.downloadOrderCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrderPdf(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrderPdf(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.downloadOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClientOrderItemsCsv(organizationId: number, portalId: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClientOrderItemsCsv(organizationId, portalId, query, orderStatus, orderType, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.exportClientOrderItemsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClientOrdersCsv(organizationId: number, portalId: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClientOrdersCsv(organizationId, portalId, query, orderStatus, orderType, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.exportClientOrdersCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishOrder(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishOrder(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.finishOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderCsvBase64(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderCsvBase64(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.getOrderCsvBase64']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetail(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetail(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.getOrderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderPdfBase64(organizationId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPdfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderPdfBase64(organizationId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.getOrderPdfBase64']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {OrderType} [orderType] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(organizationId: number, portalId: number, page?: number, size?: number, query?: string, orderStatus?: OrderStatus, orderType?: OrderType, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientOrderListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(organizationId, portalId, page, size, query, orderStatus, orderType, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {RepeatOrderRequest} repeatOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repeatOrder(organizationId: number, portalId: number, orderId: number, repeatOrderRequest: RepeatOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepeatOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repeatOrder(organizationId, portalId, orderId, repeatOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderControllerApi.repeatOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientOrderControllerApi - factory interface
 * @export
 */
export const ClientOrderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientOrderControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientOrderControllerApiCancelOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(requestParameters: ClientOrderControllerApiCancelOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiCheckOrderNumberAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrderNumberAvailable(requestParameters: ClientOrderControllerApiCheckOrderNumberAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderNumberAvailableResponse> {
            return localVarFp.checkOrderNumberAvailable(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiCreateOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(requestParameters: ClientOrderControllerApiCreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse> {
            return localVarFp.createOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderCsv(requestParameters: ClientOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadOrderCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderPdf(requestParameters: ClientOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadOrderPdf(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiExportClientOrderItemsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClientOrderItemsCsv(requestParameters: ClientOrderControllerApiExportClientOrderItemsCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exportClientOrderItemsCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiExportClientOrdersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClientOrdersCsv(requestParameters: ClientOrderControllerApiExportClientOrdersCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exportClientOrdersCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiFinishOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishOrder(requestParameters: ClientOrderControllerApiFinishOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finishOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiGetOrderCsvBase64Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCsvBase64(requestParameters: ClientOrderControllerApiGetOrderCsvBase64Request, options?: RawAxiosRequestConfig): AxiosPromise<OrderExportResponse> {
            return localVarFp.getOrderCsvBase64(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail(requestParameters: ClientOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderDetailDTO> {
            return localVarFp.getOrderDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiGetOrderPdfBase64Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPdfBase64(requestParameters: ClientOrderControllerApiGetOrderPdfBase64Request, options?: RawAxiosRequestConfig): AxiosPromise<OrderPdfResponse> {
            return localVarFp.getOrderPdfBase64(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(requestParameters: ClientOrderControllerApiGetOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderListResponseDTO> {
            return localVarFp.getOrders(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientOrderControllerApiRepeatOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatOrder(requestParameters: ClientOrderControllerApiRepeatOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepeatOrderResponse> {
            return localVarFp.repeatOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, requestParameters.repeatOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientOrderControllerApi - interface
 * @export
 * @interface ClientOrderControllerApi
 */
export interface ClientOrderControllerApiInterface {
    /**
     * 
     * @param {ClientOrderControllerApiCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    cancelOrder(requestParameters: ClientOrderControllerApiCancelOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ClientOrderControllerApiCheckOrderNumberAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    checkOrderNumberAvailable(requestParameters: ClientOrderControllerApiCheckOrderNumberAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderNumberAvailableResponse>;

    /**
     * 
     * @param {ClientOrderControllerApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    createOrder(requestParameters: ClientOrderControllerApiCreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse>;

    /**
     * 
     * @param {ClientOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    downloadOrderCsv(requestParameters: ClientOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {ClientOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    downloadOrderPdf(requestParameters: ClientOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {ClientOrderControllerApiExportClientOrderItemsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    exportClientOrderItemsCsv(requestParameters: ClientOrderControllerApiExportClientOrderItemsCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @param {ClientOrderControllerApiExportClientOrdersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    exportClientOrdersCsv(requestParameters: ClientOrderControllerApiExportClientOrdersCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @param {ClientOrderControllerApiFinishOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    finishOrder(requestParameters: ClientOrderControllerApiFinishOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderCsvBase64Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    getOrderCsvBase64(requestParameters: ClientOrderControllerApiGetOrderCsvBase64Request, options?: RawAxiosRequestConfig): AxiosPromise<OrderExportResponse>;

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    getOrderDetail(requestParameters: ClientOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderDetailDTO>;

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderPdfBase64Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    getOrderPdfBase64(requestParameters: ClientOrderControllerApiGetOrderPdfBase64Request, options?: RawAxiosRequestConfig): AxiosPromise<OrderPdfResponse>;

    /**
     * 
     * @param {ClientOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    getOrders(requestParameters: ClientOrderControllerApiGetOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientOrderListResponseDTO>;

    /**
     * 
     * @param {ClientOrderControllerApiRepeatOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApiInterface
     */
    repeatOrder(requestParameters: ClientOrderControllerApiRepeatOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepeatOrderResponse>;

}

/**
 * Request parameters for cancelOrder operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiCancelOrderRequest
 */
export interface ClientOrderControllerApiCancelOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCancelOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCancelOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCancelOrder
     */
    readonly orderId: number
}

/**
 * Request parameters for checkOrderNumberAvailable operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiCheckOrderNumberAvailableRequest
 */
export interface ClientOrderControllerApiCheckOrderNumberAvailableRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCheckOrderNumberAvailable
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCheckOrderNumberAvailable
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiCheckOrderNumberAvailable
     */
    readonly orderNumber: string
}

/**
 * Request parameters for createOrder operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiCreateOrderRequest
 */
export interface ClientOrderControllerApiCreateOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCreateOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiCreateOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {CreateOrderRequest}
     * @memberof ClientOrderControllerApiCreateOrder
     */
    readonly createOrderRequest: CreateOrderRequest
}

/**
 * Request parameters for downloadOrderCsv operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiDownloadOrderCsvRequest
 */
export interface ClientOrderControllerApiDownloadOrderCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderCsv
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderCsv
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderCsv
     */
    readonly orderId: number
}

/**
 * Request parameters for downloadOrderPdf operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiDownloadOrderPdfRequest
 */
export interface ClientOrderControllerApiDownloadOrderPdfRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderPdf
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderPdf
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiDownloadOrderPdf
     */
    readonly orderId: number
}

/**
 * Request parameters for exportClientOrderItemsCsv operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiExportClientOrderItemsCsvRequest
 */
export interface ClientOrderControllerApiExportClientOrderItemsCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly query?: string

    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly orderStatus?: OrderStatus

    /**
     * 
     * @type {OrderType}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly orderType?: OrderType

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrderItemsCsv
     */
    readonly dateTo?: string
}

/**
 * Request parameters for exportClientOrdersCsv operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiExportClientOrdersCsvRequest
 */
export interface ClientOrderControllerApiExportClientOrdersCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly query?: string

    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly orderStatus?: OrderStatus

    /**
     * 
     * @type {OrderType}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly orderType?: OrderType

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiExportClientOrdersCsv
     */
    readonly dateTo?: string
}

/**
 * Request parameters for finishOrder operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiFinishOrderRequest
 */
export interface ClientOrderControllerApiFinishOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiFinishOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiFinishOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiFinishOrder
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrderCsvBase64 operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiGetOrderCsvBase64Request
 */
export interface ClientOrderControllerApiGetOrderCsvBase64Request {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderCsvBase64
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderCsvBase64
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderCsvBase64
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrderDetail operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiGetOrderDetailRequest
 */
export interface ClientOrderControllerApiGetOrderDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderDetail
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrderPdfBase64 operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiGetOrderPdfBase64Request
 */
export interface ClientOrderControllerApiGetOrderPdfBase64Request {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderPdfBase64
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderPdfBase64
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrderPdfBase64
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrders operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiGetOrdersRequest
 */
export interface ClientOrderControllerApiGetOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly query?: string

    /**
     * 
     * @type {OrderStatus}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly orderStatus?: OrderStatus

    /**
     * 
     * @type {OrderType}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly orderType?: OrderType

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ClientOrderControllerApiGetOrders
     */
    readonly dateTo?: string
}

/**
 * Request parameters for repeatOrder operation in ClientOrderControllerApi.
 * @export
 * @interface ClientOrderControllerApiRepeatOrderRequest
 */
export interface ClientOrderControllerApiRepeatOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiRepeatOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiRepeatOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientOrderControllerApiRepeatOrder
     */
    readonly orderId: number

    /**
     * 
     * @type {RepeatOrderRequest}
     * @memberof ClientOrderControllerApiRepeatOrder
     */
    readonly repeatOrderRequest: RepeatOrderRequest
}

/**
 * ClientOrderControllerApi - object-oriented interface
 * @export
 * @class ClientOrderControllerApi
 * @extends {BaseAPI}
 */
export class ClientOrderControllerApi extends BaseAPI implements ClientOrderControllerApiInterface {
    /**
     * 
     * @param {ClientOrderControllerApiCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public cancelOrder(requestParameters: ClientOrderControllerApiCancelOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).cancelOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiCheckOrderNumberAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public checkOrderNumberAvailable(requestParameters: ClientOrderControllerApiCheckOrderNumberAvailableRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).checkOrderNumberAvailable(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public createOrder(requestParameters: ClientOrderControllerApiCreateOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).createOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public downloadOrderCsv(requestParameters: ClientOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).downloadOrderCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public downloadOrderPdf(requestParameters: ClientOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).downloadOrderPdf(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiExportClientOrderItemsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public exportClientOrderItemsCsv(requestParameters: ClientOrderControllerApiExportClientOrderItemsCsvRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).exportClientOrderItemsCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiExportClientOrdersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public exportClientOrdersCsv(requestParameters: ClientOrderControllerApiExportClientOrdersCsvRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).exportClientOrdersCsv(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiFinishOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public finishOrder(requestParameters: ClientOrderControllerApiFinishOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).finishOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderCsvBase64Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public getOrderCsvBase64(requestParameters: ClientOrderControllerApiGetOrderCsvBase64Request, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).getOrderCsvBase64(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public getOrderDetail(requestParameters: ClientOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).getOrderDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiGetOrderPdfBase64Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public getOrderPdfBase64(requestParameters: ClientOrderControllerApiGetOrderPdfBase64Request, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).getOrderPdfBase64(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public getOrders(requestParameters: ClientOrderControllerApiGetOrdersRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).getOrders(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.orderStatus, requestParameters.orderType, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientOrderControllerApiRepeatOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderControllerApi
     */
    public repeatOrder(requestParameters: ClientOrderControllerApiRepeatOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderControllerApiFp(this.configuration).repeatOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, requestParameters.repeatOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientPreferredDeliveryControllerApi - axios parameter creator
 * @export
 */
export const ClientPreferredDeliveryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí preferovaný termín doručení pro uživatele, pokud neexistuje, vytvoří výchozí
         * @summary Získá nebo vytvoří preferovaný termín doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreatePreferredDelivery: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrCreatePreferredDelivery', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrCreatePreferredDelivery', 'portalId', portalId)
            const localVarPath = `/api/client/preferred-delivery/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nastaví preferovaný termín doručení pro uživatele
         * @summary Nastaví preferovaný termín doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {SetPreferredDeliveryRequest} setPreferredDeliveryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPreferredDelivery: async (organizationId: number, portalId: number, setPreferredDeliveryRequest: SetPreferredDeliveryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setPreferredDelivery', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('setPreferredDelivery', 'portalId', portalId)
            // verify required parameter 'setPreferredDeliveryRequest' is not null or undefined
            assertParamExists('setPreferredDelivery', 'setPreferredDeliveryRequest', setPreferredDeliveryRequest)
            const localVarPath = `/api/client/preferred-delivery/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPreferredDeliveryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPreferredDeliveryControllerApi - functional programming interface
 * @export
 */
export const ClientPreferredDeliveryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientPreferredDeliveryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí preferovaný termín doručení pro uživatele, pokud neexistuje, vytvoří výchozí
         * @summary Získá nebo vytvoří preferovaný termín doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrCreatePreferredDelivery(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferredDeliveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrCreatePreferredDelivery(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPreferredDeliveryControllerApi.getOrCreatePreferredDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nastaví preferovaný termín doručení pro uživatele
         * @summary Nastaví preferovaný termín doručení
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {SetPreferredDeliveryRequest} setPreferredDeliveryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPreferredDelivery(organizationId: number, portalId: number, setPreferredDeliveryRequest: SetPreferredDeliveryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPreferredDelivery(organizationId, portalId, setPreferredDeliveryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPreferredDeliveryControllerApi.setPreferredDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientPreferredDeliveryControllerApi - factory interface
 * @export
 */
export const ClientPreferredDeliveryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientPreferredDeliveryControllerApiFp(configuration)
    return {
        /**
         * Vrátí preferovaný termín doručení pro uživatele, pokud neexistuje, vytvoří výchozí
         * @summary Získá nebo vytvoří preferovaný termín doručení
         * @param {ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreatePreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreferredDeliveryResponse> {
            return localVarFp.getOrCreatePreferredDelivery(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nastaví preferovaný termín doručení pro uživatele
         * @summary Nastaví preferovaný termín doručení
         * @param {ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPreferredDelivery(requestParameters.organizationId, requestParameters.portalId, requestParameters.setPreferredDeliveryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPreferredDeliveryControllerApi - interface
 * @export
 * @interface ClientPreferredDeliveryControllerApi
 */
export interface ClientPreferredDeliveryControllerApiInterface {
    /**
     * Vrátí preferovaný termín doručení pro uživatele, pokud neexistuje, vytvoří výchozí
     * @summary Získá nebo vytvoří preferovaný termín doručení
     * @param {ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPreferredDeliveryControllerApiInterface
     */
    getOrCreatePreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreferredDeliveryResponse>;

    /**
     * Nastaví preferovaný termín doručení pro uživatele
     * @summary Nastaví preferovaný termín doručení
     * @param {ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPreferredDeliveryControllerApiInterface
     */
    setPreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getOrCreatePreferredDelivery operation in ClientPreferredDeliveryControllerApi.
 * @export
 * @interface ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest
 */
export interface ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientPreferredDeliveryControllerApiGetOrCreatePreferredDelivery
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientPreferredDeliveryControllerApiGetOrCreatePreferredDelivery
     */
    readonly portalId: number
}

/**
 * Request parameters for setPreferredDelivery operation in ClientPreferredDeliveryControllerApi.
 * @export
 * @interface ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest
 */
export interface ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientPreferredDeliveryControllerApiSetPreferredDelivery
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientPreferredDeliveryControllerApiSetPreferredDelivery
     */
    readonly portalId: number

    /**
     * 
     * @type {SetPreferredDeliveryRequest}
     * @memberof ClientPreferredDeliveryControllerApiSetPreferredDelivery
     */
    readonly setPreferredDeliveryRequest: SetPreferredDeliveryRequest
}

/**
 * ClientPreferredDeliveryControllerApi - object-oriented interface
 * @export
 * @class ClientPreferredDeliveryControllerApi
 * @extends {BaseAPI}
 */
export class ClientPreferredDeliveryControllerApi extends BaseAPI implements ClientPreferredDeliveryControllerApiInterface {
    /**
     * Vrátí preferovaný termín doručení pro uživatele, pokud neexistuje, vytvoří výchozí
     * @summary Získá nebo vytvoří preferovaný termín doručení
     * @param {ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPreferredDeliveryControllerApi
     */
    public getOrCreatePreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiGetOrCreatePreferredDeliveryRequest, options?: RawAxiosRequestConfig) {
        return ClientPreferredDeliveryControllerApiFp(this.configuration).getOrCreatePreferredDelivery(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nastaví preferovaný termín doručení pro uživatele
     * @summary Nastaví preferovaný termín doručení
     * @param {ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPreferredDeliveryControllerApi
     */
    public setPreferredDelivery(requestParameters: ClientPreferredDeliveryControllerApiSetPreferredDeliveryRequest, options?: RawAxiosRequestConfig) {
        return ClientPreferredDeliveryControllerApiFp(this.configuration).setPreferredDelivery(requestParameters.organizationId, requestParameters.portalId, requestParameters.setPreferredDeliveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientPriceEvidenceApi - axios parameter creator
 * @export
 */
export const ClientPriceEvidenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Všechny ceny, které měla provozovna na portálu pro ECID k danému dni (stejná množina jako u minVD, včetně negarantovaných). `companyId` a `pricePortalId` jsou z položky reportu.
         * @summary Dostupné ceny k ECID a dni
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} companyId 
         * @param {number} pricePortalId 
         * @param {string} productEcid 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientPriceEvidenceAvailablePrices: async (organizationId: number, portalId: number, companyId: number, pricePortalId: number, productEcid: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'portalId', portalId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'companyId', companyId)
            // verify required parameter 'pricePortalId' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'pricePortalId', pricePortalId)
            // verify required parameter 'productEcid' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'productEcid', productEcid)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getClientPriceEvidenceAvailablePrices', 'date', date)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/reports/price-evidence/available-prices`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (pricePortalId !== undefined) {
                localVarQueryParameter['pricePortalId'] = pricePortalId;
            }

            if (productEcid !== undefined) {
                localVarQueryParameter['productEcid'] = productEcid;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPriceEvidenceApi - functional programming interface
 * @export
 */
export const ClientPriceEvidenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientPriceEvidenceApiAxiosParamCreator(configuration)
    return {
        /**
         * Všechny ceny, které měla provozovna na portálu pro ECID k danému dni (stejná množina jako u minVD, včetně negarantovaných). `companyId` a `pricePortalId` jsou z položky reportu.
         * @summary Dostupné ceny k ECID a dni
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} companyId 
         * @param {number} pricePortalId 
         * @param {string} productEcid 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientPriceEvidenceAvailablePrices(organizationId: number, portalId: number, companyId: number, pricePortalId: number, productEcid: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPriceEvidenceAvailablePricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientPriceEvidenceAvailablePrices(organizationId, portalId, companyId, pricePortalId, productEcid, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPriceEvidenceApi.getClientPriceEvidenceAvailablePrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientPriceEvidenceApi - factory interface
 * @export
 */
export const ClientPriceEvidenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientPriceEvidenceApiFp(configuration)
    return {
        /**
         * Všechny ceny, které měla provozovna na portálu pro ECID k danému dni (stejná množina jako u minVD, včetně negarantovaných). `companyId` a `pricePortalId` jsou z položky reportu.
         * @summary Dostupné ceny k ECID a dni
         * @param {ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientPriceEvidenceAvailablePrices(requestParameters: ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPriceEvidenceAvailablePricesResponse> {
            return localVarFp.getClientPriceEvidenceAvailablePrices(requestParameters.organizationId, requestParameters.portalId, requestParameters.companyId, requestParameters.pricePortalId, requestParameters.productEcid, requestParameters.date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPriceEvidenceApi - interface
 * @export
 * @interface ClientPriceEvidenceApi
 */
export interface ClientPriceEvidenceApiInterface {
    /**
     * Všechny ceny, které měla provozovna na portálu pro ECID k danému dni (stejná množina jako u minVD, včetně negarantovaných). `companyId` a `pricePortalId` jsou z položky reportu.
     * @summary Dostupné ceny k ECID a dni
     * @param {ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPriceEvidenceApiInterface
     */
    getClientPriceEvidenceAvailablePrices(requestParameters: ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPriceEvidenceAvailablePricesResponse>;

}

/**
 * Request parameters for getClientPriceEvidenceAvailablePrices operation in ClientPriceEvidenceApi.
 * @export
 * @interface ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest
 */
export interface ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly companyId: number

    /**
     * 
     * @type {number}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly pricePortalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly productEcid: string

    /**
     * 
     * @type {string}
     * @memberof ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePrices
     */
    readonly date: string
}

/**
 * ClientPriceEvidenceApi - object-oriented interface
 * @export
 * @class ClientPriceEvidenceApi
 * @extends {BaseAPI}
 */
export class ClientPriceEvidenceApi extends BaseAPI implements ClientPriceEvidenceApiInterface {
    /**
     * Všechny ceny, které měla provozovna na portálu pro ECID k danému dni (stejná množina jako u minVD, včetně negarantovaných). `companyId` a `pricePortalId` jsou z položky reportu.
     * @summary Dostupné ceny k ECID a dni
     * @param {ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPriceEvidenceApi
     */
    public getClientPriceEvidenceAvailablePrices(requestParameters: ClientPriceEvidenceApiGetClientPriceEvidenceAvailablePricesRequest, options?: RawAxiosRequestConfig) {
        return ClientPriceEvidenceApiFp(this.configuration).getClientPriceEvidenceAvailablePrices(requestParameters.organizationId, requestParameters.portalId, requestParameters.companyId, requestParameters.pricePortalId, requestParameters.productEcid, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientProductControllerApi - axios parameter creator
 * @export
 */
export const ClientProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Přidání vlastního dodavatele k produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {AddManualSupplierRequest} addManualSupplierRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManualSupplier: async (organizationId: number, portalId: number, productId: number, addManualSupplierRequest: AddManualSupplierRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addManualSupplier', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('addManualSupplier', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addManualSupplier', 'productId', productId)
            // verify required parameter 'addManualSupplierRequest' is not null or undefined
            assertParamExists('addManualSupplier', 'addManualSupplierRequest', addManualSupplierRequest)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/product/{productId}/manual-supplier`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addManualSupplierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getProductDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getProductDetail', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductDetail', 'productId', productId)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/product/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Srdíčko (PREFERRED) nebo nechtěný dodavatel (NON_PREFERRED); prázdná preference označení zruší. Platí pro celou organizaci v rámci portálu.
         * @summary Označí dodavatele u produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} supplierId 
         * @param {SetSupplierPreferenceRequest} setSupplierPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProductSupplierPreference: async (organizationId: number, portalId: number, productId: number, supplierId: number, setSupplierPreferenceRequest: SetSupplierPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setProductSupplierPreference', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('setProductSupplierPreference', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('setProductSupplierPreference', 'productId', productId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('setProductSupplierPreference', 'supplierId', supplierId)
            // verify required parameter 'setSupplierPreferenceRequest' is not null or undefined
            assertParamExists('setProductSupplierPreference', 'setSupplierPreferenceRequest', setSupplierPreferenceRequest)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/product/{productId}/supplier/{supplierId}/preference`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSupplierPreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientProductControllerApi - functional programming interface
 * @export
 */
export const ClientProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Přidání vlastního dodavatele k produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {AddManualSupplierRequest} addManualSupplierRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addManualSupplier(organizationId: number, portalId: number, productId: number, addManualSupplierRequest: AddManualSupplierRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addManualSupplier(organizationId, portalId, productId, addManualSupplierRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProductControllerApi.addManualSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDetail(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDetail(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProductControllerApi.getProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Srdíčko (PREFERRED) nebo nechtěný dodavatel (NON_PREFERRED); prázdná preference označení zruší. Platí pro celou organizaci v rámci portálu.
         * @summary Označí dodavatele u produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} supplierId 
         * @param {SetSupplierPreferenceRequest} setSupplierPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProductSupplierPreference(organizationId: number, portalId: number, productId: number, supplierId: number, setSupplierPreferenceRequest: SetSupplierPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProductSupplierPreference(organizationId, portalId, productId, supplierId, setSupplierPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProductControllerApi.setProductSupplierPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientProductControllerApi - factory interface
 * @export
 */
export const ClientProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Přidání vlastního dodavatele k produktu
         * @param {ClientProductControllerApiAddManualSupplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManualSupplier(requestParameters: ClientProductControllerApiAddManualSupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addManualSupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.addManualSupplierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientProductControllerApiGetProductDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail(requestParameters: ClientProductControllerApiGetProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientProductDetailResponse> {
            return localVarFp.getProductDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Srdíčko (PREFERRED) nebo nechtěný dodavatel (NON_PREFERRED); prázdná preference označení zruší. Platí pro celou organizaci v rámci portálu.
         * @summary Označí dodavatele u produktu
         * @param {ClientProductControllerApiSetProductSupplierPreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProductSupplierPreference(requestParameters: ClientProductControllerApiSetProductSupplierPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setProductSupplierPreference(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierId, requestParameters.setSupplierPreferenceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientProductControllerApi - interface
 * @export
 * @interface ClientProductControllerApi
 */
export interface ClientProductControllerApiInterface {
    /**
     * 
     * @summary Přidání vlastního dodavatele k produktu
     * @param {ClientProductControllerApiAddManualSupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApiInterface
     */
    addManualSupplier(requestParameters: ClientProductControllerApiAddManualSupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ClientProductControllerApiGetProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApiInterface
     */
    getProductDetail(requestParameters: ClientProductControllerApiGetProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientProductDetailResponse>;

    /**
     * Srdíčko (PREFERRED) nebo nechtěný dodavatel (NON_PREFERRED); prázdná preference označení zruší. Platí pro celou organizaci v rámci portálu.
     * @summary Označí dodavatele u produktu
     * @param {ClientProductControllerApiSetProductSupplierPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApiInterface
     */
    setProductSupplierPreference(requestParameters: ClientProductControllerApiSetProductSupplierPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for addManualSupplier operation in ClientProductControllerApi.
 * @export
 * @interface ClientProductControllerApiAddManualSupplierRequest
 */
export interface ClientProductControllerApiAddManualSupplierRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiAddManualSupplier
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiAddManualSupplier
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiAddManualSupplier
     */
    readonly productId: number

    /**
     * 
     * @type {AddManualSupplierRequest}
     * @memberof ClientProductControllerApiAddManualSupplier
     */
    readonly addManualSupplierRequest: AddManualSupplierRequest
}

/**
 * Request parameters for getProductDetail operation in ClientProductControllerApi.
 * @export
 * @interface ClientProductControllerApiGetProductDetailRequest
 */
export interface ClientProductControllerApiGetProductDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiGetProductDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiGetProductDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiGetProductDetail
     */
    readonly productId: number
}

/**
 * Request parameters for setProductSupplierPreference operation in ClientProductControllerApi.
 * @export
 * @interface ClientProductControllerApiSetProductSupplierPreferenceRequest
 */
export interface ClientProductControllerApiSetProductSupplierPreferenceRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiSetProductSupplierPreference
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiSetProductSupplierPreference
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiSetProductSupplierPreference
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductControllerApiSetProductSupplierPreference
     */
    readonly supplierId: number

    /**
     * 
     * @type {SetSupplierPreferenceRequest}
     * @memberof ClientProductControllerApiSetProductSupplierPreference
     */
    readonly setSupplierPreferenceRequest: SetSupplierPreferenceRequest
}

/**
 * ClientProductControllerApi - object-oriented interface
 * @export
 * @class ClientProductControllerApi
 * @extends {BaseAPI}
 */
export class ClientProductControllerApi extends BaseAPI implements ClientProductControllerApiInterface {
    /**
     * 
     * @summary Přidání vlastního dodavatele k produktu
     * @param {ClientProductControllerApiAddManualSupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApi
     */
    public addManualSupplier(requestParameters: ClientProductControllerApiAddManualSupplierRequest, options?: RawAxiosRequestConfig) {
        return ClientProductControllerApiFp(this.configuration).addManualSupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.addManualSupplierRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientProductControllerApiGetProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApi
     */
    public getProductDetail(requestParameters: ClientProductControllerApiGetProductDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientProductControllerApiFp(this.configuration).getProductDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Srdíčko (PREFERRED) nebo nechtěný dodavatel (NON_PREFERRED); prázdná preference označení zruší. Platí pro celou organizaci v rámci portálu.
     * @summary Označí dodavatele u produktu
     * @param {ClientProductControllerApiSetProductSupplierPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductControllerApi
     */
    public setProductSupplierPreference(requestParameters: ClientProductControllerApiSetProductSupplierPreferenceRequest, options?: RawAxiosRequestConfig) {
        return ClientProductControllerApiFp(this.configuration).setProductSupplierPreference(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierId, requestParameters.setSupplierPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientProductTileControllerApi - axios parameter creator
 * @export
 */
export const ClientProductTileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrací data dlaždic pro zadané produkty — pro obnovu jedné položky v seznamu po změně v detailu produktu, bez přenačtení celé stránky. Čte z databáze, takže vidí i změny, které ještě neprošly reindexem do Elasticsearch.
         * @summary Dlaždice vyžádaných produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {Array<number>} productIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTiles: async (organizationId: number, portalId: number, productIds: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getProductTiles', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getProductTiles', 'portalId', portalId)
            // verify required parameter 'productIds' is not null or undefined
            assertParamExists('getProductTiles', 'productIds', productIds)
            const localVarPath = `/client/product/{organizationId}/portals/{portalId}/tiles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productIds) {
                localVarQueryParameter['productIds'] = productIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientProductTileControllerApi - functional programming interface
 * @export
 */
export const ClientProductTileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientProductTileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrací data dlaždic pro zadané produkty — pro obnovu jedné položky v seznamu po změně v detailu produktu, bez přenačtení celé stránky. Čte z databáze, takže vidí i změny, které ještě neprošly reindexem do Elasticsearch.
         * @summary Dlaždice vyžádaných produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {Array<number>} productIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTiles(organizationId: number, portalId: number, productIds: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientProductTilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTiles(organizationId, portalId, productIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProductTileControllerApi.getProductTiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientProductTileControllerApi - factory interface
 * @export
 */
export const ClientProductTileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientProductTileControllerApiFp(configuration)
    return {
        /**
         * Vrací data dlaždic pro zadané produkty — pro obnovu jedné položky v seznamu po změně v detailu produktu, bez přenačtení celé stránky. Čte z databáze, takže vidí i změny, které ještě neprošly reindexem do Elasticsearch.
         * @summary Dlaždice vyžádaných produktů
         * @param {ClientProductTileControllerApiGetProductTilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTiles(requestParameters: ClientProductTileControllerApiGetProductTilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientProductTilesResponse> {
            return localVarFp.getProductTiles(requestParameters.organizationId, requestParameters.portalId, requestParameters.productIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientProductTileControllerApi - interface
 * @export
 * @interface ClientProductTileControllerApi
 */
export interface ClientProductTileControllerApiInterface {
    /**
     * Vrací data dlaždic pro zadané produkty — pro obnovu jedné položky v seznamu po změně v detailu produktu, bez přenačtení celé stránky. Čte z databáze, takže vidí i změny, které ještě neprošly reindexem do Elasticsearch.
     * @summary Dlaždice vyžádaných produktů
     * @param {ClientProductTileControllerApiGetProductTilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductTileControllerApiInterface
     */
    getProductTiles(requestParameters: ClientProductTileControllerApiGetProductTilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientProductTilesResponse>;

}

/**
 * Request parameters for getProductTiles operation in ClientProductTileControllerApi.
 * @export
 * @interface ClientProductTileControllerApiGetProductTilesRequest
 */
export interface ClientProductTileControllerApiGetProductTilesRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientProductTileControllerApiGetProductTiles
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientProductTileControllerApiGetProductTiles
     */
    readonly portalId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ClientProductTileControllerApiGetProductTiles
     */
    readonly productIds: Array<number>
}

/**
 * ClientProductTileControllerApi - object-oriented interface
 * @export
 * @class ClientProductTileControllerApi
 * @extends {BaseAPI}
 */
export class ClientProductTileControllerApi extends BaseAPI implements ClientProductTileControllerApiInterface {
    /**
     * Vrací data dlaždic pro zadané produkty — pro obnovu jedné položky v seznamu po změně v detailu produktu, bez přenačtení celé stránky. Čte z databáze, takže vidí i změny, které ještě neprošly reindexem do Elasticsearch.
     * @summary Dlaždice vyžádaných produktů
     * @param {ClientProductTileControllerApiGetProductTilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductTileControllerApi
     */
    public getProductTiles(requestParameters: ClientProductTileControllerApiGetProductTilesRequest, options?: RawAxiosRequestConfig) {
        return ClientProductTileControllerApiFp(this.configuration).getProductTiles(requestParameters.organizationId, requestParameters.portalId, requestParameters.productIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientScheduledOrdersApi - axios parameter creator
 * @export
 */
export const ClientScheduledOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveScheduledOrderRun: async (organizationId: number, portalId: number, runId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('approveScheduledOrderRun', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('approveScheduledOrderRun', 'portalId', portalId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('approveScheduledOrderRun', 'runId', runId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/runs/{runId}/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zruší šablonu (zůstává v DB kvůli historii)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelScheduledOrder: async (organizationId: number, portalId: number, scheduledOrderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelScheduledOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('cancelScheduledOrder', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('cancelScheduledOrder', 'scheduledOrderId', scheduledOrderId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří šablonu z existující objednávky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {ClientCreateScheduledOrderFromOrderRequest} clientCreateScheduledOrderFromOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduledOrderFromOrder: async (organizationId: number, portalId: number, orderId: number, clientCreateScheduledOrderFromOrderRequest: ClientCreateScheduledOrderFromOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createScheduledOrderFromOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('createScheduledOrderFromOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('createScheduledOrderFromOrder', 'orderId', orderId)
            // verify required parameter 'clientCreateScheduledOrderFromOrderRequest' is not null or undefined
            assertParamExists('createScheduledOrderFromOrder', 'clientCreateScheduledOrderFromOrderRequest', clientCreateScheduledOrderFromOrderRequest)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/from-order/{orderId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientCreateScheduledOrderFromOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nečeká na plánovaný čas — objednávka vznikne hned. Další výskyty šablony zůstávají.
         * @summary Schválí a odešle objednávku ihned
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchScheduledOrderRunNow: async (organizationId: number, portalId: number, runId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('dispatchScheduledOrderRunNow', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('dispatchScheduledOrderRunNow', 'portalId', portalId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('dispatchScheduledOrderRunNow', 'runId', runId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/runs/{runId}/dispatch-now`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail šablony včetně položek a posledních běhů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderDetail: async (organizationId: number, portalId: number, scheduledOrderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScheduledOrderDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getScheduledOrderDetail', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('getScheduledOrderDetail', 'scheduledOrderId', scheduledOrderId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historie běhů šablony
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderRuns: async (organizationId: number, portalId: number, scheduledOrderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScheduledOrderRuns', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getScheduledOrderRuns', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('getScheduledOrderRuns', 'scheduledOrderId', scheduledOrderId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}/runs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Čekající na schválení, už schválené i ty bez schvalování. Stačí právo číst — vidět, že se něco chystá, má každý; tlačítka se řídí právem schvalovat.
         * @summary Běhy, které se chystají odejít
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderUpcomingRuns: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScheduledOrderUpcomingRuns', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getScheduledOrderUpcomingRuns', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/upcoming-runs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam šablon plánovaných objednávek
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] Stránka (od 1)
         * @param {number} [size] Velikost stránky
         * @param {string} [query] 
         * @param {ScheduledOrderStatus} [status] 
         * @param {number} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrders: async (organizationId: number, portalId: number, page?: number, size?: number, query?: string, status?: ScheduledOrderStatus, supplierId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScheduledOrders', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getScheduledOrders', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pozastaví šablonu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseScheduledOrder: async (organizationId: number, portalId: number, scheduledOrderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('pauseScheduledOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('pauseScheduledOrder', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('pauseScheduledOrder', 'scheduledOrderId', scheduledOrderId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}/pause`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {ClientRejectScheduledOrderRunRequest} [clientRejectScheduledOrderRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectScheduledOrderRun: async (organizationId: number, portalId: number, runId: number, clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rejectScheduledOrderRun', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('rejectScheduledOrderRun', 'portalId', portalId)
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('rejectScheduledOrderRun', 'runId', runId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/runs/{runId}/reject`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientRejectScheduledOrderRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obnoví pozastavenou šablonu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeScheduledOrder: async (organizationId: number, portalId: number, scheduledOrderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resumeScheduledOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('resumeScheduledOrder', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('resumeScheduledOrder', 'scheduledOrderId', scheduledOrderId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}/resume`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Úprava plánu šablony (položky se v této fázi needitují)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {ClientUpdateScheduledOrderRequest} clientUpdateScheduledOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledOrder: async (organizationId: number, portalId: number, scheduledOrderId: number, clientUpdateScheduledOrderRequest: ClientUpdateScheduledOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateScheduledOrder', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateScheduledOrder', 'portalId', portalId)
            // verify required parameter 'scheduledOrderId' is not null or undefined
            assertParamExists('updateScheduledOrder', 'scheduledOrderId', scheduledOrderId)
            // verify required parameter 'clientUpdateScheduledOrderRequest' is not null or undefined
            assertParamExists('updateScheduledOrder', 'clientUpdateScheduledOrderRequest', clientUpdateScheduledOrderRequest)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/scheduled-orders/{scheduledOrderId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"scheduledOrderId"}}`, encodeURIComponent(String(scheduledOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientUpdateScheduledOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientScheduledOrdersApi - functional programming interface
 * @export
 */
export const ClientScheduledOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientScheduledOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveScheduledOrderRun(organizationId: number, portalId: number, runId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveScheduledOrderRun(organizationId, portalId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.approveScheduledOrderRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zruší šablonu (zůstává v DB kvůli historii)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelScheduledOrder(organizationId: number, portalId: number, scheduledOrderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelScheduledOrder(organizationId, portalId, scheduledOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.cancelScheduledOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří šablonu z existující objednávky
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {ClientCreateScheduledOrderFromOrderRequest} clientCreateScheduledOrderFromOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScheduledOrderFromOrder(organizationId: number, portalId: number, orderId: number, clientCreateScheduledOrderFromOrderRequest: ClientCreateScheduledOrderFromOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScheduledOrderFromOrder(organizationId, portalId, orderId, clientCreateScheduledOrderFromOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.createScheduledOrderFromOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nečeká na plánovaný čas — objednávka vznikne hned. Další výskyty šablony zůstávají.
         * @summary Schválí a odešle objednávku ihned
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dispatchScheduledOrderRunNow(organizationId: number, portalId: number, runId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dispatchScheduledOrderRunNow(organizationId, portalId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.dispatchScheduledOrderRunNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail šablony včetně položek a posledních běhů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledOrderDetail(organizationId: number, portalId: number, scheduledOrderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledOrderDetail(organizationId, portalId, scheduledOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.getScheduledOrderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historie běhů šablony
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledOrderRuns(organizationId: number, portalId: number, scheduledOrderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderRunListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledOrderRuns(organizationId, portalId, scheduledOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.getScheduledOrderRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Čekající na schválení, už schválené i ty bez schvalování. Stačí právo číst — vidět, že se něco chystá, má každý; tlačítka se řídí právem schvalovat.
         * @summary Běhy, které se chystají odejít
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledOrderUpcomingRuns(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderRunListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledOrderUpcomingRuns(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.getScheduledOrderUpcomingRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam šablon plánovaných objednávek
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] Stránka (od 1)
         * @param {number} [size] Velikost stránky
         * @param {string} [query] 
         * @param {ScheduledOrderStatus} [status] 
         * @param {number} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledOrders(organizationId: number, portalId: number, page?: number, size?: number, query?: string, status?: ScheduledOrderStatus, supplierId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledOrders(organizationId, portalId, page, size, query, status, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.getScheduledOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pozastaví šablonu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseScheduledOrder(organizationId: number, portalId: number, scheduledOrderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseScheduledOrder(organizationId, portalId, scheduledOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.pauseScheduledOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} runId 
         * @param {ClientRejectScheduledOrderRunRequest} [clientRejectScheduledOrderRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectScheduledOrderRun(organizationId: number, portalId: number, runId: number, clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectScheduledOrderRun(organizationId, portalId, runId, clientRejectScheduledOrderRunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.rejectScheduledOrderRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Obnoví pozastavenou šablonu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeScheduledOrder(organizationId: number, portalId: number, scheduledOrderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeScheduledOrder(organizationId, portalId, scheduledOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.resumeScheduledOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Úprava plánu šablony (položky se v této fázi needitují)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} scheduledOrderId 
         * @param {ClientUpdateScheduledOrderRequest} clientUpdateScheduledOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduledOrder(organizationId: number, portalId: number, scheduledOrderId: number, clientUpdateScheduledOrderRequest: ClientUpdateScheduledOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientScheduledOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduledOrder(organizationId, portalId, scheduledOrderId, clientUpdateScheduledOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientScheduledOrdersApi.updateScheduledOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientScheduledOrdersApi - factory interface
 * @export
 */
export const ClientScheduledOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientScheduledOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {ClientScheduledOrdersApiApproveScheduledOrderRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveScheduledOrderRun(requestParameters: ClientScheduledOrdersApiApproveScheduledOrderRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveScheduledOrderRun(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zruší šablonu (zůstává v DB kvůli historii)
         * @param {ClientScheduledOrdersApiCancelScheduledOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelScheduledOrder(requestParameters: ClientScheduledOrdersApiCancelScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří šablonu z existující objednávky
         * @param {ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduledOrderFromOrder(requestParameters: ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO> {
            return localVarFp.createScheduledOrderFromOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, requestParameters.clientCreateScheduledOrderFromOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Nečeká na plánovaný čas — objednávka vznikne hned. Další výskyty šablony zůstávají.
         * @summary Schválí a odešle objednávku ihned
         * @param {ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchScheduledOrderRunNow(requestParameters: ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dispatchScheduledOrderRunNow(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail šablony včetně položek a posledních běhů
         * @param {ClientScheduledOrdersApiGetScheduledOrderDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderDetail(requestParameters: ClientScheduledOrdersApiGetScheduledOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO> {
            return localVarFp.getScheduledOrderDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historie běhů šablony
         * @param {ClientScheduledOrdersApiGetScheduledOrderRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderRunListResponseDTO> {
            return localVarFp.getScheduledOrderRuns(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Čekající na schválení, už schválené i ty bez schvalování. Stačí právo číst — vidět, že se něco chystá, má každý; tlačítka se řídí právem schvalovat.
         * @summary Běhy, které se chystají odejít
         * @param {ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderUpcomingRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderRunListResponseDTO> {
            return localVarFp.getScheduledOrderUpcomingRuns(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam šablon plánovaných objednávek
         * @param {ClientScheduledOrdersApiGetScheduledOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrders(requestParameters: ClientScheduledOrdersApiGetScheduledOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderListResponseDTO> {
            return localVarFp.getScheduledOrders(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.status, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pozastaví šablonu
         * @param {ClientScheduledOrdersApiPauseScheduledOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseScheduledOrder(requestParameters: ClientScheduledOrdersApiPauseScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO> {
            return localVarFp.pauseScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {ClientScheduledOrdersApiRejectScheduledOrderRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectScheduledOrderRun(requestParameters: ClientScheduledOrdersApiRejectScheduledOrderRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectScheduledOrderRun(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, requestParameters.clientRejectScheduledOrderRunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obnoví pozastavenou šablonu
         * @param {ClientScheduledOrdersApiResumeScheduledOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeScheduledOrder(requestParameters: ClientScheduledOrdersApiResumeScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO> {
            return localVarFp.resumeScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Úprava plánu šablony (položky se v této fázi needitují)
         * @param {ClientScheduledOrdersApiUpdateScheduledOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledOrder(requestParameters: ClientScheduledOrdersApiUpdateScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO> {
            return localVarFp.updateScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, requestParameters.clientUpdateScheduledOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientScheduledOrdersApi - interface
 * @export
 * @interface ClientScheduledOrdersApi
 */
export interface ClientScheduledOrdersApiInterface {
    /**
     * 
     * @summary Schválí odeslání plánované objednávky
     * @param {ClientScheduledOrdersApiApproveScheduledOrderRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    approveScheduledOrderRun(requestParameters: ClientScheduledOrdersApiApproveScheduledOrderRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Zruší šablonu (zůstává v DB kvůli historii)
     * @param {ClientScheduledOrdersApiCancelScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    cancelScheduledOrder(requestParameters: ClientScheduledOrdersApiCancelScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Vytvoří šablonu z existující objednávky
     * @param {ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    createScheduledOrderFromOrder(requestParameters: ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO>;

    /**
     * Nečeká na plánovaný čas — objednávka vznikne hned. Další výskyty šablony zůstávají.
     * @summary Schválí a odešle objednávku ihned
     * @param {ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    dispatchScheduledOrderRunNow(requestParameters: ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Detail šablony včetně položek a posledních běhů
     * @param {ClientScheduledOrdersApiGetScheduledOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    getScheduledOrderDetail(requestParameters: ClientScheduledOrdersApiGetScheduledOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO>;

    /**
     * 
     * @summary Historie běhů šablony
     * @param {ClientScheduledOrdersApiGetScheduledOrderRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    getScheduledOrderRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderRunListResponseDTO>;

    /**
     * Čekající na schválení, už schválené i ty bez schvalování. Stačí právo číst — vidět, že se něco chystá, má každý; tlačítka se řídí právem schvalovat.
     * @summary Běhy, které se chystají odejít
     * @param {ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    getScheduledOrderUpcomingRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderRunListResponseDTO>;

    /**
     * 
     * @summary Seznam šablon plánovaných objednávek
     * @param {ClientScheduledOrdersApiGetScheduledOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    getScheduledOrders(requestParameters: ClientScheduledOrdersApiGetScheduledOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderListResponseDTO>;

    /**
     * 
     * @summary Pozastaví šablonu
     * @param {ClientScheduledOrdersApiPauseScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    pauseScheduledOrder(requestParameters: ClientScheduledOrdersApiPauseScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO>;

    /**
     * 
     * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
     * @param {ClientScheduledOrdersApiRejectScheduledOrderRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    rejectScheduledOrderRun(requestParameters: ClientScheduledOrdersApiRejectScheduledOrderRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Obnoví pozastavenou šablonu
     * @param {ClientScheduledOrdersApiResumeScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    resumeScheduledOrder(requestParameters: ClientScheduledOrdersApiResumeScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO>;

    /**
     * 
     * @summary Úprava plánu šablony (položky se v této fázi needitují)
     * @param {ClientScheduledOrdersApiUpdateScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApiInterface
     */
    updateScheduledOrder(requestParameters: ClientScheduledOrdersApiUpdateScheduledOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientScheduledOrderDetailDTO>;

}

/**
 * Request parameters for approveScheduledOrderRun operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiApproveScheduledOrderRunRequest
 */
export interface ClientScheduledOrdersApiApproveScheduledOrderRunRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiApproveScheduledOrderRun
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiApproveScheduledOrderRun
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiApproveScheduledOrderRun
     */
    readonly runId: number
}

/**
 * Request parameters for cancelScheduledOrder operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiCancelScheduledOrderRequest
 */
export interface ClientScheduledOrdersApiCancelScheduledOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCancelScheduledOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCancelScheduledOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCancelScheduledOrder
     */
    readonly scheduledOrderId: number
}

/**
 * Request parameters for createScheduledOrderFromOrder operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest
 */
export interface ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCreateScheduledOrderFromOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCreateScheduledOrderFromOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiCreateScheduledOrderFromOrder
     */
    readonly orderId: number

    /**
     * 
     * @type {ClientCreateScheduledOrderFromOrderRequest}
     * @memberof ClientScheduledOrdersApiCreateScheduledOrderFromOrder
     */
    readonly clientCreateScheduledOrderFromOrderRequest: ClientCreateScheduledOrderFromOrderRequest
}

/**
 * Request parameters for dispatchScheduledOrderRunNow operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest
 */
export interface ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiDispatchScheduledOrderRunNow
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiDispatchScheduledOrderRunNow
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiDispatchScheduledOrderRunNow
     */
    readonly runId: number
}

/**
 * Request parameters for getScheduledOrderDetail operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiGetScheduledOrderDetailRequest
 */
export interface ClientScheduledOrdersApiGetScheduledOrderDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderDetail
     */
    readonly scheduledOrderId: number
}

/**
 * Request parameters for getScheduledOrderRuns operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiGetScheduledOrderRunsRequest
 */
export interface ClientScheduledOrdersApiGetScheduledOrderRunsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderRuns
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderRuns
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderRuns
     */
    readonly scheduledOrderId: number
}

/**
 * Request parameters for getScheduledOrderUpcomingRuns operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest
 */
export interface ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderUpcomingRuns
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrderUpcomingRuns
     */
    readonly portalId: number
}

/**
 * Request parameters for getScheduledOrders operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiGetScheduledOrdersRequest
 */
export interface ClientScheduledOrdersApiGetScheduledOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly portalId: number

    /**
     * Stránka (od 1)
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly page?: number

    /**
     * Velikost stránky
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly query?: string

    /**
     * 
     * @type {ScheduledOrderStatus}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly status?: ScheduledOrderStatus

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiGetScheduledOrders
     */
    readonly supplierId?: number
}

/**
 * Request parameters for pauseScheduledOrder operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiPauseScheduledOrderRequest
 */
export interface ClientScheduledOrdersApiPauseScheduledOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiPauseScheduledOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiPauseScheduledOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiPauseScheduledOrder
     */
    readonly scheduledOrderId: number
}

/**
 * Request parameters for rejectScheduledOrderRun operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiRejectScheduledOrderRunRequest
 */
export interface ClientScheduledOrdersApiRejectScheduledOrderRunRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiRejectScheduledOrderRun
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiRejectScheduledOrderRun
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiRejectScheduledOrderRun
     */
    readonly runId: number

    /**
     * 
     * @type {ClientRejectScheduledOrderRunRequest}
     * @memberof ClientScheduledOrdersApiRejectScheduledOrderRun
     */
    readonly clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest
}

/**
 * Request parameters for resumeScheduledOrder operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiResumeScheduledOrderRequest
 */
export interface ClientScheduledOrdersApiResumeScheduledOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiResumeScheduledOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiResumeScheduledOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiResumeScheduledOrder
     */
    readonly scheduledOrderId: number
}

/**
 * Request parameters for updateScheduledOrder operation in ClientScheduledOrdersApi.
 * @export
 * @interface ClientScheduledOrdersApiUpdateScheduledOrderRequest
 */
export interface ClientScheduledOrdersApiUpdateScheduledOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiUpdateScheduledOrder
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiUpdateScheduledOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof ClientScheduledOrdersApiUpdateScheduledOrder
     */
    readonly scheduledOrderId: number

    /**
     * 
     * @type {ClientUpdateScheduledOrderRequest}
     * @memberof ClientScheduledOrdersApiUpdateScheduledOrder
     */
    readonly clientUpdateScheduledOrderRequest: ClientUpdateScheduledOrderRequest
}

/**
 * ClientScheduledOrdersApi - object-oriented interface
 * @export
 * @class ClientScheduledOrdersApi
 * @extends {BaseAPI}
 */
export class ClientScheduledOrdersApi extends BaseAPI implements ClientScheduledOrdersApiInterface {
    /**
     * 
     * @summary Schválí odeslání plánované objednávky
     * @param {ClientScheduledOrdersApiApproveScheduledOrderRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public approveScheduledOrderRun(requestParameters: ClientScheduledOrdersApiApproveScheduledOrderRunRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).approveScheduledOrderRun(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zruší šablonu (zůstává v DB kvůli historii)
     * @param {ClientScheduledOrdersApiCancelScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public cancelScheduledOrder(requestParameters: ClientScheduledOrdersApiCancelScheduledOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).cancelScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří šablonu z existující objednávky
     * @param {ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public createScheduledOrderFromOrder(requestParameters: ClientScheduledOrdersApiCreateScheduledOrderFromOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).createScheduledOrderFromOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.orderId, requestParameters.clientCreateScheduledOrderFromOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nečeká na plánovaný čas — objednávka vznikne hned. Další výskyty šablony zůstávají.
     * @summary Schválí a odešle objednávku ihned
     * @param {ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public dispatchScheduledOrderRunNow(requestParameters: ClientScheduledOrdersApiDispatchScheduledOrderRunNowRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).dispatchScheduledOrderRunNow(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail šablony včetně položek a posledních běhů
     * @param {ClientScheduledOrdersApiGetScheduledOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public getScheduledOrderDetail(requestParameters: ClientScheduledOrdersApiGetScheduledOrderDetailRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).getScheduledOrderDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historie běhů šablony
     * @param {ClientScheduledOrdersApiGetScheduledOrderRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public getScheduledOrderRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderRunsRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).getScheduledOrderRuns(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Čekající na schválení, už schválené i ty bez schvalování. Stačí právo číst — vidět, že se něco chystá, má každý; tlačítka se řídí právem schvalovat.
     * @summary Běhy, které se chystají odejít
     * @param {ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public getScheduledOrderUpcomingRuns(requestParameters: ClientScheduledOrdersApiGetScheduledOrderUpcomingRunsRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).getScheduledOrderUpcomingRuns(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam šablon plánovaných objednávek
     * @param {ClientScheduledOrdersApiGetScheduledOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public getScheduledOrders(requestParameters: ClientScheduledOrdersApiGetScheduledOrdersRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).getScheduledOrders(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.status, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pozastaví šablonu
     * @param {ClientScheduledOrdersApiPauseScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public pauseScheduledOrder(requestParameters: ClientScheduledOrdersApiPauseScheduledOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).pauseScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
     * @param {ClientScheduledOrdersApiRejectScheduledOrderRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public rejectScheduledOrderRun(requestParameters: ClientScheduledOrdersApiRejectScheduledOrderRunRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).rejectScheduledOrderRun(requestParameters.organizationId, requestParameters.portalId, requestParameters.runId, requestParameters.clientRejectScheduledOrderRunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obnoví pozastavenou šablonu
     * @param {ClientScheduledOrdersApiResumeScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public resumeScheduledOrder(requestParameters: ClientScheduledOrdersApiResumeScheduledOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).resumeScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Úprava plánu šablony (položky se v této fázi needitují)
     * @param {ClientScheduledOrdersApiUpdateScheduledOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientScheduledOrdersApi
     */
    public updateScheduledOrder(requestParameters: ClientScheduledOrdersApiUpdateScheduledOrderRequest, options?: RawAxiosRequestConfig) {
        return ClientScheduledOrdersApiFp(this.configuration).updateScheduledOrder(requestParameters.organizationId, requestParameters.portalId, requestParameters.scheduledOrderId, requestParameters.clientUpdateScheduledOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientShoppingListsManagementApi - axios parameter creator
 * @export
 */
export const ClientShoppingListsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Přidá produkt do existujícího nákupního seznamu
         * @summary Přidá produkt do nákupního seznamu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {ClientShoppingListAddProductRequest} clientShoppingListAddProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToShoppingList: async (organizationId: number, portalId: number, shoppingListId: number, clientShoppingListAddProductRequest: ClientShoppingListAddProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addProductToShoppingList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('addProductToShoppingList', 'portalId', portalId)
            // verify required parameter 'shoppingListId' is not null or undefined
            assertParamExists('addProductToShoppingList', 'shoppingListId', shoppingListId)
            // verify required parameter 'clientShoppingListAddProductRequest' is not null or undefined
            assertParamExists('addProductToShoppingList', 'clientShoppingListAddProductRequest', clientShoppingListAddProductRequest)
            const localVarPath = `/client/shopping-lists/organization/{organizationId}/portal/{portalId}/shopping-list/{shoppingListId}/product`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientShoppingListAddProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří nový nákupní seznam pro daného uživatele
         * @summary Vytvoří nový nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {CreateClientShoppingListRequestDTO} createClientShoppingListRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShoppingList: async (userId: number, organizationId: number, portalId: number, createClientShoppingListRequestDTO: CreateClientShoppingListRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createShoppingList', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createShoppingList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('createShoppingList', 'portalId', portalId)
            // verify required parameter 'createClientShoppingListRequestDTO' is not null or undefined
            assertParamExists('createShoppingList', 'createClientShoppingListRequestDTO', createClientShoppingListRequestDTO)
            const localVarPath = `/client/shopping-lists/user/{userId}/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientShoppingListRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže existující nákupní seznam
         * @summary Smaže nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShoppingList: async (userId: number, organizationId: number, portalId: number, shoppingListId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteShoppingList', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteShoppingList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteShoppingList', 'portalId', portalId)
            // verify required parameter 'shoppingListId' is not null or undefined
            assertParamExists('deleteShoppingList', 'shoppingListId', shoppingListId)
            const localVarPath = `/client/shopping-lists/user/{userId}/organization/{organizationId}/portal/{portalId}/shopping-list/{shoppingListId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail konkrétního nákupního seznamu
         * @summary Získá konkrétní nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingListById: async (userId: number, organizationId: number, portalId: number, shoppingListId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getShoppingListById', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getShoppingListById', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getShoppingListById', 'portalId', portalId)
            // verify required parameter 'shoppingListId' is not null or undefined
            assertParamExists('getShoppingListById', 'shoppingListId', shoppingListId)
            const localVarPath = `/client/shopping-lists/user/{userId}/organization/{organizationId}/portal/{portalId}/shopping-list/{shoppingListId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam všech nákupních seznamů pro daného uživatele, organizaci a portál
         * @summary Získá všechny nákupní seznamy
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingLists: async (userId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getShoppingLists', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getShoppingLists', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getShoppingLists', 'portalId', portalId)
            const localVarPath = `/client/shopping-lists/user/{userId}/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí summary všech nákupních seznamů, které již obsahují produkt — slouží add-product dialogu pro indikaci \'už v seznamu\'
         * @summary Seznamy obsahující daný produkt
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingListsContainingProduct: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getShoppingListsContainingProduct', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getShoppingListsContainingProduct', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getShoppingListsContainingProduct', 'productId', productId)
            const localVarPath = `/client/shopping-lists/organization/{organizationId}/portal/{portalId}/product/{productId}/containing-lists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Odebere konkrétní položku z nákupního seznamu
         * @summary Odebere položku z nákupního seznamu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromShoppingList: async (organizationId: number, portalId: number, shoppingListId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeFromShoppingList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('removeFromShoppingList', 'portalId', portalId)
            // verify required parameter 'shoppingListId' is not null or undefined
            assertParamExists('removeFromShoppingList', 'shoppingListId', shoppingListId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('removeFromShoppingList', 'productId', productId)
            const localVarPath = `/client/shopping-lists/organization/{organizationId}/portal/{portalId}/shopping-list/{shoppingListId}/product/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující nákupní seznam
         * @summary Aktualizuje nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {UpdateClientShoppingListRequestDTO} updateClientShoppingListRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShoppingList: async (userId: number, organizationId: number, portalId: number, shoppingListId: number, updateClientShoppingListRequestDTO: UpdateClientShoppingListRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateShoppingList', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateShoppingList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateShoppingList', 'portalId', portalId)
            // verify required parameter 'shoppingListId' is not null or undefined
            assertParamExists('updateShoppingList', 'shoppingListId', shoppingListId)
            // verify required parameter 'updateClientShoppingListRequestDTO' is not null or undefined
            assertParamExists('updateShoppingList', 'updateClientShoppingListRequestDTO', updateClientShoppingListRequestDTO)
            const localVarPath = `/client/shopping-lists/user/{userId}/organization/{organizationId}/portal/{portalId}/shopping-list/{shoppingListId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientShoppingListRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientShoppingListsManagementApi - functional programming interface
 * @export
 */
export const ClientShoppingListsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientShoppingListsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Přidá produkt do existujícího nákupního seznamu
         * @summary Přidá produkt do nákupního seznamu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {ClientShoppingListAddProductRequest} clientShoppingListAddProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductToShoppingList(organizationId: number, portalId: number, shoppingListId: number, clientShoppingListAddProductRequest: ClientShoppingListAddProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductToShoppingList(organizationId, portalId, shoppingListId, clientShoppingListAddProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.addProductToShoppingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří nový nákupní seznam pro daného uživatele
         * @summary Vytvoří nový nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {CreateClientShoppingListRequestDTO} createClientShoppingListRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShoppingList(userId: number, organizationId: number, portalId: number, createClientShoppingListRequestDTO: CreateClientShoppingListRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientShoppingListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShoppingList(userId, organizationId, portalId, createClientShoppingListRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.createShoppingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže existující nákupní seznam
         * @summary Smaže nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShoppingList(userId: number, organizationId: number, portalId: number, shoppingListId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShoppingList(userId, organizationId, portalId, shoppingListId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.deleteShoppingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail konkrétního nákupního seznamu
         * @summary Získá konkrétní nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShoppingListById(userId: number, organizationId: number, portalId: number, shoppingListId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientShoppingListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShoppingListById(userId, organizationId, portalId, shoppingListId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.getShoppingListById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam všech nákupních seznamů pro daného uživatele, organizaci a portál
         * @summary Získá všechny nákupní seznamy
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShoppingLists(userId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientShoppingListSummaryListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShoppingLists(userId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.getShoppingLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí summary všech nákupních seznamů, které již obsahují produkt — slouží add-product dialogu pro indikaci \'už v seznamu\'
         * @summary Seznamy obsahující daný produkt
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShoppingListsContainingProduct(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientShoppingListSummaryListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShoppingListsContainingProduct(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.getShoppingListsContainingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Odebere konkrétní položku z nákupního seznamu
         * @summary Odebere položku z nákupního seznamu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromShoppingList(organizationId: number, portalId: number, shoppingListId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromShoppingList(organizationId, portalId, shoppingListId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.removeFromShoppingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující nákupní seznam
         * @summary Aktualizuje nákupní seznam
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} shoppingListId ID nákupního seznamu
         * @param {UpdateClientShoppingListRequestDTO} updateClientShoppingListRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShoppingList(userId: number, organizationId: number, portalId: number, shoppingListId: number, updateClientShoppingListRequestDTO: UpdateClientShoppingListRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientShoppingListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShoppingList(userId, organizationId, portalId, shoppingListId, updateClientShoppingListRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientShoppingListsManagementApi.updateShoppingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientShoppingListsManagementApi - factory interface
 * @export
 */
export const ClientShoppingListsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientShoppingListsManagementApiFp(configuration)
    return {
        /**
         * Přidá produkt do existujícího nákupního seznamu
         * @summary Přidá produkt do nákupního seznamu
         * @param {ClientShoppingListsManagementApiAddProductToShoppingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToShoppingList(requestParameters: ClientShoppingListsManagementApiAddProductToShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addProductToShoppingList(requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.clientShoppingListAddProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří nový nákupní seznam pro daného uživatele
         * @summary Vytvoří nový nákupní seznam
         * @param {ClientShoppingListsManagementApiCreateShoppingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShoppingList(requestParameters: ClientShoppingListsManagementApiCreateShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO> {
            return localVarFp.createShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.createClientShoppingListRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže existující nákupní seznam
         * @summary Smaže nákupní seznam
         * @param {ClientShoppingListsManagementApiDeleteShoppingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShoppingList(requestParameters: ClientShoppingListsManagementApiDeleteShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail konkrétního nákupního seznamu
         * @summary Získá konkrétní nákupní seznam
         * @param {ClientShoppingListsManagementApiGetShoppingListByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingListById(requestParameters: ClientShoppingListsManagementApiGetShoppingListByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO> {
            return localVarFp.getShoppingListById(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam všech nákupních seznamů pro daného uživatele, organizaci a portál
         * @summary Získá všechny nákupní seznamy
         * @param {ClientShoppingListsManagementApiGetShoppingListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingLists(requestParameters: ClientShoppingListsManagementApiGetShoppingListsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListSummaryListDTO> {
            return localVarFp.getShoppingLists(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí summary všech nákupních seznamů, které již obsahují produkt — slouží add-product dialogu pro indikaci \'už v seznamu\'
         * @summary Seznamy obsahující daný produkt
         * @param {ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingListsContainingProduct(requestParameters: ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListSummaryListDTO> {
            return localVarFp.getShoppingListsContainingProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Odebere konkrétní položku z nákupního seznamu
         * @summary Odebere položku z nákupního seznamu
         * @param {ClientShoppingListsManagementApiRemoveFromShoppingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromShoppingList(requestParameters: ClientShoppingListsManagementApiRemoveFromShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeFromShoppingList(requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující nákupní seznam
         * @summary Aktualizuje nákupní seznam
         * @param {ClientShoppingListsManagementApiUpdateShoppingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShoppingList(requestParameters: ClientShoppingListsManagementApiUpdateShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO> {
            return localVarFp.updateShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.updateClientShoppingListRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientShoppingListsManagementApi - interface
 * @export
 * @interface ClientShoppingListsManagementApi
 */
export interface ClientShoppingListsManagementApiInterface {
    /**
     * Přidá produkt do existujícího nákupního seznamu
     * @summary Přidá produkt do nákupního seznamu
     * @param {ClientShoppingListsManagementApiAddProductToShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    addProductToShoppingList(requestParameters: ClientShoppingListsManagementApiAddProductToShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vytvoří nový nákupní seznam pro daného uživatele
     * @summary Vytvoří nový nákupní seznam
     * @param {ClientShoppingListsManagementApiCreateShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    createShoppingList(requestParameters: ClientShoppingListsManagementApiCreateShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO>;

    /**
     * Smaže existující nákupní seznam
     * @summary Smaže nákupní seznam
     * @param {ClientShoppingListsManagementApiDeleteShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    deleteShoppingList(requestParameters: ClientShoppingListsManagementApiDeleteShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí detail konkrétního nákupního seznamu
     * @summary Získá konkrétní nákupní seznam
     * @param {ClientShoppingListsManagementApiGetShoppingListByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    getShoppingListById(requestParameters: ClientShoppingListsManagementApiGetShoppingListByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO>;

    /**
     * Vrátí seznam všech nákupních seznamů pro daného uživatele, organizaci a portál
     * @summary Získá všechny nákupní seznamy
     * @param {ClientShoppingListsManagementApiGetShoppingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    getShoppingLists(requestParameters: ClientShoppingListsManagementApiGetShoppingListsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListSummaryListDTO>;

    /**
     * Vrátí summary všech nákupních seznamů, které již obsahují produkt — slouží add-product dialogu pro indikaci \'už v seznamu\'
     * @summary Seznamy obsahující daný produkt
     * @param {ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    getShoppingListsContainingProduct(requestParameters: ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListSummaryListDTO>;

    /**
     * Odebere konkrétní položku z nákupního seznamu
     * @summary Odebere položku z nákupního seznamu
     * @param {ClientShoppingListsManagementApiRemoveFromShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    removeFromShoppingList(requestParameters: ClientShoppingListsManagementApiRemoveFromShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Aktualizuje existující nákupní seznam
     * @summary Aktualizuje nákupní seznam
     * @param {ClientShoppingListsManagementApiUpdateShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApiInterface
     */
    updateShoppingList(requestParameters: ClientShoppingListsManagementApiUpdateShoppingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientShoppingListDTO>;

}

/**
 * Request parameters for addProductToShoppingList operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiAddProductToShoppingListRequest
 */
export interface ClientShoppingListsManagementApiAddProductToShoppingListRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiAddProductToShoppingList
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiAddProductToShoppingList
     */
    readonly portalId: number

    /**
     * ID nákupního seznamu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiAddProductToShoppingList
     */
    readonly shoppingListId: number

    /**
     * 
     * @type {ClientShoppingListAddProductRequest}
     * @memberof ClientShoppingListsManagementApiAddProductToShoppingList
     */
    readonly clientShoppingListAddProductRequest: ClientShoppingListAddProductRequest
}

/**
 * Request parameters for createShoppingList operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiCreateShoppingListRequest
 */
export interface ClientShoppingListsManagementApiCreateShoppingListRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientShoppingListsManagementApiCreateShoppingList
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiCreateShoppingList
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiCreateShoppingList
     */
    readonly portalId: number

    /**
     * 
     * @type {CreateClientShoppingListRequestDTO}
     * @memberof ClientShoppingListsManagementApiCreateShoppingList
     */
    readonly createClientShoppingListRequestDTO: CreateClientShoppingListRequestDTO
}

/**
 * Request parameters for deleteShoppingList operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiDeleteShoppingListRequest
 */
export interface ClientShoppingListsManagementApiDeleteShoppingListRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientShoppingListsManagementApiDeleteShoppingList
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiDeleteShoppingList
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiDeleteShoppingList
     */
    readonly portalId: number

    /**
     * ID nákupního seznamu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiDeleteShoppingList
     */
    readonly shoppingListId: number
}

/**
 * Request parameters for getShoppingListById operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiGetShoppingListByIdRequest
 */
export interface ClientShoppingListsManagementApiGetShoppingListByIdRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListById
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListById
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListById
     */
    readonly portalId: number

    /**
     * ID nákupního seznamu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListById
     */
    readonly shoppingListId: number
}

/**
 * Request parameters for getShoppingLists operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiGetShoppingListsRequest
 */
export interface ClientShoppingListsManagementApiGetShoppingListsRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingLists
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingLists
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingLists
     */
    readonly portalId: number
}

/**
 * Request parameters for getShoppingListsContainingProduct operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest
 */
export interface ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListsContainingProduct
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListsContainingProduct
     */
    readonly portalId: number

    /**
     * ID produktu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiGetShoppingListsContainingProduct
     */
    readonly productId: number
}

/**
 * Request parameters for removeFromShoppingList operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiRemoveFromShoppingListRequest
 */
export interface ClientShoppingListsManagementApiRemoveFromShoppingListRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiRemoveFromShoppingList
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiRemoveFromShoppingList
     */
    readonly portalId: number

    /**
     * ID nákupního seznamu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiRemoveFromShoppingList
     */
    readonly shoppingListId: number

    /**
     * ID produktu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiRemoveFromShoppingList
     */
    readonly productId: number
}

/**
 * Request parameters for updateShoppingList operation in ClientShoppingListsManagementApi.
 * @export
 * @interface ClientShoppingListsManagementApiUpdateShoppingListRequest
 */
export interface ClientShoppingListsManagementApiUpdateShoppingListRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientShoppingListsManagementApiUpdateShoppingList
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientShoppingListsManagementApiUpdateShoppingList
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiUpdateShoppingList
     */
    readonly portalId: number

    /**
     * ID nákupního seznamu
     * @type {number}
     * @memberof ClientShoppingListsManagementApiUpdateShoppingList
     */
    readonly shoppingListId: number

    /**
     * 
     * @type {UpdateClientShoppingListRequestDTO}
     * @memberof ClientShoppingListsManagementApiUpdateShoppingList
     */
    readonly updateClientShoppingListRequestDTO: UpdateClientShoppingListRequestDTO
}

/**
 * ClientShoppingListsManagementApi - object-oriented interface
 * @export
 * @class ClientShoppingListsManagementApi
 * @extends {BaseAPI}
 */
export class ClientShoppingListsManagementApi extends BaseAPI implements ClientShoppingListsManagementApiInterface {
    /**
     * Přidá produkt do existujícího nákupního seznamu
     * @summary Přidá produkt do nákupního seznamu
     * @param {ClientShoppingListsManagementApiAddProductToShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public addProductToShoppingList(requestParameters: ClientShoppingListsManagementApiAddProductToShoppingListRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).addProductToShoppingList(requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.clientShoppingListAddProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří nový nákupní seznam pro daného uživatele
     * @summary Vytvoří nový nákupní seznam
     * @param {ClientShoppingListsManagementApiCreateShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public createShoppingList(requestParameters: ClientShoppingListsManagementApiCreateShoppingListRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).createShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.createClientShoppingListRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže existující nákupní seznam
     * @summary Smaže nákupní seznam
     * @param {ClientShoppingListsManagementApiDeleteShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public deleteShoppingList(requestParameters: ClientShoppingListsManagementApiDeleteShoppingListRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).deleteShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail konkrétního nákupního seznamu
     * @summary Získá konkrétní nákupní seznam
     * @param {ClientShoppingListsManagementApiGetShoppingListByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public getShoppingListById(requestParameters: ClientShoppingListsManagementApiGetShoppingListByIdRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).getShoppingListById(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam všech nákupních seznamů pro daného uživatele, organizaci a portál
     * @summary Získá všechny nákupní seznamy
     * @param {ClientShoppingListsManagementApiGetShoppingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public getShoppingLists(requestParameters: ClientShoppingListsManagementApiGetShoppingListsRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).getShoppingLists(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí summary všech nákupních seznamů, které již obsahují produkt — slouží add-product dialogu pro indikaci \'už v seznamu\'
     * @summary Seznamy obsahující daný produkt
     * @param {ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public getShoppingListsContainingProduct(requestParameters: ClientShoppingListsManagementApiGetShoppingListsContainingProductRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).getShoppingListsContainingProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Odebere konkrétní položku z nákupního seznamu
     * @summary Odebere položku z nákupního seznamu
     * @param {ClientShoppingListsManagementApiRemoveFromShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public removeFromShoppingList(requestParameters: ClientShoppingListsManagementApiRemoveFromShoppingListRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).removeFromShoppingList(requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující nákupní seznam
     * @summary Aktualizuje nákupní seznam
     * @param {ClientShoppingListsManagementApiUpdateShoppingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientShoppingListsManagementApi
     */
    public updateShoppingList(requestParameters: ClientShoppingListsManagementApiUpdateShoppingListRequest, options?: RawAxiosRequestConfig) {
        return ClientShoppingListsManagementApiFp(this.configuration).updateShoppingList(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.shoppingListId, requestParameters.updateClientShoppingListRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientStockReceiptsApi - axios parameter creator
 * @export
 */
export const ClientStockReceiptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Řádky jsou všechny provozovny fakturační skupiny, včetně dosud nevyplněných. `amount = null` znamená nezadáno, ne nulu.
         * @summary Příjemky za měsíc
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientStockReceipts: async (organizationId: number, portalId: number, period: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientStockReceipts', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientStockReceipts', 'portalId', portalId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getClientStockReceipts', 'period', period)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/stock-receipts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posílá se celý stav formuláře — provozovna, která v seznamu chybí, se vynuluje. Do reportingu se hodnoty dostanou jobem, takže se v sestavě projeví s krátkým zpožděním.
         * @summary Uloží příjemky za měsíc
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {ClientStockReceiptSaveRequest} clientStockReceiptSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveClientStockReceipts: async (organizationId: number, portalId: number, clientStockReceiptSaveRequest: ClientStockReceiptSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveClientStockReceipts', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('saveClientStockReceipts', 'portalId', portalId)
            // verify required parameter 'clientStockReceiptSaveRequest' is not null or undefined
            assertParamExists('saveClientStockReceipts', 'clientStockReceiptSaveRequest', clientStockReceiptSaveRequest)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/stock-receipts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientStockReceiptSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientStockReceiptsApi - functional programming interface
 * @export
 */
export const ClientStockReceiptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientStockReceiptsApiAxiosParamCreator(configuration)
    return {
        /**
         * Řádky jsou všechny provozovny fakturační skupiny, včetně dosud nevyplněných. `amount = null` znamená nezadáno, ne nulu.
         * @summary Příjemky za měsíc
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientStockReceipts(organizationId: number, portalId: number, period: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStockReceiptMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientStockReceipts(organizationId, portalId, period, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientStockReceiptsApi.getClientStockReceipts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posílá se celý stav formuláře — provozovna, která v seznamu chybí, se vynuluje. Do reportingu se hodnoty dostanou jobem, takže se v sestavě projeví s krátkým zpožděním.
         * @summary Uloží příjemky za měsíc
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {ClientStockReceiptSaveRequest} clientStockReceiptSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveClientStockReceipts(organizationId: number, portalId: number, clientStockReceiptSaveRequest: ClientStockReceiptSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStockReceiptMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveClientStockReceipts(organizationId, portalId, clientStockReceiptSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientStockReceiptsApi.saveClientStockReceipts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientStockReceiptsApi - factory interface
 * @export
 */
export const ClientStockReceiptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientStockReceiptsApiFp(configuration)
    return {
        /**
         * Řádky jsou všechny provozovny fakturační skupiny, včetně dosud nevyplněných. `amount = null` znamená nezadáno, ne nulu.
         * @summary Příjemky za měsíc
         * @param {ClientStockReceiptsApiGetClientStockReceiptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientStockReceipts(requestParameters: ClientStockReceiptsApiGetClientStockReceiptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientStockReceiptMonthResponse> {
            return localVarFp.getClientStockReceipts(requestParameters.organizationId, requestParameters.portalId, requestParameters.period, options).then((request) => request(axios, basePath));
        },
        /**
         * Posílá se celý stav formuláře — provozovna, která v seznamu chybí, se vynuluje. Do reportingu se hodnoty dostanou jobem, takže se v sestavě projeví s krátkým zpožděním.
         * @summary Uloží příjemky za měsíc
         * @param {ClientStockReceiptsApiSaveClientStockReceiptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveClientStockReceipts(requestParameters: ClientStockReceiptsApiSaveClientStockReceiptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientStockReceiptMonthResponse> {
            return localVarFp.saveClientStockReceipts(requestParameters.organizationId, requestParameters.portalId, requestParameters.clientStockReceiptSaveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientStockReceiptsApi - interface
 * @export
 * @interface ClientStockReceiptsApi
 */
export interface ClientStockReceiptsApiInterface {
    /**
     * Řádky jsou všechny provozovny fakturační skupiny, včetně dosud nevyplněných. `amount = null` znamená nezadáno, ne nulu.
     * @summary Příjemky za měsíc
     * @param {ClientStockReceiptsApiGetClientStockReceiptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStockReceiptsApiInterface
     */
    getClientStockReceipts(requestParameters: ClientStockReceiptsApiGetClientStockReceiptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientStockReceiptMonthResponse>;

    /**
     * Posílá se celý stav formuláře — provozovna, která v seznamu chybí, se vynuluje. Do reportingu se hodnoty dostanou jobem, takže se v sestavě projeví s krátkým zpožděním.
     * @summary Uloží příjemky za měsíc
     * @param {ClientStockReceiptsApiSaveClientStockReceiptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStockReceiptsApiInterface
     */
    saveClientStockReceipts(requestParameters: ClientStockReceiptsApiSaveClientStockReceiptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientStockReceiptMonthResponse>;

}

/**
 * Request parameters for getClientStockReceipts operation in ClientStockReceiptsApi.
 * @export
 * @interface ClientStockReceiptsApiGetClientStockReceiptsRequest
 */
export interface ClientStockReceiptsApiGetClientStockReceiptsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptsApiGetClientStockReceipts
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptsApiGetClientStockReceipts
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof ClientStockReceiptsApiGetClientStockReceipts
     */
    readonly period: string
}

/**
 * Request parameters for saveClientStockReceipts operation in ClientStockReceiptsApi.
 * @export
 * @interface ClientStockReceiptsApiSaveClientStockReceiptsRequest
 */
export interface ClientStockReceiptsApiSaveClientStockReceiptsRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptsApiSaveClientStockReceipts
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof ClientStockReceiptsApiSaveClientStockReceipts
     */
    readonly portalId: number

    /**
     * 
     * @type {ClientStockReceiptSaveRequest}
     * @memberof ClientStockReceiptsApiSaveClientStockReceipts
     */
    readonly clientStockReceiptSaveRequest: ClientStockReceiptSaveRequest
}

/**
 * ClientStockReceiptsApi - object-oriented interface
 * @export
 * @class ClientStockReceiptsApi
 * @extends {BaseAPI}
 */
export class ClientStockReceiptsApi extends BaseAPI implements ClientStockReceiptsApiInterface {
    /**
     * Řádky jsou všechny provozovny fakturační skupiny, včetně dosud nevyplněných. `amount = null` znamená nezadáno, ne nulu.
     * @summary Příjemky za měsíc
     * @param {ClientStockReceiptsApiGetClientStockReceiptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStockReceiptsApi
     */
    public getClientStockReceipts(requestParameters: ClientStockReceiptsApiGetClientStockReceiptsRequest, options?: RawAxiosRequestConfig) {
        return ClientStockReceiptsApiFp(this.configuration).getClientStockReceipts(requestParameters.organizationId, requestParameters.portalId, requestParameters.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posílá se celý stav formuláře — provozovna, která v seznamu chybí, se vynuluje. Do reportingu se hodnoty dostanou jobem, takže se v sestavě projeví s krátkým zpožděním.
     * @summary Uloží příjemky za měsíc
     * @param {ClientStockReceiptsApiSaveClientStockReceiptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStockReceiptsApi
     */
    public saveClientStockReceipts(requestParameters: ClientStockReceiptsApiSaveClientStockReceiptsRequest, options?: RawAxiosRequestConfig) {
        return ClientStockReceiptsApiFp(this.configuration).saveClientStockReceipts(requestParameters.organizationId, requestParameters.portalId, requestParameters.clientStockReceiptSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientUserManagementApi - axios parameter creator
 * @export
 */
export const ClientUserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvoření nového uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {CreateClientUserRequestDTO} createClientUserRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientUser: async (organizationId: number, portalId: number, createClientUserRequestDTO: CreateClientUserRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClientUser', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('createClientUser', 'portalId', portalId)
            // verify required parameter 'createClientUserRequestDTO' is not null or undefined
            assertParamExists('createClientUser', 'createClientUserRequestDTO', createClientUserRequestDTO)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientUserRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smazání uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientUser: async (userId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteClientUser', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClientUser', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteClientUser', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUser: async (userId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getClientUser', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUser', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUser', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dostupné role pro klienty
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUserRoles: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUserRoles', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUserRoles', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dostupné bezpečnostní skupiny pro klienty
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUserSecurityGroups: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUserSecurityGroups', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUserSecurityGroups', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/security-groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam uživatelů v organizaci a portálu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} [page] Stránka
         * @param {number} [size] Velikost stránky
         * @param {string} [search] Vyhledávací dotaz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUsers: async (organizationId: number, portalId: number, page?: number, size?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClientUsers', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getClientUsers', 'portalId', portalId)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizace uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {UpdateClientUserRequestDTO} updateClientUserRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUser: async (userId: number, organizationId: number, portalId: number, updateClientUserRequestDTO: UpdateClientUserRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateClientUser', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClientUser', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateClientUser', 'portalId', portalId)
            // verify required parameter 'updateClientUserRequestDTO' is not null or undefined
            assertParamExists('updateClientUser', 'updateClientUserRequestDTO', updateClientUserRequestDTO)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientUserRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přiřazení rolí uživateli
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUserRoles: async (userId: number, organizationId: number, portalId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateClientUserRoles', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClientUserRoles', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateClientUserRoles', 'portalId', portalId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateClientUserRoles', 'requestBody', requestBody)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přiřazení bezpečnostních skupin uživateli
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUserSecurityGroups: async (userId: number, organizationId: number, portalId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateClientUserSecurityGroups', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClientUserSecurityGroups', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateClientUserSecurityGroups', 'portalId', portalId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateClientUserSecurityGroups', 'requestBody', requestBody)
            const localVarPath = `/api/client/org/{organizationId}/portal/{portalId}/users/{userId}/security-groups`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientUserManagementApi - functional programming interface
 * @export
 */
export const ClientUserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientUserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvoření nového uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {CreateClientUserRequestDTO} createClientUserRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientUser(organizationId: number, portalId: number, createClientUserRequestDTO: CreateClientUserRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientUser(organizationId, portalId, createClientUserRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.createClientUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smazání uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClientUser(userId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClientUser(userId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.deleteClientUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUser(userId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUser(userId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.getClientUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dostupné role pro klienty
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUserRoles(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientUserRoleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUserRoles(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.getClientUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dostupné bezpečnostní skupiny pro klienty
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUserSecurityGroups(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientUserSecurityGroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUserSecurityGroups(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.getClientUserSecurityGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam uživatelů v organizaci a portálu
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {number} [page] Stránka
         * @param {number} [size] Velikost stránky
         * @param {string} [search] Vyhledávací dotaz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientUsers(organizationId: number, portalId: number, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientUsers(organizationId, portalId, page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.getClientUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizace uživatele
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {UpdateClientUserRequestDTO} updateClientUserRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientUser(userId: number, organizationId: number, portalId: number, updateClientUserRequestDTO: UpdateClientUserRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientUser(userId, organizationId, portalId, updateClientUserRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.updateClientUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přiřazení rolí uživateli
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientUserRoles(userId: number, organizationId: number, portalId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientUserRoles(userId, organizationId, portalId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.updateClientUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přiřazení bezpečnostních skupin uživateli
         * @param {number} userId ID uživatele
         * @param {number} organizationId ID organizace
         * @param {number} portalId ID portálu
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientUserSecurityGroups(userId: number, organizationId: number, portalId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientUserSecurityGroups(userId, organizationId, portalId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientUserManagementApi.updateClientUserSecurityGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientUserManagementApi - factory interface
 * @export
 */
export const ClientUserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientUserManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvoření nového uživatele
         * @param {ClientUserManagementApiCreateClientUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientUser(requestParameters: ClientUserManagementApiCreateClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO> {
            return localVarFp.createClientUser(requestParameters.organizationId, requestParameters.portalId, requestParameters.createClientUserRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smazání uživatele
         * @param {ClientUserManagementApiDeleteClientUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientUser(requestParameters: ClientUserManagementApiDeleteClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail uživatele
         * @param {ClientUserManagementApiGetClientUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUser(requestParameters: ClientUserManagementApiGetClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO> {
            return localVarFp.getClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dostupné role pro klienty
         * @param {ClientUserManagementApiGetClientUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUserRoles(requestParameters: ClientUserManagementApiGetClientUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUserRoleDTO>> {
            return localVarFp.getClientUserRoles(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dostupné bezpečnostní skupiny pro klienty
         * @param {ClientUserManagementApiGetClientUserSecurityGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUserSecurityGroups(requestParameters: ClientUserManagementApiGetClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUserSecurityGroupDTO>> {
            return localVarFp.getClientUserSecurityGroups(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam uživatelů v organizaci a portálu
         * @param {ClientUserManagementApiGetClientUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientUsers(requestParameters: ClientUserManagementApiGetClientUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserListDTO> {
            return localVarFp.getClientUsers(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizace uživatele
         * @param {ClientUserManagementApiUpdateClientUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUser(requestParameters: ClientUserManagementApiUpdateClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO> {
            return localVarFp.updateClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.updateClientUserRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přiřazení rolí uživateli
         * @param {ClientUserManagementApiUpdateClientUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUserRoles(requestParameters: ClientUserManagementApiUpdateClientUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateClientUserRoles(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přiřazení bezpečnostních skupin uživateli
         * @param {ClientUserManagementApiUpdateClientUserSecurityGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientUserSecurityGroups(requestParameters: ClientUserManagementApiUpdateClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateClientUserSecurityGroups(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientUserManagementApi - interface
 * @export
 * @interface ClientUserManagementApi
 */
export interface ClientUserManagementApiInterface {
    /**
     * 
     * @summary Vytvoření nového uživatele
     * @param {ClientUserManagementApiCreateClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    createClientUser(requestParameters: ClientUserManagementApiCreateClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO>;

    /**
     * 
     * @summary Smazání uživatele
     * @param {ClientUserManagementApiDeleteClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    deleteClientUser(requestParameters: ClientUserManagementApiDeleteClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Detail uživatele
     * @param {ClientUserManagementApiGetClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    getClientUser(requestParameters: ClientUserManagementApiGetClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO>;

    /**
     * 
     * @summary Dostupné role pro klienty
     * @param {ClientUserManagementApiGetClientUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    getClientUserRoles(requestParameters: ClientUserManagementApiGetClientUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUserRoleDTO>>;

    /**
     * 
     * @summary Dostupné bezpečnostní skupiny pro klienty
     * @param {ClientUserManagementApiGetClientUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    getClientUserSecurityGroups(requestParameters: ClientUserManagementApiGetClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientUserSecurityGroupDTO>>;

    /**
     * 
     * @summary Seznam uživatelů v organizaci a portálu
     * @param {ClientUserManagementApiGetClientUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    getClientUsers(requestParameters: ClientUserManagementApiGetClientUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserListDTO>;

    /**
     * 
     * @summary Aktualizace uživatele
     * @param {ClientUserManagementApiUpdateClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    updateClientUser(requestParameters: ClientUserManagementApiUpdateClientUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDTO>;

    /**
     * 
     * @summary Přiřazení rolí uživateli
     * @param {ClientUserManagementApiUpdateClientUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    updateClientUserRoles(requestParameters: ClientUserManagementApiUpdateClientUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Přiřazení bezpečnostních skupin uživateli
     * @param {ClientUserManagementApiUpdateClientUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApiInterface
     */
    updateClientUserSecurityGroups(requestParameters: ClientUserManagementApiUpdateClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createClientUser operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiCreateClientUserRequest
 */
export interface ClientUserManagementApiCreateClientUserRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiCreateClientUser
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiCreateClientUser
     */
    readonly portalId: number

    /**
     * 
     * @type {CreateClientUserRequestDTO}
     * @memberof ClientUserManagementApiCreateClientUser
     */
    readonly createClientUserRequestDTO: CreateClientUserRequestDTO
}

/**
 * Request parameters for deleteClientUser operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiDeleteClientUserRequest
 */
export interface ClientUserManagementApiDeleteClientUserRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientUserManagementApiDeleteClientUser
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiDeleteClientUser
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiDeleteClientUser
     */
    readonly portalId: number
}

/**
 * Request parameters for getClientUser operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiGetClientUserRequest
 */
export interface ClientUserManagementApiGetClientUserRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUser
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUser
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUser
     */
    readonly portalId: number
}

/**
 * Request parameters for getClientUserRoles operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiGetClientUserRolesRequest
 */
export interface ClientUserManagementApiGetClientUserRolesRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUserRoles
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUserRoles
     */
    readonly portalId: number
}

/**
 * Request parameters for getClientUserSecurityGroups operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiGetClientUserSecurityGroupsRequest
 */
export interface ClientUserManagementApiGetClientUserSecurityGroupsRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUserSecurityGroups
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUserSecurityGroups
     */
    readonly portalId: number
}

/**
 * Request parameters for getClientUsers operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiGetClientUsersRequest
 */
export interface ClientUserManagementApiGetClientUsersRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUsers
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUsers
     */
    readonly portalId: number

    /**
     * Stránka
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUsers
     */
    readonly page?: number

    /**
     * Velikost stránky
     * @type {number}
     * @memberof ClientUserManagementApiGetClientUsers
     */
    readonly size?: number

    /**
     * Vyhledávací dotaz
     * @type {string}
     * @memberof ClientUserManagementApiGetClientUsers
     */
    readonly search?: string
}

/**
 * Request parameters for updateClientUser operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiUpdateClientUserRequest
 */
export interface ClientUserManagementApiUpdateClientUserRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUser
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUser
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUser
     */
    readonly portalId: number

    /**
     * 
     * @type {UpdateClientUserRequestDTO}
     * @memberof ClientUserManagementApiUpdateClientUser
     */
    readonly updateClientUserRequestDTO: UpdateClientUserRequestDTO
}

/**
 * Request parameters for updateClientUserRoles operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiUpdateClientUserRolesRequest
 */
export interface ClientUserManagementApiUpdateClientUserRolesRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserRoles
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserRoles
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserRoles
     */
    readonly portalId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ClientUserManagementApiUpdateClientUserRoles
     */
    readonly requestBody: Array<number>
}

/**
 * Request parameters for updateClientUserSecurityGroups operation in ClientUserManagementApi.
 * @export
 * @interface ClientUserManagementApiUpdateClientUserSecurityGroupsRequest
 */
export interface ClientUserManagementApiUpdateClientUserSecurityGroupsRequest {
    /**
     * ID uživatele
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserSecurityGroups
     */
    readonly userId: number

    /**
     * ID organizace
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserSecurityGroups
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof ClientUserManagementApiUpdateClientUserSecurityGroups
     */
    readonly portalId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ClientUserManagementApiUpdateClientUserSecurityGroups
     */
    readonly requestBody: Array<number>
}

/**
 * ClientUserManagementApi - object-oriented interface
 * @export
 * @class ClientUserManagementApi
 * @extends {BaseAPI}
 */
export class ClientUserManagementApi extends BaseAPI implements ClientUserManagementApiInterface {
    /**
     * 
     * @summary Vytvoření nového uživatele
     * @param {ClientUserManagementApiCreateClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public createClientUser(requestParameters: ClientUserManagementApiCreateClientUserRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).createClientUser(requestParameters.organizationId, requestParameters.portalId, requestParameters.createClientUserRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smazání uživatele
     * @param {ClientUserManagementApiDeleteClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public deleteClientUser(requestParameters: ClientUserManagementApiDeleteClientUserRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).deleteClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail uživatele
     * @param {ClientUserManagementApiGetClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public getClientUser(requestParameters: ClientUserManagementApiGetClientUserRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).getClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dostupné role pro klienty
     * @param {ClientUserManagementApiGetClientUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public getClientUserRoles(requestParameters: ClientUserManagementApiGetClientUserRolesRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).getClientUserRoles(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dostupné bezpečnostní skupiny pro klienty
     * @param {ClientUserManagementApiGetClientUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public getClientUserSecurityGroups(requestParameters: ClientUserManagementApiGetClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).getClientUserSecurityGroups(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam uživatelů v organizaci a portálu
     * @param {ClientUserManagementApiGetClientUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public getClientUsers(requestParameters: ClientUserManagementApiGetClientUsersRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).getClientUsers(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizace uživatele
     * @param {ClientUserManagementApiUpdateClientUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public updateClientUser(requestParameters: ClientUserManagementApiUpdateClientUserRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).updateClientUser(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.updateClientUserRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přiřazení rolí uživateli
     * @param {ClientUserManagementApiUpdateClientUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public updateClientUserRoles(requestParameters: ClientUserManagementApiUpdateClientUserRolesRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).updateClientUserRoles(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přiřazení bezpečnostních skupin uživateli
     * @param {ClientUserManagementApiUpdateClientUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientUserManagementApi
     */
    public updateClientUserSecurityGroups(requestParameters: ClientUserManagementApiUpdateClientUserSecurityGroupsRequest, options?: RawAxiosRequestConfig) {
        return ClientUserManagementApiFp(this.configuration).updateClientUserSecurityGroups(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomProductControllerApi - axios parameter creator
 * @export
 */
export const CustomProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvoření vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {CreateCustomProductRequest} createCustomProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProduct: async (organizationId: number, portalId: number, createCustomProductRequest: CreateCustomProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCustomProduct', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('createCustomProduct', 'portalId', portalId)
            // verify required parameter 'createCustomProductRequest' is not null or undefined
            assertParamExists('createCustomProduct', 'createCustomProductRequest', createCustomProductRequest)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smazání vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProduct: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCustomProduct', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteCustomProduct', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteCustomProduct', 'productId', productId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smazání obrázku vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} physicalImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductImage: async (organizationId: number, portalId: number, productId: number, physicalImageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCustomProductImage', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteCustomProductImage', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteCustomProductImage', 'productId', productId)
            // verify required parameter 'physicalImageId' is not null or undefined
            assertParamExists('deleteCustomProductImage', 'physicalImageId', physicalImageId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/{productId}/images/{physicalImageId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"physicalImageId"}}`, encodeURIComponent(String(physicalImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export vlastních produktů do XLSX
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomProducts: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportCustomProducts', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('exportCustomProducts', 'portalId', portalId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/export`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductDetail: async (organizationId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCustomProductDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getCustomProductDetail', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getCustomProductDetail', 'productId', productId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prázdná šablona pro import vlastních produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductImportTemplate: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCustomProductImportTemplate', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getCustomProductImportTemplate', 'portalId', portalId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/import/template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam vlastních produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductList: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCustomProductList', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getCustomProductList', 'portalId', portalId)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import vlastních produktů z XLSX
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {CustomProductImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomProducts: async (organizationId: number, portalId: number, file: File, duplicateMode?: CustomProductImportDuplicateMode, skipInvalidRows?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importCustomProducts', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('importCustomProducts', 'portalId', portalId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importCustomProducts', 'file', file)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/import`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }

            if (skipInvalidRows !== undefined) {
                localVarQueryParameter['skipInvalidRows'] = skipInvalidRows;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Úprava vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {UpdateCustomProductRequest} updateCustomProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProduct: async (organizationId: number, portalId: number, productId: number, updateCustomProductRequest: UpdateCustomProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCustomProduct', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateCustomProduct', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateCustomProduct', 'productId', productId)
            // verify required parameter 'updateCustomProductRequest' is not null or undefined
            assertParamExists('updateCustomProduct', 'updateCustomProductRequest', updateCustomProductRequest)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/{productId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload obrázku vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {CustomProductImageUploadRequest} customProductImageUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomProductImage: async (organizationId: number, portalId: number, productId: number, customProductImageUploadRequest: CustomProductImageUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadCustomProductImage', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('uploadCustomProductImage', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('uploadCustomProductImage', 'productId', productId)
            // verify required parameter 'customProductImageUploadRequest' is not null or undefined
            assertParamExists('uploadCustomProductImage', 'customProductImageUploadRequest', customProductImageUploadRequest)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/{productId}/images`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customProductImageUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Kontrola souboru pro import vlastních produktů (bez zápisu)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {CustomProductImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomProductImport: async (organizationId: number, portalId: number, file: File, duplicateMode?: CustomProductImportDuplicateMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validateCustomProductImport', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('validateCustomProductImport', 'portalId', portalId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('validateCustomProductImport', 'file', file)
            const localVarPath = `/client/{organizationId}/portals/{portalId}/custom-products/import/validate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomProductControllerApi - functional programming interface
 * @export
 */
export const CustomProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvoření vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {CreateCustomProductRequest} createCustomProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomProduct(organizationId: number, portalId: number, createCustomProductRequest: CreateCustomProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomProduct(organizationId, portalId, createCustomProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.createCustomProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smazání vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomProduct(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomProduct(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.deleteCustomProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smazání obrázku vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} physicalImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomProductImage(organizationId: number, portalId: number, productId: number, physicalImageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomProductImage(organizationId, portalId, productId, physicalImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.deleteCustomProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export vlastních produktů do XLSX
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCustomProducts(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCustomProducts(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.exportCustomProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductDetail(organizationId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductDetail(organizationId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.getCustomProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prázdná šablona pro import vlastních produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductImportTemplate(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductImportTemplate(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.getCustomProductImportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam vlastních produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductList(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomProductListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductList(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.getCustomProductList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import vlastních produktů z XLSX
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {CustomProductImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCustomProducts(organizationId: number, portalId: number, file: File, duplicateMode?: CustomProductImportDuplicateMode, skipInvalidRows?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductImportResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCustomProducts(organizationId, portalId, file, duplicateMode, skipInvalidRows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.importCustomProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Úprava vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {UpdateCustomProductRequest} updateCustomProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomProduct(organizationId: number, portalId: number, productId: number, updateCustomProductRequest: UpdateCustomProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomProduct(organizationId, portalId, productId, updateCustomProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.updateCustomProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload obrázku vlastního produktu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {CustomProductImageUploadRequest} customProductImageUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCustomProductImage(organizationId: number, portalId: number, productId: number, customProductImageUploadRequest: CustomProductImageUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductImageUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCustomProductImage(organizationId, portalId, productId, customProductImageUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.uploadCustomProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Kontrola souboru pro import vlastních produktů (bez zápisu)
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {CustomProductImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCustomProductImport(organizationId: number, portalId: number, file: File, duplicateMode?: CustomProductImportDuplicateMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductImportPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCustomProductImport(organizationId, portalId, file, duplicateMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomProductControllerApi.validateCustomProductImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomProductControllerApi - factory interface
 * @export
 */
export const CustomProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvoření vlastního produktu
         * @param {CustomProductControllerApiCreateCustomProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProduct(requestParameters: CustomProductControllerApiCreateCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.createCustomProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smazání vlastního produktu
         * @param {CustomProductControllerApiDeleteCustomProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProduct(requestParameters: CustomProductControllerApiDeleteCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smazání obrázku vlastního produktu
         * @param {CustomProductControllerApiDeleteCustomProductImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductImage(requestParameters: CustomProductControllerApiDeleteCustomProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomProductImage(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.physicalImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export vlastních produktů do XLSX
         * @param {CustomProductControllerApiExportCustomProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomProducts(requestParameters: CustomProductControllerApiExportCustomProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportCustomProducts(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail vlastního produktu
         * @param {CustomProductControllerApiGetCustomProductDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductDetail(requestParameters: CustomProductControllerApiGetCustomProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductDetailResponse> {
            return localVarFp.getCustomProductDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prázdná šablona pro import vlastních produktů
         * @param {CustomProductControllerApiGetCustomProductImportTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductImportTemplate(requestParameters: CustomProductControllerApiGetCustomProductImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getCustomProductImportTemplate(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam vlastních produktů
         * @param {CustomProductControllerApiGetCustomProductListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductList(requestParameters: CustomProductControllerApiGetCustomProductListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomProductListResponse>> {
            return localVarFp.getCustomProductList(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import vlastních produktů z XLSX
         * @param {CustomProductControllerApiImportCustomProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomProducts(requestParameters: CustomProductControllerApiImportCustomProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImportResultResponse> {
            return localVarFp.importCustomProducts(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Úprava vlastního produktu
         * @param {CustomProductControllerApiUpdateCustomProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProduct(requestParameters: CustomProductControllerApiUpdateCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.updateCustomProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload obrázku vlastního produktu
         * @param {CustomProductControllerApiUploadCustomProductImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomProductImage(requestParameters: CustomProductControllerApiUploadCustomProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImageUploadResponse> {
            return localVarFp.uploadCustomProductImage(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.customProductImageUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Kontrola souboru pro import vlastních produktů (bez zápisu)
         * @param {CustomProductControllerApiValidateCustomProductImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomProductImport(requestParameters: CustomProductControllerApiValidateCustomProductImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImportPreviewResponse> {
            return localVarFp.validateCustomProductImport(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomProductControllerApi - interface
 * @export
 * @interface CustomProductControllerApi
 */
export interface CustomProductControllerApiInterface {
    /**
     * 
     * @summary Vytvoření vlastního produktu
     * @param {CustomProductControllerApiCreateCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    createCustomProduct(requestParameters: CustomProductControllerApiCreateCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Smazání vlastního produktu
     * @param {CustomProductControllerApiDeleteCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    deleteCustomProduct(requestParameters: CustomProductControllerApiDeleteCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Smazání obrázku vlastního produktu
     * @param {CustomProductControllerApiDeleteCustomProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    deleteCustomProductImage(requestParameters: CustomProductControllerApiDeleteCustomProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Export vlastních produktů do XLSX
     * @param {CustomProductControllerApiExportCustomProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    exportCustomProducts(requestParameters: CustomProductControllerApiExportCustomProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Detail vlastního produktu
     * @param {CustomProductControllerApiGetCustomProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    getCustomProductDetail(requestParameters: CustomProductControllerApiGetCustomProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductDetailResponse>;

    /**
     * 
     * @summary Prázdná šablona pro import vlastních produktů
     * @param {CustomProductControllerApiGetCustomProductImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    getCustomProductImportTemplate(requestParameters: CustomProductControllerApiGetCustomProductImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Seznam vlastních produktů
     * @param {CustomProductControllerApiGetCustomProductListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    getCustomProductList(requestParameters: CustomProductControllerApiGetCustomProductListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomProductListResponse>>;

    /**
     * 
     * @summary Import vlastních produktů z XLSX
     * @param {CustomProductControllerApiImportCustomProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    importCustomProducts(requestParameters: CustomProductControllerApiImportCustomProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImportResultResponse>;

    /**
     * 
     * @summary Úprava vlastního produktu
     * @param {CustomProductControllerApiUpdateCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    updateCustomProduct(requestParameters: CustomProductControllerApiUpdateCustomProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Upload obrázku vlastního produktu
     * @param {CustomProductControllerApiUploadCustomProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    uploadCustomProductImage(requestParameters: CustomProductControllerApiUploadCustomProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImageUploadResponse>;

    /**
     * 
     * @summary Kontrola souboru pro import vlastních produktů (bez zápisu)
     * @param {CustomProductControllerApiValidateCustomProductImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApiInterface
     */
    validateCustomProductImport(requestParameters: CustomProductControllerApiValidateCustomProductImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomProductImportPreviewResponse>;

}

/**
 * Request parameters for createCustomProduct operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiCreateCustomProductRequest
 */
export interface CustomProductControllerApiCreateCustomProductRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiCreateCustomProduct
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiCreateCustomProduct
     */
    readonly portalId: number

    /**
     * 
     * @type {CreateCustomProductRequest}
     * @memberof CustomProductControllerApiCreateCustomProduct
     */
    readonly createCustomProductRequest: CreateCustomProductRequest
}

/**
 * Request parameters for deleteCustomProduct operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiDeleteCustomProductRequest
 */
export interface CustomProductControllerApiDeleteCustomProductRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProduct
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProduct
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProduct
     */
    readonly productId: number
}

/**
 * Request parameters for deleteCustomProductImage operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiDeleteCustomProductImageRequest
 */
export interface CustomProductControllerApiDeleteCustomProductImageRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProductImage
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProductImage
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProductImage
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiDeleteCustomProductImage
     */
    readonly physicalImageId: number
}

/**
 * Request parameters for exportCustomProducts operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiExportCustomProductsRequest
 */
export interface CustomProductControllerApiExportCustomProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiExportCustomProducts
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiExportCustomProducts
     */
    readonly portalId: number
}

/**
 * Request parameters for getCustomProductDetail operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiGetCustomProductDetailRequest
 */
export interface CustomProductControllerApiGetCustomProductDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductDetail
     */
    readonly productId: number
}

/**
 * Request parameters for getCustomProductImportTemplate operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiGetCustomProductImportTemplateRequest
 */
export interface CustomProductControllerApiGetCustomProductImportTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductImportTemplate
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductImportTemplate
     */
    readonly portalId: number
}

/**
 * Request parameters for getCustomProductList operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiGetCustomProductListRequest
 */
export interface CustomProductControllerApiGetCustomProductListRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductList
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiGetCustomProductList
     */
    readonly portalId: number
}

/**
 * Request parameters for importCustomProducts operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiImportCustomProductsRequest
 */
export interface CustomProductControllerApiImportCustomProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiImportCustomProducts
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiImportCustomProducts
     */
    readonly portalId: number

    /**
     * 
     * @type {File}
     * @memberof CustomProductControllerApiImportCustomProducts
     */
    readonly file: File

    /**
     * 
     * @type {CustomProductImportDuplicateMode}
     * @memberof CustomProductControllerApiImportCustomProducts
     */
    readonly duplicateMode?: CustomProductImportDuplicateMode

    /**
     * 
     * @type {boolean}
     * @memberof CustomProductControllerApiImportCustomProducts
     */
    readonly skipInvalidRows?: boolean
}

/**
 * Request parameters for updateCustomProduct operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiUpdateCustomProductRequest
 */
export interface CustomProductControllerApiUpdateCustomProductRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUpdateCustomProduct
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUpdateCustomProduct
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUpdateCustomProduct
     */
    readonly productId: number

    /**
     * 
     * @type {UpdateCustomProductRequest}
     * @memberof CustomProductControllerApiUpdateCustomProduct
     */
    readonly updateCustomProductRequest: UpdateCustomProductRequest
}

/**
 * Request parameters for uploadCustomProductImage operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiUploadCustomProductImageRequest
 */
export interface CustomProductControllerApiUploadCustomProductImageRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUploadCustomProductImage
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUploadCustomProductImage
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiUploadCustomProductImage
     */
    readonly productId: number

    /**
     * 
     * @type {CustomProductImageUploadRequest}
     * @memberof CustomProductControllerApiUploadCustomProductImage
     */
    readonly customProductImageUploadRequest: CustomProductImageUploadRequest
}

/**
 * Request parameters for validateCustomProductImport operation in CustomProductControllerApi.
 * @export
 * @interface CustomProductControllerApiValidateCustomProductImportRequest
 */
export interface CustomProductControllerApiValidateCustomProductImportRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiValidateCustomProductImport
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof CustomProductControllerApiValidateCustomProductImport
     */
    readonly portalId: number

    /**
     * 
     * @type {File}
     * @memberof CustomProductControllerApiValidateCustomProductImport
     */
    readonly file: File

    /**
     * 
     * @type {CustomProductImportDuplicateMode}
     * @memberof CustomProductControllerApiValidateCustomProductImport
     */
    readonly duplicateMode?: CustomProductImportDuplicateMode
}

/**
 * CustomProductControllerApi - object-oriented interface
 * @export
 * @class CustomProductControllerApi
 * @extends {BaseAPI}
 */
export class CustomProductControllerApi extends BaseAPI implements CustomProductControllerApiInterface {
    /**
     * 
     * @summary Vytvoření vlastního produktu
     * @param {CustomProductControllerApiCreateCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public createCustomProduct(requestParameters: CustomProductControllerApiCreateCustomProductRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).createCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.createCustomProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smazání vlastního produktu
     * @param {CustomProductControllerApiDeleteCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public deleteCustomProduct(requestParameters: CustomProductControllerApiDeleteCustomProductRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).deleteCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smazání obrázku vlastního produktu
     * @param {CustomProductControllerApiDeleteCustomProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public deleteCustomProductImage(requestParameters: CustomProductControllerApiDeleteCustomProductImageRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).deleteCustomProductImage(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.physicalImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export vlastních produktů do XLSX
     * @param {CustomProductControllerApiExportCustomProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public exportCustomProducts(requestParameters: CustomProductControllerApiExportCustomProductsRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).exportCustomProducts(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail vlastního produktu
     * @param {CustomProductControllerApiGetCustomProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public getCustomProductDetail(requestParameters: CustomProductControllerApiGetCustomProductDetailRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).getCustomProductDetail(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prázdná šablona pro import vlastních produktů
     * @param {CustomProductControllerApiGetCustomProductImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public getCustomProductImportTemplate(requestParameters: CustomProductControllerApiGetCustomProductImportTemplateRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).getCustomProductImportTemplate(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam vlastních produktů
     * @param {CustomProductControllerApiGetCustomProductListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public getCustomProductList(requestParameters: CustomProductControllerApiGetCustomProductListRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).getCustomProductList(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import vlastních produktů z XLSX
     * @param {CustomProductControllerApiImportCustomProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public importCustomProducts(requestParameters: CustomProductControllerApiImportCustomProductsRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).importCustomProducts(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Úprava vlastního produktu
     * @param {CustomProductControllerApiUpdateCustomProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public updateCustomProduct(requestParameters: CustomProductControllerApiUpdateCustomProductRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).updateCustomProduct(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.updateCustomProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload obrázku vlastního produktu
     * @param {CustomProductControllerApiUploadCustomProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public uploadCustomProductImage(requestParameters: CustomProductControllerApiUploadCustomProductImageRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).uploadCustomProductImage(requestParameters.organizationId, requestParameters.portalId, requestParameters.productId, requestParameters.customProductImageUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Kontrola souboru pro import vlastních produktů (bez zápisu)
     * @param {CustomProductControllerApiValidateCustomProductImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomProductControllerApi
     */
    public validateCustomProductImport(requestParameters: CustomProductControllerApiValidateCustomProductImportRequest, options?: RawAxiosRequestConfig) {
        return CustomProductControllerApiFp(this.configuration).validateCustomProductImport(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeliveryCalendarApi - axios parameter creator
 * @export
 */
export const DeliveryCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí kalendář s limity pro každý den v zadaném rozsahu datumů pro konkrétního dodavatele
         * @summary Získá kalendář závozových limitů pro dodavatele
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {string} from Počáteční datum (formát: yyyy-MM-dd)
         * @param {string} to Koncové datum (formát: yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryLimits: async (organizationId: number, portalId: number, supplierId: number, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeliveryLimits', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getDeliveryLimits', 'portalId', portalId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getDeliveryLimits', 'supplierId', supplierId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getDeliveryLimits', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getDeliveryLimits', 'to', to)
            const localVarPath = `/customer/delivery-calendar/organization/{organizationId}/portal/{portalId}/supplier/{supplierId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryCalendarApi - functional programming interface
 * @export
 */
export const DeliveryCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí kalendář s limity pro každý den v zadaném rozsahu datumů pro konkrétního dodavatele
         * @summary Získá kalendář závozových limitů pro dodavatele
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {string} from Počáteční datum (formát: yyyy-MM-dd)
         * @param {string} to Koncové datum (formát: yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryLimits(organizationId: number, portalId: number, supplierId: number, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryCalendarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryLimits(organizationId, portalId, supplierId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryCalendarApi.getDeliveryLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryCalendarApi - factory interface
 * @export
 */
export const DeliveryCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryCalendarApiFp(configuration)
    return {
        /**
         * Vrátí kalendář s limity pro každý den v zadaném rozsahu datumů pro konkrétního dodavatele
         * @summary Získá kalendář závozových limitů pro dodavatele
         * @param {DeliveryCalendarApiGetDeliveryLimitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryLimits(requestParameters: DeliveryCalendarApiGetDeliveryLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryCalendarResponse> {
            return localVarFp.getDeliveryLimits(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryCalendarApi - interface
 * @export
 * @interface DeliveryCalendarApi
 */
export interface DeliveryCalendarApiInterface {
    /**
     * Vrátí kalendář s limity pro každý den v zadaném rozsahu datumů pro konkrétního dodavatele
     * @summary Získá kalendář závozových limitů pro dodavatele
     * @param {DeliveryCalendarApiGetDeliveryLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryCalendarApiInterface
     */
    getDeliveryLimits(requestParameters: DeliveryCalendarApiGetDeliveryLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryCalendarResponse>;

}

/**
 * Request parameters for getDeliveryLimits operation in DeliveryCalendarApi.
 * @export
 * @interface DeliveryCalendarApiGetDeliveryLimitsRequest
 */
export interface DeliveryCalendarApiGetDeliveryLimitsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryCalendarApiGetDeliveryLimits
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryCalendarApiGetDeliveryLimits
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryCalendarApiGetDeliveryLimits
     */
    readonly supplierId: number

    /**
     * Počáteční datum (formát: yyyy-MM-dd)
     * @type {string}
     * @memberof DeliveryCalendarApiGetDeliveryLimits
     */
    readonly from: string

    /**
     * Koncové datum (formát: yyyy-MM-dd)
     * @type {string}
     * @memberof DeliveryCalendarApiGetDeliveryLimits
     */
    readonly to: string
}

/**
 * DeliveryCalendarApi - object-oriented interface
 * @export
 * @class DeliveryCalendarApi
 * @extends {BaseAPI}
 */
export class DeliveryCalendarApi extends BaseAPI implements DeliveryCalendarApiInterface {
    /**
     * Vrátí kalendář s limity pro každý den v zadaném rozsahu datumů pro konkrétního dodavatele
     * @summary Získá kalendář závozových limitů pro dodavatele
     * @param {DeliveryCalendarApiGetDeliveryLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryCalendarApi
     */
    public getDeliveryLimits(requestParameters: DeliveryCalendarApiGetDeliveryLimitsRequest, options?: RawAxiosRequestConfig) {
        return DeliveryCalendarApiFp(this.configuration).getDeliveryLimits(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeliveryExportImportApi - axios parameter creator
 * @export
 */
export const DeliveryExportImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stáhne XLSX soubor se všemi závozovými okny pro danou organizaci a portál
         * @summary Stáhne XLSX soubor se závozovými okny
         * @param {number} organizationId ID organizace (zákazníka)
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryWindowsXlsx: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadDeliveryWindowsXlsx', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('downloadDeliveryWindowsXlsx', 'portalId', portalId)
            const localVarPath = `/api/customer/delivery-export/download/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exportuje všechna závozová okna pro danou organizaci a portál do XLSX souboru s informacemi o dodavatelích, limitech, kontaktech a časech doručení
         * @summary Exportuje závozová okna do XLSX souboru
         * @param {DeliveryExportRequestDTO} deliveryExportRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDeliveryWindows: async (deliveryExportRequestDTO: DeliveryExportRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryExportRequestDTO' is not null or undefined
            assertParamExists('exportDeliveryWindows', 'deliveryExportRequestDTO', deliveryExportRequestDTO)
            const localVarPath = `/api/customer/delivery-export/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryExportRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí informace o tom, co bude exportováno, bez stažení souboru
         * @summary Zobrazí náhled exportovaných dat
         * @param {number} organizationId ID organizace (zákazníka)
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDeliveryWindowsExport: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('previewDeliveryWindowsExport', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('previewDeliveryWindowsExport', 'portalId', portalId)
            const localVarPath = `/api/customer/delivery-export/preview/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryExportImportApi - functional programming interface
 * @export
 */
export const DeliveryExportImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryExportImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Stáhne XLSX soubor se všemi závozovými okny pro danou organizaci a portál
         * @summary Stáhne XLSX soubor se závozovými okny
         * @param {number} organizationId ID organizace (zákazníka)
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDeliveryWindowsXlsx(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDeliveryWindowsXlsx(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryExportImportApi.downloadDeliveryWindowsXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exportuje všechna závozová okna pro danou organizaci a portál do XLSX souboru s informacemi o dodavatelích, limitech, kontaktech a časech doručení
         * @summary Exportuje závozová okna do XLSX souboru
         * @param {DeliveryExportRequestDTO} deliveryExportRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDeliveryWindows(deliveryExportRequestDTO: DeliveryExportRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryExportResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportDeliveryWindows(deliveryExportRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryExportImportApi.exportDeliveryWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí informace o tom, co bude exportováno, bez stažení souboru
         * @summary Zobrazí náhled exportovaných dat
         * @param {number} organizationId ID organizace (zákazníka)
         * @param {number} portalId ID portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewDeliveryWindowsExport(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryExportResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewDeliveryWindowsExport(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryExportImportApi.previewDeliveryWindowsExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryExportImportApi - factory interface
 * @export
 */
export const DeliveryExportImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryExportImportApiFp(configuration)
    return {
        /**
         * Stáhne XLSX soubor se všemi závozovými okny pro danou organizaci a portál
         * @summary Stáhne XLSX soubor se závozovými okny
         * @param {DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryWindowsXlsx(requestParameters: DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadDeliveryWindowsXlsx(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Exportuje všechna závozová okna pro danou organizaci a portál do XLSX souboru s informacemi o dodavatelích, limitech, kontaktech a časech doručení
         * @summary Exportuje závozová okna do XLSX souboru
         * @param {DeliveryExportImportApiExportDeliveryWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDeliveryWindows(requestParameters: DeliveryExportImportApiExportDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryExportResponseDTO> {
            return localVarFp.exportDeliveryWindows(requestParameters.deliveryExportRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí informace o tom, co bude exportováno, bez stažení souboru
         * @summary Zobrazí náhled exportovaných dat
         * @param {DeliveryExportImportApiPreviewDeliveryWindowsExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDeliveryWindowsExport(requestParameters: DeliveryExportImportApiPreviewDeliveryWindowsExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryExportResponseDTO> {
            return localVarFp.previewDeliveryWindowsExport(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryExportImportApi - interface
 * @export
 * @interface DeliveryExportImportApi
 */
export interface DeliveryExportImportApiInterface {
    /**
     * Stáhne XLSX soubor se všemi závozovými okny pro danou organizaci a portál
     * @summary Stáhne XLSX soubor se závozovými okny
     * @param {DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApiInterface
     */
    downloadDeliveryWindowsXlsx(requestParameters: DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Exportuje všechna závozová okna pro danou organizaci a portál do XLSX souboru s informacemi o dodavatelích, limitech, kontaktech a časech doručení
     * @summary Exportuje závozová okna do XLSX souboru
     * @param {DeliveryExportImportApiExportDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApiInterface
     */
    exportDeliveryWindows(requestParameters: DeliveryExportImportApiExportDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryExportResponseDTO>;

    /**
     * Vrátí informace o tom, co bude exportováno, bez stažení souboru
     * @summary Zobrazí náhled exportovaných dat
     * @param {DeliveryExportImportApiPreviewDeliveryWindowsExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApiInterface
     */
    previewDeliveryWindowsExport(requestParameters: DeliveryExportImportApiPreviewDeliveryWindowsExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryExportResponseDTO>;

}

/**
 * Request parameters for downloadDeliveryWindowsXlsx operation in DeliveryExportImportApi.
 * @export
 * @interface DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest
 */
export interface DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest {
    /**
     * ID organizace (zákazníka)
     * @type {number}
     * @memberof DeliveryExportImportApiDownloadDeliveryWindowsXlsx
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof DeliveryExportImportApiDownloadDeliveryWindowsXlsx
     */
    readonly portalId: number
}

/**
 * Request parameters for exportDeliveryWindows operation in DeliveryExportImportApi.
 * @export
 * @interface DeliveryExportImportApiExportDeliveryWindowsRequest
 */
export interface DeliveryExportImportApiExportDeliveryWindowsRequest {
    /**
     * 
     * @type {DeliveryExportRequestDTO}
     * @memberof DeliveryExportImportApiExportDeliveryWindows
     */
    readonly deliveryExportRequestDTO: DeliveryExportRequestDTO
}

/**
 * Request parameters for previewDeliveryWindowsExport operation in DeliveryExportImportApi.
 * @export
 * @interface DeliveryExportImportApiPreviewDeliveryWindowsExportRequest
 */
export interface DeliveryExportImportApiPreviewDeliveryWindowsExportRequest {
    /**
     * ID organizace (zákazníka)
     * @type {number}
     * @memberof DeliveryExportImportApiPreviewDeliveryWindowsExport
     */
    readonly organizationId: number

    /**
     * ID portálu
     * @type {number}
     * @memberof DeliveryExportImportApiPreviewDeliveryWindowsExport
     */
    readonly portalId: number
}

/**
 * DeliveryExportImportApi - object-oriented interface
 * @export
 * @class DeliveryExportImportApi
 * @extends {BaseAPI}
 */
export class DeliveryExportImportApi extends BaseAPI implements DeliveryExportImportApiInterface {
    /**
     * Stáhne XLSX soubor se všemi závozovými okny pro danou organizaci a portál
     * @summary Stáhne XLSX soubor se závozovými okny
     * @param {DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApi
     */
    public downloadDeliveryWindowsXlsx(requestParameters: DeliveryExportImportApiDownloadDeliveryWindowsXlsxRequest, options?: RawAxiosRequestConfig) {
        return DeliveryExportImportApiFp(this.configuration).downloadDeliveryWindowsXlsx(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exportuje všechna závozová okna pro danou organizaci a portál do XLSX souboru s informacemi o dodavatelích, limitech, kontaktech a časech doručení
     * @summary Exportuje závozová okna do XLSX souboru
     * @param {DeliveryExportImportApiExportDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApi
     */
    public exportDeliveryWindows(requestParameters: DeliveryExportImportApiExportDeliveryWindowsRequest, options?: RawAxiosRequestConfig) {
        return DeliveryExportImportApiFp(this.configuration).exportDeliveryWindows(requestParameters.deliveryExportRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí informace o tom, co bude exportováno, bez stažení souboru
     * @summary Zobrazí náhled exportovaných dat
     * @param {DeliveryExportImportApiPreviewDeliveryWindowsExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryExportImportApi
     */
    public previewDeliveryWindowsExport(requestParameters: DeliveryExportImportApiPreviewDeliveryWindowsExportRequest, options?: RawAxiosRequestConfig) {
        return DeliveryExportImportApiFp(this.configuration).previewDeliveryWindowsExport(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeliveryImportApi - axios parameter creator
 * @export
 */
export const DeliveryImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Importuje závozová okna z XLSX souboru. Import probíhá asynchronně a progress lze sledovat přes SSE endpoint.
         * @summary Importuje závozová okna z XLSX souboru
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDeliveryWindows: async (organizationId: number, portalId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importDeliveryWindows', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('importDeliveryWindows', 'portalId', portalId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importDeliveryWindows', 'file', file)
            const localVarPath = `/api/customer/delivery-import/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streamuje real-time progress importu závozových oken pro daný taskId
         * @summary Streamuje progress importu přes Server-Sent Events
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamImportProgress: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('streamImportProgress', 'taskId', taskId)
            const localVarPath = `/api/customer/delivery-import/tasks/{taskId}/progress/stream`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryImportApi - functional programming interface
 * @export
 */
export const DeliveryImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Importuje závozová okna z XLSX souboru. Import probíhá asynchronně a progress lze sledovat přes SSE endpoint.
         * @summary Importuje závozová okna z XLSX souboru
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDeliveryWindows(organizationId: number, portalId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryImportResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDeliveryWindows(organizationId, portalId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryImportApi.importDeliveryWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streamuje real-time progress importu závozových oken pro daný taskId
         * @summary Streamuje progress importu přes Server-Sent Events
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamImportProgress(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamImportProgress(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryImportApi.streamImportProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryImportApi - factory interface
 * @export
 */
export const DeliveryImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryImportApiFp(configuration)
    return {
        /**
         * Importuje závozová okna z XLSX souboru. Import probíhá asynchronně a progress lze sledovat přes SSE endpoint.
         * @summary Importuje závozová okna z XLSX souboru
         * @param {DeliveryImportApiImportDeliveryWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDeliveryWindows(requestParameters: DeliveryImportApiImportDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryImportResponseDTO> {
            return localVarFp.importDeliveryWindows(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * Streamuje real-time progress importu závozových oken pro daný taskId
         * @summary Streamuje progress importu přes Server-Sent Events
         * @param {DeliveryImportApiStreamImportProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamImportProgress(requestParameters: DeliveryImportApiStreamImportProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.streamImportProgress(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryImportApi - interface
 * @export
 * @interface DeliveryImportApi
 */
export interface DeliveryImportApiInterface {
    /**
     * Importuje závozová okna z XLSX souboru. Import probíhá asynchronně a progress lze sledovat přes SSE endpoint.
     * @summary Importuje závozová okna z XLSX souboru
     * @param {DeliveryImportApiImportDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryImportApiInterface
     */
    importDeliveryWindows(requestParameters: DeliveryImportApiImportDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryImportResponseDTO>;

    /**
     * Streamuje real-time progress importu závozových oken pro daný taskId
     * @summary Streamuje progress importu přes Server-Sent Events
     * @param {DeliveryImportApiStreamImportProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryImportApiInterface
     */
    streamImportProgress(requestParameters: DeliveryImportApiStreamImportProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>>;

}

/**
 * Request parameters for importDeliveryWindows operation in DeliveryImportApi.
 * @export
 * @interface DeliveryImportApiImportDeliveryWindowsRequest
 */
export interface DeliveryImportApiImportDeliveryWindowsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryImportApiImportDeliveryWindows
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryImportApiImportDeliveryWindows
     */
    readonly portalId: number

    /**
     * 
     * @type {File}
     * @memberof DeliveryImportApiImportDeliveryWindows
     */
    readonly file: File
}

/**
 * Request parameters for streamImportProgress operation in DeliveryImportApi.
 * @export
 * @interface DeliveryImportApiStreamImportProgressRequest
 */
export interface DeliveryImportApiStreamImportProgressRequest {
    /**
     * 
     * @type {string}
     * @memberof DeliveryImportApiStreamImportProgress
     */
    readonly taskId: string
}

/**
 * DeliveryImportApi - object-oriented interface
 * @export
 * @class DeliveryImportApi
 * @extends {BaseAPI}
 */
export class DeliveryImportApi extends BaseAPI implements DeliveryImportApiInterface {
    /**
     * Importuje závozová okna z XLSX souboru. Import probíhá asynchronně a progress lze sledovat přes SSE endpoint.
     * @summary Importuje závozová okna z XLSX souboru
     * @param {DeliveryImportApiImportDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryImportApi
     */
    public importDeliveryWindows(requestParameters: DeliveryImportApiImportDeliveryWindowsRequest, options?: RawAxiosRequestConfig) {
        return DeliveryImportApiFp(this.configuration).importDeliveryWindows(requestParameters.organizationId, requestParameters.portalId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streamuje real-time progress importu závozových oken pro daný taskId
     * @summary Streamuje progress importu přes Server-Sent Events
     * @param {DeliveryImportApiStreamImportProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryImportApi
     */
    public streamImportProgress(requestParameters: DeliveryImportApiStreamImportProgressRequest, options?: RawAxiosRequestConfig) {
        return DeliveryImportApiFp(this.configuration).streamImportProgress(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeliveryWindowsManagementApi - axios parameter creator
 * @export
 */
export const DeliveryWindowsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří nové závozové okno pro dodavatele s nastavením dnů a kontaktů
         * @summary Vytvoří nové závozové okno
         * @param {CreateDeliveryWindowRequestDTO} createDeliveryWindowRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryWindow: async (createDeliveryWindowRequestDTO: CreateDeliveryWindowRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDeliveryWindowRequestDTO' is not null or undefined
            assertParamExists('createDeliveryWindow', 'createDeliveryWindowRequestDTO', createDeliveryWindowRequestDTO)
            const localVarPath = `/api/customer/delivery-windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDeliveryWindowRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže závozové okno a všechny související dny a kontakty
         * @summary Smaže závozové okno
         * @param {number} deliveryWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryWindow: async (deliveryWindowId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryWindowId' is not null or undefined
            assertParamExists('deleteDeliveryWindow', 'deliveryWindowId', deliveryWindowId)
            const localVarPath = `/api/customer/delivery-windows/{deliveryWindowId}`
                .replace(`{${"deliveryWindowId"}}`, encodeURIComponent(String(deliveryWindowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí kompletní informace o konkrétním závozovém okně podle jeho ID včetně dnů, kontaktů a dodavatele
         * @summary Získá detail závozového okna podle ID
         * @param {number} deliveryWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowDetail: async (deliveryWindowId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryWindowId' is not null or undefined
            assertParamExists('getDeliveryWindowDetail', 'deliveryWindowId', deliveryWindowId)
            const localVarPath = `/api/customer/delivery-windows/{deliveryWindowId}`
                .replace(`{${"deliveryWindowId"}}`, encodeURIComponent(String(deliveryWindowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí kompletní informace o závozovém okně pro konkrétního dodavatele. Pokud dodavatel nemá nastavené závozové okno, vrátí virtuální záznam.
         * @summary Získá detail závozového okna podle dodavatele
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowDetailBySupplier: async (organizationId: number, portalId: number, supplierId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeliveryWindowDetailBySupplier', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getDeliveryWindowDetailBySupplier', 'portalId', portalId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getDeliveryWindowDetailBySupplier', 'supplierId', supplierId)
            const localVarPath = `/api/customer/delivery-windows/organization/{organizationId}/portal/{portalId}/supplier/{supplierId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí statistické informace o závozových oknech pro danou organizaci a portál včetně pokrytí dodavatelů
         * @summary Získá statistiku závozových oken
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowStatistics: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeliveryWindowStatistics', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getDeliveryWindowStatistics', 'portalId', portalId)
            const localVarPath = `/api/customer/delivery-windows/statistics/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam všech závozových oken pro danou organizaci a portál s podporou paginace a filtrování podle dodavatele
         * @summary Získá seznam závozových oken s paginací
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] Číslo stránky (začíná od 0)
         * @param {number} [size] Počet položek na stránku
         * @param {number} [supplierId] ID dodavatele pro filtrování
         * @param {boolean} [configured] Filtr podle nastavení: true&#x3D;jen nastavená, false&#x3D;jen nenastavená, null&#x3D;všechna
         * @param {string} [supplierName] Filtr podle jména dodavatele (částečné shody)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindows: async (organizationId: number, portalId: number, page?: number, size?: number, supplierId?: number, configured?: boolean, supplierName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeliveryWindows', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getDeliveryWindows', 'portalId', portalId)
            const localVarPath = `/api/customer/delivery-windows/organization/{organizationId}/portal/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (configured !== undefined) {
                localVarQueryParameter['configured'] = configured;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující závozové okno včetně dnů a kontaktů
         * @summary Aktualizuje závozové okno
         * @param {number} deliveryWindowId 
         * @param {UpdateDeliveryWindowRequestDTO} updateDeliveryWindowRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryWindow: async (deliveryWindowId: number, updateDeliveryWindowRequestDTO: UpdateDeliveryWindowRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryWindowId' is not null or undefined
            assertParamExists('updateDeliveryWindow', 'deliveryWindowId', deliveryWindowId)
            // verify required parameter 'updateDeliveryWindowRequestDTO' is not null or undefined
            assertParamExists('updateDeliveryWindow', 'updateDeliveryWindowRequestDTO', updateDeliveryWindowRequestDTO)
            const localVarPath = `/api/customer/delivery-windows/{deliveryWindowId}`
                .replace(`{${"deliveryWindowId"}}`, encodeURIComponent(String(deliveryWindowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryWindowRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryWindowsManagementApi - functional programming interface
 * @export
 */
export const DeliveryWindowsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryWindowsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří nové závozové okno pro dodavatele s nastavením dnů a kontaktů
         * @summary Vytvoří nové závozové okno
         * @param {CreateDeliveryWindowRequestDTO} createDeliveryWindowRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeliveryWindow(createDeliveryWindowRequestDTO: CreateDeliveryWindowRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeliveryWindow(createDeliveryWindowRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.createDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže závozové okno a všechny související dny a kontakty
         * @summary Smaže závozové okno
         * @param {number} deliveryWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeliveryWindow(deliveryWindowId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeliveryWindow(deliveryWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.deleteDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí kompletní informace o konkrétním závozovém okně podle jeho ID včetně dnů, kontaktů a dodavatele
         * @summary Získá detail závozového okna podle ID
         * @param {number} deliveryWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryWindowDetail(deliveryWindowId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryWindowDetail(deliveryWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.getDeliveryWindowDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí kompletní informace o závozovém okně pro konkrétního dodavatele. Pokud dodavatel nemá nastavené závozové okno, vrátí virtuální záznam.
         * @summary Získá detail závozového okna podle dodavatele
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryWindowDetailBySupplier(organizationId: number, portalId: number, supplierId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryWindowDetailBySupplier(organizationId, portalId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.getDeliveryWindowDetailBySupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí statistické informace o závozových oknech pro danou organizaci a portál včetně pokrytí dodavatelů
         * @summary Získá statistiku závozových oken
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryWindowStatistics(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowStatisticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryWindowStatistics(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.getDeliveryWindowStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam všech závozových oken pro danou organizaci a portál s podporou paginace a filtrování podle dodavatele
         * @summary Získá seznam závozových oken s paginací
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {number} [page] Číslo stránky (začíná od 0)
         * @param {number} [size] Počet položek na stránku
         * @param {number} [supplierId] ID dodavatele pro filtrování
         * @param {boolean} [configured] Filtr podle nastavení: true&#x3D;jen nastavená, false&#x3D;jen nenastavená, null&#x3D;všechna
         * @param {string} [supplierName] Filtr podle jména dodavatele (částečné shody)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryWindows(organizationId: number, portalId: number, page?: number, size?: number, supplierId?: number, configured?: boolean, supplierName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowPageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryWindows(organizationId, portalId, page, size, supplierId, configured, supplierName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.getDeliveryWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující závozové okno včetně dnů a kontaktů
         * @summary Aktualizuje závozové okno
         * @param {number} deliveryWindowId 
         * @param {UpdateDeliveryWindowRequestDTO} updateDeliveryWindowRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveryWindow(deliveryWindowId: number, updateDeliveryWindowRequestDTO: UpdateDeliveryWindowRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryWindowDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveryWindow(deliveryWindowId, updateDeliveryWindowRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryWindowsManagementApi.updateDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryWindowsManagementApi - factory interface
 * @export
 */
export const DeliveryWindowsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryWindowsManagementApiFp(configuration)
    return {
        /**
         * Vytvoří nové závozové okno pro dodavatele s nastavením dnů a kontaktů
         * @summary Vytvoří nové závozové okno
         * @param {DeliveryWindowsManagementApiCreateDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryWindow(requestParameters: DeliveryWindowsManagementApiCreateDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO> {
            return localVarFp.createDeliveryWindow(requestParameters.createDeliveryWindowRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže závozové okno a všechny související dny a kontakty
         * @summary Smaže závozové okno
         * @param {DeliveryWindowsManagementApiDeleteDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryWindow(requestParameters: DeliveryWindowsManagementApiDeleteDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDeliveryWindow(requestParameters.deliveryWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí kompletní informace o konkrétním závozovém okně podle jeho ID včetně dnů, kontaktů a dodavatele
         * @summary Získá detail závozového okna podle ID
         * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowDetail(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO> {
            return localVarFp.getDeliveryWindowDetail(requestParameters.deliveryWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí kompletní informace o závozovém okně pro konkrétního dodavatele. Pokud dodavatel nemá nastavené závozové okno, vrátí virtuální záznam.
         * @summary Získá detail závozového okna podle dodavatele
         * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowDetailBySupplier(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO> {
            return localVarFp.getDeliveryWindowDetailBySupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí statistické informace o závozových oknech pro danou organizaci a portál včetně pokrytí dodavatelů
         * @summary Získá statistiku závozových oken
         * @param {DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindowStatistics(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowStatisticsDTO> {
            return localVarFp.getDeliveryWindowStatistics(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam všech závozových oken pro danou organizaci a portál s podporou paginace a filtrování podle dodavatele
         * @summary Získá seznam závozových oken s paginací
         * @param {DeliveryWindowsManagementApiGetDeliveryWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryWindows(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowPageDTO> {
            return localVarFp.getDeliveryWindows(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.supplierId, requestParameters.configured, requestParameters.supplierName, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující závozové okno včetně dnů a kontaktů
         * @summary Aktualizuje závozové okno
         * @param {DeliveryWindowsManagementApiUpdateDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryWindow(requestParameters: DeliveryWindowsManagementApiUpdateDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO> {
            return localVarFp.updateDeliveryWindow(requestParameters.deliveryWindowId, requestParameters.updateDeliveryWindowRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryWindowsManagementApi - interface
 * @export
 * @interface DeliveryWindowsManagementApi
 */
export interface DeliveryWindowsManagementApiInterface {
    /**
     * Vytvoří nové závozové okno pro dodavatele s nastavením dnů a kontaktů
     * @summary Vytvoří nové závozové okno
     * @param {DeliveryWindowsManagementApiCreateDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    createDeliveryWindow(requestParameters: DeliveryWindowsManagementApiCreateDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO>;

    /**
     * Smaže závozové okno a všechny související dny a kontakty
     * @summary Smaže závozové okno
     * @param {DeliveryWindowsManagementApiDeleteDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    deleteDeliveryWindow(requestParameters: DeliveryWindowsManagementApiDeleteDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí kompletní informace o konkrétním závozovém okně podle jeho ID včetně dnů, kontaktů a dodavatele
     * @summary Získá detail závozového okna podle ID
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    getDeliveryWindowDetail(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO>;

    /**
     * Vrátí kompletní informace o závozovém okně pro konkrétního dodavatele. Pokud dodavatel nemá nastavené závozové okno, vrátí virtuální záznam.
     * @summary Získá detail závozového okna podle dodavatele
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    getDeliveryWindowDetailBySupplier(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO>;

    /**
     * Vrátí statistické informace o závozových oknech pro danou organizaci a portál včetně pokrytí dodavatelů
     * @summary Získá statistiku závozových oken
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    getDeliveryWindowStatistics(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowStatisticsDTO>;

    /**
     * Vrátí seznam všech závozových oken pro danou organizaci a portál s podporou paginace a filtrování podle dodavatele
     * @summary Získá seznam závozových oken s paginací
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    getDeliveryWindows(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowPageDTO>;

    /**
     * Aktualizuje existující závozové okno včetně dnů a kontaktů
     * @summary Aktualizuje závozové okno
     * @param {DeliveryWindowsManagementApiUpdateDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApiInterface
     */
    updateDeliveryWindow(requestParameters: DeliveryWindowsManagementApiUpdateDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeliveryWindowDetailDTO>;

}

/**
 * Request parameters for createDeliveryWindow operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiCreateDeliveryWindowRequest
 */
export interface DeliveryWindowsManagementApiCreateDeliveryWindowRequest {
    /**
     * 
     * @type {CreateDeliveryWindowRequestDTO}
     * @memberof DeliveryWindowsManagementApiCreateDeliveryWindow
     */
    readonly createDeliveryWindowRequestDTO: CreateDeliveryWindowRequestDTO
}

/**
 * Request parameters for deleteDeliveryWindow operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiDeleteDeliveryWindowRequest
 */
export interface DeliveryWindowsManagementApiDeleteDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiDeleteDeliveryWindow
     */
    readonly deliveryWindowId: number
}

/**
 * Request parameters for getDeliveryWindowDetail operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest
 */
export interface DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowDetail
     */
    readonly deliveryWindowId: number
}

/**
 * Request parameters for getDeliveryWindowDetailBySupplier operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest
 */
export interface DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplier
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplier
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplier
     */
    readonly supplierId: number
}

/**
 * Request parameters for getDeliveryWindowStatistics operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest
 */
export interface DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowStatistics
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindowStatistics
     */
    readonly portalId: number
}

/**
 * Request parameters for getDeliveryWindows operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiGetDeliveryWindowsRequest
 */
export interface DeliveryWindowsManagementApiGetDeliveryWindowsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly portalId: number

    /**
     * Číslo stránky (začíná od 0)
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly page?: number

    /**
     * Počet položek na stránku
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly size?: number

    /**
     * ID dodavatele pro filtrování
     * @type {number}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly supplierId?: number

    /**
     * Filtr podle nastavení: true&#x3D;jen nastavená, false&#x3D;jen nenastavená, null&#x3D;všechna
     * @type {boolean}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly configured?: boolean

    /**
     * Filtr podle jména dodavatele (částečné shody)
     * @type {string}
     * @memberof DeliveryWindowsManagementApiGetDeliveryWindows
     */
    readonly supplierName?: string
}

/**
 * Request parameters for updateDeliveryWindow operation in DeliveryWindowsManagementApi.
 * @export
 * @interface DeliveryWindowsManagementApiUpdateDeliveryWindowRequest
 */
export interface DeliveryWindowsManagementApiUpdateDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof DeliveryWindowsManagementApiUpdateDeliveryWindow
     */
    readonly deliveryWindowId: number

    /**
     * 
     * @type {UpdateDeliveryWindowRequestDTO}
     * @memberof DeliveryWindowsManagementApiUpdateDeliveryWindow
     */
    readonly updateDeliveryWindowRequestDTO: UpdateDeliveryWindowRequestDTO
}

/**
 * DeliveryWindowsManagementApi - object-oriented interface
 * @export
 * @class DeliveryWindowsManagementApi
 * @extends {BaseAPI}
 */
export class DeliveryWindowsManagementApi extends BaseAPI implements DeliveryWindowsManagementApiInterface {
    /**
     * Vytvoří nové závozové okno pro dodavatele s nastavením dnů a kontaktů
     * @summary Vytvoří nové závozové okno
     * @param {DeliveryWindowsManagementApiCreateDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public createDeliveryWindow(requestParameters: DeliveryWindowsManagementApiCreateDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).createDeliveryWindow(requestParameters.createDeliveryWindowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže závozové okno a všechny související dny a kontakty
     * @summary Smaže závozové okno
     * @param {DeliveryWindowsManagementApiDeleteDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public deleteDeliveryWindow(requestParameters: DeliveryWindowsManagementApiDeleteDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).deleteDeliveryWindow(requestParameters.deliveryWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí kompletní informace o konkrétním závozovém okně podle jeho ID včetně dnů, kontaktů a dodavatele
     * @summary Získá detail závozového okna podle ID
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public getDeliveryWindowDetail(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).getDeliveryWindowDetail(requestParameters.deliveryWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí kompletní informace o závozovém okně pro konkrétního dodavatele. Pokud dodavatel nemá nastavené závozové okno, vrátí virtuální záznam.
     * @summary Získá detail závozového okna podle dodavatele
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public getDeliveryWindowDetailBySupplier(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowDetailBySupplierRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).getDeliveryWindowDetailBySupplier(requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí statistické informace o závozových oknech pro danou organizaci a portál včetně pokrytí dodavatelů
     * @summary Získá statistiku závozových oken
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public getDeliveryWindowStatistics(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowStatisticsRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).getDeliveryWindowStatistics(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam všech závozových oken pro danou organizaci a portál s podporou paginace a filtrování podle dodavatele
     * @summary Získá seznam závozových oken s paginací
     * @param {DeliveryWindowsManagementApiGetDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public getDeliveryWindows(requestParameters: DeliveryWindowsManagementApiGetDeliveryWindowsRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).getDeliveryWindows(requestParameters.organizationId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.supplierId, requestParameters.configured, requestParameters.supplierName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující závozové okno včetně dnů a kontaktů
     * @summary Aktualizuje závozové okno
     * @param {DeliveryWindowsManagementApiUpdateDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryWindowsManagementApi
     */
    public updateDeliveryWindow(requestParameters: DeliveryWindowsManagementApiUpdateDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return DeliveryWindowsManagementApiFp(this.configuration).updateDeliveryWindow(requestParameters.deliveryWindowId, requestParameters.updateDeliveryWindowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DirectEmailApi - axios parameter creator
 * @export
 */
export const DirectEmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Odeslání přímého emailu
         * @param {DirectEmailSendRequest} directEmailSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDirectEmail: async (directEmailSendRequest: DirectEmailSendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directEmailSendRequest' is not null or undefined
            assertParamExists('sendDirectEmail', 'directEmailSendRequest', directEmailSendRequest)
            const localVarPath = `/api/notification/direct-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directEmailSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DirectEmailApi - functional programming interface
 * @export
 */
export const DirectEmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DirectEmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Odeslání přímého emailu
         * @param {DirectEmailSendRequest} directEmailSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendDirectEmail(directEmailSendRequest: DirectEmailSendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectEmailSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendDirectEmail(directEmailSendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DirectEmailApi.sendDirectEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DirectEmailApi - factory interface
 * @export
 */
export const DirectEmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DirectEmailApiFp(configuration)
    return {
        /**
         * 
         * @summary Odeslání přímého emailu
         * @param {DirectEmailApiSendDirectEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDirectEmail(requestParameters: DirectEmailApiSendDirectEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<DirectEmailSendResponse> {
            return localVarFp.sendDirectEmail(requestParameters.directEmailSendRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DirectEmailApi - interface
 * @export
 * @interface DirectEmailApi
 */
export interface DirectEmailApiInterface {
    /**
     * 
     * @summary Odeslání přímého emailu
     * @param {DirectEmailApiSendDirectEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectEmailApiInterface
     */
    sendDirectEmail(requestParameters: DirectEmailApiSendDirectEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<DirectEmailSendResponse>;

}

/**
 * Request parameters for sendDirectEmail operation in DirectEmailApi.
 * @export
 * @interface DirectEmailApiSendDirectEmailRequest
 */
export interface DirectEmailApiSendDirectEmailRequest {
    /**
     * 
     * @type {DirectEmailSendRequest}
     * @memberof DirectEmailApiSendDirectEmail
     */
    readonly directEmailSendRequest: DirectEmailSendRequest
}

/**
 * DirectEmailApi - object-oriented interface
 * @export
 * @class DirectEmailApi
 * @extends {BaseAPI}
 */
export class DirectEmailApi extends BaseAPI implements DirectEmailApiInterface {
    /**
     * 
     * @summary Odeslání přímého emailu
     * @param {DirectEmailApiSendDirectEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectEmailApi
     */
    public sendDirectEmail(requestParameters: DirectEmailApiSendDirectEmailRequest, options?: RawAxiosRequestConfig) {
        return DirectEmailApiFp(this.configuration).sendDirectEmail(requestParameters.directEmailSendRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoControllerApi - axios parameter creator
 * @export
 */
export const InfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoControllerApi - functional programming interface
 * @export
 */
export const InfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoControllerApi.getInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoControllerApi - factory interface
 * @export
 */
export const InfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoControllerApi - interface
 * @export
 * @interface InfoControllerApi
 */
export interface InfoControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApiInterface
     */
    getInfo(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }>;

}

/**
 * InfoControllerApi - object-oriented interface
 * @export
 * @class InfoControllerApi
 * @extends {BaseAPI}
 */
export class InfoControllerApi extends BaseAPI implements InfoControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public getInfo(options?: RawAxiosRequestConfig) {
        return InfoControllerApiFp(this.configuration).getInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingControllerApi - axios parameter creator
 * @export
 */
export const PingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingAuth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ping-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingControllerApi - functional programming interface
 * @export
 */
export const PingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingControllerApi.ping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingAuth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingAuth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingControllerApi.pingAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingControllerApi - factory interface
 * @export
 */
export const PingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingAuth(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.pingAuth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingControllerApi - interface
 * @export
 * @interface PingControllerApi
 */
export interface PingControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApiInterface
     */
    ping(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApiInterface
     */
    pingAuth(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

}

/**
 * PingControllerApi - object-oriented interface
 * @export
 * @class PingControllerApi
 * @extends {BaseAPI}
 */
export class PingControllerApi extends BaseAPI implements PingControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApi
     */
    public ping(options?: RawAxiosRequestConfig) {
        return PingControllerApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApi
     */
    public pingAuth(options?: RawAxiosRequestConfig) {
        return PingControllerApiFp(this.configuration).pingAuth(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProgressSseControllerApi - axios parameter creator
 * @export
 */
export const ProgressSseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('stream', 'taskId', taskId)
            const localVarPath = `/api/admin/tasks/{taskId}/progress/stream`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProgressSseControllerApi - functional programming interface
 * @export
 */
export const ProgressSseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProgressSseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stream(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stream(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgressSseControllerApi.stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProgressSseControllerApi - factory interface
 * @export
 */
export const ProgressSseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProgressSseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ProgressSseControllerApiStreamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream(requestParameters: ProgressSseControllerApiStreamRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.stream(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProgressSseControllerApi - interface
 * @export
 * @interface ProgressSseControllerApi
 */
export interface ProgressSseControllerApiInterface {
    /**
     * 
     * @param {ProgressSseControllerApiStreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgressSseControllerApiInterface
     */
    stream(requestParameters: ProgressSseControllerApiStreamRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>>;

}

/**
 * Request parameters for stream operation in ProgressSseControllerApi.
 * @export
 * @interface ProgressSseControllerApiStreamRequest
 */
export interface ProgressSseControllerApiStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ProgressSseControllerApiStream
     */
    readonly taskId: string
}

/**
 * ProgressSseControllerApi - object-oriented interface
 * @export
 * @class ProgressSseControllerApi
 * @extends {BaseAPI}
 */
export class ProgressSseControllerApi extends BaseAPI implements ProgressSseControllerApiInterface {
    /**
     * 
     * @param {ProgressSseControllerApiStreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgressSseControllerApi
     */
    public stream(requestParameters: ProgressSseControllerApiStreamRequest, options?: RawAxiosRequestConfig) {
        return ProgressSseControllerApiFp(this.configuration).stream(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuickOrderActionApi - axios parameter creator
 * @export
 */
export const QuickOrderActionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Schválí objednávku podle unikátního kódu
         * @summary Schválí objednávku
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveQuickActionOrder: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('approveQuickActionOrder', 'code', code)
            const localVarPath = `/api/public/order-action/{code}/approve`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail objednávky pro veřejnou stránku dodavatele
         * @summary Načte detail objednávky podle kódu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionOrder: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getQuickActionOrder', 'code', code)
            const localVarPath = `/api/public/order-action/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDF se generuje na požádání a nikam se neukládá
         * @summary Vygeneruje PDF objednávky podle kódu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionOrderPdf: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getQuickActionOrderPdf', 'code', code)
            const localVarPath = `/api/public/order-action/{code}/pdf-base64`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zamítne objednávku podle unikátního kódu s volitelným důvodem
         * @summary Zamítne objednávku
         * @param {string} code 
         * @param {QuickActionRejectRequest} [quickActionRejectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectQuickActionOrder: async (code: string, quickActionRejectRequest?: QuickActionRejectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('rejectQuickActionOrder', 'code', code)
            const localVarPath = `/api/public/order-action/{code}/reject`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quickActionRejectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickOrderActionApi - functional programming interface
 * @export
 */
export const QuickOrderActionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickOrderActionApiAxiosParamCreator(configuration)
    return {
        /**
         * Schválí objednávku podle unikátního kódu
         * @summary Schválí objednávku
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveQuickActionOrder(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickActionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveQuickActionOrder(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickOrderActionApi.approveQuickActionOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail objednávky pro veřejnou stránku dodavatele
         * @summary Načte detail objednávky podle kódu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickActionOrder(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickActionOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuickActionOrder(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickOrderActionApi.getQuickActionOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PDF se generuje na požádání a nikam se neukládá
         * @summary Vygeneruje PDF objednávky podle kódu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickActionOrderPdf(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickActionOrderPdfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuickActionOrderPdf(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickOrderActionApi.getQuickActionOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zamítne objednávku podle unikátního kódu s volitelným důvodem
         * @summary Zamítne objednávku
         * @param {string} code 
         * @param {QuickActionRejectRequest} [quickActionRejectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectQuickActionOrder(code: string, quickActionRejectRequest?: QuickActionRejectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickActionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectQuickActionOrder(code, quickActionRejectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickOrderActionApi.rejectQuickActionOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuickOrderActionApi - factory interface
 * @export
 */
export const QuickOrderActionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickOrderActionApiFp(configuration)
    return {
        /**
         * Schválí objednávku podle unikátního kódu
         * @summary Schválí objednávku
         * @param {QuickOrderActionApiApproveQuickActionOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveQuickActionOrder(requestParameters: QuickOrderActionApiApproveQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionResultResponse> {
            return localVarFp.approveQuickActionOrder(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail objednávky pro veřejnou stránku dodavatele
         * @summary Načte detail objednávky podle kódu
         * @param {QuickOrderActionApiGetQuickActionOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionOrder(requestParameters: QuickOrderActionApiGetQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionOrderResponse> {
            return localVarFp.getQuickActionOrder(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * PDF se generuje na požádání a nikam se neukládá
         * @summary Vygeneruje PDF objednávky podle kódu
         * @param {QuickOrderActionApiGetQuickActionOrderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionOrderPdf(requestParameters: QuickOrderActionApiGetQuickActionOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionOrderPdfResponse> {
            return localVarFp.getQuickActionOrderPdf(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * Zamítne objednávku podle unikátního kódu s volitelným důvodem
         * @summary Zamítne objednávku
         * @param {QuickOrderActionApiRejectQuickActionOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectQuickActionOrder(requestParameters: QuickOrderActionApiRejectQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionResultResponse> {
            return localVarFp.rejectQuickActionOrder(requestParameters.code, requestParameters.quickActionRejectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickOrderActionApi - interface
 * @export
 * @interface QuickOrderActionApi
 */
export interface QuickOrderActionApiInterface {
    /**
     * Schválí objednávku podle unikátního kódu
     * @summary Schválí objednávku
     * @param {QuickOrderActionApiApproveQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApiInterface
     */
    approveQuickActionOrder(requestParameters: QuickOrderActionApiApproveQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionResultResponse>;

    /**
     * Vrátí detail objednávky pro veřejnou stránku dodavatele
     * @summary Načte detail objednávky podle kódu
     * @param {QuickOrderActionApiGetQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApiInterface
     */
    getQuickActionOrder(requestParameters: QuickOrderActionApiGetQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionOrderResponse>;

    /**
     * PDF se generuje na požádání a nikam se neukládá
     * @summary Vygeneruje PDF objednávky podle kódu
     * @param {QuickOrderActionApiGetQuickActionOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApiInterface
     */
    getQuickActionOrderPdf(requestParameters: QuickOrderActionApiGetQuickActionOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionOrderPdfResponse>;

    /**
     * Zamítne objednávku podle unikátního kódu s volitelným důvodem
     * @summary Zamítne objednávku
     * @param {QuickOrderActionApiRejectQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApiInterface
     */
    rejectQuickActionOrder(requestParameters: QuickOrderActionApiRejectQuickActionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuickActionResultResponse>;

}

/**
 * Request parameters for approveQuickActionOrder operation in QuickOrderActionApi.
 * @export
 * @interface QuickOrderActionApiApproveQuickActionOrderRequest
 */
export interface QuickOrderActionApiApproveQuickActionOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof QuickOrderActionApiApproveQuickActionOrder
     */
    readonly code: string
}

/**
 * Request parameters for getQuickActionOrder operation in QuickOrderActionApi.
 * @export
 * @interface QuickOrderActionApiGetQuickActionOrderRequest
 */
export interface QuickOrderActionApiGetQuickActionOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof QuickOrderActionApiGetQuickActionOrder
     */
    readonly code: string
}

/**
 * Request parameters for getQuickActionOrderPdf operation in QuickOrderActionApi.
 * @export
 * @interface QuickOrderActionApiGetQuickActionOrderPdfRequest
 */
export interface QuickOrderActionApiGetQuickActionOrderPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof QuickOrderActionApiGetQuickActionOrderPdf
     */
    readonly code: string
}

/**
 * Request parameters for rejectQuickActionOrder operation in QuickOrderActionApi.
 * @export
 * @interface QuickOrderActionApiRejectQuickActionOrderRequest
 */
export interface QuickOrderActionApiRejectQuickActionOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof QuickOrderActionApiRejectQuickActionOrder
     */
    readonly code: string

    /**
     * 
     * @type {QuickActionRejectRequest}
     * @memberof QuickOrderActionApiRejectQuickActionOrder
     */
    readonly quickActionRejectRequest?: QuickActionRejectRequest
}

/**
 * QuickOrderActionApi - object-oriented interface
 * @export
 * @class QuickOrderActionApi
 * @extends {BaseAPI}
 */
export class QuickOrderActionApi extends BaseAPI implements QuickOrderActionApiInterface {
    /**
     * Schválí objednávku podle unikátního kódu
     * @summary Schválí objednávku
     * @param {QuickOrderActionApiApproveQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApi
     */
    public approveQuickActionOrder(requestParameters: QuickOrderActionApiApproveQuickActionOrderRequest, options?: RawAxiosRequestConfig) {
        return QuickOrderActionApiFp(this.configuration).approveQuickActionOrder(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail objednávky pro veřejnou stránku dodavatele
     * @summary Načte detail objednávky podle kódu
     * @param {QuickOrderActionApiGetQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApi
     */
    public getQuickActionOrder(requestParameters: QuickOrderActionApiGetQuickActionOrderRequest, options?: RawAxiosRequestConfig) {
        return QuickOrderActionApiFp(this.configuration).getQuickActionOrder(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDF se generuje na požádání a nikam se neukládá
     * @summary Vygeneruje PDF objednávky podle kódu
     * @param {QuickOrderActionApiGetQuickActionOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApi
     */
    public getQuickActionOrderPdf(requestParameters: QuickOrderActionApiGetQuickActionOrderPdfRequest, options?: RawAxiosRequestConfig) {
        return QuickOrderActionApiFp(this.configuration).getQuickActionOrderPdf(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zamítne objednávku podle unikátního kódu s volitelným důvodem
     * @summary Zamítne objednávku
     * @param {QuickOrderActionApiRejectQuickActionOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickOrderActionApi
     */
    public rejectQuickActionOrder(requestParameters: QuickOrderActionApiRejectQuickActionOrderRequest, options?: RawAxiosRequestConfig) {
        return QuickOrderActionApiFp(this.configuration).rejectQuickActionOrder(requestParameters.code, requestParameters.quickActionRejectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScheduledOrderActionApi - axios parameter creator
 * @export
 */
export const ScheduledOrderActionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveScheduledOrderAction: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('approveScheduledOrderAction', 'code', code)
            const localVarPath = `/api/public/scheduled-order-action/{code}/approve`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schválí a odešle objednávku ihned, bez čekání na plánovaný čas
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchScheduledOrderActionNow: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('dispatchScheduledOrderActionNow', 'code', code)
            const localVarPath = `/api/public/scheduled-order-action/{code}/dispatch-now`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail plánované objednávky podle kódu z e-mailu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderAction: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getScheduledOrderAction', 'code', code)
            const localVarPath = `/api/public/scheduled-order-action/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {string} code 
         * @param {ClientRejectScheduledOrderRunRequest} [clientRejectScheduledOrderRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectScheduledOrderAction: async (code: string, clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('rejectScheduledOrderAction', 'code', code)
            const localVarPath = `/api/public/scheduled-order-action/{code}/reject`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientRejectScheduledOrderRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledOrderActionApi - functional programming interface
 * @export
 */
export const ScheduledOrderActionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduledOrderActionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveScheduledOrderAction(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledOrderActionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveScheduledOrderAction(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledOrderActionApi.approveScheduledOrderAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Schválí a odešle objednávku ihned, bez čekání na plánovaný čas
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dispatchScheduledOrderActionNow(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledOrderActionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dispatchScheduledOrderActionNow(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledOrderActionApi.dispatchScheduledOrderActionNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail plánované objednávky podle kódu z e-mailu
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledOrderAction(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledOrderActionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledOrderAction(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledOrderActionApi.getScheduledOrderAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {string} code 
         * @param {ClientRejectScheduledOrderRunRequest} [clientRejectScheduledOrderRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectScheduledOrderAction(code: string, clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledOrderActionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectScheduledOrderAction(code, clientRejectScheduledOrderRunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledOrderActionApi.rejectScheduledOrderAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScheduledOrderActionApi - factory interface
 * @export
 */
export const ScheduledOrderActionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduledOrderActionApiFp(configuration)
    return {
        /**
         * 
         * @summary Schválí odeslání plánované objednávky
         * @param {ScheduledOrderActionApiApproveScheduledOrderActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveScheduledOrderAction(requestParameters: ScheduledOrderActionApiApproveScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse> {
            return localVarFp.approveScheduledOrderAction(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schválí a odešle objednávku ihned, bez čekání na plánovaný čas
         * @param {ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchScheduledOrderActionNow(requestParameters: ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse> {
            return localVarFp.dispatchScheduledOrderActionNow(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail plánované objednávky podle kódu z e-mailu
         * @param {ScheduledOrderActionApiGetScheduledOrderActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledOrderAction(requestParameters: ScheduledOrderActionApiGetScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionDetailResponse> {
            return localVarFp.getScheduledOrderAction(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
         * @param {ScheduledOrderActionApiRejectScheduledOrderActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectScheduledOrderAction(requestParameters: ScheduledOrderActionApiRejectScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse> {
            return localVarFp.rejectScheduledOrderAction(requestParameters.code, requestParameters.clientRejectScheduledOrderRunRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduledOrderActionApi - interface
 * @export
 * @interface ScheduledOrderActionApi
 */
export interface ScheduledOrderActionApiInterface {
    /**
     * 
     * @summary Schválí odeslání plánované objednávky
     * @param {ScheduledOrderActionApiApproveScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApiInterface
     */
    approveScheduledOrderAction(requestParameters: ScheduledOrderActionApiApproveScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse>;

    /**
     * 
     * @summary Schválí a odešle objednávku ihned, bez čekání na plánovaný čas
     * @param {ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApiInterface
     */
    dispatchScheduledOrderActionNow(requestParameters: ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse>;

    /**
     * 
     * @summary Detail plánované objednávky podle kódu z e-mailu
     * @param {ScheduledOrderActionApiGetScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApiInterface
     */
    getScheduledOrderAction(requestParameters: ScheduledOrderActionApiGetScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionDetailResponse>;

    /**
     * 
     * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
     * @param {ScheduledOrderActionApiRejectScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApiInterface
     */
    rejectScheduledOrderAction(requestParameters: ScheduledOrderActionApiRejectScheduledOrderActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledOrderActionResultResponse>;

}

/**
 * Request parameters for approveScheduledOrderAction operation in ScheduledOrderActionApi.
 * @export
 * @interface ScheduledOrderActionApiApproveScheduledOrderActionRequest
 */
export interface ScheduledOrderActionApiApproveScheduledOrderActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionApiApproveScheduledOrderAction
     */
    readonly code: string
}

/**
 * Request parameters for dispatchScheduledOrderActionNow operation in ScheduledOrderActionApi.
 * @export
 * @interface ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest
 */
export interface ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionApiDispatchScheduledOrderActionNow
     */
    readonly code: string
}

/**
 * Request parameters for getScheduledOrderAction operation in ScheduledOrderActionApi.
 * @export
 * @interface ScheduledOrderActionApiGetScheduledOrderActionRequest
 */
export interface ScheduledOrderActionApiGetScheduledOrderActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionApiGetScheduledOrderAction
     */
    readonly code: string
}

/**
 * Request parameters for rejectScheduledOrderAction operation in ScheduledOrderActionApi.
 * @export
 * @interface ScheduledOrderActionApiRejectScheduledOrderActionRequest
 */
export interface ScheduledOrderActionApiRejectScheduledOrderActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderActionApiRejectScheduledOrderAction
     */
    readonly code: string

    /**
     * 
     * @type {ClientRejectScheduledOrderRunRequest}
     * @memberof ScheduledOrderActionApiRejectScheduledOrderAction
     */
    readonly clientRejectScheduledOrderRunRequest?: ClientRejectScheduledOrderRunRequest
}

/**
 * ScheduledOrderActionApi - object-oriented interface
 * @export
 * @class ScheduledOrderActionApi
 * @extends {BaseAPI}
 */
export class ScheduledOrderActionApi extends BaseAPI implements ScheduledOrderActionApiInterface {
    /**
     * 
     * @summary Schválí odeslání plánované objednávky
     * @param {ScheduledOrderActionApiApproveScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApi
     */
    public approveScheduledOrderAction(requestParameters: ScheduledOrderActionApiApproveScheduledOrderActionRequest, options?: RawAxiosRequestConfig) {
        return ScheduledOrderActionApiFp(this.configuration).approveScheduledOrderAction(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schválí a odešle objednávku ihned, bez čekání na plánovaný čas
     * @param {ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApi
     */
    public dispatchScheduledOrderActionNow(requestParameters: ScheduledOrderActionApiDispatchScheduledOrderActionNowRequest, options?: RawAxiosRequestConfig) {
        return ScheduledOrderActionApiFp(this.configuration).dispatchScheduledOrderActionNow(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail plánované objednávky podle kódu z e-mailu
     * @param {ScheduledOrderActionApiGetScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApi
     */
    public getScheduledOrderAction(requestParameters: ScheduledOrderActionApiGetScheduledOrderActionRequest, options?: RawAxiosRequestConfig) {
        return ScheduledOrderActionApiFp(this.configuration).getScheduledOrderAction(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zamítne odeslání — šablona zůstává a příště se připraví znovu
     * @param {ScheduledOrderActionApiRejectScheduledOrderActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledOrderActionApi
     */
    public rejectScheduledOrderAction(requestParameters: ScheduledOrderActionApiRejectScheduledOrderActionRequest, options?: RawAxiosRequestConfig) {
        return ScheduledOrderActionApiFp(this.configuration).rejectScheduledOrderAction(requestParameters.code, requestParameters.clientRejectScheduledOrderRunRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchControllerControllerApi - axios parameter creator
 * @export
 */
export const SearchControllerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} query 
         * @param {number} customerId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete: async (query: string, customerId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('autoComplete', 'query', query)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('autoComplete', 'customerId', customerId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('autoComplete', 'portalId', portalId)
            const localVarPath = `/api/search/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk fix isFavorite flagu napříč ES dokumenty (utility, ne reindex katalogu)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexFavorites: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/search/index-favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchControllerControllerApi - functional programming interface
 * @export
 */
export const SearchControllerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchControllerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} query 
         * @param {number} customerId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoComplete(query: string, customerId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoComplete(query, customerId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchControllerControllerApi.autoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk fix isFavorite flagu napříč ES dokumenty (utility, ne reindex katalogu)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexFavorites(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexFavorites(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchControllerControllerApi.indexFavorites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchControllerControllerApi - factory interface
 * @export
 */
export const SearchControllerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchControllerControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SearchControllerControllerApiAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete(requestParameters: SearchControllerControllerApiAutoCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutocompleteResponse> {
            return localVarFp.autoComplete(requestParameters.query, requestParameters.customerId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk fix isFavorite flagu napříč ES dokumenty (utility, ne reindex katalogu)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexFavorites(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.indexFavorites(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchControllerControllerApi - interface
 * @export
 * @interface SearchControllerControllerApi
 */
export interface SearchControllerControllerApiInterface {
    /**
     * 
     * @param {SearchControllerControllerApiAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerControllerApiInterface
     */
    autoComplete(requestParameters: SearchControllerControllerApiAutoCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutocompleteResponse>;

    /**
     * 
     * @summary Bulk fix isFavorite flagu napříč ES dokumenty (utility, ne reindex katalogu)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerControllerApiInterface
     */
    indexFavorites(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for autoComplete operation in SearchControllerControllerApi.
 * @export
 * @interface SearchControllerControllerApiAutoCompleteRequest
 */
export interface SearchControllerControllerApiAutoCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchControllerControllerApiAutoComplete
     */
    readonly query: string

    /**
     * 
     * @type {number}
     * @memberof SearchControllerControllerApiAutoComplete
     */
    readonly customerId: number

    /**
     * 
     * @type {number}
     * @memberof SearchControllerControllerApiAutoComplete
     */
    readonly portalId: number
}

/**
 * SearchControllerControllerApi - object-oriented interface
 * @export
 * @class SearchControllerControllerApi
 * @extends {BaseAPI}
 */
export class SearchControllerControllerApi extends BaseAPI implements SearchControllerControllerApiInterface {
    /**
     * 
     * @param {SearchControllerControllerApiAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerControllerApi
     */
    public autoComplete(requestParameters: SearchControllerControllerApiAutoCompleteRequest, options?: RawAxiosRequestConfig) {
        return SearchControllerControllerApiFp(this.configuration).autoComplete(requestParameters.query, requestParameters.customerId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk fix isFavorite flagu napříč ES dokumenty (utility, ne reindex katalogu)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerControllerApi
     */
    public indexFavorites(options?: RawAxiosRequestConfig) {
        return SearchControllerControllerApiFp(this.configuration).indexFavorites(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierDeliveryWindowsApi - axios parameter creator
 * @export
 */
export const SupplierDeliveryWindowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí seznam zákazníků s jejich závozovými okny (limity pro jednotlivé dny, kontakty, čas dodání)
         * @summary Získá přehled závozových oken pro zákazníky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [customerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierDeliveryWindows: async (supplierId: number, portalId: number, customerName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierDeliveryWindows', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierDeliveryWindows', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/delivery-windows`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Umožňuje dodavateli upravit závozové dny, čas dodání a interní číslo zákazníka
         * @summary Aktualizuje závozové okno pro zákazníka
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {SupplierDeliveryWindowUpdateRequest} supplierDeliveryWindowUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplierDeliveryWindow: async (supplierId: number, portalId: number, organizationId: number, supplierDeliveryWindowUpdateRequest: SupplierDeliveryWindowUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('updateSupplierDeliveryWindow', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateSupplierDeliveryWindow', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSupplierDeliveryWindow', 'organizationId', organizationId)
            // verify required parameter 'supplierDeliveryWindowUpdateRequest' is not null or undefined
            assertParamExists('updateSupplierDeliveryWindow', 'supplierDeliveryWindowUpdateRequest', supplierDeliveryWindowUpdateRequest)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/delivery-windows/organization/{organizationId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierDeliveryWindowUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierDeliveryWindowsApi - functional programming interface
 * @export
 */
export const SupplierDeliveryWindowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierDeliveryWindowsApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí seznam zákazníků s jejich závozovými okny (limity pro jednotlivé dny, kontakty, čas dodání)
         * @summary Získá přehled závozových oken pro zákazníky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [customerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierDeliveryWindows(supplierId: number, portalId: number, customerName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDeliveryWindowListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierDeliveryWindows(supplierId, portalId, customerName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierDeliveryWindowsApi.getSupplierDeliveryWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Umožňuje dodavateli upravit závozové dny, čas dodání a interní číslo zákazníka
         * @summary Aktualizuje závozové okno pro zákazníka
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {SupplierDeliveryWindowUpdateRequest} supplierDeliveryWindowUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupplierDeliveryWindow(supplierId: number, portalId: number, organizationId: number, supplierDeliveryWindowUpdateRequest: SupplierDeliveryWindowUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierDeliveryWindow(supplierId, portalId, organizationId, supplierDeliveryWindowUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierDeliveryWindowsApi.updateSupplierDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierDeliveryWindowsApi - factory interface
 * @export
 */
export const SupplierDeliveryWindowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierDeliveryWindowsApiFp(configuration)
    return {
        /**
         * Vrátí seznam zákazníků s jejich závozovými okny (limity pro jednotlivé dny, kontakty, čas dodání)
         * @summary Získá přehled závozových oken pro zákazníky
         * @param {SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierDeliveryWindows(requestParameters: SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDeliveryWindowListResponse> {
            return localVarFp.getSupplierDeliveryWindows(requestParameters.supplierId, requestParameters.portalId, requestParameters.customerName, options).then((request) => request(axios, basePath));
        },
        /**
         * Umožňuje dodavateli upravit závozové dny, čas dodání a interní číslo zákazníka
         * @summary Aktualizuje závozové okno pro zákazníka
         * @param {SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplierDeliveryWindow(requestParameters: SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSupplierDeliveryWindow(requestParameters.supplierId, requestParameters.portalId, requestParameters.organizationId, requestParameters.supplierDeliveryWindowUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierDeliveryWindowsApi - interface
 * @export
 * @interface SupplierDeliveryWindowsApi
 */
export interface SupplierDeliveryWindowsApiInterface {
    /**
     * Vrátí seznam zákazníků s jejich závozovými okny (limity pro jednotlivé dny, kontakty, čas dodání)
     * @summary Získá přehled závozových oken pro zákazníky
     * @param {SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierDeliveryWindowsApiInterface
     */
    getSupplierDeliveryWindows(requestParameters: SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDeliveryWindowListResponse>;

    /**
     * Umožňuje dodavateli upravit závozové dny, čas dodání a interní číslo zákazníka
     * @summary Aktualizuje závozové okno pro zákazníka
     * @param {SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierDeliveryWindowsApiInterface
     */
    updateSupplierDeliveryWindow(requestParameters: SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getSupplierDeliveryWindows operation in SupplierDeliveryWindowsApi.
 * @export
 * @interface SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest
 */
export interface SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowsApiGetSupplierDeliveryWindows
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowsApiGetSupplierDeliveryWindows
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindowsApiGetSupplierDeliveryWindows
     */
    readonly customerName?: string
}

/**
 * Request parameters for updateSupplierDeliveryWindow operation in SupplierDeliveryWindowsApi.
 * @export
 * @interface SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest
 */
export interface SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindow
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindow
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindow
     */
    readonly organizationId: number

    /**
     * 
     * @type {SupplierDeliveryWindowUpdateRequest}
     * @memberof SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindow
     */
    readonly supplierDeliveryWindowUpdateRequest: SupplierDeliveryWindowUpdateRequest
}

/**
 * SupplierDeliveryWindowsApi - object-oriented interface
 * @export
 * @class SupplierDeliveryWindowsApi
 * @extends {BaseAPI}
 */
export class SupplierDeliveryWindowsApi extends BaseAPI implements SupplierDeliveryWindowsApiInterface {
    /**
     * Vrátí seznam zákazníků s jejich závozovými okny (limity pro jednotlivé dny, kontakty, čas dodání)
     * @summary Získá přehled závozových oken pro zákazníky
     * @param {SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierDeliveryWindowsApi
     */
    public getSupplierDeliveryWindows(requestParameters: SupplierDeliveryWindowsApiGetSupplierDeliveryWindowsRequest, options?: RawAxiosRequestConfig) {
        return SupplierDeliveryWindowsApiFp(this.configuration).getSupplierDeliveryWindows(requestParameters.supplierId, requestParameters.portalId, requestParameters.customerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Umožňuje dodavateli upravit závozové dny, čas dodání a interní číslo zákazníka
     * @summary Aktualizuje závozové okno pro zákazníka
     * @param {SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierDeliveryWindowsApi
     */
    public updateSupplierDeliveryWindow(requestParameters: SupplierDeliveryWindowsApiUpdateSupplierDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return SupplierDeliveryWindowsApiFp(this.configuration).updateSupplierDeliveryWindow(requestParameters.supplierId, requestParameters.portalId, requestParameters.organizationId, requestParameters.supplierDeliveryWindowUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierLOVApi - axios parameter creator
 * @export
 */
export const SupplierLOVApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí seznam zákazníků (organizací), které mají objednávky u daného dodavatele
         * @summary Získá seznam zákazníků pro LOV
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierLovCustomers: async (supplierId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierLovCustomers', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierLovCustomers', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/lov/customers`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierLOVApi - functional programming interface
 * @export
 */
export const SupplierLOVApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierLOVApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí seznam zákazníků (organizací), které mají objednávky u daného dodavatele
         * @summary Získá seznam zákazníků pro LOV
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierLovCustomers(supplierId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierLovCustomer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierLovCustomers(supplierId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierLOVApi.getSupplierLovCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierLOVApi - factory interface
 * @export
 */
export const SupplierLOVApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierLOVApiFp(configuration)
    return {
        /**
         * Vrátí seznam zákazníků (organizací), které mají objednávky u daného dodavatele
         * @summary Získá seznam zákazníků pro LOV
         * @param {SupplierLOVApiGetSupplierLovCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierLovCustomers(requestParameters: SupplierLOVApiGetSupplierLovCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierLovCustomer>> {
            return localVarFp.getSupplierLovCustomers(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierLOVApi - interface
 * @export
 * @interface SupplierLOVApi
 */
export interface SupplierLOVApiInterface {
    /**
     * Vrátí seznam zákazníků (organizací), které mají objednávky u daného dodavatele
     * @summary Získá seznam zákazníků pro LOV
     * @param {SupplierLOVApiGetSupplierLovCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierLOVApiInterface
     */
    getSupplierLovCustomers(requestParameters: SupplierLOVApiGetSupplierLovCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierLovCustomer>>;

}

/**
 * Request parameters for getSupplierLovCustomers operation in SupplierLOVApi.
 * @export
 * @interface SupplierLOVApiGetSupplierLovCustomersRequest
 */
export interface SupplierLOVApiGetSupplierLovCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierLOVApiGetSupplierLovCustomers
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierLOVApiGetSupplierLovCustomers
     */
    readonly portalId: number
}

/**
 * SupplierLOVApi - object-oriented interface
 * @export
 * @class SupplierLOVApi
 * @extends {BaseAPI}
 */
export class SupplierLOVApi extends BaseAPI implements SupplierLOVApiInterface {
    /**
     * Vrátí seznam zákazníků (organizací), které mají objednávky u daného dodavatele
     * @summary Získá seznam zákazníků pro LOV
     * @param {SupplierLOVApiGetSupplierLovCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierLOVApi
     */
    public getSupplierLovCustomers(requestParameters: SupplierLOVApiGetSupplierLovCustomersRequest, options?: RawAxiosRequestConfig) {
        return SupplierLOVApiFp(this.configuration).getSupplierLovCustomers(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierMessagesApi - axios parameter creator
 * @export
 */
export const SupplierMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierMessageThreads: async (supplierId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierMessageThreads', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierMessageThreads', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/messages/threads`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderMessageThread: async (supplierId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierOrderMessageThread', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierOrderMessageThread', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSupplierOrderMessageThread', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/messages/order/{orderId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierUnreadMessagesCount: async (supplierId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierUnreadMessagesCount', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierUnreadMessagesCount', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/messages/unread-count`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSupplierMessagesAsRead: async (supplierId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('markSupplierMessagesAsRead', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('markSupplierMessagesAsRead', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('markSupplierMessagesAsRead', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/messages/order/{orderId}/mark-read`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {SupplierSendMessageRequest} supplierSendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSupplierMessage: async (supplierId: number, portalId: number, orderId: number, supplierSendMessageRequest: SupplierSendMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('sendSupplierMessage', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('sendSupplierMessage', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('sendSupplierMessage', 'orderId', orderId)
            // verify required parameter 'supplierSendMessageRequest' is not null or undefined
            assertParamExists('sendSupplierMessage', 'supplierSendMessageRequest', supplierSendMessageRequest)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/messages/order/{orderId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierSendMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierMessagesApi - functional programming interface
 * @export
 */
export const SupplierMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierMessageThreads(supplierId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierMessageThreadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierMessageThreads(supplierId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierMessagesApi.getSupplierMessageThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierOrderMessageThread(supplierId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierOrderMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierOrderMessageThread(supplierId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierMessagesApi.getSupplierOrderMessageThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierUnreadMessagesCount(supplierId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierUnreadMessagesCount(supplierId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierMessagesApi.getSupplierUnreadMessagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSupplierMessagesAsRead(supplierId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSupplierMessagesAsRead(supplierId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierMessagesApi.markSupplierMessagesAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {SupplierSendMessageRequest} supplierSendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSupplierMessage(supplierId: number, portalId: number, orderId: number, supplierSendMessageRequest: SupplierSendMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSupplierMessage(supplierId, portalId, orderId, supplierSendMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierMessagesApi.sendSupplierMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierMessagesApi - factory interface
 * @export
 */
export const SupplierMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierMessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Získá seznam vláken zpráv pro dodavatele
         * @param {SupplierMessagesApiGetSupplierMessageThreadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierMessageThreads(requestParameters: SupplierMessagesApiGetSupplierMessageThreadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierMessageThreadListResponse> {
            return localVarFp.getSupplierMessageThreads(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá vlákno zpráv k objednávce
         * @param {SupplierMessagesApiGetSupplierOrderMessageThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderMessageThread(requestParameters: SupplierMessagesApiGetSupplierOrderMessageThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderMessagesResponse> {
            return localVarFp.getSupplierOrderMessageThread(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá počet nepřečtených zpráv pro dodavatele
         * @param {SupplierMessagesApiGetSupplierUnreadMessagesCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierUnreadMessagesCount(requestParameters: SupplierMessagesApiGetSupplierUnreadMessagesCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getSupplierUnreadMessagesCount(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Označí zprávy k objednávce jako přečtené
         * @param {SupplierMessagesApiMarkSupplierMessagesAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSupplierMessagesAsRead(requestParameters: SupplierMessagesApiMarkSupplierMessagesAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markSupplierMessagesAsRead(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odešle zprávu k objednávce
         * @param {SupplierMessagesApiSendSupplierMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSupplierMessage(requestParameters: SupplierMessagesApiSendSupplierMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSupplierMessage(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.supplierSendMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierMessagesApi - interface
 * @export
 * @interface SupplierMessagesApi
 */
export interface SupplierMessagesApiInterface {
    /**
     * 
     * @summary Získá seznam vláken zpráv pro dodavatele
     * @param {SupplierMessagesApiGetSupplierMessageThreadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApiInterface
     */
    getSupplierMessageThreads(requestParameters: SupplierMessagesApiGetSupplierMessageThreadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierMessageThreadListResponse>;

    /**
     * 
     * @summary Získá vlákno zpráv k objednávce
     * @param {SupplierMessagesApiGetSupplierOrderMessageThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApiInterface
     */
    getSupplierOrderMessageThread(requestParameters: SupplierMessagesApiGetSupplierOrderMessageThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderMessagesResponse>;

    /**
     * 
     * @summary Získá počet nepřečtených zpráv pro dodavatele
     * @param {SupplierMessagesApiGetSupplierUnreadMessagesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApiInterface
     */
    getSupplierUnreadMessagesCount(requestParameters: SupplierMessagesApiGetSupplierUnreadMessagesCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Označí zprávy k objednávce jako přečtené
     * @param {SupplierMessagesApiMarkSupplierMessagesAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApiInterface
     */
    markSupplierMessagesAsRead(requestParameters: SupplierMessagesApiMarkSupplierMessagesAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Odešle zprávu k objednávce
     * @param {SupplierMessagesApiSendSupplierMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApiInterface
     */
    sendSupplierMessage(requestParameters: SupplierMessagesApiSendSupplierMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getSupplierMessageThreads operation in SupplierMessagesApi.
 * @export
 * @interface SupplierMessagesApiGetSupplierMessageThreadsRequest
 */
export interface SupplierMessagesApiGetSupplierMessageThreadsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierMessageThreads
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierMessageThreads
     */
    readonly portalId: number
}

/**
 * Request parameters for getSupplierOrderMessageThread operation in SupplierMessagesApi.
 * @export
 * @interface SupplierMessagesApiGetSupplierOrderMessageThreadRequest
 */
export interface SupplierMessagesApiGetSupplierOrderMessageThreadRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierOrderMessageThread
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierOrderMessageThread
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierOrderMessageThread
     */
    readonly orderId: number
}

/**
 * Request parameters for getSupplierUnreadMessagesCount operation in SupplierMessagesApi.
 * @export
 * @interface SupplierMessagesApiGetSupplierUnreadMessagesCountRequest
 */
export interface SupplierMessagesApiGetSupplierUnreadMessagesCountRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierUnreadMessagesCount
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiGetSupplierUnreadMessagesCount
     */
    readonly portalId: number
}

/**
 * Request parameters for markSupplierMessagesAsRead operation in SupplierMessagesApi.
 * @export
 * @interface SupplierMessagesApiMarkSupplierMessagesAsReadRequest
 */
export interface SupplierMessagesApiMarkSupplierMessagesAsReadRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiMarkSupplierMessagesAsRead
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiMarkSupplierMessagesAsRead
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiMarkSupplierMessagesAsRead
     */
    readonly orderId: number
}

/**
 * Request parameters for sendSupplierMessage operation in SupplierMessagesApi.
 * @export
 * @interface SupplierMessagesApiSendSupplierMessageRequest
 */
export interface SupplierMessagesApiSendSupplierMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiSendSupplierMessage
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiSendSupplierMessage
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierMessagesApiSendSupplierMessage
     */
    readonly orderId: number

    /**
     * 
     * @type {SupplierSendMessageRequest}
     * @memberof SupplierMessagesApiSendSupplierMessage
     */
    readonly supplierSendMessageRequest: SupplierSendMessageRequest
}

/**
 * SupplierMessagesApi - object-oriented interface
 * @export
 * @class SupplierMessagesApi
 * @extends {BaseAPI}
 */
export class SupplierMessagesApi extends BaseAPI implements SupplierMessagesApiInterface {
    /**
     * 
     * @summary Získá seznam vláken zpráv pro dodavatele
     * @param {SupplierMessagesApiGetSupplierMessageThreadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApi
     */
    public getSupplierMessageThreads(requestParameters: SupplierMessagesApiGetSupplierMessageThreadsRequest, options?: RawAxiosRequestConfig) {
        return SupplierMessagesApiFp(this.configuration).getSupplierMessageThreads(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá vlákno zpráv k objednávce
     * @param {SupplierMessagesApiGetSupplierOrderMessageThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApi
     */
    public getSupplierOrderMessageThread(requestParameters: SupplierMessagesApiGetSupplierOrderMessageThreadRequest, options?: RawAxiosRequestConfig) {
        return SupplierMessagesApiFp(this.configuration).getSupplierOrderMessageThread(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá počet nepřečtených zpráv pro dodavatele
     * @param {SupplierMessagesApiGetSupplierUnreadMessagesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApi
     */
    public getSupplierUnreadMessagesCount(requestParameters: SupplierMessagesApiGetSupplierUnreadMessagesCountRequest, options?: RawAxiosRequestConfig) {
        return SupplierMessagesApiFp(this.configuration).getSupplierUnreadMessagesCount(requestParameters.supplierId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Označí zprávy k objednávce jako přečtené
     * @param {SupplierMessagesApiMarkSupplierMessagesAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApi
     */
    public markSupplierMessagesAsRead(requestParameters: SupplierMessagesApiMarkSupplierMessagesAsReadRequest, options?: RawAxiosRequestConfig) {
        return SupplierMessagesApiFp(this.configuration).markSupplierMessagesAsRead(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odešle zprávu k objednávce
     * @param {SupplierMessagesApiSendSupplierMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierMessagesApi
     */
    public sendSupplierMessage(requestParameters: SupplierMessagesApiSendSupplierMessageRequest, options?: RawAxiosRequestConfig) {
        return SupplierMessagesApiFp(this.configuration).sendSupplierMessage(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.supplierSendMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierOrderControllerApi - axios parameter creator
 * @export
 */
export const SupplierOrderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dodavatel přijme objednávku ke zpracování
         * @summary Přijme objednávku
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {AcceptOrderRequest} [acceptOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrder: async (supplierId: number, portalId: number, orderId: number, acceptOrderRequest?: AcceptOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('acceptOrder', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('acceptOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('acceptOrder', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/orders/{orderId}/accept`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail objednávky pro daného dodavatele
         * @summary Získá detail objednávky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderDetail: async (supplierId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierOrderDetail', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierOrderDetail', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSupplierOrderDetail', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/orders/{orderId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDF objednávky pro dodavatele (base64), generuje se na požádání
         * @summary Vygeneruje PDF objednávky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderPdf: async (supplierId: number, portalId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierOrderPdf', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierOrderPdf', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSupplierOrderPdf', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/orders/{orderId}/pdf-base64`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam objednávek pro daného dodavatele a portál
         * @summary Získá seznam objednávek dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {string} [deliveryDateFrom] 
         * @param {string} [deliveryDateTo] 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrders: async (supplierId: number, portalId: number, page?: number, size?: number, organizationId?: number, deliveryDateFrom?: string, deliveryDateTo?: string, query?: string, orderStatus?: OrderStatus, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierOrders', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierOrders', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/orders`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (deliveryDateFrom !== undefined) {
                localVarQueryParameter['deliveryDateFrom'] = (deliveryDateFrom as any instanceof Date) ?
                    (deliveryDateFrom as any).toISOString().substring(0,10) :
                    deliveryDateFrom;
            }

            if (deliveryDateTo !== undefined) {
                localVarQueryParameter['deliveryDateTo'] = (deliveryDateTo as any instanceof Date) ?
                    (deliveryDateTo as any).toISOString().substring(0,10) :
                    deliveryDateTo;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dodavatel odmítne objednávku
         * @summary Odmítne objednávku
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {RejectOrderRequest} [rejectOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrder: async (supplierId: number, portalId: number, orderId: number, rejectOrderRequest?: RejectOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('rejectOrder', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('rejectOrder', 'portalId', portalId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('rejectOrder', 'orderId', orderId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/orders/{orderId}/reject`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierOrderControllerApi - functional programming interface
 * @export
 */
export const SupplierOrderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierOrderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Dodavatel přijme objednávku ke zpracování
         * @summary Přijme objednávku
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {AcceptOrderRequest} [acceptOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptOrder(supplierId: number, portalId: number, orderId: number, acceptOrderRequest?: AcceptOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptOrder(supplierId, portalId, orderId, acceptOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierOrderControllerApi.acceptOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail objednávky pro daného dodavatele
         * @summary Získá detail objednávky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierOrderDetail(supplierId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierOrderDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierOrderDetail(supplierId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierOrderControllerApi.getSupplierOrderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PDF objednávky pro dodavatele (base64), generuje se na požádání
         * @summary Vygeneruje PDF objednávky
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierOrderPdf(supplierId: number, portalId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierOrderPdfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierOrderPdf(supplierId, portalId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierOrderControllerApi.getSupplierOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam objednávek pro daného dodavatele a portál
         * @summary Získá seznam objednávek dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {string} [deliveryDateFrom] 
         * @param {string} [deliveryDateTo] 
         * @param {string} [query] 
         * @param {OrderStatus} [orderStatus] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierOrders(supplierId: number, portalId: number, page?: number, size?: number, organizationId?: number, deliveryDateFrom?: string, deliveryDateTo?: string, query?: string, orderStatus?: OrderStatus, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultSupplierOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierOrders(supplierId, portalId, page, size, organizationId, deliveryDateFrom, deliveryDateTo, query, orderStatus, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierOrderControllerApi.getSupplierOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dodavatel odmítne objednávku
         * @summary Odmítne objednávku
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} orderId 
         * @param {RejectOrderRequest} [rejectOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrder(supplierId: number, portalId: number, orderId: number, rejectOrderRequest?: RejectOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectOrder(supplierId, portalId, orderId, rejectOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierOrderControllerApi.rejectOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierOrderControllerApi - factory interface
 * @export
 */
export const SupplierOrderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierOrderControllerApiFp(configuration)
    return {
        /**
         * Dodavatel přijme objednávku ke zpracování
         * @summary Přijme objednávku
         * @param {SupplierOrderControllerApiAcceptOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrder(requestParameters: SupplierOrderControllerApiAcceptOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderActionResponse> {
            return localVarFp.acceptOrder(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.acceptOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail objednávky pro daného dodavatele
         * @summary Získá detail objednávky
         * @param {SupplierOrderControllerApiGetSupplierOrderDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderDetail(requestParameters: SupplierOrderControllerApiGetSupplierOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderDetailResponse> {
            return localVarFp.getSupplierOrderDetail(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * PDF objednávky pro dodavatele (base64), generuje se na požádání
         * @summary Vygeneruje PDF objednávky
         * @param {SupplierOrderControllerApiGetSupplierOrderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrderPdf(requestParameters: SupplierOrderControllerApiGetSupplierOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderPdfResponse> {
            return localVarFp.getSupplierOrderPdf(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam objednávek pro daného dodavatele a portál
         * @summary Získá seznam objednávek dodavatele
         * @param {SupplierOrderControllerApiGetSupplierOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierOrders(requestParameters: SupplierOrderControllerApiGetSupplierOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierOrderListResponse> {
            return localVarFp.getSupplierOrders(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.deliveryDateFrom, requestParameters.deliveryDateTo, requestParameters.query, requestParameters.orderStatus, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Dodavatel odmítne objednávku
         * @summary Odmítne objednávku
         * @param {SupplierOrderControllerApiRejectOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrder(requestParameters: SupplierOrderControllerApiRejectOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderActionResponse> {
            return localVarFp.rejectOrder(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.rejectOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierOrderControllerApi - interface
 * @export
 * @interface SupplierOrderControllerApi
 */
export interface SupplierOrderControllerApiInterface {
    /**
     * Dodavatel přijme objednávku ke zpracování
     * @summary Přijme objednávku
     * @param {SupplierOrderControllerApiAcceptOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApiInterface
     */
    acceptOrder(requestParameters: SupplierOrderControllerApiAcceptOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderActionResponse>;

    /**
     * Vrátí detail objednávky pro daného dodavatele
     * @summary Získá detail objednávky
     * @param {SupplierOrderControllerApiGetSupplierOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApiInterface
     */
    getSupplierOrderDetail(requestParameters: SupplierOrderControllerApiGetSupplierOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderDetailResponse>;

    /**
     * PDF objednávky pro dodavatele (base64), generuje se na požádání
     * @summary Vygeneruje PDF objednávky
     * @param {SupplierOrderControllerApiGetSupplierOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApiInterface
     */
    getSupplierOrderPdf(requestParameters: SupplierOrderControllerApiGetSupplierOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierOrderPdfResponse>;

    /**
     * Vrátí stránkovaný seznam objednávek pro daného dodavatele a portál
     * @summary Získá seznam objednávek dodavatele
     * @param {SupplierOrderControllerApiGetSupplierOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApiInterface
     */
    getSupplierOrders(requestParameters: SupplierOrderControllerApiGetSupplierOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierOrderListResponse>;

    /**
     * Dodavatel odmítne objednávku
     * @summary Odmítne objednávku
     * @param {SupplierOrderControllerApiRejectOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApiInterface
     */
    rejectOrder(requestParameters: SupplierOrderControllerApiRejectOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderActionResponse>;

}

/**
 * Request parameters for acceptOrder operation in SupplierOrderControllerApi.
 * @export
 * @interface SupplierOrderControllerApiAcceptOrderRequest
 */
export interface SupplierOrderControllerApiAcceptOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiAcceptOrder
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiAcceptOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiAcceptOrder
     */
    readonly orderId: number

    /**
     * 
     * @type {AcceptOrderRequest}
     * @memberof SupplierOrderControllerApiAcceptOrder
     */
    readonly acceptOrderRequest?: AcceptOrderRequest
}

/**
 * Request parameters for getSupplierOrderDetail operation in SupplierOrderControllerApi.
 * @export
 * @interface SupplierOrderControllerApiGetSupplierOrderDetailRequest
 */
export interface SupplierOrderControllerApiGetSupplierOrderDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderDetail
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderDetail
     */
    readonly orderId: number
}

/**
 * Request parameters for getSupplierOrderPdf operation in SupplierOrderControllerApi.
 * @export
 * @interface SupplierOrderControllerApiGetSupplierOrderPdfRequest
 */
export interface SupplierOrderControllerApiGetSupplierOrderPdfRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderPdf
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderPdf
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrderPdf
     */
    readonly orderId: number
}

/**
 * Request parameters for getSupplierOrders operation in SupplierOrderControllerApi.
 * @export
 * @interface SupplierOrderControllerApiGetSupplierOrdersRequest
 */
export interface SupplierOrderControllerApiGetSupplierOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly organizationId?: number

    /**
     * 
     * @type {string}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly deliveryDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly deliveryDateTo?: string

    /**
     * 
     * @type {string}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly query?: string

    /**
     * 
     * @type {OrderStatus}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly orderStatus?: OrderStatus

    /**
     * 
     * @type {string}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof SupplierOrderControllerApiGetSupplierOrders
     */
    readonly dateTo?: string
}

/**
 * Request parameters for rejectOrder operation in SupplierOrderControllerApi.
 * @export
 * @interface SupplierOrderControllerApiRejectOrderRequest
 */
export interface SupplierOrderControllerApiRejectOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiRejectOrder
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiRejectOrder
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierOrderControllerApiRejectOrder
     */
    readonly orderId: number

    /**
     * 
     * @type {RejectOrderRequest}
     * @memberof SupplierOrderControllerApiRejectOrder
     */
    readonly rejectOrderRequest?: RejectOrderRequest
}

/**
 * SupplierOrderControllerApi - object-oriented interface
 * @export
 * @class SupplierOrderControllerApi
 * @extends {BaseAPI}
 */
export class SupplierOrderControllerApi extends BaseAPI implements SupplierOrderControllerApiInterface {
    /**
     * Dodavatel přijme objednávku ke zpracování
     * @summary Přijme objednávku
     * @param {SupplierOrderControllerApiAcceptOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApi
     */
    public acceptOrder(requestParameters: SupplierOrderControllerApiAcceptOrderRequest, options?: RawAxiosRequestConfig) {
        return SupplierOrderControllerApiFp(this.configuration).acceptOrder(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.acceptOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail objednávky pro daného dodavatele
     * @summary Získá detail objednávky
     * @param {SupplierOrderControllerApiGetSupplierOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApi
     */
    public getSupplierOrderDetail(requestParameters: SupplierOrderControllerApiGetSupplierOrderDetailRequest, options?: RawAxiosRequestConfig) {
        return SupplierOrderControllerApiFp(this.configuration).getSupplierOrderDetail(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDF objednávky pro dodavatele (base64), generuje se na požádání
     * @summary Vygeneruje PDF objednávky
     * @param {SupplierOrderControllerApiGetSupplierOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApi
     */
    public getSupplierOrderPdf(requestParameters: SupplierOrderControllerApiGetSupplierOrderPdfRequest, options?: RawAxiosRequestConfig) {
        return SupplierOrderControllerApiFp(this.configuration).getSupplierOrderPdf(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam objednávek pro daného dodavatele a portál
     * @summary Získá seznam objednávek dodavatele
     * @param {SupplierOrderControllerApiGetSupplierOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApi
     */
    public getSupplierOrders(requestParameters: SupplierOrderControllerApiGetSupplierOrdersRequest, options?: RawAxiosRequestConfig) {
        return SupplierOrderControllerApiFp(this.configuration).getSupplierOrders(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.deliveryDateFrom, requestParameters.deliveryDateTo, requestParameters.query, requestParameters.orderStatus, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dodavatel odmítne objednávku
     * @summary Odmítne objednávku
     * @param {SupplierOrderControllerApiRejectOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierOrderControllerApi
     */
    public rejectOrder(requestParameters: SupplierOrderControllerApiRejectOrderRequest, options?: RawAxiosRequestConfig) {
        return SupplierOrderControllerApiFp(this.configuration).rejectOrder(requestParameters.supplierId, requestParameters.portalId, requestParameters.orderId, requestParameters.rejectOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierPricesApi - axios parameter creator
 * @export
 */
export const SupplierPricesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Streamovaný CSV export položek dodavatele ve formátu portal_export-polozky (19 sloupců). Respektuje stejné filtry jako výpis cen (aukce, zákazník, dotaz, garance, typ ceny).
         * @summary Exportuje ceny/položky dodavatele do CSV (per aukce)
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {string} [query] 
         * @param {ExportSupplierPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSupplierPrices: async (supplierId: number, portalId: number, organizationId?: number, auctionId?: number, query?: string, guaranteedFilter?: ExportSupplierPricesGuaranteedFilterEnum, priceType?: PriceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('exportSupplierPrices', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('exportSupplierPrices', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/prices/export`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (auctionId !== undefined) {
                localVarQueryParameter['auctionId'] = auctionId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (guaranteedFilter !== undefined) {
                localVarQueryParameter['guaranteedFilter'] = guaranteedFilter;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam aukcí, které mají přiřazené ceny od dodavatele
         * @summary Získá seznam aukcí pro filtr cen
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPriceAuctions: async (supplierId: number, portalId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierPriceAuctions', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierPriceAuctions', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/prices/auctions`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny od dodavatele (přes PriceVisibility)
         * @summary Získá seznam zákazníků pro filtr cen
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPriceCustomers: async (supplierId: number, portalId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierPriceCustomers', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierPriceCustomers', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/prices/customers`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam cen pro daného dodavatele a portál s možností filtrování
         * @summary Získá seznam cen dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {string} [query] 
         * @param {GetSupplierPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPrices: async (supplierId: number, portalId: number, page?: number, size?: number, organizationId?: number, auctionId?: number, query?: string, guaranteedFilter?: GetSupplierPricesGuaranteedFilterEnum, priceType?: PriceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierPrices', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierPrices', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/prices`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (auctionId !== undefined) {
                localVarQueryParameter['auctionId'] = auctionId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (guaranteedFilter !== undefined) {
                localVarQueryParameter['guaranteedFilter'] = guaranteedFilter;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierPricesApi - functional programming interface
 * @export
 */
export const SupplierPricesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierPricesApiAxiosParamCreator(configuration)
    return {
        /**
         * Streamovaný CSV export položek dodavatele ve formátu portal_export-polozky (19 sloupců). Respektuje stejné filtry jako výpis cen (aukce, zákazník, dotaz, garance, typ ceny).
         * @summary Exportuje ceny/položky dodavatele do CSV (per aukce)
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {string} [query] 
         * @param {ExportSupplierPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSupplierPrices(supplierId: number, portalId: number, organizationId?: number, auctionId?: number, query?: string, guaranteedFilter?: ExportSupplierPricesGuaranteedFilterEnum, priceType?: PriceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSupplierPrices(supplierId, portalId, organizationId, auctionId, query, guaranteedFilter, priceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierPricesApi.exportSupplierPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam aukcí, které mají přiřazené ceny od dodavatele
         * @summary Získá seznam aukcí pro filtr cen
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierPriceAuctions(supplierId: number, portalId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceAuctionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierPriceAuctions(supplierId, portalId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierPricesApi.getSupplierPriceAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny od dodavatele (přes PriceVisibility)
         * @summary Získá seznam zákazníků pro filtr cen
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierPriceCustomers(supplierId: number, portalId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceCustomerDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierPriceCustomers(supplierId, portalId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierPricesApi.getSupplierPriceCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam cen pro daného dodavatele a portál s možností filtrování
         * @summary Získá seznam cen dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {string} [query] 
         * @param {GetSupplierPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierPrices(supplierId: number, portalId: number, page?: number, size?: number, organizationId?: number, auctionId?: number, query?: string, guaranteedFilter?: GetSupplierPricesGuaranteedFilterEnum, priceType?: PriceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultSupplierPriceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierPrices(supplierId, portalId, page, size, organizationId, auctionId, query, guaranteedFilter, priceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierPricesApi.getSupplierPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierPricesApi - factory interface
 * @export
 */
export const SupplierPricesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierPricesApiFp(configuration)
    return {
        /**
         * Streamovaný CSV export položek dodavatele ve formátu portal_export-polozky (19 sloupců). Respektuje stejné filtry jako výpis cen (aukce, zákazník, dotaz, garance, typ ceny).
         * @summary Exportuje ceny/položky dodavatele do CSV (per aukce)
         * @param {SupplierPricesApiExportSupplierPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSupplierPrices(requestParameters: SupplierPricesApiExportSupplierPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exportSupplierPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.organizationId, requestParameters.auctionId, requestParameters.query, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam aukcí, které mají přiřazené ceny od dodavatele
         * @summary Získá seznam aukcí pro filtr cen
         * @param {SupplierPricesApiGetSupplierPriceAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPriceAuctions(requestParameters: SupplierPricesApiGetSupplierPriceAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PriceAuctionDTO>> {
            return localVarFp.getSupplierPriceAuctions(requestParameters.supplierId, requestParameters.portalId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny od dodavatele (přes PriceVisibility)
         * @summary Získá seznam zákazníků pro filtr cen
         * @param {SupplierPricesApiGetSupplierPriceCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPriceCustomers(requestParameters: SupplierPricesApiGetSupplierPriceCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PriceCustomerDTO>> {
            return localVarFp.getSupplierPriceCustomers(requestParameters.supplierId, requestParameters.portalId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam cen pro daného dodavatele a portál s možností filtrování
         * @summary Získá seznam cen dodavatele
         * @param {SupplierPricesApiGetSupplierPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierPrices(requestParameters: SupplierPricesApiGetSupplierPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierPriceListResponse> {
            return localVarFp.getSupplierPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.auctionId, requestParameters.query, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierPricesApi - interface
 * @export
 * @interface SupplierPricesApi
 */
export interface SupplierPricesApiInterface {
    /**
     * Streamovaný CSV export položek dodavatele ve formátu portal_export-polozky (19 sloupců). Respektuje stejné filtry jako výpis cen (aukce, zákazník, dotaz, garance, typ ceny).
     * @summary Exportuje ceny/položky dodavatele do CSV (per aukce)
     * @param {SupplierPricesApiExportSupplierPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApiInterface
     */
    exportSupplierPrices(requestParameters: SupplierPricesApiExportSupplierPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Vrátí seznam aukcí, které mají přiřazené ceny od dodavatele
     * @summary Získá seznam aukcí pro filtr cen
     * @param {SupplierPricesApiGetSupplierPriceAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApiInterface
     */
    getSupplierPriceAuctions(requestParameters: SupplierPricesApiGetSupplierPriceAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PriceAuctionDTO>>;

    /**
     * Vrátí seznam zákazníků, kteří mají přiřazené ceny od dodavatele (přes PriceVisibility)
     * @summary Získá seznam zákazníků pro filtr cen
     * @param {SupplierPricesApiGetSupplierPriceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApiInterface
     */
    getSupplierPriceCustomers(requestParameters: SupplierPricesApiGetSupplierPriceCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PriceCustomerDTO>>;

    /**
     * Vrátí stránkovaný seznam cen pro daného dodavatele a portál s možností filtrování
     * @summary Získá seznam cen dodavatele
     * @param {SupplierPricesApiGetSupplierPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApiInterface
     */
    getSupplierPrices(requestParameters: SupplierPricesApiGetSupplierPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierPriceListResponse>;

}

/**
 * Request parameters for exportSupplierPrices operation in SupplierPricesApi.
 * @export
 * @interface SupplierPricesApiExportSupplierPricesRequest
 */
export interface SupplierPricesApiExportSupplierPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly auctionId?: number

    /**
     * 
     * @type {string}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly query?: string

    /**
     * 
     * @type {'GUARANTEED' | 'NOT_GUARANTEED' | 'ALL'}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly guaranteedFilter?: ExportSupplierPricesGuaranteedFilterEnum

    /**
     * 
     * @type {PriceType}
     * @memberof SupplierPricesApiExportSupplierPrices
     */
    readonly priceType?: PriceType
}

/**
 * Request parameters for getSupplierPriceAuctions operation in SupplierPricesApi.
 * @export
 * @interface SupplierPricesApiGetSupplierPriceAuctionsRequest
 */
export interface SupplierPricesApiGetSupplierPriceAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPriceAuctions
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPriceAuctions
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof SupplierPricesApiGetSupplierPriceAuctions
     */
    readonly query?: string
}

/**
 * Request parameters for getSupplierPriceCustomers operation in SupplierPricesApi.
 * @export
 * @interface SupplierPricesApiGetSupplierPriceCustomersRequest
 */
export interface SupplierPricesApiGetSupplierPriceCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPriceCustomers
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPriceCustomers
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof SupplierPricesApiGetSupplierPriceCustomers
     */
    readonly query?: string
}

/**
 * Request parameters for getSupplierPrices operation in SupplierPricesApi.
 * @export
 * @interface SupplierPricesApiGetSupplierPricesRequest
 */
export interface SupplierPricesApiGetSupplierPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly auctionId?: number

    /**
     * 
     * @type {string}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly query?: string

    /**
     * 
     * @type {'GUARANTEED' | 'NOT_GUARANTEED' | 'ALL'}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly guaranteedFilter?: GetSupplierPricesGuaranteedFilterEnum

    /**
     * 
     * @type {PriceType}
     * @memberof SupplierPricesApiGetSupplierPrices
     */
    readonly priceType?: PriceType
}

/**
 * SupplierPricesApi - object-oriented interface
 * @export
 * @class SupplierPricesApi
 * @extends {BaseAPI}
 */
export class SupplierPricesApi extends BaseAPI implements SupplierPricesApiInterface {
    /**
     * Streamovaný CSV export položek dodavatele ve formátu portal_export-polozky (19 sloupců). Respektuje stejné filtry jako výpis cen (aukce, zákazník, dotaz, garance, typ ceny).
     * @summary Exportuje ceny/položky dodavatele do CSV (per aukce)
     * @param {SupplierPricesApiExportSupplierPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApi
     */
    public exportSupplierPrices(requestParameters: SupplierPricesApiExportSupplierPricesRequest, options?: RawAxiosRequestConfig) {
        return SupplierPricesApiFp(this.configuration).exportSupplierPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.organizationId, requestParameters.auctionId, requestParameters.query, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam aukcí, které mají přiřazené ceny od dodavatele
     * @summary Získá seznam aukcí pro filtr cen
     * @param {SupplierPricesApiGetSupplierPriceAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApi
     */
    public getSupplierPriceAuctions(requestParameters: SupplierPricesApiGetSupplierPriceAuctionsRequest, options?: RawAxiosRequestConfig) {
        return SupplierPricesApiFp(this.configuration).getSupplierPriceAuctions(requestParameters.supplierId, requestParameters.portalId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam zákazníků, kteří mají přiřazené ceny od dodavatele (přes PriceVisibility)
     * @summary Získá seznam zákazníků pro filtr cen
     * @param {SupplierPricesApiGetSupplierPriceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApi
     */
    public getSupplierPriceCustomers(requestParameters: SupplierPricesApiGetSupplierPriceCustomersRequest, options?: RawAxiosRequestConfig) {
        return SupplierPricesApiFp(this.configuration).getSupplierPriceCustomers(requestParameters.supplierId, requestParameters.portalId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam cen pro daného dodavatele a portál s možností filtrování
     * @summary Získá seznam cen dodavatele
     * @param {SupplierPricesApiGetSupplierPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierPricesApi
     */
    public getSupplierPrices(requestParameters: SupplierPricesApiGetSupplierPricesRequest, options?: RawAxiosRequestConfig) {
        return SupplierPricesApiFp(this.configuration).getSupplierPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.auctionId, requestParameters.query, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportSupplierPricesGuaranteedFilterEnum = {
    Guaranteed: 'GUARANTEED',
    NotGuaranteed: 'NOT_GUARANTEED',
    All: 'ALL'
} as const;
export type ExportSupplierPricesGuaranteedFilterEnum = typeof ExportSupplierPricesGuaranteedFilterEnum[keyof typeof ExportSupplierPricesGuaranteedFilterEnum];
/**
 * @export
 */
export const GetSupplierPricesGuaranteedFilterEnum = {
    Guaranteed: 'GUARANTEED',
    NotGuaranteed: 'NOT_GUARANTEED',
    All: 'ALL'
} as const;
export type GetSupplierPricesGuaranteedFilterEnum = typeof GetSupplierPricesGuaranteedFilterEnum[keyof typeof GetSupplierPricesGuaranteedFilterEnum];


/**
 * SupplierProductDetailApi - axios parameter creator
 * @export
 */
export const SupplierProductDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Smaže dodavatelský obrázek produktu. Nelze mazat globální obrázky.
         * @summary Smaže obrázek produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} physicalImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplierProductDetailImage: async (supplierId: number, portalId: number, productId: number, physicalImageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('deleteSupplierProductDetailImage', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteSupplierProductDetailImage', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteSupplierProductDetailImage', 'productId', productId)
            // verify required parameter 'physicalImageId' is not null or undefined
            assertParamExists('deleteSupplierProductDetailImage', 'physicalImageId', physicalImageId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/images/{physicalImageId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"physicalImageId"}}`, encodeURIComponent(String(physicalImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí základní informace o produktu včetně katalogových dat
         * @summary Získá detail produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetail: async (supplierId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetail', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetail', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetail', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam aukcí, ve kterých je tento produkt
         * @summary Získá seznam aukcí produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailAuctions: async (supplierId: number, portalId: number, productId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetailAuctions', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetailAuctions', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetailAuctions', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/auctions`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny k tomuto produktu (přes PriceVisibility)
         * @summary Získá seznam zákazníků produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailCustomers: async (supplierId: number, portalId: number, productId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetailCustomers', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetailCustomers', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetailCustomers', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/customers`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam globálních a dodavatelských obrázků produktu
         * @summary Získá seznam obrázků produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailImages: async (supplierId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetailImages', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetailImages', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetailImages', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/images`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam portálů, kde je produkt viditelný
         * @summary Získá seznam portálů produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailPortals: async (supplierId: number, portalId: number, productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetailPortals', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetailPortals', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetailPortals', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/portals`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam cen pro daný produkt s možností filtrování
         * @summary Získá stránkovaný seznam cen produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {GetSupplierProductDetailPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailPrices: async (supplierId: number, portalId: number, productId: number, page?: number, size?: number, organizationId?: number, auctionId?: number, guaranteedFilter?: GetSupplierProductDetailPricesGuaranteedFilterEnum, priceType?: PriceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProductDetailPrices', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProductDetailPrices', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getSupplierProductDetailPrices', 'productId', productId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/prices`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (auctionId !== undefined) {
                localVarQueryParameter['auctionId'] = auctionId;
            }

            if (guaranteedFilter !== undefined) {
                localVarQueryParameter['guaranteedFilter'] = guaranteedFilter;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nahrá obrázek jako dodavatelský obrázek produktu (base64)
         * @summary Nahrá nový obrázek produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {SupplierProductImageUploadRequest} supplierProductImageUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSupplierProductDetailImage: async (supplierId: number, portalId: number, productId: number, supplierProductImageUploadRequest: SupplierProductImageUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('uploadSupplierProductDetailImage', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('uploadSupplierProductDetailImage', 'portalId', portalId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('uploadSupplierProductDetailImage', 'productId', productId)
            // verify required parameter 'supplierProductImageUploadRequest' is not null or undefined
            assertParamExists('uploadSupplierProductDetailImage', 'supplierProductImageUploadRequest', supplierProductImageUploadRequest)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products/{productId}/images`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierProductImageUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierProductDetailApi - functional programming interface
 * @export
 */
export const SupplierProductDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierProductDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Smaže dodavatelský obrázek produktu. Nelze mazat globální obrázky.
         * @summary Smaže obrázek produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} physicalImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSupplierProductDetailImage(supplierId: number, portalId: number, productId: number, physicalImageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplierProductDetailImage(supplierId, portalId, productId, physicalImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.deleteSupplierProductDetailImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí základní informace o produktu včetně katalogových dat
         * @summary Získá detail produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetail(supplierId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetail(supplierId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam aukcí, ve kterých je tento produkt
         * @summary Získá seznam aukcí produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetailAuctions(supplierId: number, portalId: number, productId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierProductAuctionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetailAuctions(supplierId, portalId, productId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetailAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny k tomuto produktu (přes PriceVisibility)
         * @summary Získá seznam zákazníků produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetailCustomers(supplierId: number, portalId: number, productId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierProductCustomerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetailCustomers(supplierId, portalId, productId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetailCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam globálních a dodavatelských obrázků produktu
         * @summary Získá seznam obrázků produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetailImages(supplierId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierProductImageResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetailImages(supplierId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetailImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam portálů, kde je produkt viditelný
         * @summary Získá seznam portálů produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetailPortals(supplierId: number, portalId: number, productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierProductPortalResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetailPortals(supplierId, portalId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetailPortals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam cen pro daný produkt s možností filtrování
         * @summary Získá stránkovaný seznam cen produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [organizationId] 
         * @param {number} [auctionId] 
         * @param {GetSupplierProductDetailPricesGuaranteedFilterEnum} [guaranteedFilter] 
         * @param {PriceType} [priceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProductDetailPrices(supplierId: number, portalId: number, productId: number, page?: number, size?: number, organizationId?: number, auctionId?: number, guaranteedFilter?: GetSupplierProductDetailPricesGuaranteedFilterEnum, priceType?: PriceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultSupplierProductPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductDetailPrices(supplierId, portalId, productId, page, size, organizationId, auctionId, guaranteedFilter, priceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.getSupplierProductDetailPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nahrá obrázek jako dodavatelský obrázek produktu (base64)
         * @summary Nahrá nový obrázek produktu
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} productId 
         * @param {SupplierProductImageUploadRequest} supplierProductImageUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSupplierProductDetailImage(supplierId: number, portalId: number, productId: number, supplierProductImageUploadRequest: SupplierProductImageUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierProductImageUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSupplierProductDetailImage(supplierId, portalId, productId, supplierProductImageUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductDetailApi.uploadSupplierProductDetailImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierProductDetailApi - factory interface
 * @export
 */
export const SupplierProductDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierProductDetailApiFp(configuration)
    return {
        /**
         * Smaže dodavatelský obrázek produktu. Nelze mazat globální obrázky.
         * @summary Smaže obrázek produktu
         * @param {SupplierProductDetailApiDeleteSupplierProductDetailImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplierProductDetailImage(requestParameters: SupplierProductDetailApiDeleteSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSupplierProductDetailImage(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.physicalImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí základní informace o produktu včetně katalogových dat
         * @summary Získá detail produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetail(requestParameters: SupplierProductDetailApiGetSupplierProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierProductDetailResponse> {
            return localVarFp.getSupplierProductDetail(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam aukcí, ve kterých je tento produkt
         * @summary Získá seznam aukcí produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailAuctions(requestParameters: SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductAuctionResponse>> {
            return localVarFp.getSupplierProductDetailAuctions(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam zákazníků, kteří mají přiřazené ceny k tomuto produktu (přes PriceVisibility)
         * @summary Získá seznam zákazníků produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailCustomers(requestParameters: SupplierProductDetailApiGetSupplierProductDetailCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductCustomerResponse>> {
            return localVarFp.getSupplierProductDetailCustomers(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam globálních a dodavatelských obrázků produktu
         * @summary Získá seznam obrázků produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailImages(requestParameters: SupplierProductDetailApiGetSupplierProductDetailImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductImageResponse>> {
            return localVarFp.getSupplierProductDetailImages(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam portálů, kde je produkt viditelný
         * @summary Získá seznam portálů produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailPortalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailPortals(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPortalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductPortalResponse>> {
            return localVarFp.getSupplierProductDetailPortals(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam cen pro daný produkt s možností filtrování
         * @summary Získá stránkovaný seznam cen produktu
         * @param {SupplierProductDetailApiGetSupplierProductDetailPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProductDetailPrices(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierProductPriceResponse> {
            return localVarFp.getSupplierProductDetailPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.auctionId, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(axios, basePath));
        },
        /**
         * Nahrá obrázek jako dodavatelský obrázek produktu (base64)
         * @summary Nahrá nový obrázek produktu
         * @param {SupplierProductDetailApiUploadSupplierProductDetailImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSupplierProductDetailImage(requestParameters: SupplierProductDetailApiUploadSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierProductImageUploadResponse> {
            return localVarFp.uploadSupplierProductDetailImage(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierProductImageUploadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierProductDetailApi - interface
 * @export
 * @interface SupplierProductDetailApi
 */
export interface SupplierProductDetailApiInterface {
    /**
     * Smaže dodavatelský obrázek produktu. Nelze mazat globální obrázky.
     * @summary Smaže obrázek produktu
     * @param {SupplierProductDetailApiDeleteSupplierProductDetailImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    deleteSupplierProductDetailImage(requestParameters: SupplierProductDetailApiDeleteSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí základní informace o produktu včetně katalogových dat
     * @summary Získá detail produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetail(requestParameters: SupplierProductDetailApiGetSupplierProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierProductDetailResponse>;

    /**
     * Vrátí seznam aukcí, ve kterých je tento produkt
     * @summary Získá seznam aukcí produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetailAuctions(requestParameters: SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductAuctionResponse>>;

    /**
     * Vrátí seznam zákazníků, kteří mají přiřazené ceny k tomuto produktu (přes PriceVisibility)
     * @summary Získá seznam zákazníků produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetailCustomers(requestParameters: SupplierProductDetailApiGetSupplierProductDetailCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductCustomerResponse>>;

    /**
     * Vrátí seznam globálních a dodavatelských obrázků produktu
     * @summary Získá seznam obrázků produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetailImages(requestParameters: SupplierProductDetailApiGetSupplierProductDetailImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductImageResponse>>;

    /**
     * Vrátí seznam portálů, kde je produkt viditelný
     * @summary Získá seznam portálů produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailPortalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetailPortals(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPortalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SupplierProductPortalResponse>>;

    /**
     * Vrátí stránkovaný seznam cen pro daný produkt s možností filtrování
     * @summary Získá stránkovaný seznam cen produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    getSupplierProductDetailPrices(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierProductPriceResponse>;

    /**
     * Nahrá obrázek jako dodavatelský obrázek produktu (base64)
     * @summary Nahrá nový obrázek produktu
     * @param {SupplierProductDetailApiUploadSupplierProductDetailImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApiInterface
     */
    uploadSupplierProductDetailImage(requestParameters: SupplierProductDetailApiUploadSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierProductImageUploadResponse>;

}

/**
 * Request parameters for deleteSupplierProductDetailImage operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiDeleteSupplierProductDetailImageRequest
 */
export interface SupplierProductDetailApiDeleteSupplierProductDetailImageRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiDeleteSupplierProductDetailImage
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiDeleteSupplierProductDetailImage
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiDeleteSupplierProductDetailImage
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiDeleteSupplierProductDetailImage
     */
    readonly physicalImageId: number
}

/**
 * Request parameters for getSupplierProductDetail operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetail
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetail
     */
    readonly productId: number
}

/**
 * Request parameters for getSupplierProductDetailAuctions operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailAuctions
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailAuctions
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailAuctions
     */
    readonly productId: number

    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailAuctions
     */
    readonly query?: string
}

/**
 * Request parameters for getSupplierProductDetailCustomers operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailCustomersRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailCustomers
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailCustomers
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailCustomers
     */
    readonly productId: number

    /**
     * 
     * @type {string}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailCustomers
     */
    readonly query?: string
}

/**
 * Request parameters for getSupplierProductDetailImages operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailImagesRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailImagesRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailImages
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailImages
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailImages
     */
    readonly productId: number
}

/**
 * Request parameters for getSupplierProductDetailPortals operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailPortalsRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailPortalsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPortals
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPortals
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPortals
     */
    readonly productId: number
}

/**
 * Request parameters for getSupplierProductDetailPrices operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiGetSupplierProductDetailPricesRequest
 */
export interface SupplierProductDetailApiGetSupplierProductDetailPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly auctionId?: number

    /**
     * 
     * @type {'GUARANTEED' | 'NOT_GUARANTEED' | 'ALL'}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly guaranteedFilter?: GetSupplierProductDetailPricesGuaranteedFilterEnum

    /**
     * 
     * @type {PriceType}
     * @memberof SupplierProductDetailApiGetSupplierProductDetailPrices
     */
    readonly priceType?: PriceType
}

/**
 * Request parameters for uploadSupplierProductDetailImage operation in SupplierProductDetailApi.
 * @export
 * @interface SupplierProductDetailApiUploadSupplierProductDetailImageRequest
 */
export interface SupplierProductDetailApiUploadSupplierProductDetailImageRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiUploadSupplierProductDetailImage
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiUploadSupplierProductDetailImage
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductDetailApiUploadSupplierProductDetailImage
     */
    readonly productId: number

    /**
     * 
     * @type {SupplierProductImageUploadRequest}
     * @memberof SupplierProductDetailApiUploadSupplierProductDetailImage
     */
    readonly supplierProductImageUploadRequest: SupplierProductImageUploadRequest
}

/**
 * SupplierProductDetailApi - object-oriented interface
 * @export
 * @class SupplierProductDetailApi
 * @extends {BaseAPI}
 */
export class SupplierProductDetailApi extends BaseAPI implements SupplierProductDetailApiInterface {
    /**
     * Smaže dodavatelský obrázek produktu. Nelze mazat globální obrázky.
     * @summary Smaže obrázek produktu
     * @param {SupplierProductDetailApiDeleteSupplierProductDetailImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public deleteSupplierProductDetailImage(requestParameters: SupplierProductDetailApiDeleteSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).deleteSupplierProductDetailImage(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.physicalImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí základní informace o produktu včetně katalogových dat
     * @summary Získá detail produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetail(requestParameters: SupplierProductDetailApiGetSupplierProductDetailRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetail(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam aukcí, ve kterých je tento produkt
     * @summary Získá seznam aukcí produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetailAuctions(requestParameters: SupplierProductDetailApiGetSupplierProductDetailAuctionsRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetailAuctions(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam zákazníků, kteří mají přiřazené ceny k tomuto produktu (přes PriceVisibility)
     * @summary Získá seznam zákazníků produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetailCustomers(requestParameters: SupplierProductDetailApiGetSupplierProductDetailCustomersRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetailCustomers(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam globálních a dodavatelských obrázků produktu
     * @summary Získá seznam obrázků produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetailImages(requestParameters: SupplierProductDetailApiGetSupplierProductDetailImagesRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetailImages(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam portálů, kde je produkt viditelný
     * @summary Získá seznam portálů produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailPortalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetailPortals(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPortalsRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetailPortals(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam cen pro daný produkt s možností filtrování
     * @summary Získá stránkovaný seznam cen produktu
     * @param {SupplierProductDetailApiGetSupplierProductDetailPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public getSupplierProductDetailPrices(requestParameters: SupplierProductDetailApiGetSupplierProductDetailPricesRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).getSupplierProductDetailPrices(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.organizationId, requestParameters.auctionId, requestParameters.guaranteedFilter, requestParameters.priceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nahrá obrázek jako dodavatelský obrázek produktu (base64)
     * @summary Nahrá nový obrázek produktu
     * @param {SupplierProductDetailApiUploadSupplierProductDetailImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductDetailApi
     */
    public uploadSupplierProductDetailImage(requestParameters: SupplierProductDetailApiUploadSupplierProductDetailImageRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductDetailApiFp(this.configuration).uploadSupplierProductDetailImage(requestParameters.supplierId, requestParameters.portalId, requestParameters.productId, requestParameters.supplierProductImageUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetSupplierProductDetailPricesGuaranteedFilterEnum = {
    Guaranteed: 'GUARANTEED',
    NotGuaranteed: 'NOT_GUARANTEED',
    All: 'ALL'
} as const;
export type GetSupplierProductDetailPricesGuaranteedFilterEnum = typeof GetSupplierProductDetailPricesGuaranteedFilterEnum[keyof typeof GetSupplierProductDetailPricesGuaranteedFilterEnum];


/**
 * SupplierProductsApi - axios parameter creator
 * @export
 */
export const SupplierProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí stránkovaný seznam produktů pro daného dodavatele
         * @summary Získá seznam produktů dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProducts: async (supplierId: number, portalId: number, page?: number, size?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplierProducts', 'supplierId', supplierId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getSupplierProducts', 'portalId', portalId)
            const localVarPath = `/api/supplier/{supplierId}/portal/{portalId}/products`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierProductsApi - functional programming interface
 * @export
 */
export const SupplierProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí stránkovaný seznam produktů pro daného dodavatele
         * @summary Získá seznam produktů dodavatele
         * @param {number} supplierId 
         * @param {number} portalId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierProducts(supplierId: number, portalId: number, page?: number, size?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultSupplierProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProducts(supplierId, portalId, page, size, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierProductsApi.getSupplierProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierProductsApi - factory interface
 * @export
 */
export const SupplierProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierProductsApiFp(configuration)
    return {
        /**
         * Vrátí stránkovaný seznam produktů pro daného dodavatele
         * @summary Získá seznam produktů dodavatele
         * @param {SupplierProductsApiGetSupplierProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierProducts(requestParameters: SupplierProductsApiGetSupplierProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierProductResponse> {
            return localVarFp.getSupplierProducts(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierProductsApi - interface
 * @export
 * @interface SupplierProductsApi
 */
export interface SupplierProductsApiInterface {
    /**
     * Vrátí stránkovaný seznam produktů pro daného dodavatele
     * @summary Získá seznam produktů dodavatele
     * @param {SupplierProductsApiGetSupplierProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductsApiInterface
     */
    getSupplierProducts(requestParameters: SupplierProductsApiGetSupplierProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultSupplierProductResponse>;

}

/**
 * Request parameters for getSupplierProducts operation in SupplierProductsApi.
 * @export
 * @interface SupplierProductsApiGetSupplierProductsRequest
 */
export interface SupplierProductsApiGetSupplierProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupplierProductsApiGetSupplierProducts
     */
    readonly supplierId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductsApiGetSupplierProducts
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductsApiGetSupplierProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SupplierProductsApiGetSupplierProducts
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof SupplierProductsApiGetSupplierProducts
     */
    readonly query?: string
}

/**
 * SupplierProductsApi - object-oriented interface
 * @export
 * @class SupplierProductsApi
 * @extends {BaseAPI}
 */
export class SupplierProductsApi extends BaseAPI implements SupplierProductsApiInterface {
    /**
     * Vrátí stránkovaný seznam produktů pro daného dodavatele
     * @summary Získá seznam produktů dodavatele
     * @param {SupplierProductsApiGetSupplierProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierProductsApi
     */
    public getSupplierProducts(requestParameters: SupplierProductsApiGetSupplierProductsRequest, options?: RawAxiosRequestConfig) {
        return SupplierProductsApiFp(this.configuration).getSupplierProducts(requestParameters.supplierId, requestParameters.portalId, requestParameters.page, requestParameters.size, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskControllerApi - axios parameter creator
 * @export
 */
export const TaskControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Seznam běžících úloh
         * @param {number} userId 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningTasks: async (userId: number, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRunningTasks', 'userId', userId)
            const localVarPath = `/api/admin/tasks/running`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá informace o úloze
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTask', 'taskId', taskId)
            const localVarPath = `/api/admin/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam úloh uživatele
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTasks: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskControllerApi - functional programming interface
 * @export
 */
export const TaskControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Seznam běžících úloh
         * @param {number} userId 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunningTasks(userId: number, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunningTasks(userId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getRunningTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá informace o úloze
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam úloh uživatele
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTasks(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTasks(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getUserTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskControllerApi - factory interface
 * @export
 */
export const TaskControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Seznam běžících úloh
         * @param {TaskControllerApiGetRunningTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningTasks(requestParameters: TaskControllerApiGetRunningTasksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskDTO>> {
            return localVarFp.getRunningTasks(requestParameters.userId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá informace o úloze
         * @param {TaskControllerApiGetTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(requestParameters: TaskControllerApiGetTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskDTO> {
            return localVarFp.getTask(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam úloh uživatele
         * @param {TaskControllerApiGetUserTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTasks(requestParameters: TaskControllerApiGetUserTasksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskDTO>> {
            return localVarFp.getUserTasks(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskControllerApi - interface
 * @export
 * @interface TaskControllerApi
 */
export interface TaskControllerApiInterface {
    /**
     * 
     * @summary Seznam běžících úloh
     * @param {TaskControllerApiGetRunningTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApiInterface
     */
    getRunningTasks(requestParameters: TaskControllerApiGetRunningTasksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskDTO>>;

    /**
     * 
     * @summary Získá informace o úloze
     * @param {TaskControllerApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApiInterface
     */
    getTask(requestParameters: TaskControllerApiGetTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskDTO>;

    /**
     * 
     * @summary Seznam úloh uživatele
     * @param {TaskControllerApiGetUserTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApiInterface
     */
    getUserTasks(requestParameters?: TaskControllerApiGetUserTasksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskDTO>>;

}

/**
 * Request parameters for getRunningTasks operation in TaskControllerApi.
 * @export
 * @interface TaskControllerApiGetRunningTasksRequest
 */
export interface TaskControllerApiGetRunningTasksRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskControllerApiGetRunningTasks
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof TaskControllerApiGetRunningTasks
     */
    readonly organizationId?: number
}

/**
 * Request parameters for getTask operation in TaskControllerApi.
 * @export
 * @interface TaskControllerApiGetTaskRequest
 */
export interface TaskControllerApiGetTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof TaskControllerApiGetTask
     */
    readonly taskId: string
}

/**
 * Request parameters for getUserTasks operation in TaskControllerApi.
 * @export
 * @interface TaskControllerApiGetUserTasksRequest
 */
export interface TaskControllerApiGetUserTasksRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskControllerApiGetUserTasks
     */
    readonly limit?: number
}

/**
 * TaskControllerApi - object-oriented interface
 * @export
 * @class TaskControllerApi
 * @extends {BaseAPI}
 */
export class TaskControllerApi extends BaseAPI implements TaskControllerApiInterface {
    /**
     * 
     * @summary Seznam běžících úloh
     * @param {TaskControllerApiGetRunningTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getRunningTasks(requestParameters: TaskControllerApiGetRunningTasksRequest, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getRunningTasks(requestParameters.userId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá informace o úloze
     * @param {TaskControllerApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getTask(requestParameters: TaskControllerApiGetTaskRequest, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam úloh uživatele
     * @param {TaskControllerApiGetUserTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getUserTasks(requestParameters: TaskControllerApiGetUserTasksRequest = {}, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getUserTasks(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkflowControllerApi - axios parameter creator
 * @export
 */
export const WorkflowControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {WorkflowCompleteRequest} workflowCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkflowTask: async (portalId: number, organizationId: number, instanceId: number, workflowCompleteRequest: WorkflowCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('completeWorkflowTask', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('completeWorkflowTask', 'organizationId', organizationId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('completeWorkflowTask', 'instanceId', instanceId)
            // verify required parameter 'workflowCompleteRequest' is not null or undefined
            assertParamExists('completeWorkflowTask', 'workflowCompleteRequest', workflowCompleteRequest)
            const localVarPath = `/api/workflow/portals/{portalId}/organizations/{organizationId}/tasks/{instanceId}/complete`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTaskActions: async (portalId: number, organizationId: number, instanceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getWorkflowTaskActions', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWorkflowTaskActions', 'organizationId', organizationId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('getWorkflowTaskActions', 'instanceId', instanceId)
            const localVarPath = `/api/workflow/portals/{portalId}/organizations/{organizationId}/tasks/{instanceId}/actions`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {GetWorkflowTaskDetailUserTypeEnum} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTaskDetail: async (portalId: number, organizationId: number, instanceId: number, userType: GetWorkflowTaskDetailUserTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getWorkflowTaskDetail', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWorkflowTaskDetail', 'organizationId', organizationId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('getWorkflowTaskDetail', 'instanceId', instanceId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getWorkflowTaskDetail', 'userType', userType)
            const localVarPath = `/api/workflow/portals/{portalId}/organizations/{organizationId}/tasks/{instanceId}`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {GetWorkflowTasksUserTypeEnum} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTasks: async (portalId: number, organizationId: number, userType: GetWorkflowTasksUserTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getWorkflowTasks', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWorkflowTasks', 'organizationId', organizationId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getWorkflowTasks', 'userType', userType)
            const localVarPath = `/api/workflow/portals/{portalId}/organizations/{organizationId}/tasks`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasWorkflowTaskActions: async (portalId: number, organizationId: number, instanceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('hasWorkflowTaskActions', 'portalId', portalId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hasWorkflowTaskActions', 'organizationId', organizationId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('hasWorkflowTaskActions', 'instanceId', instanceId)
            const localVarPath = `/api/workflow/portals/{portalId}/organizations/{organizationId}/tasks/{instanceId}/has-actions`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkflowStartRequest} workflowStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWorkflow: async (workflowStartRequest: WorkflowStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowStartRequest' is not null or undefined
            assertParamExists('startWorkflow', 'workflowStartRequest', workflowStartRequest)
            const localVarPath = `/api/workflow/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowControllerApi - functional programming interface
 * @export
 */
export const WorkflowControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {WorkflowCompleteRequest} workflowCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWorkflowTask(portalId: number, organizationId: number, instanceId: number, workflowCompleteRequest: WorkflowCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWorkflowTask(portalId, organizationId, instanceId, workflowCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.completeWorkflowTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTaskActions(portalId: number, organizationId: number, instanceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkflowActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTaskActions(portalId, organizationId, instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.getWorkflowTaskActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {GetWorkflowTaskDetailUserTypeEnum} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTaskDetail(portalId: number, organizationId: number, instanceId: number, userType: GetWorkflowTaskDetailUserTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTaskDetail(portalId, organizationId, instanceId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.getWorkflowTaskDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {GetWorkflowTasksUserTypeEnum} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTasks(portalId: number, organizationId: number, userType: GetWorkflowTasksUserTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTasks(portalId, organizationId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.getWorkflowTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {number} organizationId 
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasWorkflowTaskActions(portalId: number, organizationId: number, instanceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasWorkflowTaskActions(portalId, organizationId, instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.hasWorkflowTaskActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorkflowStartRequest} workflowStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startWorkflow(workflowStartRequest: WorkflowStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startWorkflow(workflowStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowControllerApi.startWorkflow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkflowControllerApi - factory interface
 * @export
 */
export const WorkflowControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {WorkflowControllerApiCompleteWorkflowTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkflowTask(requestParameters: WorkflowControllerApiCompleteWorkflowTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeWorkflowTask(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, requestParameters.workflowCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkflowControllerApiGetWorkflowTaskActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTaskActions(requestParameters: WorkflowControllerApiGetWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkflowActionResponse>> {
            return localVarFp.getWorkflowTaskActions(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkflowControllerApiGetWorkflowTaskDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTaskDetail(requestParameters: WorkflowControllerApiGetWorkflowTaskDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailResponse> {
            return localVarFp.getWorkflowTaskDetail(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkflowControllerApiGetWorkflowTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTasks(requestParameters: WorkflowControllerApiGetWorkflowTasksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskResponse>> {
            return localVarFp.getWorkflowTasks(requestParameters.portalId, requestParameters.organizationId, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkflowControllerApiHasWorkflowTaskActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasWorkflowTaskActions(requestParameters: WorkflowControllerApiHasWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.hasWorkflowTaskActions(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkflowControllerApiStartWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWorkflow(requestParameters: WorkflowControllerApiStartWorkflowRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowStartResponse> {
            return localVarFp.startWorkflow(requestParameters.workflowStartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowControllerApi - interface
 * @export
 * @interface WorkflowControllerApi
 */
export interface WorkflowControllerApiInterface {
    /**
     * 
     * @param {WorkflowControllerApiCompleteWorkflowTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    completeWorkflowTask(requestParameters: WorkflowControllerApiCompleteWorkflowTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTaskActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    getWorkflowTaskActions(requestParameters: WorkflowControllerApiGetWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkflowActionResponse>>;

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTaskDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    getWorkflowTaskDetail(requestParameters: WorkflowControllerApiGetWorkflowTaskDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailResponse>;

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    getWorkflowTasks(requestParameters: WorkflowControllerApiGetWorkflowTasksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskResponse>>;

    /**
     * 
     * @param {WorkflowControllerApiHasWorkflowTaskActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    hasWorkflowTaskActions(requestParameters: WorkflowControllerApiHasWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @param {WorkflowControllerApiStartWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApiInterface
     */
    startWorkflow(requestParameters: WorkflowControllerApiStartWorkflowRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowStartResponse>;

}

/**
 * Request parameters for completeWorkflowTask operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiCompleteWorkflowTaskRequest
 */
export interface WorkflowControllerApiCompleteWorkflowTaskRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiCompleteWorkflowTask
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiCompleteWorkflowTask
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiCompleteWorkflowTask
     */
    readonly instanceId: number

    /**
     * 
     * @type {WorkflowCompleteRequest}
     * @memberof WorkflowControllerApiCompleteWorkflowTask
     */
    readonly workflowCompleteRequest: WorkflowCompleteRequest
}

/**
 * Request parameters for getWorkflowTaskActions operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiGetWorkflowTaskActionsRequest
 */
export interface WorkflowControllerApiGetWorkflowTaskActionsRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskActions
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskActions
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskActions
     */
    readonly instanceId: number
}

/**
 * Request parameters for getWorkflowTaskDetail operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiGetWorkflowTaskDetailRequest
 */
export interface WorkflowControllerApiGetWorkflowTaskDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskDetail
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTaskDetail
     */
    readonly instanceId: number

    /**
     * 
     * @type {'CLIENT' | 'SUPPLIER'}
     * @memberof WorkflowControllerApiGetWorkflowTaskDetail
     */
    readonly userType: GetWorkflowTaskDetailUserTypeEnum
}

/**
 * Request parameters for getWorkflowTasks operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiGetWorkflowTasksRequest
 */
export interface WorkflowControllerApiGetWorkflowTasksRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTasks
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiGetWorkflowTasks
     */
    readonly organizationId: number

    /**
     * 
     * @type {'CLIENT' | 'SUPPLIER'}
     * @memberof WorkflowControllerApiGetWorkflowTasks
     */
    readonly userType: GetWorkflowTasksUserTypeEnum
}

/**
 * Request parameters for hasWorkflowTaskActions operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiHasWorkflowTaskActionsRequest
 */
export interface WorkflowControllerApiHasWorkflowTaskActionsRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiHasWorkflowTaskActions
     */
    readonly portalId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiHasWorkflowTaskActions
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof WorkflowControllerApiHasWorkflowTaskActions
     */
    readonly instanceId: number
}

/**
 * Request parameters for startWorkflow operation in WorkflowControllerApi.
 * @export
 * @interface WorkflowControllerApiStartWorkflowRequest
 */
export interface WorkflowControllerApiStartWorkflowRequest {
    /**
     * 
     * @type {WorkflowStartRequest}
     * @memberof WorkflowControllerApiStartWorkflow
     */
    readonly workflowStartRequest: WorkflowStartRequest
}

/**
 * WorkflowControllerApi - object-oriented interface
 * @export
 * @class WorkflowControllerApi
 * @extends {BaseAPI}
 */
export class WorkflowControllerApi extends BaseAPI implements WorkflowControllerApiInterface {
    /**
     * 
     * @param {WorkflowControllerApiCompleteWorkflowTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public completeWorkflowTask(requestParameters: WorkflowControllerApiCompleteWorkflowTaskRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).completeWorkflowTask(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, requestParameters.workflowCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTaskActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public getWorkflowTaskActions(requestParameters: WorkflowControllerApiGetWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).getWorkflowTaskActions(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTaskDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public getWorkflowTaskDetail(requestParameters: WorkflowControllerApiGetWorkflowTaskDetailRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).getWorkflowTaskDetail(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkflowControllerApiGetWorkflowTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public getWorkflowTasks(requestParameters: WorkflowControllerApiGetWorkflowTasksRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).getWorkflowTasks(requestParameters.portalId, requestParameters.organizationId, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkflowControllerApiHasWorkflowTaskActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public hasWorkflowTaskActions(requestParameters: WorkflowControllerApiHasWorkflowTaskActionsRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).hasWorkflowTaskActions(requestParameters.portalId, requestParameters.organizationId, requestParameters.instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkflowControllerApiStartWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowControllerApi
     */
    public startWorkflow(requestParameters: WorkflowControllerApiStartWorkflowRequest, options?: RawAxiosRequestConfig) {
        return WorkflowControllerApiFp(this.configuration).startWorkflow(requestParameters.workflowStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetWorkflowTaskDetailUserTypeEnum = {
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;
export type GetWorkflowTaskDetailUserTypeEnum = typeof GetWorkflowTaskDetailUserTypeEnum[keyof typeof GetWorkflowTaskDetailUserTypeEnum];
/**
 * @export
 */
export const GetWorkflowTasksUserTypeEnum = {
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;
export type GetWorkflowTasksUserTypeEnum = typeof GetWorkflowTasksUserTypeEnum[keyof typeof GetWorkflowTasksUserTypeEnum];


